//#region ../../node_modules/@vue/shared/dist/shared.esm-bundler.js
// @__NO_SIDE_EFFECTS__
function e(e) {
	let t = /* @__PURE__ */ Object.create(null);
	for (let n of e.split(",")) t[n] = 1;
	return (e) => e in t;
}
var t = process.env.NODE_ENV === "production" ? {} : Object.freeze({}), n = process.env.NODE_ENV === "production" ? [] : Object.freeze([]), r = () => {}, i = () => !1, a = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), o = (e) => e.startsWith("onUpdate:"), s = Object.assign, c = (e, t) => {
	let n = e.indexOf(t);
	n > -1 && e.splice(n, 1);
}, l = Object.prototype.hasOwnProperty, u = (e, t) => l.call(e, t), d = Array.isArray, f = (e) => x(e) === "[object Map]", p = (e) => x(e) === "[object Set]", m = (e) => x(e) === "[object Date]", h = (e) => typeof e == "function", g = (e) => typeof e == "string", _ = (e) => typeof e == "symbol", v = (e) => typeof e == "object" && !!e, y = (e) => (v(e) || h(e)) && h(e.then) && h(e.catch), b = Object.prototype.toString, x = (e) => b.call(e), S = (e) => x(e).slice(8, -1), C = (e) => x(e) === "[object Object]", w = (e) => g(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, T = /* @__PURE__ */ e(",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"), ee = /* @__PURE__ */ e("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"), te = (e) => {
	let t = /* @__PURE__ */ Object.create(null);
	return ((n) => t[n] || (t[n] = e(n)));
}, ne = /-\w/g, E = te((e) => e.replace(ne, (e) => e.slice(1).toUpperCase())), D = /\B([A-Z])/g, O = te((e) => e.replace(D, "-$1").toLowerCase()), k = te((e) => e.charAt(0).toUpperCase() + e.slice(1)), A = te((e) => e ? `on${k(e)}` : ""), j = (e, t) => !Object.is(e, t), re = (e, ...t) => {
	for (let n = 0; n < e.length; n++) e[n](...t);
}, M = (e, t, n, r = !1) => {
	Object.defineProperty(e, t, {
		configurable: !0,
		enumerable: !1,
		writable: r,
		value: n
	});
}, N = (e) => {
	let t = parseFloat(e);
	return isNaN(t) ? e : t;
}, ie, ae = () => ie ||= typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
function oe(e) {
	if (d(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = g(r) ? ce(r) : oe(r);
			if (i) for (let e in i) t[e] = i[e];
		}
		return t;
	}
	if (g(e) || v(e)) return e;
}
var P = /;(?![^(]*\))/g, F = /:([^]+)/, se = /\/\*[^]*?\*\//g;
function ce(e) {
	let t = {};
	return e.replace(se, "").split(P).forEach((e) => {
		if (e) {
			let n = e.split(F);
			n.length > 1 && (t[n[0].trim()] = n[1].trim());
		}
	}), t;
}
function I(e) {
	let t = "";
	if (g(e)) t = e;
	else if (d(e)) for (let n = 0; n < e.length; n++) {
		let r = I(e[n]);
		r && (t += r + " ");
	}
	else if (v(e)) for (let n in e) e[n] && (t += n + " ");
	return t.trim();
}
function le(e) {
	if (!e) return null;
	let { class: t, style: n } = e;
	return t && !g(t) && (e.class = I(t)), n && (e.style = oe(n)), e;
}
var ue = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot", de = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view", fe = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics", pe = /* @__PURE__ */ e(ue), me = /* @__PURE__ */ e(de), he = /* @__PURE__ */ e(fe), ge = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", _e = /* @__PURE__ */ e(ge);
ge + "";
function ve(e) {
	return !!e || e === "";
}
function ye(e, t) {
	if (e.length !== t.length) return !1;
	let n = !0;
	for (let r = 0; n && r < e.length; r++) n = xe(e[r], t[r]);
	return n;
}
function be(e, t) {
	if (e.size !== t.size) return !1;
	let n = Array.from(t), r = new Uint8Array(n.length);
	for (let t of e) {
		let e = -1;
		for (let i = 0; i < n.length; i++) if (!r[i] && xe(t, n[i])) {
			e = i;
			break;
		}
		if (e < 0) return !1;
		r[e] = 1;
	}
	return !0;
}
function xe(e, t) {
	if (e === t) return !0;
	let n = m(e), r = m(t);
	if (n || r) return n && r ? e.getTime() === t.getTime() : !1;
	if (n = _(e), r = _(t), n || r) return e === t;
	if (n = d(e), r = d(t), n || r) return n && r ? ye(e, t) : !1;
	if (n = v(e), r = v(t), n || r) {
		if (!n || !r) return !1;
		if (n = f(e), r = f(t), n || r || (n = p(e), r = p(t), n || r)) return n && r ? be(e, t) : !1;
		if (Object.keys(e).length !== Object.keys(t).length) return !1;
		for (let n in e) {
			let r = e.hasOwnProperty(n), i = t.hasOwnProperty(n);
			if (r && !i || !r && i || !xe(e[n], t[n])) return !1;
		}
	}
	return String(e) === String(t);
}
var Se = (e) => !!(e && e.__v_isRef === !0), Ce = (e) => g(e) ? e : e == null ? "" : d(e) || v(e) && (e.toString === b || !h(e.toString)) ? Se(e) ? Ce(e.value) : JSON.stringify(e, we, 2) : String(e), we = (e, t) => Se(t) ? we(e, t.value) : f(t) ? { [`Map(${t.size})`]: [...t.entries()].reduce((e, [t, n], r) => (e[Te(t, r) + " =>"] = n, e), {}) } : p(t) ? { [`Set(${t.size})`]: [...t.values()].map((e) => Te(e)) } : _(t) ? Te(t) : v(t) && !d(t) && !C(t) ? String(t) : t, Te = (e, t = "") => _(e) ? `Symbol(${e.description ?? t})` : e;
//#endregion
//#region ../../node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
function Ee(e, ...t) {
	console.warn(`[Vue warn] ${e}`, ...t);
}
var De, Oe = class {
	constructor(e = !1) {
		this.detached = e, this._active = !0, this._on = 0, this.effects = [], this.cleanups = [], this._isPaused = !1, this._warnOnRun = !0, this.__v_skip = !0, !e && De && (De.active ? (this.parent = De, this.index = (De.scopes || (De.scopes = [])).push(this) - 1) : (this._active = !1, this._warnOnRun = !1));
	}
	get active() {
		return this._active;
	}
	pause() {
		if (this._active) {
			this._isPaused = !0;
			let e, t;
			if (this.scopes) {
				let n = this.scopes.slice();
				for (e = 0, t = n.length; e < t; e++) n[e].pause();
			}
			for (e = 0, t = this.effects.length; e < t; e++) this.effects[e].pause();
		}
	}
	resume() {
		if (this._active && this._isPaused) {
			this._isPaused = !1;
			let e, t;
			if (this.scopes) {
				let n = this.scopes.slice();
				for (e = 0, t = n.length; e < t; e++) n[e].resume();
			}
			let n = this.effects.slice();
			for (e = 0, t = n.length; e < t; e++) n[e].resume();
		}
	}
	run(e) {
		if (this._active) {
			let t = De;
			try {
				return De = this, e();
			} finally {
				De = t;
			}
		} else process.env.NODE_ENV !== "production" && this._warnOnRun && Ee("cannot run an inactive effect scope.");
	}
	on() {
		++this._on === 1 && (this.prevScope = De, De = this);
	}
	off() {
		if (this._on > 0 && --this._on === 0) {
			if (De === this) De = this.prevScope;
			else {
				let e = De;
				for (; e;) {
					if (e.prevScope === this) {
						e.prevScope = this.prevScope;
						break;
					}
					e = e.prevScope;
				}
			}
			this.prevScope = void 0;
		}
	}
	stop(e) {
		if (this._active) {
			this._active = !1;
			let t, n;
			for (t = 0, n = this.effects.length; t < n; t++) this.effects[t].stop();
			for (this.effects.length = 0, t = 0, n = this.cleanups.length; t < n; t++) this.cleanups[t]();
			if (this.cleanups.length = 0, this.scopes) {
				let e = this.scopes.slice();
				for (t = 0, n = e.length; t < n; t++) e[t].stop(!0);
				this.scopes.length = 0;
			}
			if (!this.detached && this.parent && !e) {
				let e = this.parent.scopes.pop();
				e && e !== this && (this.parent.scopes[this.index] = e, e.index = this.index);
			}
			this.parent = void 0;
		}
	}
};
function ke() {
	return De;
}
function Ae(e, t = !1) {
	De ? De.cleanups.push(e) : process.env.NODE_ENV !== "production" && !t && Ee("onScopeDispose() is called when there is no active effect scope to be associated with.");
}
var L, je = /* @__PURE__ */ new WeakSet(), Me = class {
	constructor(e) {
		this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, De && (De.active ? De.effects.push(this) : this.flags &= -2);
	}
	pause() {
		this.flags |= 64;
	}
	resume() {
		this.flags & 64 && (this.flags &= -65, je.has(this) && (je.delete(this), this.trigger()));
	}
	notify() {
		this.flags & 2 && !(this.flags & 32) || this.flags & 8 || Ie(this);
	}
	run() {
		if (!(this.flags & 1)) return this.fn();
		this.flags |= 2, Ye(this), ze(this);
		let e = L, t = Ge;
		L = this, Ge = !0;
		try {
			return this.fn();
		} finally {
			process.env.NODE_ENV !== "production" && L !== this && Ee("Active effect was not restored correctly - this is likely a Vue internal bug."), Be(this), L = e, Ge = t, this.flags &= -3;
		}
	}
	stop() {
		if (this.flags & 1) {
			for (let e = this.deps; e; e = e.nextDep) Ue(e);
			this.deps = this.depsTail = void 0, Ye(this), this.onStop && this.onStop(), this.flags &= -2;
		}
	}
	trigger() {
		this.flags & 64 ? je.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
	}
	runIfDirty() {
		Ve(this) && this.run();
	}
	get dirty() {
		return Ve(this);
	}
}, Ne = 0, Pe, Fe;
function Ie(e, t = !1) {
	if (e.flags |= 8, t) {
		e.next = Fe, Fe = e;
		return;
	}
	e.next = Pe, Pe = e;
}
function Le() {
	Ne++;
}
function Re() {
	if (--Ne > 0) return;
	if (Fe) {
		let e = Fe;
		for (Fe = void 0; e;) {
			let t = e.next;
			e.next = void 0, e.flags &= -9, e = t;
		}
	}
	let e;
	for (; Pe;) {
		let t = Pe;
		for (Pe = void 0; t;) {
			let n = t.next;
			if (t.next = void 0, t.flags &= -9, t.flags & 1) try {
				t.trigger();
			} catch (t) {
				e ||= t;
			}
			t = n;
		}
	}
	if (e) throw e;
}
function ze(e) {
	for (let t = e.deps; t; t = t.nextDep) t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function Be(e) {
	let t, n = e.depsTail, r = n;
	for (; r;) {
		let e = r.prevDep;
		r.version === -1 ? (r === n && (n = e), Ue(r), We(r)) : t = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = e;
	}
	e.deps = t, e.depsTail = n;
}
function Ve(e) {
	for (let t = e.deps; t; t = t.nextDep) if (t.dep.version !== t.version || t.dep.computed && (He(t.dep.computed) || t.dep.version !== t.version)) return !0;
	return !!e._dirty;
}
function He(e) {
	if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === Xe) || (e.globalVersion = Xe, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !Ve(e)))) return;
	e.flags |= 2;
	let t = e.dep, n = L, r = Ge;
	L = e, Ge = !0;
	try {
		ze(e);
		let n = e.fn(e._value);
		(t.version === 0 || j(n, e._value)) && (e.flags |= 128, e._value = n, t.version++);
	} catch (e) {
		throw t.version++, e;
	} finally {
		L = n, Ge = r, Be(e), e.flags &= -3;
	}
}
function Ue(e, t = !1) {
	let { dep: n, prevSub: r, nextSub: i } = e;
	if (r && (r.nextSub = i, e.prevSub = void 0), i && (i.prevSub = r, e.nextSub = void 0), process.env.NODE_ENV !== "production" && n.subsHead === e && (n.subsHead = i), n.subs === e && (n.subs = r, !r && n.computed)) {
		n.computed.flags &= -5;
		for (let e = n.computed.deps; e; e = e.nextDep) Ue(e, !0);
	}
	!t && !--n.sc && n.map && n.map.delete(n.key);
}
function We(e) {
	let { prevDep: t, nextDep: n } = e;
	t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
var Ge = !0, Ke = [];
function qe() {
	Ke.push(Ge), Ge = !1;
}
function Je() {
	let e = Ke.pop();
	Ge = e === void 0 || e;
}
function Ye(e) {
	let { cleanup: t } = e;
	if (e.cleanup = void 0, t) {
		let e = L;
		L = void 0;
		try {
			t();
		} finally {
			L = e;
		}
	}
}
var Xe = 0, Ze = class {
	constructor(e, t) {
		this.sub = e, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
	}
}, Qe = class {
	constructor(e) {
		this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
	}
	track(e) {
		if (!L || !Ge || L === this.computed) return;
		let t = this.activeLink;
		if (t === void 0 || t.sub !== L) t = this.activeLink = new Ze(L, this), L.deps ? (t.prevDep = L.depsTail, L.depsTail.nextDep = t, L.depsTail = t) : L.deps = L.depsTail = t, $e(t);
		else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
			let e = t.nextDep;
			e.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = e), t.prevDep = L.depsTail, t.nextDep = void 0, L.depsTail.nextDep = t, L.depsTail = t, L.deps === t && (L.deps = e);
		}
		return process.env.NODE_ENV !== "production" && L.onTrack && L.onTrack(s({ effect: L }, e)), t;
	}
	trigger(e) {
		this.version++, Xe++, this.notify(e);
	}
	notify(e) {
		Le();
		try {
			if (process.env.NODE_ENV !== "production") for (let t = this.subsHead; t; t = t.nextSub) t.sub.onTrigger && !(t.sub.flags & 8) && t.sub.onTrigger(s({ effect: t.sub }, e));
			for (let e = this.subs; e; e = e.prevSub) e.sub.notify() && e.sub.dep.notify();
		} finally {
			Re();
		}
	}
};
function $e(e) {
	if (e.dep.sc++, e.sub.flags & 4) {
		let t = e.dep.computed;
		if (t && !e.dep.subs) {
			t.flags |= 20;
			for (let e = t.deps; e; e = e.nextDep) $e(e);
		}
		let n = e.dep.subs;
		n !== e && (e.prevSub = n, n && (n.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
	}
}
var et = /* @__PURE__ */ new WeakMap(), tt = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Object iterate"), nt = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Map keys iterate"), rt = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Array iterate");
function it(e, t, n) {
	if (Ge && L) {
		let r = et.get(e);
		r || et.set(e, r = /* @__PURE__ */ new Map());
		let i = r.get(n);
		i || (r.set(n, i = new Qe()), i.map = r, i.key = n), process.env.NODE_ENV === "production" ? i.track() : i.track({
			target: e,
			type: t,
			key: n
		});
	}
}
function at(e, t, n, r, i, a) {
	let o = et.get(e);
	if (!o) {
		Xe++;
		return;
	}
	let s = (o) => {
		o && (process.env.NODE_ENV === "production" ? o.trigger() : o.trigger({
			target: e,
			type: t,
			key: n,
			newValue: r,
			oldValue: i,
			oldTarget: a
		}));
	};
	if (Le(), t === "clear") o.forEach(s);
	else {
		let i = d(e), a = i && w(n);
		if (i && n === "length") {
			let e = Number(r);
			o.forEach((t, n) => {
				(n === "length" || n === rt || !_(n) && n >= e) && s(t);
			});
		} else switch ((n !== void 0 || o.has(void 0)) && s(o.get(n)), a && s(o.get(rt)), t) {
			case "add":
				i ? a && s(o.get("length")) : (s(o.get(tt)), f(e) && s(o.get(nt)));
				break;
			case "delete":
				i || (s(o.get(tt)), f(e) && s(o.get(nt)));
				break;
			case "set": f(e) && s(o.get(tt));
		}
	}
	Re();
}
function ot(e, t) {
	let n = et.get(e);
	return n && n.get(t);
}
function st(e) {
	let t = /* @__PURE__ */ R(e);
	return t === e ? t : (it(t, "iterate", rt), /* @__PURE__ */ Xt(e) ? t : t.map($t));
}
function ct(e) {
	return it(e = /* @__PURE__ */ R(e), "iterate", rt), e;
}
function lt(e, t) {
	return /* @__PURE__ */ Yt(e) ? en(/* @__PURE__ */ Jt(e) ? $t(t) : t) : $t(t);
}
var ut = {
	__proto__: null,
	[Symbol.iterator]() {
		return dt(this, Symbol.iterator, (e) => lt(this, e));
	},
	concat(...e) {
		return st(this).concat(...e.map((e) => d(e) ? st(e) : e));
	},
	entries() {
		return dt(this, "entries", (e) => (e[1] = lt(this, e[1]), e));
	},
	every(e, t) {
		return pt(this, "every", e, t, void 0, arguments);
	},
	filter(e, t) {
		return pt(this, "filter", e, t, (e) => e.map((e) => lt(this, e)), arguments);
	},
	find(e, t) {
		return pt(this, "find", e, t, (e) => lt(this, e), arguments);
	},
	findIndex(e, t) {
		return pt(this, "findIndex", e, t, void 0, arguments);
	},
	findLast(e, t) {
		return pt(this, "findLast", e, t, (e) => lt(this, e), arguments);
	},
	findLastIndex(e, t) {
		return pt(this, "findLastIndex", e, t, void 0, arguments);
	},
	forEach(e, t) {
		return pt(this, "forEach", e, t, void 0, arguments);
	},
	includes(...e) {
		return ht(this, "includes", e);
	},
	indexOf(...e) {
		return ht(this, "indexOf", e);
	},
	join(e) {
		return st(this).join(e);
	},
	lastIndexOf(...e) {
		return ht(this, "lastIndexOf", e);
	},
	map(e, t) {
		return pt(this, "map", e, t, void 0, arguments);
	},
	pop() {
		return gt(this, "pop");
	},
	push(...e) {
		return gt(this, "push", e);
	},
	reduce(e, ...t) {
		return mt(this, "reduce", e, t);
	},
	reduceRight(e, ...t) {
		return mt(this, "reduceRight", e, t);
	},
	shift() {
		return gt(this, "shift");
	},
	some(e, t) {
		return pt(this, "some", e, t, void 0, arguments);
	},
	splice(...e) {
		return gt(this, "splice", e);
	},
	toReversed() {
		return st(this).toReversed();
	},
	toSorted(e) {
		return st(this).toSorted(e);
	},
	toSpliced(...e) {
		return st(this).toSpliced(...e);
	},
	unshift(...e) {
		return gt(this, "unshift", e);
	},
	values() {
		return dt(this, "values", (e) => lt(this, e));
	}
};
function dt(e, t, n) {
	let r = ct(e), i = r[t]();
	return r !== e && !/* @__PURE__ */ Xt(e) && (i._next = i.next, i.next = () => {
		let e = i._next();
		return e.done || (e.value = n(e.value)), e;
	}), i;
}
var ft = Array.prototype;
function pt(e, t, n, r, i, a) {
	let o = ct(e), s = o !== e && !/* @__PURE__ */ Xt(e), c = o[t];
	if (c !== ft[t]) {
		let t = c.apply(e, a);
		return s ? $t(t) : t;
	}
	let l = n;
	o !== e && (s ? l = function(t, r) {
		return n.call(this, lt(e, t), r, e);
	} : n.length > 2 && (l = function(t, r) {
		return n.call(this, t, r, e);
	}));
	let u = c.call(o, l, r);
	return s && i ? i(u) : u;
}
function mt(e, t, n, r) {
	let i = ct(e), a = i !== e && !/* @__PURE__ */ Xt(e), o = n, s = !1;
	i !== e && (a ? (s = r.length === 0, o = function(t, r, i) {
		return s && (s = !1, t = lt(e, t)), n.call(this, t, lt(e, r), i, e);
	}) : n.length > 3 && (o = function(t, r, i) {
		return n.call(this, t, r, i, e);
	}));
	let c = i[t](o, ...r);
	return s ? lt(e, c) : c;
}
function ht(e, t, n) {
	let r = /* @__PURE__ */ R(e);
	it(r, "iterate", rt);
	let i = r[t](...n);
	return (i === -1 || i === !1) && /* @__PURE__ */ Zt(n[0]) ? (n[0] = /* @__PURE__ */ R(n[0]), r[t](...n)) : i;
}
function gt(e, t, n = []) {
	qe(), Le();
	let r = (/* @__PURE__ */ R(e))[t].apply(e, n);
	return Re(), Je(), r;
}
var _t = /* @__PURE__ */ e("__proto__,__v_isRef,__isVue"), vt = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(_));
function yt(e) {
	_(e) || (e = String(e));
	let t = /* @__PURE__ */ R(this);
	return it(t, "has", e), t.hasOwnProperty(e);
}
var bt = class {
	constructor(e = !1, t = !1) {
		this._isReadonly = e, this._isShallow = t;
	}
	get(e, t, n) {
		if (t === "__v_skip") return e.__v_skip;
		let r = this._isReadonly, i = this._isShallow;
		if (t === "__v_isReactive") return !r;
		if (t === "__v_isReadonly") return r;
		if (t === "__v_isShallow") return i;
		if (t === "__v_raw") return n === (r ? i ? Vt : Bt : i ? zt : Rt).get(e) || Object.getPrototypeOf(e) === Object.getPrototypeOf(n) ? e : void 0;
		let a = d(e);
		if (!r) {
			let e;
			if (a && (e = ut[t])) return e;
			if (t === "hasOwnProperty") return yt;
		}
		let o = Reflect.get(e, t, /* @__PURE__ */ z(e) ? e : n);
		if ((_(t) ? vt.has(t) : _t(t)) || (r || it(e, "get", t), i)) return o;
		if (/* @__PURE__ */ z(o)) {
			let e = a && w(t) ? o : o.value;
			return r && v(e) ? /* @__PURE__ */ Gt(e) : e;
		}
		return v(o) ? r ? /* @__PURE__ */ Gt(o) : /* @__PURE__ */ Ut(o) : o;
	}
}, xt = class extends bt {
	constructor(e = !1) {
		super(!1, e);
	}
	set(e, t, n, r) {
		let i = e[t], a = d(e) && w(t);
		if (!this._isShallow) {
			let r = /* @__PURE__ */ Yt(i);
			if (!/* @__PURE__ */ Xt(n) && !/* @__PURE__ */ Yt(n) && (i = /* @__PURE__ */ R(i), n = /* @__PURE__ */ R(n)), !a && /* @__PURE__ */ z(i) && !/* @__PURE__ */ z(n)) return r ? (process.env.NODE_ENV !== "production" && Ee(`Set operation on key "${String(t)}" failed: target is readonly.`, e[t]), !0) : (i.value = n, !0);
		}
		let o = a ? Number(t) < e.length : u(e, t), s = Reflect.set(e, t, n, /* @__PURE__ */ z(e) ? e : r);
		return e === /* @__PURE__ */ R(r) && s && (o ? j(n, i) && at(e, "set", t, n, i) : at(e, "add", t, n)), s;
	}
	deleteProperty(e, t) {
		let n = u(e, t), r = e[t], i = Reflect.deleteProperty(e, t);
		return i && n && at(e, "delete", t, void 0, r), i;
	}
	has(e, t) {
		let n = Reflect.has(e, t);
		return (!_(t) || !vt.has(t)) && it(e, "has", t), n;
	}
	ownKeys(e) {
		return it(e, "iterate", d(e) ? "length" : tt), Reflect.ownKeys(e);
	}
}, St = class extends bt {
	constructor(e = !1) {
		super(!0, e);
	}
	set(e, t) {
		return process.env.NODE_ENV !== "production" && Ee(`Set operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
	deleteProperty(e, t) {
		return process.env.NODE_ENV !== "production" && Ee(`Delete operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
}, Ct = /* @__PURE__ */ new xt(), wt = /* @__PURE__ */ new St(), Tt = /* @__PURE__ */ new xt(!0), Et = /* @__PURE__ */ new St(!0), Dt = (e) => e, Ot = (e) => Reflect.getPrototypeOf(e);
function kt(e, t, n) {
	return function(...r) {
		let i = this.__v_raw, a = /* @__PURE__ */ R(i), o = f(a), c = e === "entries" || e === Symbol.iterator && o, l = e === "keys" && o, u = i[e](...r), d = n ? Dt : t ? en : $t;
		return !t && it(a, "iterate", l ? nt : tt), s(Object.create(u), { next() {
			let { value: e, done: t } = u.next();
			return t ? {
				value: e,
				done: t
			} : {
				value: c ? [d(e[0]), d(e[1])] : d(e),
				done: t
			};
		} });
	};
}
function At(e) {
	return function(...t) {
		if (process.env.NODE_ENV !== "production") {
			let n = t[0] ? `on key "${t[0]}" ` : "";
			Ee(`${k(e)} operation ${n}failed: target is readonly.`, /* @__PURE__ */ R(this));
		}
		return e === "delete" ? !1 : e === "clear" ? void 0 : this;
	};
}
function jt(e, t) {
	let n = {
		get(n) {
			let r = this.__v_raw, i = /* @__PURE__ */ R(r), a = /* @__PURE__ */ R(n);
			e || (j(n, a) && it(i, "get", n), it(i, "get", a));
			let { has: o } = Ot(i), s = t ? Dt : e ? en : $t;
			if (o.call(i, n)) return s(r.get(n));
			if (o.call(i, a)) return s(r.get(a));
			r !== i && r.get(n);
		},
		get size() {
			let t = this.__v_raw;
			return !e && it(/* @__PURE__ */ R(t), "iterate", tt), t.size;
		},
		has(t) {
			let n = this.__v_raw, r = /* @__PURE__ */ R(n), i = /* @__PURE__ */ R(t);
			return e || (j(t, i) && it(r, "has", t), it(r, "has", i)), t === i ? n.has(t) : n.has(t) || n.has(i);
		},
		forEach(n, r) {
			let i = this, a = i.__v_raw, o = /* @__PURE__ */ R(a), s = t ? Dt : e ? en : $t;
			return !e && it(o, "iterate", tt), a.forEach((e, t) => n.call(r, s(e), s(t), i));
		}
	};
	return s(n, e ? {
		add: At("add"),
		set: At("set"),
		delete: At("delete"),
		clear: At("clear")
	} : {
		add(e) {
			let n = /* @__PURE__ */ R(this), r = Ot(n), i = /* @__PURE__ */ R(e), a = !t && !/* @__PURE__ */ Xt(e) && !/* @__PURE__ */ Yt(e) ? i : e;
			return r.has.call(n, a) || j(e, a) && r.has.call(n, e) || j(i, a) && r.has.call(n, i) || (n.add(a), at(n, "add", a, a)), this;
		},
		set(e, n) {
			!t && !/* @__PURE__ */ Xt(n) && !/* @__PURE__ */ Yt(n) && (n = /* @__PURE__ */ R(n));
			let r = /* @__PURE__ */ R(this), { has: i, get: a } = Ot(r), o = i.call(r, e);
			o ? process.env.NODE_ENV !== "production" && Lt(r, i, e) : (e = /* @__PURE__ */ R(e), o = i.call(r, e));
			let s = a.call(r, e);
			return r.set(e, n), o ? j(n, s) && at(r, "set", e, n, s) : at(r, "add", e, n), this;
		},
		delete(e) {
			let t = /* @__PURE__ */ R(this), { has: n, get: r } = Ot(t), i = n.call(t, e);
			i ? process.env.NODE_ENV !== "production" && Lt(t, n, e) : (e = /* @__PURE__ */ R(e), i = n.call(t, e));
			let a = r ? r.call(t, e) : void 0, o = t.delete(e);
			return i && at(t, "delete", e, void 0, a), o;
		},
		clear() {
			let e = /* @__PURE__ */ R(this), t = e.size !== 0, n = process.env.NODE_ENV === "production" ? void 0 : f(e) ? new Map(e) : new Set(e), r = e.clear();
			return t && at(e, "clear", void 0, void 0, n), r;
		}
	}), [
		"keys",
		"values",
		"entries",
		Symbol.iterator
	].forEach((r) => {
		n[r] = kt(r, e, t);
	}), n;
}
function Mt(e, t) {
	let n = jt(e, t);
	return (t, r, i) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? t : Reflect.get(u(n, r) && r in t ? n : t, r, i);
}
var Nt = { get: /* @__PURE__ */ Mt(!1, !1) }, Pt = { get: /* @__PURE__ */ Mt(!1, !0) }, Ft = { get: /* @__PURE__ */ Mt(!0, !1) }, It = { get: /* @__PURE__ */ Mt(!0, !0) };
function Lt(e, t, n) {
	let r = /* @__PURE__ */ R(n);
	if (r !== n && t.call(e, r)) {
		let t = S(e);
		Ee(`Reactive ${t} contains both the raw and reactive versions of the same object${t === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
	}
}
var Rt = /* @__PURE__ */ new WeakMap(), zt = /* @__PURE__ */ new WeakMap(), Bt = /* @__PURE__ */ new WeakMap(), Vt = /* @__PURE__ */ new WeakMap();
function Ht(e) {
	switch (e) {
		case "Object":
		case "Array": return 1;
		case "Map":
		case "Set":
		case "WeakMap":
		case "WeakSet": return 2;
		default: return 0;
	}
}
// @__NO_SIDE_EFFECTS__
function Ut(e) {
	return /* @__PURE__ */ Yt(e) ? e : qt(e, !1, Ct, Nt, Rt);
}
// @__NO_SIDE_EFFECTS__
function Wt(e) {
	return qt(e, !1, Tt, Pt, zt);
}
// @__NO_SIDE_EFFECTS__
function Gt(e) {
	return qt(e, !0, wt, Ft, Bt);
}
// @__NO_SIDE_EFFECTS__
function Kt(e) {
	return qt(e, !0, Et, It, Vt);
}
function qt(e, t, n, r, i) {
	if (!v(e)) return process.env.NODE_ENV !== "production" && Ee(`value cannot be made ${t ? "readonly" : "reactive"}: ${String(e)}`), e;
	if (e.__v_raw && !(t && e.__v_isReactive) || e.__v_skip || !Object.isExtensible(e)) return e;
	let a = i.get(e);
	if (a) return a;
	let o = Ht(S(e));
	if (o === 0) return e;
	let s = new Proxy(e, o === 2 ? r : n);
	return i.set(e, s), s;
}
// @__NO_SIDE_EFFECTS__
function Jt(e) {
	return /* @__PURE__ */ Yt(e) ? /* @__PURE__ */ Jt(e.__v_raw) : !!(e && e.__v_isReactive);
}
// @__NO_SIDE_EFFECTS__
function Yt(e) {
	return !!(e && e.__v_isReadonly);
}
// @__NO_SIDE_EFFECTS__
function Xt(e) {
	return !!(e && e.__v_isShallow);
}
// @__NO_SIDE_EFFECTS__
function Zt(e) {
	return e ? !!e.__v_raw : !1;
}
// @__NO_SIDE_EFFECTS__
function R(e) {
	let t = e && e.__v_raw;
	return t ? /* @__PURE__ */ R(t) : e;
}
function Qt(e) {
	return !u(e, "__v_skip") && Object.isExtensible(e) && M(e, "__v_skip", !0), e;
}
var $t = (e) => v(e) ? /* @__PURE__ */ Ut(e) : e, en = (e) => v(e) ? /* @__PURE__ */ Gt(e) : e;
// @__NO_SIDE_EFFECTS__
function z(e) {
	return e ? e.__v_isRef === !0 : !1;
}
// @__NO_SIDE_EFFECTS__
function B(e) {
	return nn(e, !1);
}
// @__NO_SIDE_EFFECTS__
function tn(e) {
	return nn(e, !0);
}
function nn(e, t) {
	return /* @__PURE__ */ z(e) ? e : new rn(e, t);
}
var rn = class {
	constructor(e, t) {
		this.dep = new Qe(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = t ? e : /* @__PURE__ */ R(e), this._value = t ? e : $t(e), this.__v_isShallow = t;
	}
	get value() {
		return process.env.NODE_ENV === "production" ? this.dep.track() : this.dep.track({
			target: this,
			type: "get",
			key: "value"
		}), this._value;
	}
	set value(e) {
		let t = this._rawValue, n = this.__v_isShallow || /* @__PURE__ */ Xt(e) || /* @__PURE__ */ Yt(e);
		e = n ? e : /* @__PURE__ */ R(e), j(e, t) && (this._rawValue = e, this._value = n ? e : $t(e), process.env.NODE_ENV === "production" ? this.dep.trigger() : this.dep.trigger({
			target: this,
			type: "set",
			key: "value",
			newValue: e,
			oldValue: t
		}));
	}
};
function an(e) {
	e.dep && (process.env.NODE_ENV === "production" ? e.dep.trigger() : e.dep.trigger({
		target: e,
		type: "set",
		key: "value",
		newValue: e._value
	}));
}
function V(e) {
	return /* @__PURE__ */ z(e) ? e.value : e;
}
function on(e) {
	return h(e) ? e() : V(e);
}
var sn = {
	get: (e, t, n) => t === "__v_raw" ? e : V(Reflect.get(e, t, n)),
	set: (e, t, n, r) => {
		let i = e[t];
		return /* @__PURE__ */ z(i) && !/* @__PURE__ */ z(n) ? (i.value = n, !0) : Reflect.set(e, t, n, r);
	}
};
function cn(e) {
	return /* @__PURE__ */ Jt(e) ? e : new Proxy(e, sn);
}
var ln = class {
	constructor(e) {
		this.__v_isRef = !0, this._value = void 0;
		let t = this.dep = new Qe(), { get: n, set: r } = e(t.track.bind(t), t.trigger.bind(t));
		this._get = n, this._set = r;
	}
	get value() {
		return this._value = this._get();
	}
	set value(e) {
		this._set(e);
	}
};
function un(e) {
	return new ln(e);
}
// @__NO_SIDE_EFFECTS__
function dn(e) {
	process.env.NODE_ENV !== "production" && !/* @__PURE__ */ Zt(e) && Ee("toRefs() expects a reactive object but received a plain one.");
	let t = d(e) ? Array(e.length) : {};
	for (let n in e) t[n] = hn(e, n);
	return t;
}
var fn = class {
	constructor(e, t, n) {
		this._object = e, this._defaultValue = n, this.__v_isRef = !0, this._value = void 0, this._key = _(t) ? t : String(t), this._raw = /* @__PURE__ */ R(e);
		let r = !0, i = e;
		if (!d(e) || _(this._key) || !w(this._key)) do
			r = !/* @__PURE__ */ Zt(i) || /* @__PURE__ */ Xt(i);
		while (r && (i = i.__v_raw));
		this._shallow = r;
	}
	get value() {
		let e = this._object[this._key];
		return this._shallow && (e = V(e)), this._value = e === void 0 ? this._defaultValue : e;
	}
	set value(e) {
		if (this._shallow && /* @__PURE__ */ z(this._raw[this._key])) {
			let t = this._object[this._key];
			if (/* @__PURE__ */ z(t)) {
				t.value = e;
				return;
			}
		}
		this._object[this._key] = e;
	}
	get dep() {
		return ot(this._raw, this._key);
	}
}, pn = class {
	constructor(e) {
		this._getter = e, this.__v_isRef = !0, this.__v_isReadonly = !0, this._value = void 0;
	}
	get value() {
		return this._value = this._getter();
	}
};
// @__NO_SIDE_EFFECTS__
function mn(e, t, n) {
	return /* @__PURE__ */ z(e) ? e : h(e) ? new pn(e) : v(e) && arguments.length > 1 ? hn(e, t, n) : /* @__PURE__ */ B(e);
}
function hn(e, t, n) {
	return new fn(e, t, n);
}
var gn = class {
	constructor(e, t, n) {
		this.fn = e, this.setter = t, this._value = void 0, this.dep = new Qe(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = Xe - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !t, this.isSSR = n;
	}
	notify() {
		if (this.flags |= 16, !(this.flags & 8) && L !== this) return Ie(this, !0), !0;
		process.env.NODE_ENV;
	}
	get value() {
		let e = process.env.NODE_ENV === "production" ? this.dep.track() : this.dep.track({
			target: this,
			type: "get",
			key: "value"
		});
		return He(this), e && (e.version = this.dep.version), this._value;
	}
	set value(e) {
		this.setter ? this.setter(e) : process.env.NODE_ENV !== "production" && Ee("Write operation failed: computed value is readonly");
	}
};
// @__NO_SIDE_EFFECTS__
function _n(e, t, n = !1) {
	let r, i;
	h(e) ? r = e : (r = e.get, i = e.set);
	let a = new gn(r, i, n);
	return process.env.NODE_ENV !== "production" && t && !n && (a.onTrack = t.onTrack, a.onTrigger = t.onTrigger), a;
}
var vn = {}, yn = /* @__PURE__ */ new WeakMap(), bn = void 0;
function xn(e, t = !1, n = bn) {
	if (n) {
		let t = yn.get(n);
		t || yn.set(n, t = []), t.push(e);
	} else process.env.NODE_ENV !== "production" && !t && Ee("onWatcherCleanup() was called when there was no active watcher to associate with.");
}
function Sn(e, n, i = t) {
	let { immediate: a, deep: o, once: s, scheduler: l, augmentJob: u, call: f } = i, p = (e) => {
		(i.onWarn || Ee)("Invalid watch source: ", e, "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.");
	}, m = (e) => o ? e : /* @__PURE__ */ Xt(e) || o === !1 || o === 0 ? Cn(e, 1) : Cn(e), g, _, v, y, b = !1, x = !1;
	if (/* @__PURE__ */ z(e) ? (_ = () => e.value, b = /* @__PURE__ */ Xt(e)) : /* @__PURE__ */ Jt(e) ? (_ = () => m(e), b = !0) : d(e) ? (x = !0, b = e.some((e) => /* @__PURE__ */ Jt(e) || /* @__PURE__ */ Xt(e)), _ = () => e.map((e) => {
		if (/* @__PURE__ */ z(e)) return e.value;
		if (/* @__PURE__ */ Jt(e)) return m(e);
		if (h(e)) return f ? f(e, 2) : e();
		process.env.NODE_ENV !== "production" && p(e);
	})) : h(e) ? _ = n ? f ? () => f(e, 2) : e : () => {
		if (v) {
			qe();
			try {
				v();
			} finally {
				Je();
			}
		}
		let t = bn;
		bn = g;
		try {
			return f ? f(e, 3, [y]) : e(y);
		} finally {
			bn = t;
		}
	} : (_ = r, process.env.NODE_ENV !== "production" && p(e)), n && o) {
		let e = _, t = o === !0 ? Infinity : o;
		_ = () => Cn(e(), t);
	}
	let S = ke(), C = () => {
		g.stop(), S && S.active && c(S.effects, g);
	};
	if (s && n) {
		let e = n;
		n = (...t) => {
			let n = e(...t);
			return C(), n;
		};
	}
	let w = x ? Array(e.length).fill(vn) : vn, T = (e) => {
		if (g.flags & 1 && (g.dirty || e)) {
			if (n) {
				let t = g.run();
				if (e || o || b || (x ? t.some((e, t) => j(e, w[t])) : j(t, w))) {
					v && v();
					let e = bn;
					bn = g;
					try {
						let e = [
							t,
							w === vn ? void 0 : x && w[0] === vn ? [] : w,
							y
						];
						w = t, f ? f(n, 3, e) : n(...e);
					} finally {
						bn = e;
					}
				}
			} else g.run();
		}
	};
	return u && u(T), g = new Me(_), g.scheduler = l ? () => l(T, !1) : T, y = (e) => xn(e, !1, g), v = g.onStop = () => {
		let e = yn.get(g);
		if (e) {
			if (f) f(e, 4);
			else for (let t of e) t();
			yn.delete(g);
		}
	}, process.env.NODE_ENV !== "production" && (g.onTrack = i.onTrack, g.onTrigger = i.onTrigger), n ? a ? T(!0) : w = g.run() : l ? l(T.bind(null, !0), !0) : g.run(), C.pause = g.pause.bind(g), C.resume = g.resume.bind(g), C.stop = C, C;
}
function Cn(e, t = Infinity, n) {
	if (t <= 0 || !v(e) || e.__v_skip || (n ||= /* @__PURE__ */ new Map(), (n.get(e) || 0) >= t)) return e;
	if (n.set(e, t), t--, /* @__PURE__ */ z(e)) Cn(e.value, t, n);
	else if (d(e)) for (let r = 0; r < e.length; r++) Cn(e[r], t, n);
	else if (p(e) || f(e)) e.forEach((e) => {
		Cn(e, t, n);
	});
	else if (C(e)) {
		for (let r in e) Cn(e[r], t, n);
		for (let r of Object.getOwnPropertySymbols(e)) Object.prototype.propertyIsEnumerable.call(e, r) && Cn(e[r], t, n);
	}
	return e;
}
//#endregion
//#region ../../node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js
var wn = [];
function Tn(e) {
	wn.push(e);
}
function En() {
	wn.pop();
}
var Dn = !1;
function H(e, ...t) {
	if (Dn) return;
	Dn = !0, qe();
	let n = wn.length ? wn[wn.length - 1].component : null, r = n && n.appContext.config.warnHandler, i = On();
	if (r) Pn(r, n, 11, [
		e + t.map((e) => e.toString?.call(e) ?? JSON.stringify(e)).join(""),
		n && n.proxy,
		i.map(({ vnode: e }) => `at <${ws(n, e.type)}>`).join("\n"),
		i
	]);
	else {
		let n = [`[Vue warn]: ${e}`, ...t];
		i.length && n.push("\n", ...kn(i)), console.warn(...n);
	}
	Je(), Dn = !1;
}
function On() {
	let e = wn[wn.length - 1];
	if (!e) return [];
	let t = [];
	for (; e;) {
		let n = t[0];
		n && n.vnode === e ? n.recurseCount++ : t.push({
			vnode: e,
			recurseCount: 0
		});
		let r = e.component && e.component.parent;
		e = r && r.vnode;
	}
	return t;
}
function kn(e) {
	let t = [];
	return e.forEach((e, n) => {
		t.push(...n === 0 ? [] : ["\n"], ...An(e));
	}), t;
}
function An({ vnode: e, recurseCount: t }) {
	let n = t > 0 ? `... (${t} recursive calls)` : "", r = e.component ? e.component.parent == null : !1, i = ` at <${ws(e.component, e.type, r)}`, a = ">" + n;
	return e.props ? [
		i,
		...jn(e.props),
		a
	] : [i + a];
}
function jn(e) {
	let t = [], n = Object.keys(e);
	return n.slice(0, 3).forEach((n) => {
		t.push(...Mn(n, e[n]));
	}), n.length > 3 && t.push(" ..."), t;
}
function Mn(e, t, n) {
	return g(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : /* @__PURE__ */ z(t) ? (t = Mn(e, /* @__PURE__ */ R(t.value), !0), n ? t : [
		`${e}=Ref<`,
		t,
		">"
	]) : h(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = /* @__PURE__ */ R(t), n ? t : [`${e}=`, t]);
}
var Nn = {
	sp: "serverPrefetch hook",
	bc: "beforeCreate hook",
	c: "created hook",
	bm: "beforeMount hook",
	m: "mounted hook",
	bu: "beforeUpdate hook",
	u: "updated",
	bum: "beforeUnmount hook",
	um: "unmounted hook",
	a: "activated hook",
	da: "deactivated hook",
	ec: "errorCaptured hook",
	rtc: "renderTracked hook",
	rtg: "renderTriggered hook",
	0: "setup function",
	1: "render function",
	2: "watcher getter",
	3: "watcher callback",
	4: "watcher cleanup function",
	5: "native event handler",
	6: "component event handler",
	7: "vnode hook",
	8: "directive hook",
	9: "transition hook",
	10: "app errorHandler",
	11: "app warnHandler",
	12: "ref function",
	13: "async component loader",
	14: "scheduler flush",
	15: "component update",
	16: "app unmount cleanup function"
};
function Pn(e, t, n, r) {
	try {
		return r ? e(...r) : e();
	} catch (e) {
		In(e, t, n);
	}
}
function Fn(e, t, n, r) {
	if (h(e)) {
		let i = Pn(e, t, n, r);
		return i && y(i) && i.catch((e) => {
			In(e, t, n);
		}), i;
	}
	if (d(e)) {
		let i = [];
		for (let a = 0; a < e.length; a++) i.push(Fn(e[a], t, n, r));
		return i;
	}
	process.env.NODE_ENV !== "production" && H(`Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`);
}
function In(e, n, r, i = !0) {
	let a = n ? n.vnode : null, { errorHandler: o, throwUnhandledErrorInProduction: s } = n && n.appContext.config || t;
	if (n) {
		let t = n.parent, i = n.proxy, a = process.env.NODE_ENV === "production" ? `https://vuejs.org/error-reference/#runtime-${r}` : Nn[r];
		for (; t;) {
			let n = t.ec;
			if (n) {
				for (let t = 0; t < n.length; t++) if (n[t](e, i, a) === !1) return;
			}
			t = t.parent;
		}
		if (o) {
			qe(), Pn(o, null, 10, [
				e,
				i,
				a
			]), Je();
			return;
		}
	}
	Ln(e, r, a, i, s);
}
function Ln(e, t, n, r = !0, i = !1) {
	if (process.env.NODE_ENV !== "production") {
		let i = Nn[t];
		if (n && Tn(n), H(`Unhandled error${i ? ` during execution of ${i}` : ""}`), n && En(), r) throw e;
		console.error(e);
	} else if (i) throw e;
	else console.error(e);
}
var Rn = [], zn = -1, Bn = [], Vn = null, Hn = 0, Un = /* @__PURE__ */ Promise.resolve(), Wn = null, Gn = 100;
function Kn(e) {
	let t = Wn || Un;
	return e ? t.then(this ? e.bind(this) : e) : t;
}
function qn(e) {
	let t = zn + 1, n = Rn.length;
	for (; t < n;) {
		let r = t + n >>> 1, i = Rn[r], a = $n(i);
		a < e || a === e && i.flags & 2 ? t = r + 1 : n = r;
	}
	return t;
}
function Jn(e) {
	if (!(e.flags & 1)) {
		let t = $n(e), n = Rn[Rn.length - 1];
		!n || !(e.flags & 2) && t >= $n(n) ? Rn.push(e) : Rn.splice(qn(t), 0, e), e.flags |= 1, Yn();
	}
}
function Yn() {
	Wn ||= Un.then(er);
}
function Xn(e) {
	if (!d(e)) Vn && e.id === -1 ? Vn.splice(Hn + 1, 0, e) : e.flags & 1 || (Bn.push(e), e.flags |= 1);
	else for (let t = 0; t < e.length; t++) Bn.push(e[t]);
	Yn();
}
function Zn(e, t, n = zn + 1) {
	for (process.env.NODE_ENV !== "production" && (t ||= /* @__PURE__ */ new Map()); n < Rn.length; n++) {
		let r = Rn[n];
		if (r && r.flags & 2) {
			if (e && r.id !== e.uid || process.env.NODE_ENV !== "production" && tr(t, r)) continue;
			Rn.splice(n, 1), n--, r.flags & 4 && (r.flags &= -2), r(), r.flags & 4 || (r.flags &= -2);
		}
	}
}
function Qn(e) {
	if (Bn.length) {
		let t = [...new Set(Bn)].sort((e, t) => $n(e) - $n(t));
		if (Bn.length = 0, Vn) {
			for (let e = 0; e < t.length; e++) Vn.push(t[e]);
			return;
		}
		for (Vn = t, process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map()), Hn = 0; Hn < Vn.length; Hn++) {
			let t = Vn[Hn];
			process.env.NODE_ENV !== "production" && tr(e, t) || (t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2);
		}
		Vn = null, Hn = 0;
	}
}
var $n = (e) => e.id == null ? e.flags & 2 ? -1 : Infinity : e.id;
function er(e) {
	process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map());
	let t = process.env.NODE_ENV === "production" ? r : (t) => tr(e, t);
	try {
		for (zn = 0; zn < Rn.length; zn++) {
			let e = Rn[zn];
			if (e && !(e.flags & 8)) {
				if (process.env.NODE_ENV !== "production" && t(e)) continue;
				e.flags & 4 && (e.flags &= -2), Pn(e, e.i, e.i ? 15 : 14), e.flags & 4 || (e.flags &= -2);
			}
		}
	} finally {
		for (; zn < Rn.length; zn++) {
			let e = Rn[zn];
			e && (e.flags &= -2);
		}
		zn = -1, Rn.length = 0, Qn(e), Wn = null, (Rn.length || Bn.length) && er(e);
	}
}
function tr(e, t) {
	let n = e.get(t) || 0;
	if (n > Gn) {
		let e = t.i, n = e && Cs(e.type);
		return In(`Maximum recursive updates exceeded${n ? ` in component <${n}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10), !0;
	}
	return e.set(t, n + 1), !1;
}
var nr = !1, rr = (e) => {
	try {
		return nr;
	} finally {
		nr = e;
	}
}, ir = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (ae().__VUE_HMR_RUNTIME__ = {
	createRecord: pr(cr),
	rerender: pr(ur),
	reload: pr(dr)
});
var ar = /* @__PURE__ */ new Map();
function or(e) {
	let t = e.type.__hmrId, n = ar.get(t);
	n ||= (cr(t, e.type), ar.get(t)), n.instances.add(e);
}
function sr(e) {
	ar.get(e.type.__hmrId).instances.delete(e);
}
function cr(e, t) {
	return !ar.has(e) && (ar.set(e, {
		initialDef: lr(t),
		instances: /* @__PURE__ */ new Set()
	}), !0);
}
function lr(e) {
	return Ts(e) ? e.__vccOpts : e;
}
function ur(e, t) {
	let n = ar.get(e);
	n && (n.initialDef.render = t, [...n.instances].forEach((e) => {
		t && (e.render = t, lr(e.type).render = t), e.renderCache = [], nr = !0, e.job.flags & 8 || e.update(), nr = !1;
	}));
}
function dr(e, t) {
	let n = ar.get(e);
	if (!n) return;
	t = lr(t), fr(n.initialDef, t);
	let r = [...n.instances];
	for (let e = 0; e < r.length; e++) {
		let i = r[e], a = lr(i.type), o = ir.get(a);
		o || (a !== n.initialDef && fr(a, t), ir.set(a, o = /* @__PURE__ */ new Set())), o.add(i), i.appContext.propsCache.delete(i.type), i.appContext.emitsCache.delete(i.type), i.appContext.optionsCache.delete(i.type), i.ceReload ? (o.add(i), i.ceReload(t.styles), o.delete(i)) : i.parent ? Jn(() => {
			i.job.flags & 8 || (nr = !0, i.parent.update(), nr = !1, o.delete(i));
		}) : i.appContext.reload ? i.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn("[HMR] Root or manually mounted instance modified. Full reload required."), i.root.ce && i !== i.root && i.root.ce._removeChildStyle(a);
	}
	Xn(() => {
		ir.clear();
	});
}
function fr(e, t) {
	s(e, t);
	for (let n in e) n !== "__file" && !(n in t) && delete e[n];
}
function pr(e) {
	return (t, n) => {
		try {
			return e(t, n);
		} catch (e) {
			console.error(e), console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
		}
	};
}
var mr, hr = [], gr = !1;
function _r(e, ...t) {
	mr ? mr.emit(e, ...t) : gr || hr.push({
		event: e,
		args: t
	});
}
function vr(e, t) {
	mr = e, mr ? (mr.enabled = !0, hr.forEach(({ event: e, args: t }) => mr.emit(e, ...t)), hr = []) : typeof window < "u" && window.HTMLElement && !(window.navigator?.userAgent)?.includes("jsdom") ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((e) => {
		vr(e, t);
	}), setTimeout(() => {
		mr || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, gr = !0, hr = []);
	}, 3e3)) : (gr = !0, hr = []);
}
function yr(e, t) {
	_r("app:init", e, t, {
		Fragment: To,
		Text: Eo,
		Comment: Do,
		Static: Oo
	});
}
function br(e) {
	_r("app:unmount", e);
}
var xr = /* @__PURE__ */ Tr("component:added"), Sr = /* @__PURE__ */ Tr("component:updated"), Cr = /* @__PURE__ */ Tr("component:removed"), wr = (e) => {
	mr && typeof mr.cleanupBuffer == "function" && !mr.cleanupBuffer(e) && Cr(e);
};
// @__NO_SIDE_EFFECTS__
function Tr(e) {
	return (t) => {
		_r(e, t.appContext.app, t.uid, t.parent ? t.parent.uid : void 0, t);
	};
}
var Er = /* @__PURE__ */ Or("perf:start"), Dr = /* @__PURE__ */ Or("perf:end");
function Or(e) {
	return (t, n, r) => {
		_r(e, t.appContext.app, t.uid, t, n, r);
	};
}
function kr(e, t, n) {
	_r("component:emit", e.appContext.app, e, t, n);
}
var Ar = null, jr = null;
function Mr(e) {
	let t = Ar;
	return Ar = e, jr = e && e.type.__scopeId || null, t;
}
function U(e, t = Ar, n) {
	if (!t || e._n) return e;
	let r = (...n) => {
		r._d && No(-1);
		let i = Mr(t), a = ko.length, o;
		try {
			o = e(...n);
		} finally {
			for (let e = ko.length; e > a; e--) jo();
			Mr(i), r._d && No(1);
		}
		return process.env.NODE_ENV !== "production" && Sr(t), o;
	};
	return r._n = !0, r._c = !0, r._d = !0, r;
}
function Nr(e) {
	ee(e) && H("Do not use built-in directive ids as custom directive id: " + e);
}
function Pr(e, t, n, r) {
	let i = e.dirs, a = t && t.dirs;
	for (let o = 0; o < i.length; o++) {
		let s = i[o];
		a && (s.oldValue = a[o].value);
		let c = s.dir[r];
		c && (qe(), Fn(c, n, 8, [
			e.el,
			s,
			e,
			t
		]), Je());
	}
}
function Fr(e, t) {
	if (process.env.NODE_ENV !== "production" && (!Y || Y.isMounted) && H("provide() can only be used inside setup()."), Y) {
		let n = Y.provides, r = Y.parent && Y.parent.provides;
		r === n && (n = Y.provides = Object.create(r)), n[e] = t;
	}
}
function Ir(e, t, n = !1) {
	let r = rs();
	if (r || fa) {
		let i = fa ? fa._context.provides : r ? r.parent == null || r.ce ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
		if (i && e in i) return i[e];
		if (arguments.length > 1) return n && h(t) ? t.call(r && r.proxy) : t;
		process.env.NODE_ENV !== "production" && H(`injection "${String(e)}" not found.`);
	} else process.env.NODE_ENV !== "production" && H("inject() can only be used inside setup() or functional components.");
}
function Lr() {
	return !!(rs() || fa);
}
var Rr = /* @__PURE__ */ Symbol.for("v-scx"), zr = () => {
	{
		let e = Ir(Rr);
		return e || process.env.NODE_ENV !== "production" && H("Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."), e;
	}
};
function Br(e, t) {
	return Ur(e, null, t);
}
function Vr(e, t) {
	return Ur(e, null, process.env.NODE_ENV === "production" ? { flush: "sync" } : s({}, t, { flush: "sync" }));
}
function Hr(e, t, n) {
	return process.env.NODE_ENV !== "production" && !h(t) && H("`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."), Ur(e, t, n);
}
function Ur(e, n, i = t) {
	let { immediate: a, deep: o, flush: c, once: l } = i;
	process.env.NODE_ENV !== "production" && !n && (a !== void 0 && H("watch() \"immediate\" option is only respected when using the watch(source, callback, options?) signature."), o !== void 0 && H("watch() \"deep\" option is only respected when using the watch(source, callback, options?) signature."), l !== void 0 && H("watch() \"once\" option is only respected when using the watch(source, callback, options?) signature."));
	let u = s({}, i);
	process.env.NODE_ENV !== "production" && (u.onWarn = H);
	let d = n && a || !n && c !== "post", f;
	if (ds) {
		if (c === "sync") {
			let e = zr();
			f = e.__watcherHandles ||= [];
		} else if (!d) {
			let e = () => {};
			return e.stop = r, e.resume = r, e.pause = r, e;
		}
	}
	let p = Y;
	u.call = (e, t, n) => Fn(e, p, t, n);
	let m = !1;
	c === "post" ? u.scheduler = (e) => {
		fo(e, p && p.suspense);
	} : c !== "sync" && (m = !0, u.scheduler = (e, t) => {
		t ? e() : Jn(e);
	}), u.augmentJob = (e) => {
		n && (e.flags |= 4), m && (e.flags |= 2, p && (e.id = p.uid, e.i = p));
	};
	let h = Sn(e, n, u);
	return ds && (f ? f.push(h) : d && h()), h;
}
function Wr(e, t, n) {
	let r = this.proxy, i = g(e) ? e.includes(".") ? Gr(r, e) : () => r[e] : e.bind(r, r), a;
	h(t) ? a = t : (a = t.handler, n = t);
	let o = os(this), s = Ur(i, a.bind(r), n);
	return o(), s;
}
function Gr(e, t) {
	let n = t.split(".");
	return () => {
		let t = e;
		for (let e = 0; e < n.length && t; e++) t = t[n[e]];
		return t;
	};
}
var Kr = /* @__PURE__ */ Symbol("_vte"), qr = (e) => e.__isTeleport, Jr = /* @__PURE__ */ Symbol("_leaveCb");
function Yr(e) {
	let t = e[0];
	if (e.length > 1) {
		let n = !1;
		for (let r of e) if (r.type !== Do) {
			if (process.env.NODE_ENV !== "production" && n) {
				H("<transition> can only be used on a single element or component. Use <transition-group> for lists.");
				break;
			}
			if (t = r, n = !0, process.env.NODE_ENV === "production") break;
		}
	}
	return t;
}
function Xr(e) {
	if (!ci(e)) return qr(e.type) && e.children ? Yr(e.children) : e;
	if (e.component) return e.component.subTree;
	let { shapeFlag: t, children: n } = e;
	if (n) {
		if (t & 16) return n[0];
		if (t & 32 && h(n.default)) return n.default();
	}
}
function Zr(e, t) {
	if (e.shapeFlag & 6 && e.component) {
		e.transition = t;
		let n = e.component.subTree;
		Zr(qr(n.type) && Xr(n) || n, t);
	} else e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
// @__NO_SIDE_EFFECTS__
function Qr(e, t) {
	return h(e) ? /* @__PURE__ */ s({ name: e.name }, t, { setup: e }) : e;
}
function $r() {
	let e = rs();
	return e ? (e.appContext.config.idPrefix || "v") + "-" + e.ids[0] + e.ids[1]++ : (process.env.NODE_ENV !== "production" && H("useId() is called when there is no active component instance to be associated with."), "");
}
function ei(e) {
	e.ids = [
		e.ids[0] + e.ids[2]++ + "-",
		0,
		0
	];
}
var ti = /* @__PURE__ */ new WeakSet();
function ni(e) {
	let n = rs(), r = /* @__PURE__ */ tn(null);
	if (n) {
		let i = n.refs === t ? n.refs = {} : n.refs;
		process.env.NODE_ENV !== "production" && ri(i, e) ? H(`useTemplateRef('${e}') already exists.`) : Object.defineProperty(i, e, {
			enumerable: !0,
			get: () => r.value,
			set: (e) => r.value = e
		});
	} else process.env.NODE_ENV !== "production" && H("useTemplateRef() is called when there is no active component instance to be associated with.");
	let i = process.env.NODE_ENV === "production" ? r : /* @__PURE__ */ Gt(r);
	return process.env.NODE_ENV !== "production" && ti.add(i), i;
}
function ri(e, t) {
	let n;
	return !!((n = Object.getOwnPropertyDescriptor(e, t)) && !n.configurable);
}
var ii = /* @__PURE__ */ new WeakMap();
function ai(e, n, r, a, o = !1) {
	if (d(e)) {
		e.forEach((e, t) => ai(e, n && (d(n) ? n[t] : n), r, a, o));
		return;
	}
	if (si(a) && !o) {
		a.shapeFlag & 512 && a.type.__asyncResolved && a.component.subTree.component && ai(e, n, r, a.component.subTree);
		return;
	}
	let s = a.shapeFlag & 4 ? bs(a.component) : a.el, l = o ? null : s, { i: f, r: p } = e;
	if (process.env.NODE_ENV !== "production" && !f) {
		H("Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function.");
		return;
	}
	let m = n && n.r, _ = f.refs === t ? f.refs = {} : f.refs, v = f.setupState, y = /* @__PURE__ */ R(v), b = v === t ? i : (e) => process.env.NODE_ENV !== "production" && (u(y, e) && !/* @__PURE__ */ z(y[e]) && H(`Template ref "${e}" used on a non-ref value. It will not work in the production build.`), ti.has(y[e])) || ri(_, e) ? !1 : u(y, e), x = (e, t) => !(process.env.NODE_ENV !== "production" && ti.has(e) || t && ri(_, t));
	if (m != null && m !== p) {
		if (oi(n), g(m)) _[m] = null, b(m) && (v[m] = null);
		else if (/* @__PURE__ */ z(m)) {
			let e = n;
			x(m, e.k) && (m.value = null), e.k && (_[e.k] = null);
		}
	}
	if (h(p)) Pn(p, f, 12, [l, _]);
	else {
		let t = g(p), n = /* @__PURE__ */ z(p);
		if (t || n) {
			let i = () => {
				if (e.f) {
					let n = t ? b(p) ? v[p] : _[p] : x(p) || !e.k ? p.value : _[e.k];
					if (o) d(n) && c(n, s);
					else if (d(n)) n.includes(s) || n.push(s);
					else if (t) _[p] = [s], b(p) && (v[p] = _[p]);
					else {
						let t = [s];
						x(p, e.k) && (p.value = t), e.k && (_[e.k] = t);
					}
				} else t ? (_[p] = l, b(p) && (v[p] = l)) : n ? (x(p, e.k) && (p.value = l), e.k && (_[e.k] = l)) : process.env.NODE_ENV !== "production" && H("Invalid template ref type:", p, `(${typeof p})`);
			};
			if (l) {
				let t = () => {
					i(), ii.delete(e);
				};
				t.id = -1, ii.set(e, t), fo(t, r);
			} else oi(e), i();
		} else process.env.NODE_ENV !== "production" && H("Invalid template ref type:", p, `(${typeof p})`);
	}
}
function oi(e) {
	let t = ii.get(e);
	t && (t.flags |= 8, ii.delete(e));
}
ae().requestIdleCallback, ae().cancelIdleCallback;
var si = (e) => !!e.type.__asyncLoader, ci = (e) => e.type.__isKeepAlive;
function li(e, t) {
	di(e, "a", t);
}
function ui(e, t) {
	di(e, "da", t);
}
function di(e, t, n = Y) {
	let r = e.__wdc ||= () => {
		let t = n;
		for (; t;) {
			if (t.isDeactivated) return;
			t = t.parent;
		}
		return e();
	};
	if (pi(t, r, n), n) {
		let e = n.parent;
		for (; e && e.parent;) ci(e.parent.vnode) && fi(r, t, n, e), e = e.parent;
	}
}
function fi(e, t, n, r) {
	let i = pi(t, e, r, !0);
	bi(() => {
		c(r[t], i);
	}, n);
}
function pi(e, t, n = Y, r = !1) {
	if (n) {
		let i = n[e] || (n[e] = []), a = t.__weh ||= (...r) => {
			qe();
			let i = os(n), a = Fn(t, n, e, r);
			return i(), Je(), a;
		};
		return r ? i.unshift(a) : i.push(a), a;
	}
	process.env.NODE_ENV !== "production" && H(`${A(Nn[e].replace(/ hook$/, ""))} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`);
}
var mi = (e) => (t, n = Y) => {
	(!ds || e === "sp") && pi(e, (...e) => t(...e), n);
}, hi = mi("bm"), gi = mi("m"), _i = mi("bu"), vi = mi("u"), yi = mi("bum"), bi = mi("um"), xi = mi("sp"), Si = mi("rtg"), Ci = mi("rtc");
function wi(e, t = Y) {
	pi("ec", e, t);
}
var Ti = "components", Ei = /* @__PURE__ */ Symbol.for("v-ndc");
function Di(e) {
	return g(e) ? Oi(Ti, e, !1) || e : e || Ei;
}
function Oi(e, t, n = !0, r = !1) {
	let i = Ar || Y;
	if (i) {
		let a = i.type;
		if (e === Ti) {
			let e = Cs(a, !1);
			if (e && (e === t || e === E(t) || e === k(E(t)))) return a;
		}
		let o = ki(i[e] || a[e], t) || ki(i.appContext[e], t);
		if (!o && r) return a;
		if (process.env.NODE_ENV !== "production" && n && !o) {
			let n = e === Ti ? "\nIf this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement." : "";
			H(`Failed to resolve ${e.slice(0, -1)}: ${t}${n}`);
		}
		return o;
	}
	process.env.NODE_ENV !== "production" && H(`resolve${k(e.slice(0, -1))} can only be used in render() or setup().`);
}
function ki(e, t) {
	return e && (e[t] || e[E(t)] || e[k(E(t))]);
}
function Ai(e, t, n, r) {
	let i, a = n && n[r], o = d(e);
	if (o || g(e)) {
		let n = o && /* @__PURE__ */ Jt(e), r = !1, s = !1;
		n && (r = !/* @__PURE__ */ Xt(e), s = /* @__PURE__ */ Yt(e), e = ct(e)), i = Array(e.length);
		for (let n = 0, o = e.length; n < o; n++) i[n] = t(r ? s ? en($t(e[n])) : $t(e[n]) : e[n], n, void 0, a && a[n]);
	} else if (typeof e == "number") {
		if (process.env.NODE_ENV !== "production" && (!Number.isInteger(e) || e < 0)) H(`The v-for range expects a positive integer value but got ${e}.`), i = [];
		else {
			i = Array(e);
			for (let n = 0; n < e; n++) i[n] = t(n + 1, n, void 0, a && a[n]);
		}
	} else if (v(e)) {
		if (e[Symbol.iterator]) i = Array.from(e, (e, n) => t(e, n, void 0, a && a[n]));
		else {
			let n = Object.keys(e);
			i = Array(n.length);
			for (let r = 0, o = n.length; r < o; r++) {
				let o = n[r];
				i[r] = t(e[o], o, r, a && a[r]);
			}
		}
	} else i = [];
	return n && (n[r] = i), i;
}
function W(e, t, n, r, i, a) {
	if (n ??= {}, Ar.ce || Ar.parent && si(Ar.parent) && Ar.parent.ce) {
		let e = a != null && n.key == null ? s({}, n, { key: a }) : n, i = Object.keys(e).length > 0;
		return t !== "default" && (e.name = t), G(), K(To, null, [q("slot", e, r && r())], i ? -2 : 64);
	}
	let o = e[t];
	process.env.NODE_ENV !== "production" && o && o.length > 1 && (H("SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template."), o = () => []), o && o._c && (o._d = !1);
	let c = ko.length;
	G();
	let l;
	try {
		let i = o && ji(o(n)), s = n.key || a || i && i.key;
		l = K(To, { key: (s && !_(s) ? s : `_${t}`) + (!i && r ? "_fb" : "") }, i || (r ? r() : []), i && e._ === 1 ? 64 : -2);
	} catch (e) {
		for (let e = ko.length; e > c; e--) jo();
		throw e;
	} finally {
		o && o._c && (o._d = !0);
	}
	return !i && l.scopeId && (l.slotScopeIds = [l.scopeId + "-s"]), l;
}
function ji(e) {
	return e.some((e) => !Io(e) || !(e.type === Do || e.type === To && !ji(e.children))) ? e : null;
}
var Mi = (e) => e ? us(e) ? bs(e) : Mi(e.parent) : null, Ni = (e) => {
	let t = !1;
	for (;;) {
		if (e.patchFlag > 0 && e.patchFlag & 2048) {
			let n = Ca(e.children);
			if (!n) return;
			e = n, t = !0;
			continue;
		}
		let n = e.component;
		if (n && n.subTree) {
			e = n.subTree;
			continue;
		}
		let r = e.suspense;
		if (r && r.activeBranch) {
			e = r.activeBranch;
			continue;
		}
		return t ? e.el : void 0;
	}
}, Pi = (e) => {
	let t = e.subTree && Ni(e.subTree);
	return t === void 0 ? e.vnode.el : t;
}, Fi = /* @__PURE__ */ s(/* @__PURE__ */ Object.create(null), {
	$: (e) => e,
	$el: (e) => process.env.NODE_ENV === "production" ? e.vnode.el : Pi(e),
	$data: (e) => e.data,
	$props: (e) => process.env.NODE_ENV === "production" ? e.props : /* @__PURE__ */ Kt(e.props),
	$attrs: (e) => process.env.NODE_ENV === "production" ? e.attrs : /* @__PURE__ */ Kt(e.attrs),
	$slots: (e) => process.env.NODE_ENV === "production" ? e.slots : /* @__PURE__ */ Kt(e.slots),
	$refs: (e) => process.env.NODE_ENV === "production" ? e.refs : /* @__PURE__ */ Kt(e.refs),
	$parent: (e) => Mi(e.parent),
	$root: (e) => Mi(e.root),
	$host: (e) => e.ce,
	$emit: (e) => e.emit,
	$options: (e) => $i(e),
	$forceUpdate: (e) => e.f ||= () => {
		Jn(e.update);
	},
	$nextTick: (e) => e.n ||= Kn.bind(e.proxy),
	$watch: (e) => Wr.bind(e)
}), Ii = (e) => e === "_" || e === "$", Li = (e, n) => e !== t && !e.__isScriptSetup && u(e, n), Ri = {
	get({ _: e }, n) {
		if (n === "__v_skip") return !0;
		let { ctx: r, setupState: i, data: a, props: o, accessCache: s, type: c, appContext: l } = e;
		if (process.env.NODE_ENV !== "production" && n === "__isVue") return !0;
		if (n[0] !== "$") {
			let e = s[n];
			if (e !== void 0) switch (e) {
				case 1: return i[n];
				case 2: return a[n];
				case 4: return r[n];
				case 3: return o[n];
			}
			else if (Li(i, n)) return s[n] = 1, i[n];
			else if (a !== t && u(a, n)) return s[n] = 2, a[n];
			else if (u(o, n)) return s[n] = 3, o[n];
			else if (r !== t && u(r, n)) return s[n] = 4, r[n];
			else Ji && (s[n] = 0);
		}
		let d = Fi[n], f, p;
		if (d) return n === "$attrs" ? (it(e.attrs, "get", ""), process.env.NODE_ENV !== "production" && ba()) : process.env.NODE_ENV !== "production" && n === "$slots" && it(e, "get", n), d(e);
		if ((f = c.__cssModules) && (f = f[n])) return f;
		if (r !== t && u(r, n)) return s[n] = 4, r[n];
		if (p = l.config.globalProperties, u(p, n)) return p[n];
		process.env.NODE_ENV !== "production" && Ar && (!g(n) || n.indexOf("__v") !== 0) && (a !== t && Ii(n[0]) && u(a, n) ? H(`Property ${JSON.stringify(n)} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`) : e === Ar && H(`Property ${JSON.stringify(n)} was accessed during render but is not defined on instance.`));
	},
	set({ _: e }, n, r) {
		let { data: i, setupState: a, ctx: o } = e;
		return Li(a, n) ? (a[n] = r, !0) : process.env.NODE_ENV !== "production" && a.__isScriptSetup && u(a, n) ? (H(`Cannot mutate <script setup> binding "${n}" from Options API.`), !1) : i !== t && u(i, n) ? (i[n] = r, !0) : u(e.props, n) ? (process.env.NODE_ENV !== "production" && H(`Attempting to mutate prop "${n}". Props are readonly.`), !1) : n[0] === "$" && n.slice(1) in e ? (process.env.NODE_ENV !== "production" && H(`Attempting to mutate public property "${n}". Properties starting with $ are reserved and readonly.`), !1) : (process.env.NODE_ENV !== "production" && n in e.appContext.config.globalProperties ? Object.defineProperty(o, n, {
			enumerable: !0,
			configurable: !0,
			value: r
		}) : o[n] = r, !0);
	},
	has({ _: { data: e, setupState: n, accessCache: r, ctx: i, appContext: a, props: o, type: s } }, c) {
		let l;
		return !!(r[c] || e !== t && c[0] !== "$" && u(e, c) || Li(n, c) || u(o, c) || u(i, c) || u(Fi, c) || u(a.config.globalProperties, c) || (l = s.__cssModules) && l[c]);
	},
	defineProperty(e, t, n) {
		return n.get == null ? u(n, "value") && this.set(e, t, n.value, null) : e._.accessCache[t] = 0, Reflect.defineProperty(e, t, n);
	}
};
process.env.NODE_ENV !== "production" && (Ri.ownKeys = (e) => (H("Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."), Reflect.ownKeys(e)));
function zi(e) {
	let t = {};
	return Object.defineProperty(t, "_", {
		configurable: !0,
		enumerable: !1,
		get: () => e
	}), Object.keys(Fi).forEach((n) => {
		Object.defineProperty(t, n, {
			configurable: !0,
			enumerable: !1,
			get: () => Fi[n](e),
			set: r
		});
	}), t;
}
function Bi(e) {
	let { ctx: t, propsOptions: [n] } = e;
	n && Object.keys(n).forEach((n) => {
		Object.defineProperty(t, n, {
			enumerable: !0,
			configurable: !0,
			get: () => e.props[n],
			set: r
		});
	});
}
function Vi(e) {
	let { ctx: t, setupState: n } = e;
	Object.keys(/* @__PURE__ */ R(n)).forEach((e) => {
		if (!n.__isScriptSetup) {
			if (Ii(e[0])) {
				H(`setup() return property ${JSON.stringify(e)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
				return;
			}
			Object.defineProperty(t, e, {
				enumerable: !0,
				configurable: !0,
				get: () => n[e],
				set: r
			});
		}
	});
}
function Hi() {
	return Wi("useSlots").slots;
}
function Ui() {
	return Wi("useAttrs").attrs;
}
function Wi(e) {
	let t = rs();
	return process.env.NODE_ENV !== "production" && !t && H(`${e}() called without active instance.`), t.setupContext ||= ys(t);
}
function Gi(e) {
	return d(e) ? e.reduce((e, t) => (e[t] = null, e), {}) : e;
}
function Ki(e, t) {
	return !e || !t ? e || t : d(e) && d(t) ? e.concat(t) : s({}, Gi(e), Gi(t));
}
function qi() {
	let e = /* @__PURE__ */ Object.create(null);
	return (t, n) => {
		e[n] ? H(`${t} property "${n}" is already defined in ${e[n]}.`) : e[n] = t;
	};
}
var Ji = !0;
function Yi(e) {
	let t = $i(e), n = e.proxy, i = e.ctx;
	Ji = !1, t.beforeCreate && Zi(t.beforeCreate, e, "bc");
	let { data: a, computed: o, methods: s, watch: c, provide: l, inject: u, created: f, beforeMount: p, mounted: m, beforeUpdate: g, updated: _, activated: b, deactivated: x, beforeDestroy: S, beforeUnmount: C, destroyed: w, unmounted: T, render: ee, renderTracked: te, renderTriggered: ne, errorCaptured: E, serverPrefetch: D, expose: O, inheritAttrs: k, components: A, directives: j, filters: re } = t, M = process.env.NODE_ENV === "production" ? null : qi();
	if (process.env.NODE_ENV !== "production") {
		let [t] = e.propsOptions;
		if (t) for (let e in t) M("Props", e);
	}
	if (u && Xi(u, i, M), s) for (let e in s) {
		let t = s[e];
		h(t) ? (process.env.NODE_ENV === "production" ? i[e] = t.bind(n) : Object.defineProperty(i, e, {
			value: t.bind(n),
			configurable: !0,
			enumerable: !0,
			writable: !0
		}), process.env.NODE_ENV !== "production" && M("Methods", e)) : process.env.NODE_ENV !== "production" && H(`Method "${e}" has type "${typeof t}" in the component definition. Did you reference the function correctly?`);
	}
	if (a) {
		process.env.NODE_ENV !== "production" && !h(a) && H("The data option must be a function. Plain object usage is no longer supported.");
		let t = a.call(n, n);
		if (process.env.NODE_ENV !== "production" && y(t) && H("data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>."), !v(t)) process.env.NODE_ENV !== "production" && H("data() should return an object.");
		else if (e.data = /* @__PURE__ */ Ut(t), process.env.NODE_ENV !== "production") for (let e in t) M("Data", e), Ii(e[0]) || Object.defineProperty(i, e, {
			configurable: !0,
			enumerable: !0,
			get: () => t[e],
			set: r
		});
	}
	if (Ji = !0, o) for (let e in o) {
		let t = o[e], a = h(t) ? t.bind(n, n) : h(t.get) ? t.get.bind(n, n) : r;
		process.env.NODE_ENV !== "production" && a === r && H(`Computed property "${e}" has no getter.`);
		let s = X({
			get: a,
			set: !h(t) && h(t.set) ? t.set.bind(n) : process.env.NODE_ENV === "production" ? r : () => {
				H(`Write operation failed: computed property "${e}" is readonly.`);
			}
		});
		Object.defineProperty(i, e, {
			enumerable: !0,
			configurable: !0,
			get: () => s.value,
			set: (e) => s.value = e
		}), process.env.NODE_ENV !== "production" && M("Computed", e);
	}
	if (c) for (let e in c) Qi(c[e], i, n, e);
	if (l) {
		let e = h(l) ? l.call(n) : l;
		Reflect.ownKeys(e).forEach((t) => {
			Fr(t, e[t]);
		});
	}
	f && Zi(f, e, "c");
	function N(e, t) {
		d(t) ? t.forEach((t) => e(t.bind(n))) : t && e(t.bind(n));
	}
	if (N(hi, p), N(gi, m), N(_i, g), N(vi, _), N(li, b), N(ui, x), N(wi, E), N(Ci, te), N(Si, ne), N(yi, C), N(bi, T), N(xi, D), d(O)) {
		if (O.length) {
			let t = e.exposed ||= {};
			O.forEach((e) => {
				Object.defineProperty(t, e, {
					get: () => n[e],
					set: (t) => n[e] = t,
					enumerable: !0
				});
			});
		} else e.exposed ||= {};
	}
	ee && e.render === r && (e.render = ee), k != null && (e.inheritAttrs = k), A && (e.components = A), j && (e.directives = j), D && ei(e);
}
function Xi(e, t, n = r) {
	d(e) && (e = ia(e));
	for (let r in e) {
		let i = e[r], a;
		a = v(i) ? "default" in i ? Ir(i.from || r, i.default, !0) : Ir(i.from || r) : Ir(i), /* @__PURE__ */ z(a) ? Object.defineProperty(t, r, {
			enumerable: !0,
			configurable: !0,
			get: () => a.value,
			set: (e) => a.value = e
		}) : t[r] = a, process.env.NODE_ENV !== "production" && n("Inject", r);
	}
}
function Zi(e, t, n) {
	Fn(d(e) ? e.map((e) => e.bind(t.proxy)) : e.bind(t.proxy), t, n);
}
function Qi(e, t, n, r) {
	let i = r.includes(".") ? Gr(n, r) : () => n[r];
	if (g(e)) {
		let n = t[e];
		h(n) ? Hr(i, n) : process.env.NODE_ENV !== "production" && H(`Invalid watch handler specified by key "${e}"`, n);
	} else if (h(e)) Hr(i, e.bind(n));
	else if (v(e)) {
		if (d(e)) e.forEach((e) => Qi(e, t, n, r));
		else {
			let r = h(e.handler) ? e.handler.bind(n) : t[e.handler];
			h(r) ? Hr(i, r, e) : process.env.NODE_ENV !== "production" && H(`Invalid watch handler specified by key "${e.handler}"`, r);
		}
	} else process.env.NODE_ENV !== "production" && H(`Invalid watch option: "${r}"`, e);
}
function $i(e) {
	let t = e.type, { mixins: n, extends: r } = t, { mixins: i, optionsCache: a, config: { optionMergeStrategies: o } } = e.appContext, s = a.get(t), c;
	return s ? c = s : !i.length && !n && !r ? c = t : (c = {}, i.length && i.forEach((e) => ea(c, e, o, !0)), ea(c, t, o)), v(t) && a.set(t, c), c;
}
function ea(e, t, n, r = !1) {
	let { mixins: i, extends: a } = t;
	a && ea(e, a, n, !0), i && i.forEach((t) => ea(e, t, n, !0));
	for (let i in t) if (r && i === "expose") process.env.NODE_ENV !== "production" && H("\"expose\" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.");
	else {
		let r = ta[i] || n && n[i];
		e[i] = r ? r(e[i], t[i]) : t[i];
	}
	return e;
}
var ta = {
	data: na,
	props: sa,
	emits: sa,
	methods: oa,
	computed: oa,
	beforeCreate: aa,
	created: aa,
	beforeMount: aa,
	mounted: aa,
	beforeUpdate: aa,
	updated: aa,
	beforeDestroy: aa,
	beforeUnmount: aa,
	destroyed: aa,
	unmounted: aa,
	activated: aa,
	deactivated: aa,
	errorCaptured: aa,
	serverPrefetch: aa,
	components: oa,
	directives: oa,
	watch: ca,
	provide: na,
	inject: ra
};
function na(e, t) {
	return t ? e ? function() {
		return s(h(e) ? e.call(this, this) : e, h(t) ? t.call(this, this) : t);
	} : t : e;
}
function ra(e, t) {
	return oa(ia(e), ia(t));
}
function ia(e) {
	if (d(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) t[e[n]] = e[n];
		return t;
	}
	return e;
}
function aa(e, t) {
	return e ? [...new Set([].concat(e, t))] : t;
}
function oa(e, t) {
	return e ? s(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function sa(e, t) {
	return e ? d(e) && d(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : s(/* @__PURE__ */ Object.create(null), Gi(e), Gi(t ?? {})) : t;
}
function ca(e, t) {
	if (!e) return t;
	if (!t) return e;
	let n = s(/* @__PURE__ */ Object.create(null), e);
	for (let r in t) n[r] = aa(e[r], t[r]);
	return n;
}
function la() {
	return {
		app: null,
		config: {
			isNativeTag: i,
			performance: !1,
			globalProperties: {},
			optionMergeStrategies: {},
			errorHandler: void 0,
			warnHandler: void 0,
			compilerOptions: {}
		},
		mixins: [],
		components: {},
		directives: {},
		provides: /* @__PURE__ */ Object.create(null),
		optionsCache: /* @__PURE__ */ new WeakMap(),
		propsCache: /* @__PURE__ */ new WeakMap(),
		emitsCache: /* @__PURE__ */ new WeakMap()
	};
}
var ua = 0;
function da(e, t) {
	return function(n, r = null) {
		h(n) || (n = s({}, n)), r != null && !v(r) && (process.env.NODE_ENV !== "production" && H("root props passed to app.mount() must be an object."), r = null);
		let i = la(), a = /* @__PURE__ */ new WeakSet(), o = [], c = !1, l = i.app = {
			_uid: ua++,
			_component: n,
			_props: r,
			_container: null,
			_context: i,
			_instance: null,
			version: Os,
			get config() {
				return i.config;
			},
			set config(e) {
				process.env.NODE_ENV !== "production" && H("app.config cannot be replaced. Modify individual options instead.");
			},
			use(e, ...t) {
				return a.has(e) ? process.env.NODE_ENV !== "production" && H("Plugin has already been applied to target app.") : e && h(e.install) ? (a.add(e), e.install(l, ...t)) : h(e) ? (a.add(e), e(l, ...t)) : process.env.NODE_ENV !== "production" && H("A plugin must either be a function or an object with an \"install\" function."), l;
			},
			mixin(e) {
				return i.mixins.includes(e) ? process.env.NODE_ENV !== "production" && H("Mixin has already been applied to target app" + (e.name ? `: ${e.name}` : "")) : i.mixins.push(e), l;
			},
			component(e, t) {
				return process.env.NODE_ENV !== "production" && ls(e, i.config), t ? (process.env.NODE_ENV !== "production" && i.components[e] && H(`Component "${e}" has already been registered in target app.`), i.components[e] = t, l) : i.components[e];
			},
			directive(e, t) {
				return process.env.NODE_ENV !== "production" && Nr(e), t ? (process.env.NODE_ENV !== "production" && i.directives[e] && H(`Directive "${e}" has already been registered in target app.`), i.directives[e] = t, l) : i.directives[e];
			},
			mount(a, o, s) {
				if (c) process.env.NODE_ENV !== "production" && H("App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`");
				else {
					process.env.NODE_ENV !== "production" && a.__vue_app__ && H("There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first.");
					let u = l._ceVNode || q(n, r);
					return u.appContext = i, s === !0 ? s = "svg" : s === !1 && (s = void 0), process.env.NODE_ENV !== "production" && (i.reload = () => {
						let t = Go(u);
						t.el = null, e(t, a, s);
					}), o && t ? t(u, a) : e(u, a, s), c = !0, l._container = a, a.__vue_app__ = l, process.env.NODE_ENV !== "production" && (l._instance = u.component, yr(l, Os)), bs(u.component);
				}
			},
			onUnmount(e) {
				process.env.NODE_ENV !== "production" && typeof e != "function" && H(`Expected function as first argument to app.onUnmount(), but got ${typeof e}`), o.push(e);
			},
			unmount() {
				c ? (Fn(o, l._instance, 16), e(null, l._container), process.env.NODE_ENV !== "production" && (l._instance = null, br(l)), delete l._container.__vue_app__) : process.env.NODE_ENV !== "production" && H("Cannot unmount an app that is not mounted.");
			},
			provide(e, t) {
				return process.env.NODE_ENV !== "production" && e in i.provides && (u(i.provides, e) ? H(`App already provides property with key "${String(e)}". It will be overwritten with the new value.`) : H(`App already provides property with key "${String(e)}" inherited from its parent element. It will be overwritten with the new value.`)), i.provides[e] = t, l;
			},
			runWithContext(e) {
				let t = fa;
				fa = l;
				try {
					return e();
				} finally {
					fa = t;
				}
			}
		};
		return l;
	};
}
var fa = null;
function pa(e, n, r = t) {
	let i = rs();
	if (process.env.NODE_ENV !== "production" && !i) return H("useModel() called without active instance."), /* @__PURE__ */ B();
	let a = E(n);
	if (process.env.NODE_ENV !== "production" && !i.propsOptions[0][a]) return H(`useModel() called with prop "${n}" which is not declared.`), /* @__PURE__ */ B();
	let o = O(n), s = ma(e, a), c = un((s, c) => {
		let l, u = t, d;
		return Vr(() => {
			let t = e[a];
			j(l, t) && (l = t, c());
		}), {
			get() {
				return s(), r.get ? r.get(l) : l;
			},
			set(e) {
				let s = r.set ? r.set(e) : e;
				if (!j(s, l) && !(u !== t && j(e, u))) return;
				let f = i.vnode.props, p = !!(f && (n in f || a in f || o in f) && (`onUpdate:${n}` in f || `onUpdate:${a}` in f || `onUpdate:${o}` in f));
				p || (l = e, c()), i.emit(`update:${n}`, s), j(e, u) && (j(e, s) && !j(s, d) || p && u !== t && !j(s, l)) && c(), u = e, d = s;
			}
		};
	});
	return c[Symbol.iterator] = () => {
		let e = 0;
		return { next() {
			return e < 2 ? {
				value: e++ ? s || t : c,
				done: !1
			} : { done: !0 };
		} };
	}, c;
}
var ma = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${E(t)}Modifiers`] || e[`${O(t)}Modifiers`];
function ha(e, n, ...r) {
	if (e.isUnmounted) return;
	let i = e.vnode.props || t;
	if (process.env.NODE_ENV !== "production") {
		let { emitsOptions: t, propsOptions: [i] } = e;
		if (t) {
			if (!(n in t)) (!i || !(A(E(n)) in i)) && H(`Component emitted event "${n}" but it is neither declared in the emits option nor as an "${A(E(n))}" prop.`);
			else {
				let e = t[n];
				h(e) && (e(...r) || H(`Invalid event arguments: event validation failed for event "${n}".`));
			}
		}
	}
	let a = r, o = n.startsWith("update:"), s = o && ma(i, n.slice(7));
	if (s && (s.trim && (a = r.map((e) => g(e) ? e.trim() : e)), s.number && (a = a.map(N))), process.env.NODE_ENV !== "production" && kr(e, n, a), process.env.NODE_ENV !== "production") {
		let t = n.toLowerCase();
		t !== n && i[A(t)] && H(`Event "${t}" is emitted in component ${ws(e, e.type)} but the handler is registered for "${n}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${O(n)}" instead of "${n}".`);
	}
	let c, l = i[c = A(n)] || i[c = A(E(n))];
	!l && o && (l = i[c = A(O(n))]), l && Fn(l, e, 6, a);
	let u = i[c + "Once"];
	if (u) {
		if (!e.emitted) e.emitted = {};
		else if (e.emitted[c]) return;
		e.emitted[c] = !0, Fn(u, e, 6, a);
	}
}
var ga = /* @__PURE__ */ new WeakMap();
function _a(e, t, n = !1) {
	let r = n ? ga : t.emitsCache, i = r.get(e);
	if (i !== void 0) return i;
	let a = e.emits, o = {}, c = !1;
	if (!h(e)) {
		let r = (e) => {
			let n = _a(e, t, !0);
			n && (c = !0, s(o, n));
		};
		!n && t.mixins.length && t.mixins.forEach(r), e.extends && r(e.extends), e.mixins && e.mixins.forEach(r);
	}
	return !a && !c ? (v(e) && r.set(e, null), null) : (d(a) ? a.forEach((e) => o[e] = null) : s(o, a), v(e) && r.set(e, o), o);
}
function va(e, t) {
	return !e || !a(t) ? !1 : (t = t.slice(2), t = t === "Once" ? t : t.replace(/Once$/, ""), u(e, t[0].toLowerCase() + t.slice(1)) || u(e, O(t)) || u(e, t));
}
var ya = !1;
function ba() {
	ya = !0;
}
function xa(e) {
	let { type: t, vnode: n, proxy: r, withProxy: i, propsOptions: [s], slots: c, attrs: l, emit: u, render: d, renderCache: f, props: p, data: m, setupState: h, ctx: g, inheritAttrs: _ } = e, v = Mr(e), y, b;
	process.env.NODE_ENV !== "production" && (ya = !1);
	try {
		if (n.shapeFlag & 4) {
			let e = i || r, t = process.env.NODE_ENV !== "production" && h.__isScriptSetup ? new Proxy(e, { get(e, t, n) {
				return H(`Property '${String(t)}' was accessed via 'this'. Avoid using 'this' in templates.`), Reflect.get(e, t, n);
			} }) : e;
			y = Yo(d.call(t, e, f, process.env.NODE_ENV === "production" ? p : /* @__PURE__ */ Kt(p), h, m, g)), b = l;
		} else {
			let e = t;
			process.env.NODE_ENV !== "production" && l === p && ba(), y = Yo(e.length > 1 ? e(process.env.NODE_ENV === "production" ? p : /* @__PURE__ */ Kt(p), process.env.NODE_ENV === "production" ? {
				attrs: l,
				slots: c,
				emit: u
			} : {
				get attrs() {
					return ba(), /* @__PURE__ */ Kt(l);
				},
				slots: c,
				emit: u
			}) : e(process.env.NODE_ENV === "production" ? p : /* @__PURE__ */ Kt(p), null)), b = t.props ? l : wa(l);
		}
	} catch (t) {
		ko.length = 0, In(t, e, 1), y = q(Do);
	}
	let x = y, S;
	if (process.env.NODE_ENV !== "production" && y.patchFlag > 0 && y.patchFlag & 2048 && ([x, S] = Sa(y)), b && _ !== !1) {
		let e = Object.keys(b), { shapeFlag: t } = x;
		if (e.length) {
			if (t & 7) s && e.some(o) && (b = Ta(b, s)), x = Go(x, b, !1, !0);
			else if (process.env.NODE_ENV !== "production" && !ya && x.type !== Do) {
				let e = Object.keys(l), t = [], n = [];
				for (let r = 0, i = e.length; r < i; r++) {
					let i = e[r];
					a(i) ? o(i) || t.push(i[2].toLowerCase() + i.slice(3)) : n.push(i);
				}
				n.length && H(`Extraneous non-props attributes (${n.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes.`), t.length && H(`Extraneous non-emits event listeners (${t.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`);
			}
		}
	}
	if (n.dirs && (process.env.NODE_ENV !== "production" && !Ea(x) && H("Runtime directive used on component with non-element root node. The directives will not function as intended."), x = Go(x, null, !1, !0), x.dirs = x.dirs ? x.dirs.concat(n.dirs) : n.dirs), n.transition) {
		let e = qr(x.type) && Xr(x) || x;
		process.env.NODE_ENV !== "production" && !Ea(e) && H("Component inside <Transition> renders non-element root node that cannot be animated."), Zr(e, n.transition);
	}
	return process.env.NODE_ENV !== "production" && S ? S(x) : y = x, Mr(v), y;
}
var Sa = (e) => {
	let t = e.children, n = e.dynamicChildren, r = Ca(t, !1);
	if (!r) return [e, void 0];
	if (process.env.NODE_ENV !== "production" && r.patchFlag > 0 && r.patchFlag & 2048) return Sa(r);
	let i = t.indexOf(r), a = n ? n.indexOf(r) : -1;
	return [Yo(r), (r) => {
		t[i] = r, n && (a > -1 ? n[a] = r : r.patchFlag > 0 && (e.dynamicChildren = [...n, r]));
	}];
};
function Ca(e, t = !0) {
	let n;
	for (let r = 0; r < e.length; r++) {
		let i = e[r];
		if (Io(i)) {
			if (i.type !== Do || i.children === "v-if") {
				if (n) return;
				if (n = i, process.env.NODE_ENV !== "production" && t && n.patchFlag > 0 && n.patchFlag & 2048) return Ca(n.children);
			}
		} else return;
	}
	return n;
}
var wa = (e) => {
	let t;
	for (let n in e) (n === "class" || n === "style" || a(n)) && ((t ||= {})[n] = e[n]);
	return t;
}, Ta = (e, t) => {
	let n = {};
	for (let r in e) (!o(r) || !(r.slice(9) in t)) && (n[r] = e[r]);
	return n;
}, Ea = (e) => e.shapeFlag & 7 || e.type === Do;
function Da(e, t, n) {
	let { props: r, children: i, component: a } = e, { props: o, children: s, patchFlag: c } = t, l = a.emitsOptions;
	if (process.env.NODE_ENV !== "production" && (i || s) && nr || t.dirs || t.transition) return !0;
	if (n && c >= 0) {
		if (c & 1024) return !0;
		if (c & 16) return r ? Oa(r, o, l) : !!o;
		if (c & 8) {
			let e = t.dynamicProps;
			for (let t = 0; t < e.length; t++) {
				let n = e[t];
				if (ka(o, r, n) && !va(l, n)) return !0;
			}
		}
	} else return (i || s) && (!s || !s.$stable) ? !0 : r === o ? !1 : r ? !o || Oa(r, o, l) : !!o;
	return !1;
}
function Oa(e, t, n) {
	let r = Object.keys(t);
	if (r.length !== Object.keys(e).length) return !0;
	for (let i = 0; i < r.length; i++) {
		let a = r[i];
		if (ka(t, e, a) && !va(n, a)) return !0;
	}
	return !1;
}
function ka(e, t, n) {
	let r = e[n], i = t[n];
	return n === "style" && v(r) && v(i) ? !xe(r, i) : r !== i;
}
function Aa({ vnode: e, parent: t, suspense: n }, r) {
	for (; t;) {
		let n = t.subTree;
		if (n.suspense && n.suspense.activeBranch === e && (n.suspense.vnode.el = n.el = r, e = n), n === e) (e = t.vnode).el = r, t = t.parent;
		else break;
	}
	n && n.activeBranch === e && (n.vnode.el = r);
}
var ja = {}, Ma = () => Object.create(ja), Na = (e) => Object.getPrototypeOf(e) === ja;
function Pa(e, t, n, r = !1) {
	let i = {}, a = Ma();
	e.propsDefaults = /* @__PURE__ */ Object.create(null), La(e, t, i, a);
	for (let t in e.propsOptions[0]) t in i || (i[t] = void 0);
	process.env.NODE_ENV !== "production" && Ua(t || {}, i, e), e.props = n ? r ? i : /* @__PURE__ */ Wt(i) : e.type.props ? i : a, e.attrs = a;
}
function Fa(e) {
	for (; e;) {
		if (e.type.__hmrId) return !0;
		e = e.parent;
	}
}
function Ia(e, t, n, r) {
	let { props: i, attrs: a, vnode: { patchFlag: o } } = e, s = /* @__PURE__ */ R(i), [c] = e.propsOptions, l = !1;
	if (!(process.env.NODE_ENV !== "production" && Fa(e)) && (r || o > 0) && !(o & 16)) {
		if (o & 8) {
			let n = e.vnode.dynamicProps;
			for (let r = 0; r < n.length; r++) {
				let o = n[r];
				if (va(e.emitsOptions, o)) continue;
				let d = t[o];
				if (c) {
					if (u(a, o)) d !== a[o] && (a[o] = d, l = !0);
					else {
						let t = E(o);
						i[t] = Ra(c, s, t, d, e, !1);
					}
				} else d !== a[o] && (a[o] = d, l = !0);
			}
		}
	} else {
		La(e, t, i, a) && (l = !0);
		let r;
		for (let a in s) (!t || !u(t, a) && ((r = O(a)) === a || !u(t, r))) && (c ? n && (n[a] !== void 0 || n[r] !== void 0) && (i[a] = Ra(c, s, a, void 0, e, !0)) : delete i[a]);
		if (a !== s) for (let e in a) (!t || !u(t, e)) && (delete a[e], l = !0);
	}
	l && at(e.attrs, "set", ""), process.env.NODE_ENV !== "production" && Ua(t || {}, i, e);
}
function La(e, n, r, i) {
	let [a, o] = e.propsOptions, s = !1, c;
	if (n) for (let t in n) {
		if (T(t)) continue;
		let l = n[t], d;
		a && u(a, d = E(t)) ? !o || !o.includes(d) ? r[d] = l : (c ||= {})[d] = l : va(e.emitsOptions, t) || (!(t in i) || l !== i[t]) && (i[t] = l, s = !0);
	}
	if (o) {
		let n = /* @__PURE__ */ R(r), i = c || t;
		for (let t = 0; t < o.length; t++) {
			let s = o[t];
			r[s] = Ra(a, n, s, i[s], e, !u(i, s));
		}
	}
	return s;
}
function Ra(e, t, n, r, i, a) {
	let o = e[n];
	if (o != null) {
		let e = u(o, "default");
		if (e && r === void 0) {
			let e = o.default;
			if (o.type !== Function && !o.skipFactory && h(e)) {
				let { propsDefaults: a } = i;
				if (n in a) r = a[n];
				else {
					let o = os(i);
					r = a[n] = e.call(null, t), o();
				}
			} else r = e;
			i.ce && i.ce._setProp(n, r);
		}
		o[0] && (a && !e ? r = !1 : o[1] && (r === "" || r === O(n)) && (r = !0));
	}
	return r;
}
var za = /* @__PURE__ */ new WeakMap();
function Ba(e, r, i = !1) {
	let a = i ? za : r.propsCache, o = a.get(e);
	if (o) return o;
	let c = e.props, l = {}, f = [], p = !1;
	if (!h(e)) {
		let t = (e) => {
			p = !0;
			let [t, n] = Ba(e, r, !0);
			s(l, t), n && f.push(...n);
		};
		!i && r.mixins.length && r.mixins.forEach(t), e.extends && t(e.extends), e.mixins && e.mixins.forEach(t);
	}
	if (!c && !p) return v(e) && a.set(e, n), n;
	if (d(c)) for (let e = 0; e < c.length; e++) {
		process.env.NODE_ENV !== "production" && !g(c[e]) && H("props must be strings when using array syntax.", c[e]);
		let n = E(c[e]);
		Va(n) && (l[n] = t);
	}
	else if (c) {
		process.env.NODE_ENV !== "production" && !v(c) && H("invalid props options", c);
		for (let e in c) {
			let t = E(e);
			if (Va(t)) {
				let n = c[e], r = l[t] = d(n) || h(n) ? { type: n } : s({}, n), i = r.type, a = !1, o = !0;
				if (d(i)) for (let e = 0; e < i.length; ++e) {
					let t = i[e], n = h(t) && t.name;
					if (n === "Boolean") {
						a = !0;
						break;
					}
					n === "String" && (o = !1);
				}
				else a = h(i) && i.name === "Boolean";
				r[0] = a, r[1] = o, (a || u(r, "default")) && f.push(t);
			}
		}
	}
	let m = [l, f];
	return v(e) && a.set(e, m), m;
}
function Va(e) {
	return e[0] !== "$" && !T(e) || (process.env.NODE_ENV !== "production" && H(`Invalid prop name: "${e}" is a reserved property.`), !1);
}
function Ha(e) {
	return e === null ? "null" : typeof e == "function" ? e.name || "" : typeof e == "object" && e.constructor && e.constructor.name || "";
}
function Ua(e, t, n) {
	let r = /* @__PURE__ */ R(t), i = n.propsOptions[0], a = Object.keys(e).map((e) => E(e));
	for (let e in i) {
		let t = i[e];
		t != null && Wa(e, r[e], t, process.env.NODE_ENV === "production" ? r : /* @__PURE__ */ Kt(r), !a.includes(e));
	}
}
function Wa(e, t, n, r, i) {
	let { type: a, required: o, validator: s, skipCheck: c } = n;
	if (o && i) {
		H("Missing required prop: \"" + e + "\"");
		return;
	}
	if (t != null || o) {
		if (a != null && a !== !0 && !c) {
			let n = !1, r = d(a) ? a : [a], i = [];
			for (let e = 0; e < r.length && !n; e++) {
				let { valid: a, expectedType: o } = Ka(t, r[e]);
				i.push(o || ""), n = a;
			}
			if (!n) {
				H(qa(e, t, i));
				return;
			}
		}
		s && !s(t, r) && H("Invalid prop: custom validator check failed for prop \"" + e + "\".");
	}
}
var Ga = /* @__PURE__ */ e("String,Number,Boolean,Function,Symbol,BigInt");
function Ka(e, t) {
	let n, r = Ha(t);
	if (r === "null") n = e === null;
	else if (Ga(r)) {
		let i = typeof e;
		n = i === r.toLowerCase(), !n && i === "object" && (n = e instanceof t);
	} else n = r === "Object" ? v(e) : r === "Array" ? d(e) : e instanceof t;
	return {
		valid: n,
		expectedType: r
	};
}
function qa(e, t, n) {
	if (n.length === 0) return `Prop type [] for prop "${e}" won't match anything. Did you mean to use type Array instead?`;
	let r = `Invalid prop: type check failed for prop "${e}". Expected ${n.map(k).join(" | ")}`, i = n[0], a = S(t), o = Ja(t, i), s = Ja(t, a);
	return n.length === 1 && Ya(i) && Xa(i, a) && (r += ` with value ${o}`), r += `, got ${a} `, Ya(a) && (r += `with value ${s}.`), r;
}
function Ja(e, t) {
	return _(e) ? e.toString() : t === "String" ? `"${e}"` : t === "Number" ? `${Number(e)}` : `${e}`;
}
function Ya(e) {
	return [
		"string",
		"number",
		"boolean"
	].some((t) => e.toLowerCase() === t);
}
function Xa(...e) {
	return e.every((e) => {
		let t = e.toLowerCase();
		return t !== "boolean" && t !== "symbol";
	});
}
var Za = (e) => e === "_" || e === "_ctx" || e === "$stable", Qa = (e) => d(e) ? e.map(Yo) : [Yo(e)], $a = (e, t, n) => {
	if (t._n) return t;
	let r = U((...r) => (process.env.NODE_ENV !== "production" && Y && !(n === null && Ar) && !(n && n.root !== Y.root) && H(`Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`), Qa(t(...r))), n);
	return r._c = !1, r;
}, eo = (e, t, n) => {
	let r = e._ctx;
	for (let n in e) {
		if (Za(n)) continue;
		let i = e[n];
		if (h(i)) t[n] = $a(n, i, r);
		else if (i != null) {
			process.env.NODE_ENV !== "production" && H(`Non-function value encountered for slot "${n}". Prefer function slots for better performance.`);
			let e = Qa(i);
			t[n] = () => e;
		}
	}
}, to = (e, t) => {
	process.env.NODE_ENV !== "production" && !ci(e.vnode) && H("Non-function value encountered for default slot. Prefer function slots for better performance.");
	let n = Qa(t);
	e.slots.default = () => n;
}, no = (e, t, n) => {
	for (let r in t) (n || !Za(r)) && (e[r] = t[r]);
}, ro = (e, t, n) => {
	let r = e.slots = Ma();
	if (e.vnode.shapeFlag & 32) {
		let e = t._;
		e ? (no(r, t, n), n && M(r, "_", e, !0)) : eo(t, r);
	} else t && to(e, t);
}, io = (e, n, r) => {
	let { vnode: i, slots: a } = e, o = !0, s = t;
	if (i.shapeFlag & 32) {
		let t = n._;
		t ? process.env.NODE_ENV !== "production" && nr ? (no(a, n, r), at(e, "set", "$slots")) : r && t === 1 ? o = !1 : no(a, n, r) : (o = !n.$stable, eo(n, a)), s = n;
	} else n && (to(e, n), s = { default: 1 });
	if (o) for (let e in a) !Za(e) && s[e] == null && delete a[e];
}, ao, oo;
function so(e, t) {
	e.appContext.config.performance && lo() && oo.mark(`vue-${t}-${e.uid}`), process.env.NODE_ENV !== "production" && Er(e, t, lo() ? oo.now() : Date.now());
}
function co(e, t) {
	if (e.appContext.config.performance && lo()) {
		let n = `vue-${t}-${e.uid}`, r = n + ":end", i = `<${ws(e, e.type)}> ${t}`;
		oo.mark(r), oo.measure(i, n, r), oo.clearMeasures(i), oo.clearMarks(n), oo.clearMarks(r);
	}
	process.env.NODE_ENV !== "production" && Dr(e, t, lo() ? oo.now() : Date.now());
}
function lo() {
	return ao === void 0 && (typeof window < "u" && window.performance ? (ao = !0, oo = window.performance) : ao = !1), ao;
}
function uo() {
	let e = [];
	if (process.env.NODE_ENV !== "production" && e.length) {
		let t = e.length > 1;
		console.warn(`Feature flag${t ? "s" : ""} ${e.join(", ")} ${t ? "are" : "is"} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`);
	}
}
var fo = wo;
function po(e) {
	return mo(e);
}
function mo(e, i) {
	uo();
	let a = ae();
	a.__VUE__ = !0, process.env.NODE_ENV !== "production" && vr(a.__VUE_DEVTOOLS_GLOBAL_HOOK__, a);
	let { insert: o, remove: s, patchProp: c, createElement: l, createText: u, createComment: d, setText: f, setElementText: p, parentNode: m, nextSibling: h, setScopeId: g = r, insertStaticContent: _ } = e, v = (e, t, n, r = null, i = null, a = null, o = void 0, s = null, c = process.env.NODE_ENV !== "production" && nr ? !1 : !!t.dynamicChildren) => {
		if (e === t) return;
		e && !Lo(e, t) && (r = me(e), le(e, i, a, !0), e = null), t.patchFlag === -2 && (c = !1, t.dynamicChildren = null);
		let { type: l, ref: u, shapeFlag: d } = t;
		switch (l) {
			case Eo:
				y(e, t, n, r);
				break;
			case Do:
				b(e, t, n, r);
				break;
			case Oo:
				e == null ? x(t, n, r, o) : process.env.NODE_ENV !== "production" && S(e, t, n, o);
				break;
			case To:
				A(e, t, n, r, i, a, o, s, c);
				break;
			default: d & 1 ? ee(e, t, n, r, i, a, o, s, c) : d & 6 ? j(e, t, n, r, i, a, o, s, c) : d & 64 || d & 128 ? l.process(e, t, n, r, i, a, o, s, c, _e) : process.env.NODE_ENV !== "production" && H("Invalid VNode type:", l, `(${typeof l})`);
		}
		u != null && i ? ai(u, e && e.ref, a, t || e, !t) : u == null && e && e.ref != null && ai(e.ref, null, a, e, !0);
	}, y = (e, t, n, r) => {
		if (e == null) o(t.el = u(t.children), n, r);
		else {
			let n = t.el = e.el;
			t.children !== e.children && f(n, t.children);
		}
	}, b = (e, t, n, r) => {
		e == null ? o(t.el = d(t.children || ""), n, r) : t.el = e.el;
	}, x = (e, t, n, r) => {
		[e.el, e.anchor] = _(e.children, t, n, r, e.el, e.anchor);
	}, S = (e, t, n, r) => {
		if (t.children !== e.children) {
			let i = h(e.anchor);
			w(e), [t.el, t.anchor] = _(t.children, n, i, r);
		} else t.el = e.el, t.anchor = e.anchor;
	}, C = ({ el: e, anchor: t }, n, r) => {
		let i;
		for (; e && e !== t;) i = h(e), o(e, n, r), e = i;
		o(t, n, r);
	}, w = ({ el: e, anchor: t }) => {
		let n;
		for (; e && e !== t;) n = h(e), s(e), e = n;
		s(t);
	}, ee = (e, t, n, r, i, a, o, s, c) => {
		if (t.type === "svg" ? o = "svg" : t.type === "math" && (o = "mathml"), e == null) te(t, n, r, i, a, o, s, c);
		else {
			let n = e.el && e.el._isVueCE ? e.el : null;
			try {
				n && n._beginPatch(), D(e, t, i, a, o, s, c);
			} finally {
				n && n._endPatch();
			}
		}
	}, te = (e, t, n, r, i, a, s, u) => {
		let d, f, { props: m, shapeFlag: h, transition: g, dirs: _ } = e;
		if (d = e.el = l(e.type, a, m && m.is, m), h & 8 ? p(d, e.children) : h & 16 && E(e.children, d, null, r, i, ho(e, a), s, u), _ && Pr(e, null, r, "created"), ne(d, e, e.scopeId, s, r), m) {
			for (let e in m) e !== "value" && !T(e) && c(d, e, null, m[e], a, r);
			"value" in m && c(d, "value", null, m.value, a), (f = m.onVnodeBeforeMount) && $o(f, r, e);
		}
		process.env.NODE_ENV !== "production" && (M(d, "__vnode", e, !0), M(d, "__vueParentComponent", r, !0)), _ && Pr(e, null, r, "beforeMount");
		let v = _o(i, g);
		if (v && g.beforeEnter(d), o(d, t, n), (f = m && m.onVnodeMounted) || v || _) {
			let t = process.env.NODE_ENV !== "production" && nr;
			fo(() => {
				let n;
				process.env.NODE_ENV !== "production" && (n = rr(t));
				try {
					f && $o(f, r, e), v && g.enter(d), _ && Pr(e, null, r, "mounted");
				} finally {
					process.env.NODE_ENV !== "production" && rr(n);
				}
			}, i);
		}
	}, ne = (e, t, n, r, i) => {
		if (n && g(e, n), r) for (let t = 0; t < r.length; t++) g(e, r[t]);
		if (i) {
			let n = i.subTree;
			if (process.env.NODE_ENV !== "production" && n.patchFlag > 0 && n.patchFlag & 2048 && (n = Ca(n.children) || n), t === n || Co(n.type) && (n.ssContent === t || n.ssFallback === t)) {
				let t = i.vnode;
				ne(e, t, t.scopeId, t.slotScopeIds, i.parent);
			}
		}
	}, E = (e, t, n, r, i, a, o, s, c = 0) => {
		for (let l = c; l < e.length; l++) {
			let c = e[l] = s ? Xo(e[l]) : Yo(e[l]);
			v(null, c, t, n, r, i, a, o, s);
		}
	}, D = (e, n, r, i, a, o, s) => {
		let l = n.el = e.el;
		process.env.NODE_ENV !== "production" && (l.__vnode = n);
		let { patchFlag: u, dynamicChildren: d, dirs: f } = n;
		u |= e.patchFlag & 16;
		let m = e.props || t, h = n.props || t, g;
		if (r && go(r, !1), (g = h.onVnodeBeforeUpdate) && $o(g, r, n, e), f && Pr(n, e, r, "beforeUpdate"), r && go(r, !0), (process.env.NODE_ENV !== "production" && nr || d && (!e.dynamicChildren || e.dynamicChildren.length !== d.length)) && (u = 0, s = !1, d = null), (m.innerHTML && h.innerHTML == null || m.textContent && h.textContent == null) && p(l, ""), d ? (O(e.dynamicChildren, d, l, r, i, ho(n, a), o), process.env.NODE_ENV !== "production" && vo(e, n)) : s || F(e, n, l, null, r, i, ho(n, a), o, !1), u > 0) {
			if (u & 16) k(l, m, h, r, a);
			else if (u & 2 && m.class !== h.class && c(l, "class", null, h.class, a), u & 4 && c(l, "style", m.style, h.style, a), u & 8) {
				let e = n.dynamicProps;
				for (let t = 0; t < e.length; t++) {
					let n = e[t], i = m[n], o = h[n];
					(o !== i || n === "value") && c(l, n, i, o, a, r);
				}
			}
			u & 1 && e.children !== n.children && p(l, n.children);
		} else !s && d == null && k(l, m, h, r, a);
		((g = h.onVnodeUpdated) || f) && fo(() => {
			g && $o(g, r, n, e), f && Pr(n, e, r, "updated");
		}, i);
	}, O = (e, t, n, r, i, a, o) => {
		for (let s = 0; s < t.length; s++) {
			let c = e[s], l = t[s], u = c.el && (c.type === To || !Lo(c, l) || c.shapeFlag & 198) ? m(c.el) : n;
			v(c, l, u, null, r, i, a, o, !0);
		}
	}, k = (e, n, r, i, a) => {
		if (n !== r) {
			if (n !== t) for (let t in n) !T(t) && !(t in r) && c(e, t, n[t], null, a, i);
			for (let t in r) {
				if (T(t)) continue;
				let o = r[t], s = n[t];
				o !== s && t !== "value" && c(e, t, s, o, a, i);
			}
			"value" in r && c(e, "value", n.value, r.value, a);
		}
	}, A = (e, t, n, r, i, a, s, c, l) => {
		let d = t.el = e ? e.el : u(""), f = t.anchor = e ? e.anchor : u(""), { patchFlag: p, dynamicChildren: m, slotScopeIds: h } = t;
		process.env.NODE_ENV !== "production" && (nr || p & 2048) && (p = 0, l = !1, m = null), h && (c = c ? c.concat(h) : h), e == null ? (o(d, n, r), o(f, n, r), E(t.children || [], n, f, i, a, s, c, l)) : p > 0 && p & 64 && m && e.dynamicChildren && e.dynamicChildren.length === m.length ? (O(e.dynamicChildren, m, n, i, a, s, c), process.env.NODE_ENV === "production" ? (t.key != null || i && t === i.subTree) && vo(e, t, !0) : vo(e, t)) : F(e, t, n, f, i, a, s, c, l);
	}, j = (e, t, n, r, i, a, o, s, c) => {
		t.slotScopeIds = s, e == null ? t.shapeFlag & 512 ? i.ctx.activate(t, n, r, o, c) : N(t, n, r, i, a, o, c) : ie(e, t, c);
	}, N = (e, t, n, r, i, a, o) => {
		let s = e.component = ns(e, r, i);
		if (process.env.NODE_ENV !== "production" && s.type.__hmrId && or(s), process.env.NODE_ENV !== "production" && (Tn(e), so(s, "mount")), ci(e) && (s.ctx.renderer = _e), process.env.NODE_ENV !== "production" && so(s, "init"), fs(s, !1, o), process.env.NODE_ENV !== "production" && co(s, "init"), process.env.NODE_ENV !== "production" && nr && (e.el = null), s.asyncDep) {
			if (i && i.registerDep(s, oe, o), !e.el) {
				let r = s.subTree = q(Do);
				b(null, r, t, n), e.placeholder = r.el;
			}
		} else oe(s, e, t, n, i, a, o);
		process.env.NODE_ENV !== "production" && (En(), co(s, "mount"));
	}, ie = (e, t, n) => {
		let r = t.component = e.component;
		if (Da(e, t, n)) {
			if (r.asyncDep && !r.asyncResolved) {
				process.env.NODE_ENV !== "production" && Tn(t), P(r, t, n), process.env.NODE_ENV !== "production" && En();
				return;
			}
			r.next = t, r.update();
		} else t.el = e.el, r.vnode = t;
	}, oe = (e, t, n, r, i, a, o) => {
		let s = () => {
			if (e.isMounted) {
				let { next: t, bu: n, u: r, parent: s, vnode: c } = e;
				{
					let n = bo(e);
					if (n) {
						t && (t.el = c.el, P(e, t, o)), n.asyncDep.then(() => {
							fo(() => {
								e.isUnmounted || l();
							}, i);
						});
						return;
					}
				}
				let u = t, d;
				process.env.NODE_ENV !== "production" && Tn(t || e.vnode), go(e, !1), t ? (t.el = c.el, P(e, t, o)) : t = c, n && re(n), (d = t.props && t.props.onVnodeBeforeUpdate) && $o(d, s, t, c), go(e, !0), process.env.NODE_ENV !== "production" && so(e, "render");
				let f = xa(e);
				process.env.NODE_ENV !== "production" && co(e, "render");
				let p = e.subTree;
				e.subTree = f, process.env.NODE_ENV !== "production" && so(e, "patch"), v(p, f, m(p.el), me(p), e, i, a), process.env.NODE_ENV !== "production" && co(e, "patch"), t.el = f.el, u === null && Aa(e, f.el), r && fo(r, i), (d = t.props && t.props.onVnodeUpdated) && fo(() => $o(d, s, t, c), i), process.env.NODE_ENV !== "production" && Sr(e), process.env.NODE_ENV !== "production" && En();
			} else {
				let o, { el: s, props: c } = t, { bm: l, m: u, parent: d, root: f, type: p } = e, m = si(t);
				if (go(e, !1), l && re(l), !m && (o = c && c.onVnodeBeforeMount) && $o(o, d, t), go(e, !0), s && ye) {
					let t = () => {
						process.env.NODE_ENV !== "production" && so(e, "render"), e.subTree = xa(e), process.env.NODE_ENV !== "production" && co(e, "render"), process.env.NODE_ENV !== "production" && so(e, "hydrate"), ye(s, e.subTree, e, i, null), process.env.NODE_ENV !== "production" && co(e, "hydrate");
					};
					m && p.__asyncHydrate ? p.__asyncHydrate(s, e, t) : t();
				} else {
					f.ce && f.ce._hasShadowRoot() && f.ce._injectChildStyle(p, e.parent ? e.parent.type : void 0), process.env.NODE_ENV !== "production" && so(e, "render");
					let o = e.subTree = xa(e);
					process.env.NODE_ENV !== "production" && co(e, "render"), process.env.NODE_ENV !== "production" && so(e, "patch"), v(null, o, n, r, e, i, a), process.env.NODE_ENV !== "production" && co(e, "patch"), t.el = o.el;
				}
				if (u && fo(u, i), !m && (o = c && c.onVnodeMounted)) {
					let e = t;
					fo(() => $o(o, d, e), i);
				}
				(t.shapeFlag & 256 || d && si(d.vnode) && d.vnode.shapeFlag & 256) && e.a && fo(e.a, i), e.isMounted = !0, process.env.NODE_ENV !== "production" && xr(e), t = n = r = null;
			}
		};
		e.scope.on();
		let c = e.effect = new Me(s);
		e.scope.off();
		let l = e.update = c.run.bind(c), u = e.job = c.runIfDirty.bind(c);
		u.i = e, u.id = e.uid, c.scheduler = () => Jn(u), go(e, !0), process.env.NODE_ENV !== "production" && (c.onTrack = e.rtc ? (t) => re(e.rtc, t) : void 0, c.onTrigger = e.rtg ? (t) => re(e.rtg, t) : void 0), l();
	}, P = (e, t, n) => {
		t.component = e;
		let r = e.vnode.props;
		e.vnode = t, e.next = null, Ia(e, t.props, r, n), io(e, t.children, n), qe(), Zn(e), Je();
	}, F = (e, t, n, r, i, a, o, s, c = !1) => {
		let l = e && e.children, u = e ? e.shapeFlag : 0, d = t.children, { patchFlag: f, shapeFlag: m } = t;
		if (f > 0) {
			if (f & 128) {
				ce(l, d, n, r, i, a, o, s, c);
				return;
			}
			if (f & 256) {
				se(l, d, n, r, i, a, o, s, c);
				return;
			}
		}
		m & 8 ? (u & 16 && pe(l, i, a), d !== l && p(n, d)) : u & 16 ? m & 16 ? ce(l, d, n, r, i, a, o, s, c) : pe(l, i, a, !0) : (u & 8 && p(n, ""), m & 16 && E(d, n, r, i, a, o, s, c));
	}, se = (e, t, r, i, a, o, s, c, l) => {
		e ||= n, t ||= n;
		let u = e.length, d = t.length, f = Math.min(u, d), p = 0;
		for (; p < f; p++) {
			let n = t[p] = l ? Xo(t[p]) : Yo(t[p]);
			v(e[p], n, r, null, a, o, s, c, l);
		}
		u > d ? pe(e, a, o, !0, !1, f) : E(t, r, i, a, o, s, c, l, f);
	}, ce = (e, t, r, i, a, o, s, c, l) => {
		let u = 0, d = t.length, f = e.length - 1, p = d - 1;
		for (; u <= f && u <= p;) {
			let n = e[u], i = t[u] = l ? Xo(t[u]) : Yo(t[u]);
			if (Lo(n, i)) v(n, i, r, null, a, o, s, c, l);
			else break;
			u++;
		}
		for (; u <= f && u <= p;) {
			let n = e[f], i = t[p] = l ? Xo(t[p]) : Yo(t[p]);
			if (Lo(n, i)) v(n, i, r, null, a, o, s, c, l);
			else break;
			f--, p--;
		}
		if (u > f) {
			if (u <= p) {
				let e = p + 1, n = e < d ? t[e].el : i;
				for (; u <= p;) v(null, t[u] = l ? Xo(t[u]) : Yo(t[u]), r, n, a, o, s, c, l), u++;
			}
		} else if (u > p) for (; u <= f;) le(e[u], a, o, !0), u++;
		else {
			let m = u, h = u, g = /* @__PURE__ */ new Map();
			for (u = h; u <= p; u++) {
				let e = t[u] = l ? Xo(t[u]) : Yo(t[u]);
				e.key != null && (process.env.NODE_ENV !== "production" && g.has(e.key) && H("Duplicate keys found during update:", JSON.stringify(e.key), "Make sure keys are unique."), g.set(e.key, u));
			}
			let _, y = 0, b = p - h + 1, x = !1, S = 0, C = Array(b);
			for (u = 0; u < b; u++) C[u] = 0;
			for (u = m; u <= f; u++) {
				let n = e[u];
				if (y >= b) {
					le(n, a, o, !0);
					continue;
				}
				let i;
				if (n.key != null) i = g.get(n.key);
				else for (_ = h; _ <= p; _++) if (C[_ - h] === 0 && Lo(n, t[_])) {
					i = _;
					break;
				}
				i === void 0 ? le(n, a, o, !0) : (C[i - h] = u + 1, i >= S ? S = i : x = !0, v(n, t[i], r, null, a, o, s, c, l), y++);
			}
			let w = x ? yo(C) : n;
			for (_ = w.length - 1, u = b - 1; u >= 0; u--) {
				let e = h + u, n = t[e], f = t[e + 1], p = e + 1 < d ? f.el || So(f) : i;
				C[u] === 0 ? v(null, n, r, p, a, o, s, c, l) : x && (_ < 0 || u !== w[_] ? I(n, r, p, 2) : _--);
			}
		}
	}, I = (e, t, n, r, i = null) => {
		let { el: a, type: c, transition: l, children: u, shapeFlag: d } = e;
		if (d & 6) {
			I(e.component.subTree, t, n, r);
			return;
		}
		if (d & 128) {
			e.suspense.move(t, n, r);
			return;
		}
		if (d & 64) {
			c.move(e, t, n, _e);
			return;
		}
		if (c === To) {
			o(a, t, n);
			for (let e = 0; e < u.length; e++) I(u[e], t, n, r);
			o(e.anchor, t, n);
			return;
		}
		if (c === Oo) {
			C(e, t, n);
			return;
		}
		if (r !== 2 && d & 1 && l) {
			if (r === 0) l.persisted && !a[Jr] ? o(a, t, n) : (l.beforeEnter(a), o(a, t, n), fo(() => l.enter(a), i));
			else {
				let { leave: r, delayLeave: i, afterLeave: c } = l, u = () => {
					e.ctx.isUnmounted ? s(a) : o(a, t, n);
				}, d = () => {
					let e = a._isLeaving || !!a[Jr];
					a._isLeaving && a[Jr](!0), l.persisted && !e ? u() : r(a, () => {
						u(), c && c();
					});
				};
				i ? i(a, u, d) : d();
			}
		} else o(a, t, n);
	}, le = (e, t, n, r = !1, i = !1) => {
		let { type: a, props: o, ref: s, children: c, dynamicChildren: l, shapeFlag: u, patchFlag: d, dirs: f, cacheIndex: p, memo: m } = e;
		if (d === -2 && (i = !1), s != null && (qe(), ai(s, null, n, e, !0), Je()), p != null && (t.renderCache[p] = void 0), u & 256) {
			t.ctx.deactivate(e);
			return;
		}
		let h = u & 1 && f, g = !si(e), _;
		if (g && (_ = o && o.onVnodeBeforeUnmount) && $o(_, t, e), u & 6) fe(e.component, n, r);
		else {
			if (u & 128) {
				e.suspense.unmount(n, r);
				return;
			}
			h && Pr(e, null, t, "beforeUnmount"), u & 64 ? e.type.remove(e, t, n, _e, r) : l && !l.hasOnce && (a !== To || d > 0 && d & 64) ? pe(l, t, n, !1, !0) : (a === To && d & 384 || !i && u & 16) && pe(c, t, n), r && ue(e);
		}
		let v = m != null && p == null;
		(g && (_ = o && o.onVnodeUnmounted) || h || v) && fo(() => {
			_ && $o(_, t, e), h && Pr(e, null, t, "unmounted"), v && (e.el = null);
		}, n);
	}, ue = (e) => {
		let { type: t, el: n, anchor: r, transition: i } = e;
		if (t === To) {
			process.env.NODE_ENV !== "production" && e.patchFlag > 0 && e.patchFlag & 2048 && i && !i.persisted ? e.children.forEach((e) => {
				e.type === Do ? s(e.el) : ue(e);
			}) : de(n, r);
			return;
		}
		if (t === Oo) {
			w(e);
			return;
		}
		let a = () => {
			s(n), i && !i.persisted && i.afterLeave && i.afterLeave();
		};
		if (e.shapeFlag & 1 && i && !i.persisted) {
			let { leave: t, delayLeave: r } = i, o = () => t(n, a);
			r ? r(e.el, a, o) : o();
		} else a();
	}, de = (e, t) => {
		let n;
		for (; e !== t;) n = h(e), s(e), e = n;
		s(t);
	}, fe = (e, t, n) => {
		process.env.NODE_ENV !== "production" && e.type.__hmrId && sr(e);
		let { bum: r, scope: i, job: a, subTree: o, um: s, m: c, a: l } = e;
		xo(c), xo(l), r && re(r), i.stop(), a && (a.flags |= 8, le(o, e, t, n)), s && fo(s, t), fo(() => {
			e.isUnmounted = !0;
		}, t), process.env.NODE_ENV !== "production" && wr(e);
	}, pe = (e, t, n, r = !1, i = !1, a = 0) => {
		for (let o = a; o < e.length; o++) le(e[o], t, n, r, i);
	}, me = (e) => {
		if (e.shapeFlag & 6) return me(e.component.subTree);
		if (e.shapeFlag & 128) return e.suspense.next();
		let t = h(e.anchor || e.el), n = t && t[Kr];
		return n ? h(n) : t;
	}, he = !1, ge = (e, t, n) => {
		let r;
		e == null ? t._vnode && (le(t._vnode, null, null, !0), r = t._vnode.component) : v(t._vnode || null, e, t, null, null, null, n), t._vnode = e, he ||= (he = !0, Zn(r), Qn(), !1);
	}, _e = {
		p: v,
		um: le,
		m: I,
		r: ue,
		mt: N,
		mc: E,
		pc: F,
		pbc: O,
		n: me,
		o: e
	}, ve, ye;
	return i && ([ve, ye] = i(_e)), {
		render: ge,
		hydrate: ve,
		createApp: da(ge, ve)
	};
}
function ho({ type: e, props: t }, n) {
	return n === "svg" && e === "foreignObject" || n === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : n;
}
function go({ effect: e, job: t }, n) {
	n ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function _o(e, t) {
	return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function vo(e, t, n = !1) {
	let r = e.children, i = t.children;
	if (d(r) && d(i)) for (let e = 0; e < r.length; e++) {
		let t = r[e], a = i[e];
		a.shapeFlag & 1 && !a.dynamicChildren && ((a.patchFlag <= 0 || a.patchFlag === 32) && (a = i[e] = Xo(i[e]), a.el = t.el), !n && a.patchFlag !== -2 && vo(t, a)), a.type === Eo && (a.patchFlag === -1 && (a = i[e] = Xo(a)), a.el = t.el), a.type === Do && !a.el && (a.el = t.el), process.env.NODE_ENV !== "production" && a.el && (a.el.__vnode = a);
	}
}
function yo(e) {
	let t = e.slice(), n = [0], r, i, a, o, s, c = e.length;
	for (r = 0; r < c; r++) {
		let c = e[r];
		if (c !== 0) {
			if (i = n[n.length - 1], e[i] < c) {
				t[r] = i, n.push(r);
				continue;
			}
			for (a = 0, o = n.length - 1; a < o;) s = a + o >> 1, e[n[s]] < c ? a = s + 1 : o = s;
			c < e[n[a]] && (a > 0 && (t[r] = n[a - 1]), n[a] = r);
		}
	}
	for (a = n.length, o = n[a - 1]; a-- > 0;) n[a] = o, o = t[o];
	return n;
}
function bo(e) {
	let t = e.subTree.component;
	if (t) return t.asyncDep && !t.asyncResolved ? t : bo(t);
}
function xo(e) {
	if (e) for (let t = 0; t < e.length; t++) e[t].flags |= 8;
}
function So(e) {
	if (e.placeholder) return e.placeholder;
	let t = e.component;
	return t ? So(t.subTree) : null;
}
var Co = (e) => e.__isSuspense;
function wo(e, t) {
	t && t.pendingBranch ? d(e) ? t.effects.push(...e) : t.effects.push(e) : Xn(e);
}
var To = /* @__PURE__ */ Symbol.for("v-fgt"), Eo = /* @__PURE__ */ Symbol.for("v-txt"), Do = /* @__PURE__ */ Symbol.for("v-cmt"), Oo = /* @__PURE__ */ Symbol.for("v-stc"), ko = [], Ao = null;
function G(e = !1) {
	ko.push(Ao = e ? null : []);
}
function jo() {
	ko.pop(), Ao = ko[ko.length - 1] || null;
}
var Mo = 1;
function No(e, t = !1) {
	Mo += e, e < 0 && Ao && t && (Ao.hasOnce = !0);
}
function Po(e) {
	return e.dynamicChildren = Mo > 0 ? Ao || n : null, jo(), Mo > 0 && Ao && Ao.push(e), e;
}
function Fo(e, t, n, r, i, a) {
	return Po(Vo(e, t, n, r, i, a, !0));
}
function K(e, t, n, r, i) {
	return Po(q(e, t, n, r, i, !0));
}
function Io(e) {
	return e ? e.__v_isVNode === !0 : !1;
}
function Lo(e, t) {
	if (process.env.NODE_ENV !== "production" && t.shapeFlag & 6 && e.component) {
		let n = ir.get(t.type);
		if (n && n.has(e.component)) return e.shapeFlag &= -257, t.shapeFlag &= -513, !1;
	}
	return e.type === t.type && e.key === t.key;
}
var Ro = (...e) => Uo(...e), zo = ({ key: e }) => e ?? null, Bo = ({ ref: e, ref_key: t, ref_for: n }) => (typeof e == "number" && (e = "" + e), e == null ? null : g(e) || /* @__PURE__ */ z(e) || h(e) ? {
	i: Ar,
	r: e,
	k: t,
	f: !!n
} : e);
function Vo(e, t = null, n = null, r = 0, i = null, a = e === To ? 0 : 1, o = !1, s = !1) {
	let c = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e,
		props: t,
		key: t && zo(t),
		ref: t && Bo(t),
		scopeId: jr,
		slotScopeIds: null,
		children: n,
		component: null,
		suspense: null,
		ssContent: null,
		ssFallback: null,
		dirs: null,
		transition: null,
		el: null,
		anchor: null,
		target: null,
		targetStart: null,
		targetAnchor: null,
		staticCount: 0,
		shapeFlag: a,
		patchFlag: r,
		dynamicProps: i,
		dynamicChildren: null,
		appContext: null,
		ctx: Ar
	};
	if (s ? (Zo(c, n), a & 128 && e.normalize(c)) : n && (c.shapeFlag |= g(n) ? 8 : 16), process.env.NODE_ENV !== "production" && c.key !== c.key && H("VNode created with invalid key (NaN). VNode type:", c.type), process.env.NODE_ENV !== "production" && t && c.shapeFlag & 1) {
		let e = t.innerHTML == null ? t.textContent == null ? null : "textContent" : "innerHTML";
		e && Ho(c.children) && H(`The \`${e}\` prop on <${c.type}> will override its children. Remove either the \`${e}\` prop or the children.`);
	}
	return Mo > 0 && !o && Ao && (c.patchFlag > 0 || a & 6) && c.patchFlag !== 32 && Ao.push(c), c;
}
function Ho(e) {
	return g(e) ? e !== "" : d(e) ? e.length > 0 : !1;
}
var q = process.env.NODE_ENV === "production" ? Uo : Ro;
function Uo(e, t = null, n = null, r = 0, i = null, a = !1) {
	if ((!e || e === Ei) && (process.env.NODE_ENV !== "production" && !e && H(`Invalid vnode type when creating vnode: ${e}.`), e = Do), Io(e)) {
		let r = Go(e, t, !0);
		return n && Zo(r, n), Mo > 0 && !a && Ao && (r.shapeFlag & 6 ? Ao[Ao.indexOf(e)] = r : Ao.push(r)), r.patchFlag = -2, r;
	}
	if (Ts(e) && (e = e.__vccOpts), t) {
		t = Wo(t);
		let { class: e, style: n } = t;
		e && !g(e) && (t.class = I(e)), v(n) && (/* @__PURE__ */ Zt(n) && !d(n) && (n = s({}, n)), t.style = oe(n));
	}
	let o = g(e) ? 1 : Co(e) ? 128 : qr(e) ? 64 : v(e) ? 4 : h(e) ? 2 : 0;
	return process.env.NODE_ENV !== "production" && o & 4 && /* @__PURE__ */ Zt(e) && (e = /* @__PURE__ */ R(e), H("Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.", "\nComponent that was made reactive: ", e)), Vo(e, t, n, r, i, o, a, !0);
}
function Wo(e) {
	return e ? /* @__PURE__ */ Zt(e) || Na(e) ? s({}, e) : e : null;
}
function Go(e, t, n = !1, r = !1) {
	let { props: i, ref: a, patchFlag: o, children: s, transition: c } = e, l = t ? Qo(i || {}, t) : i, u = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e.type,
		props: l,
		key: l && zo(l),
		ref: t && t.ref ? n && a ? d(a) ? a.concat(Bo(t)) : [a, Bo(t)] : Bo(t) : a,
		scopeId: e.scopeId,
		slotScopeIds: e.slotScopeIds,
		children: process.env.NODE_ENV !== "production" && o === -1 && d(s) ? s.map(Ko) : s,
		target: e.target,
		targetStart: e.targetStart,
		targetAnchor: e.targetAnchor,
		staticCount: e.staticCount,
		shapeFlag: e.shapeFlag,
		patchFlag: t && e.type !== To ? o === -1 ? 16 : o | 16 : o,
		dynamicProps: e.dynamicProps,
		dynamicChildren: e.dynamicChildren,
		appContext: e.appContext,
		dirs: e.dirs,
		transition: c,
		component: e.component,
		suspense: e.suspense,
		ssContent: e.ssContent && Go(e.ssContent),
		ssFallback: e.ssFallback && Go(e.ssFallback),
		placeholder: e.placeholder,
		el: e.el,
		anchor: e.anchor,
		ctx: e.ctx,
		ce: e.ce
	};
	return c && r && Zr(u, c.clone(u)), u;
}
function Ko(e) {
	let t = Go(e);
	return d(e.children) && (t.children = e.children.map(Ko)), t;
}
function qo(e = " ", t = 0) {
	return q(Eo, null, e, t);
}
function Jo(e, t) {
	let n = q(Oo, null, e);
	return n.staticCount = t, n;
}
function J(e = "", t = !1) {
	return t ? (G(), K(Do, null, e)) : q(Do, null, e);
}
function Yo(e) {
	return e == null || typeof e == "boolean" ? q(Do) : d(e) ? q(To, null, e.slice()) : Io(e) ? Xo(e) : q(Eo, null, String(e));
}
function Xo(e) {
	return e.el === null && e.patchFlag !== -1 || e.memo ? e : Go(e);
}
function Zo(e, t) {
	let n = 0, { shapeFlag: r } = e;
	if (t == null) t = null;
	else if (d(t)) n = 16;
	else if (typeof t == "object") {
		if (r & 65) {
			let n = t.default;
			n && (n._c && (n._d = !1), Zo(e, n()), n._c && (n._d = !0));
			return;
		}
		{
			n = 32;
			let r = t._;
			!r && !Na(t) ? t._ctx = Ar : r === 3 && Ar && (Ar.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
		}
	} else if (h(t)) {
		if (r & 65) {
			Zo(e, { default: t });
			return;
		}
		t = {
			default: t,
			_ctx: Ar
		}, n = 32;
	} else t = String(t), r & 64 ? (n = 16, t = [qo(t)]) : n = 8;
	e.children = t, e.shapeFlag |= n;
}
function Qo(...e) {
	let t = {};
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (let e in r) if (e === "class") t.class !== r.class && (t.class = I([t.class, r.class]));
		else if (e === "style") t.style = oe([t.style, r.style]);
		else if (a(e)) {
			let n = t[e], i = r[e];
			i && n !== i && !(d(n) && n.includes(i)) ? t[e] = n ? [].concat(n, i) : i : i == null && n == null && !o(e) && (t[e] = i);
		} else e !== "" && (t[e] = r[e]);
	}
	return t;
}
function $o(e, t, n, r = null) {
	Fn(e, t, 7, [n, r]);
}
var es = la(), ts = 0;
function ns(e, n, r) {
	let i = e.type, a = (n ? n.appContext : e.appContext) || es, o = {
		uid: ts++,
		vnode: e,
		type: i,
		parent: n,
		appContext: a,
		root: null,
		next: null,
		subTree: null,
		effect: null,
		update: null,
		job: null,
		scope: new Oe(!0),
		render: null,
		proxy: null,
		exposed: null,
		exposeProxy: null,
		withProxy: null,
		provides: n ? n.provides : Object.create(a.provides),
		ids: n ? n.ids : [
			"",
			0,
			0
		],
		accessCache: null,
		renderCache: [],
		components: null,
		directives: null,
		propsOptions: Ba(i, a),
		emitsOptions: _a(i, a),
		emit: null,
		emitted: null,
		propsDefaults: t,
		inheritAttrs: i.inheritAttrs,
		ctx: t,
		data: t,
		props: t,
		attrs: t,
		slots: t,
		refs: t,
		setupState: t,
		setupContext: null,
		suspense: r,
		suspenseId: r ? r.pendingId : 0,
		asyncDep: null,
		asyncResolved: !1,
		isMounted: !1,
		isUnmounted: !1,
		isDeactivated: !1,
		bc: null,
		c: null,
		bm: null,
		m: null,
		bu: null,
		u: null,
		um: null,
		bum: null,
		da: null,
		a: null,
		rtg: null,
		rtc: null,
		ec: null,
		sp: null
	};
	return o.ctx = process.env.NODE_ENV === "production" ? { _: o } : zi(o), o.root = n ? n.root : o, o.emit = ha.bind(null, o), e.ce && e.ce(o), o;
}
var Y = null, rs = () => Y || Ar, is, as;
{
	let e = ae(), t = (t, n) => {
		let r;
		return (r = e[t]) || (r = e[t] = []), r.push(n), (e) => {
			r.length > 1 ? r.forEach((t) => t(e)) : r[0](e);
		};
	};
	is = t("__VUE_INSTANCE_SETTERS__", (e) => Y = e), as = t("__VUE_SSR_SETTERS__", (e) => ds = e);
}
var os = (e) => {
	let t = Y;
	return is(e), e.scope.on(), () => {
		e.scope.off(), is(t);
	};
}, ss = () => {
	Y && Y.scope.off(), is(null);
}, cs = /* @__PURE__ */ e("slot,component");
function ls(e, { isNativeTag: t }) {
	(cs(e) || t(e)) && H("Do not use built-in or reserved HTML elements as component id: " + e);
}
function us(e) {
	return e.vnode.shapeFlag & 4;
}
var ds = !1;
function fs(e, t = !1, n = !1) {
	t && as(t);
	let { props: r, children: i } = e.vnode, a = us(e);
	Pa(e, r, a, t), ro(e, i, n || t);
	let o = a ? ps(e, t) : void 0;
	return t && as(!1), o;
}
function ps(e, t) {
	let n = e.type;
	if (process.env.NODE_ENV !== "production") {
		if (n.name && ls(n.name, e.appContext.config), n.components) {
			let t = Object.keys(n.components);
			for (let n = 0; n < t.length; n++) ls(t[n], e.appContext.config);
		}
		if (n.directives) {
			let e = Object.keys(n.directives);
			for (let t = 0; t < e.length; t++) Nr(e[t]);
		}
		n.compilerOptions && hs() && H("\"compilerOptions\" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.");
	}
	e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, Ri), process.env.NODE_ENV !== "production" && Bi(e);
	let { setup: r } = n;
	if (r) {
		qe();
		let i = e.setupContext = r.length > 1 ? ys(e) : null, a = os(e), o = Pn(r, e, 0, [process.env.NODE_ENV === "production" ? e.props : /* @__PURE__ */ Kt(e.props), i]), s = y(o);
		if (Je(), a(), (s || e.sp) && !si(e) && ei(e), s) {
			if (o.then(ss, ss), t) return o.then((n) => {
				as(!0);
				try {
					ms(e, n, t);
				} finally {
					as(!1);
				}
			}).catch((t) => {
				In(t, e, 0);
			});
			e.asyncDep = o, process.env.NODE_ENV !== "production" && !e.suspense && H(`Component <${ws(e, n)}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`);
		} else ms(e, o, t);
	} else gs(e, t);
}
function ms(e, t, n) {
	h(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : v(t) ? (process.env.NODE_ENV !== "production" && Io(t) && H("setup() should not return VNodes directly - return a render function instead."), process.env.NODE_ENV !== "production" && (e.devtoolsRawSetupState = t), e.setupState = cn(t), process.env.NODE_ENV !== "production" && Vi(e)) : process.env.NODE_ENV !== "production" && t !== void 0 && H(`setup() should return an object. Received: ${t === null ? "null" : typeof t}`), gs(e, n);
}
var hs = () => !0;
function gs(e, t, n) {
	let i = e.type;
	e.render ||= i.render || r;
	{
		let t = os(e);
		qe();
		try {
			Yi(e);
		} finally {
			Je(), t();
		}
	}
	process.env.NODE_ENV !== "production" && !i.render && e.render === r && !t && (i.template ? H("Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias \"vue\" to \"vue/dist/vue.esm-bundler.js\".") : H("Component is missing template or render function: ", i));
}
var _s = process.env.NODE_ENV === "production" ? { get(e, t) {
	return it(e, "get", ""), e[t];
} } : {
	get(e, t) {
		return ba(), it(e, "get", ""), e[t];
	},
	set() {
		return H("setupContext.attrs is readonly."), !1;
	},
	deleteProperty() {
		return H("setupContext.attrs is readonly."), !1;
	}
};
function vs(e) {
	return new Proxy(e.slots, { get(t, n) {
		return it(e, "get", "$slots"), t[n];
	} });
}
function ys(e) {
	let t = (t) => {
		if (process.env.NODE_ENV !== "production" && (e.exposed && H("expose() should be called only once per setup()."), t != null)) {
			let e = typeof t;
			e === "object" && (d(t) ? e = "array" : /* @__PURE__ */ z(t) && (e = "ref")), e !== "object" && H(`expose() should be passed a plain object, received ${e}.`);
		}
		e.exposed = t || {};
	};
	if (process.env.NODE_ENV !== "production") {
		let n, r;
		return Object.freeze({
			get attrs() {
				return n ||= new Proxy(e.attrs, _s);
			},
			get slots() {
				return r ||= vs(e);
			},
			get emit() {
				return (t, ...n) => e.emit(t, ...n);
			},
			expose: t
		});
	}
	return {
		attrs: new Proxy(e.attrs, _s),
		slots: e.slots,
		emit: e.emit,
		expose: t
	};
}
function bs(e) {
	return e.exposed ? e.exposeProxy ||= new Proxy(cn(Qt(e.exposed)), {
		get(t, n) {
			if (n in t) return t[n];
			if (n in Fi) return Fi[n](e);
		},
		has(e, t) {
			return t in e || t in Fi;
		}
	}) : e.proxy;
}
var xs = /(?:^|[-_])\w/g, Ss = (e) => e.replace(xs, (e) => e.toUpperCase()).replace(/[-_]/g, "");
function Cs(e, t = !0) {
	return h(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function ws(e, t, n = !1) {
	let r = Cs(t);
	if (!r && t.__file) {
		let e = t.__file.match(/([^/\\]+)\.\w+$/);
		e && (r = e[1]);
	}
	if (!r && e) {
		let n = (e) => {
			for (let n in e) if (e[n] === t) return n;
		};
		r = n(e.components) || e.parent && n(e.parent.type.components) || n(e.appContext.components);
	}
	return r ? Ss(r) : n ? "App" : "Anonymous";
}
function Ts(e) {
	return h(e) && "__vccOpts" in e;
}
var X = (e, t) => {
	let n = /* @__PURE__ */ _n(e, t, ds);
	if (process.env.NODE_ENV !== "production") {
		let e = rs();
		e && e.appContext.config.warnRecursiveComputed && (n._warnRecursive = !0);
	}
	return n;
};
function Es(e, t, n) {
	try {
		No(-1);
		let r = arguments.length;
		return r === 2 ? v(t) && !d(t) ? Io(t) ? q(e, null, [t]) : q(e, t) : q(e, null, t) : (r > 3 ? n = Array.prototype.slice.call(arguments, 2) : r === 3 && Io(n) && (n = [n]), q(e, t, n));
	} finally {
		No(1);
	}
}
function Ds() {
	if (process.env.NODE_ENV === "production" || typeof window > "u") return;
	let e = { style: "color:#3ba776" }, n = { style: "color:#1677ff" }, r = { style: "color:#f5222d" }, i = { style: "color:#eb2f96" }, a = {
		__vue_custom_formatter: !0,
		header(t) {
			if (!v(t)) return null;
			if (t.__isVue) return [
				"div",
				e,
				"VueInstance"
			];
			if (/* @__PURE__ */ z(t)) {
				qe();
				let n = t.value;
				return Je(), [
					"div",
					{},
					[
						"span",
						e,
						p(t)
					],
					"<",
					l(n),
					">"
				];
			}
			return /* @__PURE__ */ Jt(t) ? [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ Xt(t) ? "ShallowReactive" : "Reactive"
				],
				"<",
				l(t),
				`>${/* @__PURE__ */ Yt(t) ? " (readonly)" : ""}`
			] : /* @__PURE__ */ Yt(t) ? [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ Xt(t) ? "ShallowReadonly" : "Readonly"
				],
				"<",
				l(t),
				">"
			] : null;
		},
		hasBody(e) {
			return e && e.__isVue;
		},
		body(e) {
			if (e && e.__isVue) return [
				"div",
				{},
				...o(e.$)
			];
		}
	};
	function o(e) {
		let n = [];
		e.type.props && e.props && n.push(c("props", /* @__PURE__ */ R(e.props))), e.setupState !== t && n.push(c("setup", e.setupState)), e.data !== t && n.push(c("data", /* @__PURE__ */ R(e.data)));
		let r = u(e, "computed");
		r && n.push(c("computed", r));
		let a = u(e, "inject");
		return a && n.push(c("injected", a)), n.push([
			"div",
			{},
			[
				"span",
				{ style: i.style + ";opacity:0.66" },
				"$ (internal): "
			],
			["object", { object: e }]
		]), n;
	}
	function c(e, t) {
		return t = s({}, t), Object.keys(t).length ? [
			"div",
			{ style: "line-height:1.25em;margin-bottom:0.6em" },
			[
				"div",
				{ style: "color:#476582" },
				e
			],
			[
				"div",
				{ style: "padding-left:1.25em" },
				...Object.keys(t).map((e) => [
					"div",
					{},
					[
						"span",
						i,
						e + ": "
					],
					l(t[e], !1)
				])
			]
		] : ["span", {}];
	}
	function l(e, t = !0) {
		return typeof e == "number" ? [
			"span",
			n,
			e
		] : typeof e == "string" ? [
			"span",
			r,
			JSON.stringify(e)
		] : typeof e == "boolean" ? [
			"span",
			i,
			e
		] : v(e) ? ["object", { object: t ? /* @__PURE__ */ R(e) : e }] : [
			"span",
			r,
			String(e)
		];
	}
	function u(e, t) {
		let n = e.type;
		if (h(n)) return;
		let r = {};
		for (let i in e.ctx) f(n, i, t) && (r[i] = e.ctx[i]);
		return r;
	}
	function f(e, t, n) {
		let r = e[n];
		if (d(r) && r.includes(t) || v(r) && t in r || e.extends && f(e.extends, t, n) || e.mixins && e.mixins.some((e) => f(e, t, n))) return !0;
	}
	function p(e) {
		return /* @__PURE__ */ Xt(e) ? "ShallowRef" : e.effect ? "ComputedRef" : "Ref";
	}
	window.devtoolsFormatters ? window.devtoolsFormatters.push(a) : window.devtoolsFormatters = [a];
}
var Os = "3.5.42", ks = process.env.NODE_ENV === "production" ? r : H;
process.env.NODE_ENV, process.env.NODE_ENV;
//#endregion
//#region ../../node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js
var As = void 0, js = typeof window < "u" && window.trustedTypes;
if (js) try {
	As = /* @__PURE__ */ js.createPolicy("vue", { createHTML: (e) => e });
} catch (e) {
	process.env.NODE_ENV !== "production" && ks(`Error creating trusted types policy: ${e}`);
}
var Ms = As ? (e) => As.createHTML(e) : (e) => e, Ns = "http://www.w3.org/2000/svg", Ps = "http://www.w3.org/1998/Math/MathML", Fs = typeof document < "u" ? document : null, Is = Fs && /* @__PURE__ */ Fs.createElement("template"), Ls = {
	insert: (e, t, n) => {
		t.insertBefore(e, n || null);
	},
	remove: (e) => {
		let t = e.parentNode;
		t && t.removeChild(e);
	},
	createElement: (e, t, n, r) => {
		let i = t === "svg" ? Fs.createElementNS(Ns, e) : t === "mathml" ? Fs.createElementNS(Ps, e) : n ? Fs.createElement(e, { is: n }) : Fs.createElement(e);
		return e === "select" && r && r.multiple != null && i.setAttribute("multiple", r.multiple), i;
	},
	createText: (e) => Fs.createTextNode(e),
	createComment: (e) => Fs.createComment(e),
	setText: (e, t) => {
		e.nodeValue = t;
	},
	setElementText: (e, t) => {
		e.textContent = t;
	},
	parentNode: (e) => e.parentNode,
	nextSibling: (e) => e.nextSibling,
	querySelector: (e) => Fs.querySelector(e),
	setScopeId(e, t) {
		e.setAttribute(t, "");
	},
	insertStaticContent(e, t, n, r, i, a) {
		let o = n ? n.previousSibling : t.lastChild;
		if (i && (i === a || i.nextSibling)) for (; t.insertBefore(i.cloneNode(!0), n), i !== a && (i = i.nextSibling););
		else {
			Is.innerHTML = Ms(r === "svg" ? `<svg>${e}</svg>` : r === "mathml" ? `<math>${e}</math>` : e);
			let i = Is.content;
			if (r === "svg" || r === "mathml") {
				let e = i.firstChild;
				for (; e.firstChild;) i.appendChild(e.firstChild);
				i.removeChild(e);
			}
			t.insertBefore(i, n);
		}
		return [o ? o.nextSibling : t.firstChild, n ? n.previousSibling : t.lastChild];
	}
}, Rs = /* @__PURE__ */ Symbol("_vtc");
function zs(e, t, n) {
	let r = e[Rs];
	r && (t = (t ? [t, ...r] : [...r]).join(" ")), t == null ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
}
var Bs = /* @__PURE__ */ Symbol("_vod"), Vs = /* @__PURE__ */ Symbol("_vsh"), Hs = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "CSS_VAR_TEXT"), Us = /(?:^|;)\s*display\s*:/;
function Ws(e, t, n) {
	let r = e.style, i = g(n), a = !1;
	if (n && !i) {
		if (t) {
			if (g(t)) for (let e of t.split(";")) {
				let t = e.slice(0, e.indexOf(":")).trim();
				n[t] ?? qs(r, t, "");
			}
			else for (let e in t) n[e] ?? qs(r, e, "");
		}
		for (let i in n) {
			i === "display" && (a = !0);
			let o = n[i];
			o == null ? qs(r, i, "") : Zs(e, i, !g(t) && t ? t[i] : void 0, o) || qs(r, i, o);
		}
	} else if (i) {
		if (t !== n) {
			let e = r[Hs];
			e && (n += ";" + e), r.cssText = n, a = Us.test(n);
		}
	} else t && e.removeAttribute("style");
	Bs in e && (e[Bs] = a ? r.display : "", e[Vs] && (r.display = "none"));
}
var Gs = /[^\\];\s*$/, Ks = /\s*!important$/;
function qs(e, t, n) {
	if (d(n)) n.forEach((n) => qs(e, t, n));
	else if (n ??= "", process.env.NODE_ENV !== "production" && Gs.test(n) && ks(`Unexpected semicolon at the end of '${t}' style value: '${n}'`), t.startsWith("--")) Ks.test(n) ? e.setProperty(t, n.replace(Ks, ""), "important") : e.setProperty(t, n);
	else {
		let r = Xs(e, t);
		Ks.test(n) ? e.setProperty(O(r), n.replace(Ks, ""), "important") : e[r] = n;
	}
}
var Js = [
	"Webkit",
	"Moz",
	"ms"
], Ys = {};
function Xs(e, t) {
	let n = Ys[t];
	if (n) return n;
	let r = E(t);
	if (r !== "filter" && r in e) return Ys[t] = r;
	r = k(r);
	for (let n = 0; n < Js.length; n++) {
		let i = Js[n] + r;
		if (i in e) return Ys[t] = i;
	}
	return t;
}
function Zs(e, t, n, r) {
	return e.tagName === "TEXTAREA" && (t === "width" || t === "height") && g(r) && n === r;
}
var Qs = "http://www.w3.org/1999/xlink";
function $s(e, t, n, r, i, a = _e(t)) {
	r && t.startsWith("xlink:") ? n == null ? e.removeAttributeNS(Qs, t.slice(6, t.length)) : e.setAttributeNS(Qs, t, n) : n == null || a && !ve(n) ? e.removeAttribute(t) : e.setAttribute(t, a ? "" : _(n) ? String(n) : n);
}
function ec(e, t, n, r, i) {
	if (t === "innerHTML" || t === "textContent") {
		n != null && (e[t] = t === "innerHTML" ? Ms(n) : n);
		return;
	}
	let a = e.tagName;
	if (t === "value" && a !== "PROGRESS" && !a.includes("-")) {
		let r = a === "OPTION" ? e.getAttribute("value") || "" : e.value, i = n == null ? e.type === "checkbox" ? "on" : "" : String(n);
		(r !== i || !("_value" in e)) && (e.value = i), n ?? e.removeAttribute(t), e._value = n;
		return;
	}
	let o = !1;
	if (n === "" || n == null) {
		let r = typeof e[t];
		r === "boolean" ? n = ve(n) : n == null && r === "string" ? (n = "", o = !0) : r === "number" && (n = 0, o = !0);
	}
	try {
		e[t] = n;
	} catch (e) {
		process.env.NODE_ENV !== "production" && !o && ks(`Failed setting prop "${t}" on <${a.toLowerCase()}>: value ${n} is invalid.`, e);
	}
	o && e.removeAttribute(i || t);
}
function tc(e, t, n, r) {
	e.addEventListener(t, n, r);
}
function nc(e, t, n, r) {
	e.removeEventListener(t, n, r);
}
var rc = /* @__PURE__ */ Symbol("_vei");
function ic(e, t, n, r, i = null) {
	let a = e[rc] || (e[rc] = {}), o = a[t];
	if (r && o) o.value = process.env.NODE_ENV === "production" ? r : fc(r, t);
	else {
		let [n, s] = sc(t);
		r ? tc(e, n, a[t] = dc(process.env.NODE_ENV === "production" ? r : fc(r, t), i), s) : o && (nc(e, n, o, s), a[t] = void 0);
	}
}
var ac = /(Once|Passive|Capture)$/, oc = /^on:?(?:Once|Passive|Capture)$/;
function sc(e) {
	let t, n;
	for (; (n = e.match(ac)) && !oc.test(e);) t ||= {}, e = e.slice(0, e.length - n[1].length), t[n[1].toLowerCase()] = !0;
	return [e[2] === ":" ? e.slice(3) : O(e.slice(2)), t];
}
var cc = 0, lc = /* @__PURE__ */ Promise.resolve(), uc = () => cc ||= (lc.then(() => cc = 0), Date.now());
function dc(e, t) {
	let n = (e) => {
		if (!e._vts) e._vts = Date.now();
		else if (e._vts <= n.attached) return;
		let r = n.value;
		if (d(r)) {
			let n = e.stopImmediatePropagation;
			e.stopImmediatePropagation = () => {
				n.call(e), e._stopped = !0;
			};
			let i = r.slice(), a = [e];
			for (let n = 0; n < i.length && !e._stopped; n++) {
				let e = i[n];
				e && Fn(e, t, 5, a);
			}
		} else Fn(r, t, 5, [e]);
	};
	return n.value = e, n.attached = uc(), n;
}
function fc(e, t) {
	return h(e) || d(e) ? e : (ks(`Wrong type passed as event handler to ${t} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof e}.`), r);
}
var pc = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, mc = (e, t, n, r, i, s) => {
	let c = i === "svg";
	t === "class" ? zs(e, r, c) : t === "style" ? Ws(e, n, r) : a(t) ? o(t) || ic(e, t, n, r, s) : (t[0] === "." ? (t = t.slice(1), 1) : t[0] === "^" ? (t = t.slice(1), 0) : hc(e, t, r, c)) ? (ec(e, t, r), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && $s(e, t, r, c, s, t !== "value")) : e._isVueCE && (gc(e, t) || e._def.__asyncLoader && (/[A-Z]/.test(t) || !g(r))) ? ec(e, E(t), r, s, t) : (t === "true-value" ? e._trueValue = r : t === "false-value" && (e._falseValue = r), $s(e, t, r, c));
};
function hc(e, t, n, r) {
	if (r) return !!(t === "innerHTML" || t === "textContent" || t in e && pc(t) && h(n));
	if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "autocorrect" || t === "sandbox" && e.tagName === "IFRAME" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA") return !1;
	if (t === "width" || t === "height") {
		let t = e.tagName;
		if (t === "IMG" || t === "VIDEO" || t === "CANVAS" || t === "SOURCE") return !1;
	}
	return pc(t) && g(n) ? !1 : t in e;
}
function gc(e, t) {
	let n = e._def.props;
	if (!n) return !1;
	let r = E(t);
	return Array.isArray(n) ? n.some((e) => E(e) === r) : Object.keys(n).some((e) => E(e) === r);
}
var _c = [
	"ctrl",
	"shift",
	"alt",
	"meta"
], vc = {
	stop: (e) => e.stopPropagation(),
	prevent: (e) => e.preventDefault(),
	self: (e) => e.target !== e.currentTarget,
	ctrl: (e) => !e.ctrlKey,
	shift: (e) => !e.shiftKey,
	alt: (e) => !e.altKey,
	meta: (e) => !e.metaKey,
	left: (e) => "button" in e && e.button !== 0,
	middle: (e) => "button" in e && e.button !== 1,
	right: (e) => "button" in e && e.button !== 2,
	exact: (e, t) => _c.some((n) => e[`${n}Key`] && !t.includes(n))
}, yc = (e, t) => {
	if (!e) return e;
	let n = e._withMods ||= {}, r = t.join(".");
	return n[r] || (n[r] = ((n, ...r) => {
		for (let e = 0; e < t.length; e++) {
			let r = vc[t[e]];
			if (r && r(n, t)) return;
		}
		return e(n, ...r);
	}));
}, bc = {
	esc: "escape",
	space: " ",
	up: "arrow-up",
	left: "arrow-left",
	right: "arrow-right",
	down: "arrow-down",
	delete: "backspace"
}, xc = (e, t) => {
	let n = e._withKeys ||= {}, r = t.join(".");
	return n[r] || (n[r] = ((n) => {
		if (!("key" in n)) return;
		let r = O(n.key);
		if (t.some((e) => e === r || bc[e] === r)) return e(n);
	}));
}, Sc = /* @__PURE__ */ s({ patchProp: mc }, Ls), Cc;
function wc() {
	return Cc ||= po(Sc);
}
var Tc = ((...e) => {
	let t = wc().createApp(...e);
	process.env.NODE_ENV !== "production" && (Dc(t), Oc(t));
	let { mount: n } = t;
	return t.mount = (e) => {
		let r = kc(e);
		if (!r) return;
		let i = t._component;
		!h(i) && !i.render && !i.template && (i.template = r.innerHTML), r.nodeType === 1 && (r.textContent = "");
		let a = n(r, !1, Ec(r));
		return r instanceof Element && (r.removeAttribute("v-cloak"), r.setAttribute("data-v-app", "")), a;
	}, t;
});
function Ec(e) {
	if (e instanceof SVGElement) return "svg";
	if (typeof MathMLElement == "function" && e instanceof MathMLElement) return "mathml";
}
function Dc(e) {
	Object.defineProperty(e.config, "isNativeTag", {
		value: (e) => pe(e) || me(e) || he(e),
		writable: !1
	});
}
function Oc(e) {
	if (hs()) {
		let t = e.config.isCustomElement;
		Object.defineProperty(e.config, "isCustomElement", {
			get() {
				return t;
			},
			set() {
				ks("The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead.");
			}
		});
		let n = e.config.compilerOptions, r = "The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka \"full build\"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader's `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc";
		Object.defineProperty(e.config, "compilerOptions", {
			get() {
				return ks(r), n;
			},
			set() {
				ks(r);
			}
		});
	}
}
function kc(e) {
	if (g(e)) {
		let t = document.querySelector(e);
		return process.env.NODE_ENV !== "production" && !t && ks(`Failed to mount app: mount target selector "${e}" returned null.`), t;
	}
	return process.env.NODE_ENV !== "production" && window.ShadowRoot && e instanceof window.ShadowRoot && e.mode === "closed" && ks("mounting on a ShadowRoot with `{mode: \"closed\"}` may lead to unpredictable bugs"), e;
}
//#endregion
//#region ../../node_modules/vue/dist/vue.runtime.esm-bundler.js
function Ac() {
	Ds();
}
process.env.NODE_ENV !== "production" && Ac();
//#endregion
//#region ../../node_modules/@iconify/vue/dist/iconify.mjs
var jc = /^[a-z0-9]+(-[a-z0-9]+)*$/, Mc = (e, t, n, r = "") => {
	let i = e.split(":");
	if (e.slice(0, 1) === "@") {
		if (i.length < 2 || i.length > 3) return null;
		r = i.shift().slice(1);
	}
	if (i.length > 3 || !i.length) return null;
	if (i.length > 1) {
		let e = i.pop(), n = i.pop(), a = {
			provider: i.length > 0 ? i[0] : r,
			prefix: n,
			name: e
		};
		return t && !Nc(a) ? null : a;
	}
	let a = i[0], o = a.split("-");
	if (o.length > 1) {
		let e = {
			provider: r,
			prefix: o.shift(),
			name: o.join("-")
		};
		return t && !Nc(e) ? null : e;
	}
	if (n && r === "") {
		let e = {
			provider: r,
			prefix: "",
			name: a
		};
		return t && !Nc(e, n) ? null : e;
	}
	return null;
}, Nc = (e, t) => e ? !!((t && e.prefix === "" || e.prefix) && e.name) : !1;
function Pc(e, t) {
	let n = e.icons, r = e.aliases || Object.create(null), i = Object.create(null);
	function a(e) {
		if (n[e]) return i[e] = [];
		if (!(e in i)) {
			i[e] = null;
			let t = r[e] && r[e].parent, n = t && a(t);
			n && (i[e] = [t].concat(n));
		}
		return i[e];
	}
	return Object.keys(n).concat(Object.keys(r)).forEach(a), i;
}
var Fc = Object.freeze({
	left: 0,
	top: 0,
	width: 16,
	height: 16
}), Ic = Object.freeze({
	rotate: 0,
	vFlip: !1,
	hFlip: !1
}), Lc = Object.freeze({
	...Fc,
	...Ic
}), Rc = Object.freeze({
	...Lc,
	body: "",
	hidden: !1
});
function zc(e, t) {
	let n = {};
	!e.hFlip != !t.hFlip && (n.hFlip = !0), !e.vFlip != !t.vFlip && (n.vFlip = !0);
	let r = ((e.rotate || 0) + (t.rotate || 0)) % 4;
	return r && (n.rotate = r), n;
}
function Bc(e, t) {
	let n = zc(e, t);
	for (let r in Rc) r in Ic ? r in e && !(r in n) && (n[r] = Ic[r]) : r in t ? n[r] = t[r] : r in e && (n[r] = e[r]);
	return n;
}
function Vc(e, t, n) {
	let r = e.icons, i = e.aliases || Object.create(null), a = {};
	function o(e) {
		a = Bc(r[e] || i[e], a);
	}
	return o(t), n.forEach(o), Bc(e, a);
}
function Hc(e, t) {
	let n = [];
	if (typeof e != "object" || typeof e.icons != "object") return n;
	e.not_found instanceof Array && e.not_found.forEach((e) => {
		t(e, null), n.push(e);
	});
	let r = Pc(e);
	for (let i in r) {
		let a = r[i];
		a && (t(i, Vc(e, i, a)), n.push(i));
	}
	return n;
}
var Uc = {
	provider: "",
	aliases: {},
	not_found: {},
	...Fc
};
function Wc(e, t) {
	for (let n in t) if (n in e && typeof e[n] != typeof t[n]) return !1;
	return !0;
}
function Gc(e) {
	if (typeof e != "object" || !e) return null;
	let t = e;
	if (typeof t.prefix != "string" || !e.icons || typeof e.icons != "object" || !Wc(e, Uc)) return null;
	let n = t.icons;
	for (let e in n) {
		let t = n[e];
		if (!e || typeof t.body != "string" || !Wc(t, Rc)) return null;
	}
	let r = t.aliases || Object.create(null);
	for (let e in r) {
		let t = r[e], i = t.parent;
		if (!e || typeof i != "string" || !n[i] && !r[i] || !Wc(t, Rc)) return null;
	}
	return t;
}
var Kc = Object.create(null);
function qc(e, t) {
	return {
		provider: e,
		prefix: t,
		icons: Object.create(null),
		missing: /* @__PURE__ */ new Set()
	};
}
function Jc(e, t) {
	let n = Kc[e] || (Kc[e] = Object.create(null));
	return n[t] || (n[t] = qc(e, t));
}
function Yc(e, t) {
	return Gc(t) ? Hc(t, (t, n) => {
		n ? e.icons[t] = n : e.missing.add(t);
	}) : [];
}
function Xc(e, t, n) {
	try {
		if (typeof n.body == "string") return e.icons[t] = { ...n }, !0;
	} catch {}
	return !1;
}
var Zc = !1;
function Qc(e) {
	return typeof e == "boolean" && (Zc = e), Zc;
}
function $c(e) {
	let t = typeof e == "string" ? Mc(e, !0, Zc) : e;
	if (t) {
		let e = Jc(t.provider, t.prefix), n = t.name;
		return e.icons[n] || (e.missing.has(n) ? null : void 0);
	}
}
function el(e, t) {
	let n = Mc(e, !0, Zc);
	if (!n) return !1;
	let r = Jc(n.provider, n.prefix);
	return t ? Xc(r, n.name, t) : (r.missing.add(n.name), !0);
}
function tl(e, t) {
	if (typeof e != "object") return !1;
	if (typeof t != "string" && (t = e.provider || ""), Zc && !t && !e.prefix) {
		let t = !1;
		return Gc(e) && (e.prefix = "", Hc(e, (e, n) => {
			el(e, n) && (t = !0);
		})), t;
	}
	let n = e.prefix;
	return Nc({
		prefix: n,
		name: "a"
	}) ? !!Yc(Jc(t, n), e) : !1;
}
function nl(e) {
	return !!$c(e);
}
var rl = Object.freeze({
	width: null,
	height: null
}), il = Object.freeze({
	...rl,
	...Ic
}), al = /(-?[0-9.]*[0-9]+[0-9.]*)/g, ol = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function sl(e, t, n) {
	if (t === 1) return e;
	if (n ||= 100, typeof e == "number") return Math.ceil(e * t * n) / n;
	if (typeof e != "string") return e;
	let r = e.split(al);
	if (r === null || !r.length) return e;
	let i = [], a = r.shift(), o = ol.test(a);
	for (;;) {
		if (o) {
			let e = parseFloat(a);
			isNaN(e) ? i.push(a) : i.push(Math.ceil(e * t * n) / n);
		} else i.push(a);
		if (a = r.shift(), a === void 0) return i.join("");
		o = !o;
	}
}
function cl(e, t = "defs") {
	let n = "", r = e.indexOf("<" + t);
	for (; r >= 0;) {
		let i = e.indexOf(">", r), a = e.indexOf("</" + t);
		if (i === -1 || a === -1) break;
		let o = e.indexOf(">", a);
		if (o === -1) break;
		n += e.slice(i + 1, a).trim(), e = e.slice(0, r).trim() + e.slice(o + 1);
	}
	return {
		defs: n,
		content: e
	};
}
function ll(e, t) {
	return e ? "<defs>" + e + "</defs>" + t : t;
}
function ul(e, t, n) {
	let r = cl(e);
	return ll(r.defs, t + r.content + n);
}
var dl = (e) => e === "unset" || e === "undefined" || e === "none";
function fl(e, t) {
	let n = {
		...Lc,
		...e
	}, r = {
		...il,
		...t
	}, i = {
		left: n.left,
		top: n.top,
		width: n.width,
		height: n.height
	}, a = n.body;
	[n, r].forEach((e) => {
		let t = [], n = e.hFlip, r = e.vFlip, o = e.rotate;
		n ? r ? o += 2 : (t.push("translate(" + (i.width + i.left).toString() + " " + (0 - i.top).toString() + ")"), t.push("scale(-1 1)"), i.top = i.left = 0) : r && (t.push("translate(" + (0 - i.left).toString() + " " + (i.height + i.top).toString() + ")"), t.push("scale(1 -1)"), i.top = i.left = 0);
		let s;
		switch (o < 0 && (o -= Math.floor(o / 4) * 4), o %= 4, o) {
			case 1:
				s = i.height / 2 + i.top, t.unshift("rotate(90 " + s.toString() + " " + s.toString() + ")");
				break;
			case 2:
				t.unshift("rotate(180 " + (i.width / 2 + i.left).toString() + " " + (i.height / 2 + i.top).toString() + ")");
				break;
			case 3: s = i.width / 2 + i.left, t.unshift("rotate(-90 " + s.toString() + " " + s.toString() + ")");
		}
		o % 2 == 1 && (i.left !== i.top && (s = i.left, i.left = i.top, i.top = s), i.width !== i.height && (s = i.width, i.width = i.height, i.height = s)), t.length && (a = ul(a, "<g transform=\"" + t.join(" ") + "\">", "</g>"));
	});
	let o = r.width, s = r.height, c = i.width, l = i.height, u, d;
	o === null ? (d = s === null ? "1em" : s === "auto" ? l : s, u = sl(d, c / l)) : (u = o === "auto" ? c : o, d = s === null ? sl(u, l / c) : s === "auto" ? l : s);
	let f = {}, p = (e, t) => {
		dl(t) || (f[e] = t.toString());
	};
	p("width", u), p("height", d);
	let m = [
		i.left,
		i.top,
		c,
		l
	];
	return f.viewBox = m.join(" "), {
		attributes: f,
		viewBox: m,
		body: a
	};
}
var pl = /\sid="(\S+)"/g, ml = /* @__PURE__ */ new Map();
function hl(e) {
	e = e.replace(/[0-9]+$/, "") || "a";
	let t = ml.get(e) || 0;
	return ml.set(e, t + 1), t ? `${e}${t}` : e;
}
function gl(e) {
	let t = [], n;
	for (; n = pl.exec(e);) t.push(n[1]);
	if (!t.length) return e;
	let r = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
	return t.forEach((t) => {
		let n = hl(t), i = t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
		e = e.replace(RegExp("([#;\"])(" + i + ")([\")]|\\.[a-z])", "g"), "$1" + n + r + "$3");
	}), e = e.replace(new RegExp(r, "g"), ""), e;
}
var _l = Object.create(null);
function vl(e, t) {
	_l[e] = t;
}
function yl(e) {
	return _l[e] || _l[""];
}
function bl(e) {
	let t;
	if (typeof e.resources == "string") t = [e.resources];
	else if (t = e.resources, !(t instanceof Array) || !t.length) return null;
	return {
		resources: t,
		path: e.path || "/",
		maxURL: e.maxURL || 500,
		rotate: e.rotate || 750,
		timeout: e.timeout || 5e3,
		random: e.random === !0,
		index: e.index || 0,
		dataAfterTimeout: e.dataAfterTimeout !== !1
	};
}
for (var xl = Object.create(null), Sl = ["https://api.simplesvg.com", "https://api.unisvg.com"], Cl = []; Sl.length > 0;) Sl.length === 1 || Math.random() > .5 ? Cl.push(Sl.shift()) : Cl.push(Sl.pop());
xl[""] = bl({ resources: ["https://api.iconify.design"].concat(Cl) });
function wl(e, t) {
	let n = bl(t);
	return n !== null && (xl[e] = n, !0);
}
function Tl(e) {
	return xl[e];
}
var El = (() => {
	let e;
	try {
		if (e = fetch, typeof e == "function") return e;
	} catch {}
})();
function Dl(e, t) {
	let n = Tl(e);
	if (!n) return 0;
	let r;
	if (!n.maxURL) r = 0;
	else {
		let e = 0;
		n.resources.forEach((t) => {
			e = Math.max(e, t.length);
		});
		let i = t + ".json?icons=";
		r = n.maxURL - e - n.path.length - i.length;
	}
	return r;
}
function Ol(e) {
	return e === 404;
}
var kl = (e, t, n) => {
	let r = [], i = Dl(e, t), a = "icons", o = {
		type: a,
		provider: e,
		prefix: t,
		icons: []
	}, s = 0;
	return n.forEach((n, c) => {
		s += n.length + 1, s >= i && c > 0 && (r.push(o), o = {
			type: a,
			provider: e,
			prefix: t,
			icons: []
		}, s = n.length), o.icons.push(n);
	}), r.push(o), r;
};
function Al(e) {
	if (typeof e == "string") {
		let t = Tl(e);
		if (t) return t.path;
	}
	return "/";
}
var jl = {
	prepare: kl,
	send: (e, t, n) => {
		if (!El) {
			n("abort", 424);
			return;
		}
		let r = Al(t.provider);
		switch (t.type) {
			case "icons": {
				let e = t.prefix, n = t.icons.join(","), i = new URLSearchParams({ icons: n });
				r += e + ".json?" + i.toString();
				break;
			}
			case "custom": {
				let e = t.uri;
				r += e.slice(0, 1) === "/" ? e.slice(1) : e;
				break;
			}
			default:
				n("abort", 400);
				return;
		}
		let i = 503;
		El(e + r).then((e) => {
			let t = e.status;
			if (t !== 200) {
				setTimeout(() => {
					n(Ol(t) ? "abort" : "next", t);
				});
				return;
			}
			return i = 501, e.json();
		}).then((e) => {
			if (typeof e != "object" || !e) {
				setTimeout(() => {
					e === 404 ? n("abort", e) : n("next", i);
				});
				return;
			}
			setTimeout(() => {
				n("success", e);
			});
		}).catch(() => {
			n("next", i);
		});
	}
};
function Ml(e, t) {
	e.forEach((e) => {
		let n = e.loaderCallbacks;
		n && (e.loaderCallbacks = n.filter((e) => e.id !== t));
	});
}
function Nl(e) {
	e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
		e.pendingCallbacksFlag = !1;
		let t = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
		if (!t.length) return;
		let n = !1, r = e.provider, i = e.prefix;
		t.forEach((t) => {
			let a = t.icons, o = a.pending.length;
			a.pending = a.pending.filter((t) => {
				if (t.prefix !== i) return !0;
				let o = t.name;
				if (e.icons[o]) a.loaded.push({
					provider: r,
					prefix: i,
					name: o
				});
				else if (e.missing.has(o)) a.missing.push({
					provider: r,
					prefix: i,
					name: o
				});
				else return n = !0, !0;
				return !1;
			}), a.pending.length !== o && (n || Ml([e], t.id), t.callback(a.loaded.slice(0), a.missing.slice(0), a.pending.slice(0), t.abort));
		});
	}));
}
var Pl = 0;
function Fl(e, t, n) {
	let r = Pl++, i = Ml.bind(null, n, r);
	if (!t.pending.length) return i;
	let a = {
		id: r,
		icons: t,
		callback: e,
		abort: i
	};
	return n.forEach((e) => {
		(e.loaderCallbacks ||= []).push(a);
	}), i;
}
function Il(e) {
	let t = {
		loaded: [],
		missing: [],
		pending: []
	}, n = Object.create(null);
	e.sort((e, t) => e.provider === t.provider ? e.prefix === t.prefix ? e.name.localeCompare(t.name) : e.prefix.localeCompare(t.prefix) : e.provider.localeCompare(t.provider));
	let r = {
		provider: "",
		prefix: "",
		name: ""
	};
	return e.forEach((e) => {
		if (r.name === e.name && r.prefix === e.prefix && r.provider === e.provider) return;
		r = e;
		let i = e.provider, a = e.prefix, o = e.name, s = n[i] || (n[i] = Object.create(null)), c = s[a] || (s[a] = Jc(i, a)), l;
		l = o in c.icons ? t.loaded : a === "" || c.missing.has(o) ? t.missing : t.pending;
		let u = {
			provider: i,
			prefix: a,
			name: o
		};
		l.push(u);
	}), t;
}
function Ll(e, t = !0, n = !1) {
	let r = [];
	return e.forEach((e) => {
		let i = typeof e == "string" ? Mc(e, t, n) : e;
		i && r.push(i);
	}), r;
}
var Rl = {
	resources: [],
	index: 0,
	timeout: 2e3,
	rotate: 750,
	random: !1,
	dataAfterTimeout: !1
};
function zl(e, t, n, r) {
	let i = e.resources.length, a = e.random ? Math.floor(Math.random() * i) : e.index, o;
	if (e.random) {
		let t = e.resources.slice(0);
		for (o = []; t.length > 1;) {
			let e = Math.floor(Math.random() * t.length);
			o.push(t[e]), t = t.slice(0, e).concat(t.slice(e + 1));
		}
		o = o.concat(t);
	} else o = e.resources.slice(a).concat(e.resources.slice(0, a));
	let s = Date.now(), c = "pending", l = 0, u, d = null, f = [], p = [];
	typeof r == "function" && p.push(r);
	function m() {
		d &&= (clearTimeout(d), null);
	}
	function h() {
		c === "pending" && (c = "aborted"), m(), f.forEach((e) => {
			e.status === "pending" && (e.status = "aborted");
		}), f = [];
	}
	function g(e, t) {
		t && (p = []), typeof e == "function" && p.push(e);
	}
	function _() {
		return {
			startTime: s,
			payload: t,
			status: c,
			queriesSent: l,
			queriesPending: f.length,
			subscribe: g,
			abort: h
		};
	}
	function v() {
		c = "failed", p.forEach((e) => {
			e(void 0, u);
		});
	}
	function y() {
		f.forEach((e) => {
			e.status === "pending" && (e.status = "aborted");
		}), f = [];
	}
	function b(t, n, r) {
		let i = n !== "success";
		switch (f = f.filter((e) => e !== t), c) {
			case "pending": break;
			case "failed":
				if (i || !e.dataAfterTimeout) return;
				break;
			default: return;
		}
		if (n === "abort") {
			u = r, v();
			return;
		}
		if (i) {
			u = r, f.length || (o.length ? x() : v());
			return;
		}
		if (m(), y(), !e.random) {
			let n = e.resources.indexOf(t.resource);
			n !== -1 && n !== e.index && (e.index = n);
		}
		c = "completed", p.forEach((e) => {
			e(r);
		});
	}
	function x() {
		if (c !== "pending") return;
		m();
		let r = o.shift();
		if (r === void 0) {
			if (f.length) {
				d = setTimeout(() => {
					m(), c === "pending" && (y(), v());
				}, e.timeout);
				return;
			}
			v();
			return;
		}
		let i = {
			status: "pending",
			resource: r,
			callback: (e, t) => {
				b(i, e, t);
			}
		};
		f.push(i), l++, d = setTimeout(x, e.rotate), n(r, t, i.callback);
	}
	return setTimeout(x), _;
}
function Bl(e) {
	let t = {
		...Rl,
		...e
	}, n = [];
	function r() {
		n = n.filter((e) => e().status === "pending");
	}
	function i(e, i, a) {
		let o = zl(t, e, i, (e, t) => {
			r(), a && a(e, t);
		});
		return n.push(o), o;
	}
	function a(e) {
		return n.find((t) => e(t)) || null;
	}
	return {
		query: i,
		find: a,
		setIndex: (e) => {
			t.index = e;
		},
		getIndex: () => t.index,
		cleanup: r
	};
}
function Vl() {}
var Hl = Object.create(null);
function Ul(e) {
	if (!Hl[e]) {
		let t = Tl(e);
		if (!t) return;
		Hl[e] = {
			config: t,
			redundancy: Bl(t)
		};
	}
	return Hl[e];
}
function Wl(e, t, n) {
	let r, i;
	if (typeof e == "string") {
		let t = yl(e);
		if (!t) return n(void 0, 424), Vl;
		i = t.send;
		let a = Ul(e);
		a && (r = a.redundancy);
	} else {
		let t = bl(e);
		if (t) {
			r = Bl(t);
			let n = yl(e.resources ? e.resources[0] : "");
			n && (i = n.send);
		}
	}
	return !r || !i ? (n(void 0, 424), Vl) : r.query(t, i, n)().abort;
}
function Gl() {}
function Kl(e) {
	e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
		e.iconsLoaderFlag = !1, Nl(e);
	}));
}
function ql(e) {
	let t = [], n = [];
	return e.forEach((e) => {
		(e.match(jc) ? t : n).push(e);
	}), {
		valid: t,
		invalid: n
	};
}
function Jl(e, t, n) {
	function r() {
		let n = e.pendingIcons;
		t.forEach((t) => {
			n && n.delete(t), e.icons[t] || e.missing.add(t);
		});
	}
	if (n && typeof n == "object") try {
		if (!Yc(e, n).length) {
			r();
			return;
		}
	} catch (e) {
		console.error(e);
	}
	r(), Kl(e);
}
function Yl(e, t) {
	e instanceof Promise ? e.then((e) => {
		t(e);
	}).catch(() => {
		t(null);
	}) : t(e);
}
function Xl(e, t) {
	e.iconsToLoad = e.iconsToLoad ? e.iconsToLoad.concat(t).sort() : t, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
		e.iconsQueueFlag = !1;
		let { provider: t, prefix: n } = e, r = e.iconsToLoad;
		if (delete e.iconsToLoad, !r || !r.length) return;
		let i = e.loadIcon;
		if (e.loadIcons && (r.length > 1 || !i)) {
			Yl(e.loadIcons(r, n, t), (t) => {
				Jl(e, r, t);
			});
			return;
		}
		if (i) {
			r.forEach((r) => {
				Yl(i(r, n, t), (t) => {
					Jl(e, [r], t ? {
						prefix: n,
						icons: { [r]: t }
					} : null);
				});
			});
			return;
		}
		let { valid: a, invalid: o } = ql(r);
		if (o.length && Jl(e, o, null), !a.length) return;
		let s = n.match(jc) ? yl(t) : null;
		if (!s) {
			Jl(e, a, null);
			return;
		}
		s.prepare(t, n, a).forEach((n) => {
			Wl(t, n, (t) => {
				Jl(e, n.icons, t);
			});
		});
	}));
}
var Zl = (e, t) => {
	let n = Il(Ll(e, !0, Qc()));
	if (!n.pending.length) {
		let e = !0;
		return t && setTimeout(() => {
			e && t(n.loaded, n.missing, n.pending, Gl);
		}), () => {
			e = !1;
		};
	}
	let r = Object.create(null), i = [], a, o;
	return n.pending.forEach((e) => {
		let { provider: t, prefix: n } = e;
		if (n === o && t === a) return;
		a = t, o = n, i.push(Jc(t, n));
		let s = r[t] || (r[t] = Object.create(null));
		s[n] || (s[n] = []);
	}), n.pending.forEach((e) => {
		let { provider: t, prefix: n, name: i } = e, a = Jc(t, n), o = a.pendingIcons ||= /* @__PURE__ */ new Set();
		o.has(i) || (o.add(i), r[t][n].push(i));
	}), i.forEach((e) => {
		let t = r[e.provider][e.prefix];
		t.length && Xl(e, t);
	}), t ? Fl(t, n, i) : Gl;
};
function Ql(e, t) {
	let n = { ...e };
	for (let e in t) {
		let r = t[e], i = typeof r;
		e in rl ? (r === null || r && (i === "string" || i === "number")) && (n[e] = r) : i === typeof n[e] && (n[e] = e === "rotate" ? r % 4 : r);
	}
	return n;
}
var $l = /[\s,]+/;
function eu(e, t) {
	t.split($l).forEach((t) => {
		switch (t.trim()) {
			case "horizontal":
				e.hFlip = !0;
				break;
			case "vertical": e.vFlip = !0;
		}
	});
}
function tu(e, t = 0) {
	let n = e.replace(/^-?[0-9.]*/, "");
	function r(e) {
		for (; e < 0;) e += 4;
		return e % 4;
	}
	if (n === "") {
		let t = parseInt(e);
		return isNaN(t) ? 0 : r(t);
	}
	if (n !== e) {
		let t = 0;
		switch (n) {
			case "%":
				t = 25;
				break;
			case "deg": t = 90;
		}
		if (t) {
			let i = parseFloat(e.slice(0, e.length - n.length));
			return isNaN(i) ? 0 : (i /= t, i % 1 == 0 ? r(i) : 0);
		}
	}
	return t;
}
function nu(e, t) {
	let n = e.indexOf("xlink:") === -1 ? "" : " xmlns:xlink=\"http://www.w3.org/1999/xlink\"";
	for (let e in t) n += " " + e + "=\"" + t[e] + "\"";
	return "<svg xmlns=\"http://www.w3.org/2000/svg\"" + n + ">" + e + "</svg>";
}
function ru(e) {
	return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function iu(e) {
	return "data:image/svg+xml," + ru(e);
}
function au(e) {
	return "url(\"" + iu(e) + "\")";
}
var ou = {
	...il,
	inline: !1
}, su = {
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:xlink": "http://www.w3.org/1999/xlink",
	"aria-hidden": !0,
	role: "img"
}, cu = { display: "inline-block" }, lu = { backgroundColor: "currentColor" }, uu = { backgroundColor: "transparent" }, du = {
	Image: "var(--svg)",
	Repeat: "no-repeat",
	Size: "100% 100%"
}, fu = {
	webkitMask: lu,
	mask: lu,
	background: uu
};
for (let e in fu) {
	let t = fu[e];
	for (let n in du) t[e + n] = du[n];
}
var pu = {};
["horizontal", "vertical"].forEach((e) => {
	let t = e.slice(0, 1) + "Flip";
	pu[e + "-flip"] = t, pu[e.slice(0, 1) + "-flip"] = t, pu[e + "Flip"] = t;
});
function mu(e) {
	return e + (e.match(/^[-0-9.]+$/) ? "px" : "");
}
var hu = (e, t) => {
	let n = Ql(ou, t), r = { ...su }, i = t.mode || "svg", a = {}, o = t.style, s = typeof o == "object" && !(o instanceof Array) ? o : {};
	for (let e in t) {
		let i = t[e];
		if (i !== void 0) switch (e) {
			case "icon":
			case "style":
			case "onLoad":
			case "mode":
			case "ssr":
			case "customise": break;
			case "inline":
			case "hFlip":
			case "vFlip":
				n[e] = i === !0 || i === "true" || i === 1;
				break;
			case "flip":
				typeof i == "string" && eu(n, i);
				break;
			case "color":
				a.color = i;
				break;
			case "rotate":
				typeof i == "string" ? n[e] = tu(i) : typeof i == "number" && (n[e] = i);
				break;
			case "ariaHidden":
			case "aria-hidden":
				i !== !0 && i !== "true" && delete r["aria-hidden"];
				break;
			default: {
				let t = pu[e];
				t ? (i === !0 || i === "true" || i === 1) && (n[t] = !0) : ou[e] === void 0 && (r[e] = i);
			}
		}
	}
	let c = fl(e, n), l = c.attributes;
	if (n.inline && (a.verticalAlign = "-0.125em"), i === "svg") return r.style = {
		...a,
		...s
	}, Object.assign(r, l), r.innerHTML = gl(c.body), Es("svg", r);
	let { body: u, width: d, height: f } = e, p = i === "mask" || i !== "bg" && u.indexOf("currentColor") !== -1, m = nu(u, {
		...l,
		width: d + "",
		height: f + ""
	});
	return r.style = {
		...a,
		"--svg": au(m),
		width: mu(l.width),
		height: mu(l.height),
		...cu,
		...p ? lu : uu,
		...s
	}, Es("span", r);
};
if (Qc(!0), vl("", jl), typeof document < "u" && typeof window < "u") {
	let e = window;
	if (e.IconifyPreload !== void 0) {
		let t = e.IconifyPreload, n = "Invalid IconifyPreload syntax.";
		typeof t == "object" && t && (t instanceof Array ? t : [t]).forEach((e) => {
			try {
				(typeof e != "object" || !e || e instanceof Array || typeof e.icons != "object" || typeof e.prefix != "string" || !tl(e)) && console.error(n);
			} catch {
				console.error(n);
			}
		});
	}
	if (e.IconifyProviders !== void 0) {
		let t = e.IconifyProviders;
		if (typeof t == "object" && t) for (let e in t) {
			let n = "IconifyProviders[" + e + "] is invalid.";
			try {
				let r = t[e];
				if (typeof r != "object" || !r || r.resources === void 0) continue;
				wl(e, r) || console.error(n);
			} catch {
				console.error(n);
			}
		}
	}
}
var gu = {
	...Lc,
	body: ""
}, _u = /* @__PURE__ */ Qr((e, { emit: t }) => {
	let n = /* @__PURE__ */ B(null);
	function r() {
		n.value &&= (n.value.abort?.(), null);
	}
	let i = /* @__PURE__ */ B(!!e.ssr), a = /* @__PURE__ */ B(""), o = /* @__PURE__ */ tn(null);
	function s() {
		let i = e.icon;
		if (typeof i == "object" && i && typeof i.body == "string") return a.value = "", { data: i };
		let o;
		if (typeof i != "string" || (o = Mc(i, !1, !0)) === null) return null;
		let s = $c(o);
		if (!s) {
			let e = n.value;
			return (!e || e.name !== i) && (s === null ? n.value = { name: i } : n.value = {
				name: i,
				abort: Zl([o], c)
			}), null;
		}
		r(), a.value !== i && (a.value = i, Kn(() => {
			t("load", i);
		}));
		let l = e.customise;
		if (l) {
			s = Object.assign({}, s);
			let e = l(s.body, o.name, o.prefix, o.provider);
			typeof e == "string" && (s.body = e);
		}
		let u = ["iconify"];
		return o.prefix !== "" && u.push("iconify--" + o.prefix), o.provider !== "" && u.push("iconify--" + o.provider), {
			data: s,
			classes: u
		};
	}
	function c() {
		let e = s();
		e ? e.data !== o.value?.data && (o.value = e) : o.value = null;
	}
	return i.value ? c() : gi(() => {
		i.value = !0, c();
	}), Hr(() => e.icon, c), bi(r), () => {
		let t = o.value;
		if (!t) return hu(gu, e);
		let n = e;
		return t.classes && (n = {
			...e,
			class: t.classes.join(" ")
		}), hu({
			...Lc,
			...t.data
		}, n);
	};
}, {
	props: [
		"icon",
		"mode",
		"ssr",
		"width",
		"height",
		"style",
		"color",
		"inline",
		"rotate",
		"hFlip",
		"horizontalFlip",
		"vFlip",
		"verticalFlip",
		"flip",
		"id",
		"ariaHidden",
		"customise",
		"title"
	],
	emits: ["load"]
}), vu = !1;
function yu(e) {
	if (vu) return;
	let t = JSON.parse("[{\"prefix\":\"lucide\",\"icons\":{\"arrow-down\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"M12 5v14m7-7l-7 7l-7-7\\\"/>\"},\"arrow-left\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"m12 19l-7-7l7-7m7 7H5\\\"/>\"},\"arrow-right\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"M5 12h14m-7-7l7 7l-7 7\\\"/>\"},\"arrow-up\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"m5 12l7-7l7 7m-7 7V5\\\"/>\"},\"arrow-up-right\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"M7 7h10v10M7 17L17 7\\\"/>\"},\"check\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"M20 6L9 17l-5-5\\\"/>\"},\"chevron-down\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"m6 9l6 6l6-6\\\"/>\"},\"chevron-left\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"m15 18l-6-6l6-6\\\"/>\"},\"chevron-right\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"m9 18l6-6l-6-6\\\"/>\"},\"chevron-up\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"m18 15l-6-6l-6 6\\\"/>\"},\"chevrons-left\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"m11 17l-5-5l5-5m7 10l-5-5l5-5\\\"/>\"},\"chevrons-right\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"m6 17l5-5l-5-5m7 10l5-5l-5-5\\\"/>\"},\"circle-alert\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><circle cx=\\\"12\\\" cy=\\\"12\\\" r=\\\"10\\\"/><path d=\\\"M12 8v4m0 4h.01\\\"/></g>\"},\"circle-check\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><circle cx=\\\"12\\\" cy=\\\"12\\\" r=\\\"10\\\"/><path d=\\\"m16 9l-5.5 5.5L8 12\\\"/></g>\"},\"circle-x\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><circle cx=\\\"12\\\" cy=\\\"12\\\" r=\\\"10\\\"/><path d=\\\"m15 9l-6 6m0-6l6 6\\\"/></g>\"},\"copy\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><rect width=\\\"14\\\" height=\\\"14\\\" x=\\\"8\\\" y=\\\"8\\\" rx=\\\"2\\\" ry=\\\"2\\\"/><path d=\\\"M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2\\\"/></g>\"},\"copy-check\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><path d=\\\"m12 15l2 2l4-4\\\"/><rect width=\\\"14\\\" height=\\\"14\\\" x=\\\"8\\\" y=\\\"8\\\" rx=\\\"2\\\" ry=\\\"2\\\"/><path d=\\\"M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2\\\"/></g>\"},\"ellipsis\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><circle cx=\\\"12\\\" cy=\\\"12\\\" r=\\\"1\\\"/><circle cx=\\\"19\\\" cy=\\\"12\\\" r=\\\"1\\\"/><circle cx=\\\"5\\\" cy=\\\"12\\\" r=\\\"1\\\"/></g>\"},\"eye\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><path d=\\\"M2.062 12.348a1 1 0 0 1 0-.696a10.75 10.75 0 0 1 19.876 0a1 1 0 0 1 0 .696a10.75 10.75 0 0 1-19.876 0\\\"/><circle cx=\\\"12\\\" cy=\\\"12\\\" r=\\\"3\\\"/></g>\"},\"eye-off\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><path d=\\\"M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575a1 1 0 0 1 0 .696a10.8 10.8 0 0 1-1.444 2.49m-6.41-.679a3 3 0 0 1-4.242-4.242\\\"/><path d=\\\"M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151a1 1 0 0 1 0-.696a10.75 10.75 0 0 1 4.446-5.143M2 2l20 20\\\"/></g>\"},\"file\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><path d=\\\"M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z\\\"/><path d=\\\"M14 2v5a1 1 0 0 0 1 1h5\\\"/></g>\"},\"folder\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z\\\"/>\"},\"folder-open\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"m6 14l1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2\\\"/>\"},\"grip-vertical\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><circle cx=\\\"9\\\" cy=\\\"12\\\" r=\\\"1\\\"/><circle cx=\\\"9\\\" cy=\\\"5\\\" r=\\\"1\\\"/><circle cx=\\\"9\\\" cy=\\\"19\\\" r=\\\"1\\\"/><circle cx=\\\"15\\\" cy=\\\"12\\\" r=\\\"1\\\"/><circle cx=\\\"15\\\" cy=\\\"5\\\" r=\\\"1\\\"/><circle cx=\\\"15\\\" cy=\\\"19\\\" r=\\\"1\\\"/></g>\"},\"hash\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"M4 9h16M4 15h16M10 3L8 21m8-18l-2 18\\\"/>\"},\"info\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><circle cx=\\\"12\\\" cy=\\\"12\\\" r=\\\"10\\\"/><path d=\\\"M12 16v-4m0-4h.01\\\"/></g>\"},\"lightbulb\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"M15 14c.2-1 .7-1.7 1.5-2.5c1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5c.7.7 1.3 1.5 1.5 2.5m0 4h6m-5 4h4\\\"/>\"},\"loader-circle\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"M21 12a9 9 0 1 1-6.219-8.56\\\"/>\"},\"menu\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"M4 5h16M4 12h16M4 19h16\\\"/>\"},\"minus\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"M5 12h14\\\"/>\"},\"monitor\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><rect width=\\\"20\\\" height=\\\"14\\\" x=\\\"2\\\" y=\\\"3\\\" rx=\\\"2\\\"/><path d=\\\"M8 21h8m-4-4v4\\\"/></g>\"},\"moon\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401\\\"/>\"},\"panel-left-close\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><rect width=\\\"18\\\" height=\\\"18\\\" x=\\\"3\\\" y=\\\"3\\\" rx=\\\"2\\\"/><path d=\\\"M9 3v18m7-6l-3-3l3-3\\\"/></g>\"},\"panel-left-open\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><rect width=\\\"18\\\" height=\\\"18\\\" x=\\\"3\\\" y=\\\"3\\\" rx=\\\"2\\\"/><path d=\\\"M9 3v18m5-12l3 3l-3 3\\\"/></g>\"},\"plus\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"M5 12h14m-7-7v14\\\"/>\"},\"rotate-ccw\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><path d=\\\"M3 12a9 9 0 1 0 9-9a9.75 9.75 0 0 0-6.74 2.74L3 8\\\"/><path d=\\\"M3 3v5h5\\\"/></g>\"},\"search\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><path d=\\\"m21 21l-4.34-4.34\\\"/><circle cx=\\\"11\\\" cy=\\\"11\\\" r=\\\"8\\\"/></g>\"},\"square\":{\"width\":24,\"height\":24,\"body\":\"<rect width=\\\"18\\\" height=\\\"18\\\" x=\\\"3\\\" y=\\\"3\\\" fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" rx=\\\"2\\\"/>\"},\"star\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z\\\"/>\"},\"sun\":{\"width\":24,\"height\":24,\"body\":\"<g fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\"><circle cx=\\\"12\\\" cy=\\\"12\\\" r=\\\"4\\\"/><path d=\\\"M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41\\\"/></g>\"},\"triangle-alert\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"m21.73 18l-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3M12 9v4m0 4h.01\\\"/>\"},\"upload\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"M12 3v12m5-7l-5-5l-5 5m14 7v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\\\"/>\"},\"x\":{\"width\":24,\"height\":24,\"body\":\"<path fill=\\\"none\\\" stroke=\\\"currentColor\\\" stroke-linecap=\\\"round\\\" stroke-linejoin=\\\"round\\\" stroke-width=\\\"2\\\" d=\\\"M18 6L6 18M6 6l12 12\\\"/>\"}}}]");
	for (let n of t) for (let [t, r] of Object.entries(n.icons)) e(n.prefix ? n.prefix + ":" + t : t, r);
	vu = !0;
}
//#endregion
//#region ../../node_modules/@nuxt/ui/dist/runtime/vue/plugins/icons.js
var bu = { install() {
	yu((e, t) => {
		let n = e.indexOf(":");
		return n !== -1 && e.slice(0, n).includes("-") && el(e.replace(":", "-"), t), el(e, t);
	});
} };
//#endregion
//#region ../../node_modules/unhead/dist/shared/unhead.D7HkBzZn.mjs
function xu(e, t) {
	if (typeof t == "function" && t.key && e.plugins.has(t.key)) return;
	let n = typeof t == "function" ? t(e) : t, r = n.key || String(e.plugins.size + 1);
	if (!e.plugins.get(r)) {
		e.plugins.set(r, n);
		for (let t in n.hooks || {}) e.hooks?.hook(t, n.hooks[t]);
	}
}
// @__NO_SIDE_EFFECTS__
function Su(e, t = {}) {
	let n = !t.document, r = /* @__PURE__ */ new Map(), i = {
		_entryCount: 1,
		_h: 0,
		plugins: /* @__PURE__ */ new Map(),
		resolvedOptions: t,
		ssr: n,
		entries: r,
		hooks: void 0,
		render: () => e(i),
		use: (e) => xu(i, e),
		push(e, t) {
			let a = t?._index ?? i._entryCount++, o = t ? { ...t } : {};
			delete o.head, delete o.onRendered, delete o._index;
			let s = {
				_i: a,
				input: e,
				options: o
			};
			return r.set(a, s), {
				_i: a,
				dispose() {
					r.delete(a);
				},
				patch(e) {
					n ? (s.input = e, delete s._tags) : s._pending = e, r.has(a) || r.set(a, s);
				}
			};
		}
	};
	return t.init?.forEach((e) => e && i.push(e)), i;
}
//#endregion
//#region ../../node_modules/unhead/dist/shared/unhead.CGPOfp5O.mjs
var Cu = /* @__PURE__ */ new Set([
	"link",
	"style",
	"script",
	"noscript"
]), wu = /* @__PURE__ */ new Set([
	"title",
	"titleTemplate",
	"script",
	"style",
	"noscript"
]), Tu = /* @__PURE__ */ new Set([
	"base",
	"meta",
	"link",
	"style",
	"script",
	"noscript"
]), Eu = /* @__PURE__ */ new Set([
	"title",
	"base",
	"htmlAttrs",
	"bodyAttrs",
	"meta",
	"link",
	"style",
	"script",
	"noscript"
]), Du = /* @__PURE__ */ new Set([
	"base",
	"title",
	"titleTemplate",
	"bodyAttrs",
	"htmlAttrs",
	"templateParams"
]), Ou = /* @__PURE__ */ new Set([
	"key",
	"tagPosition",
	"tagPriority",
	"tagDuplicateStrategy",
	"innerHTML",
	"textContent",
	"processTemplateParams"
]), ku = /* @__PURE__ */ new Set([
	"templateParams",
	"htmlAttrs",
	"bodyAttrs"
]), Au = /* @__PURE__ */ new Set([
	"theme-color",
	"google-site-verification",
	"author",
	"og:locale:alternate",
	"og:image",
	"og:video",
	"og:audio",
	"article:author",
	"article:tag",
	"book:author",
	"book:tag",
	"twitter:image"
]), ju = {
	critical: -8,
	high: -1,
	low: 2
}, Mu = (e) => typeof e == "number" ? Number.isFinite(e) : e;
// @__NO_SIDE_EFFECTS__
function Nu(e) {
	return e === "__proto__" || e === "constructor" || e === "prototype";
}
//#endregion
//#region ../../node_modules/hookable/dist/index.mjs
function Pu(e, t = {}, n) {
	for (let r in e) {
		let i = e[r], a = n ? `${n}:${r}` : r;
		typeof i == "object" && i ? Pu(i, t, a) : typeof i == "function" && (t[a] = i);
	}
	return t;
}
var Fu = /* @__PURE__ */ (() => {
	if (console.createTask) return console.createTask;
	let e = { run: (e) => e() };
	return () => e;
})();
function Iu(e, t, n, r) {
	for (let i = n; i < e.length; i += 1) try {
		let n = r ? r.run(() => e[i](...t)) : e[i](...t);
		if (n && typeof n.then == "function") return Promise.resolve(n).then(() => Iu(e, t, i + 1, r));
	} catch (e) {
		return Promise.reject(e);
	}
}
function Lu(e, t, n) {
	if (e.length > 0) return Iu(e, t, 0, Fu(n));
}
function Ru(e, t, n) {
	if (e.length > 0) {
		let r = Fu(n);
		return Promise.all(e.map((e) => r.run(() => e(...t))));
	}
}
function zu(e, t) {
	for (let n of [...e]) n(t);
}
var Bu = class {
	_hooks;
	_before;
	_after;
	_deprecatedHooks;
	_deprecatedMessages;
	constructor() {
		this._hooks = {}, this._before = void 0, this._after = void 0, this._deprecatedMessages = void 0, this._deprecatedHooks = {}, this.hook = this.hook.bind(this), this.callHook = this.callHook.bind(this), this.callHookWith = this.callHookWith.bind(this);
	}
	hook(e, t, n = {}) {
		if (!e || typeof t != "function") return () => {};
		let r = e, i;
		for (; this._deprecatedHooks[e];) i = this._deprecatedHooks[e], e = i.to;
		if (i && !n.allowDeprecated) {
			let e = i.message;
			e ||= `${r} hook has been deprecated` + (i.to ? `, please use ${i.to}` : ""), this._deprecatedMessages ||= /* @__PURE__ */ new Set(), this._deprecatedMessages.has(e) || (console.warn(e), this._deprecatedMessages.add(e));
		}
		if (!t.name) try {
			Object.defineProperty(t, "name", {
				get: () => "_" + e.replace(/\W+/g, "_") + "_hook_cb",
				configurable: !0
			});
		} catch {}
		return this._hooks[e] = this._hooks[e] || [], this._hooks[e].push(t), () => {
			t &&= (this.removeHook(e, t), void 0);
		};
	}
	hookOnce(e, t) {
		let n, r = (...e) => (typeof n == "function" && n(), n = void 0, r = void 0, t(...e));
		return n = this.hook(e, r), n;
	}
	removeHook(e, t) {
		let n = this._hooks[e];
		if (n) {
			let r = n.indexOf(t);
			r !== -1 && n.splice(r, 1), n.length === 0 && (this._hooks[e] = void 0);
		}
	}
	clearHook(e) {
		this._hooks[e] = void 0;
	}
	deprecateHook(e, t) {
		this._deprecatedHooks[e] = typeof t == "string" ? { to: t } : t;
		let n = this._hooks[e] || [];
		this._hooks[e] = void 0;
		for (let t of n) this.hook(e, t);
	}
	deprecateHooks(e) {
		for (let t in e) this.deprecateHook(t, e[t]);
	}
	addHooks(e) {
		let t = Pu(e), n = Object.keys(t).map((e) => this.hook(e, t[e]));
		return () => {
			for (let e of n) e();
			n.length = 0;
		};
	}
	removeHooks(e) {
		let t = Pu(e);
		for (let e in t) this.removeHook(e, t[e]);
	}
	removeAllHooks() {
		this._hooks = {};
	}
	callHook(e, ...t) {
		return this.callHookWith(Lu, e, t);
	}
	callHookParallel(e, ...t) {
		return this.callHookWith(Ru, e, t);
	}
	callHookWith(e, t, n) {
		let r = this._before || this._after ? {
			name: t,
			args: n,
			context: {}
		} : void 0;
		this._before && zu(this._before, r);
		let i = e(this._hooks[t] ? [...this._hooks[t]] : [], n, t);
		return i instanceof Promise ? i.finally(() => {
			this._after && r && zu(this._after, r);
		}) : (this._after && r && zu(this._after, r), i);
	}
	beforeEach(e) {
		return this._before = this._before || [], this._before.push(e), () => {
			if (this._before !== void 0) {
				let t = this._before.indexOf(e);
				t !== -1 && this._before.splice(t, 1);
			}
		};
	}
	afterEach(e) {
		return this._after = this._after || [], this._after.push(e), () => {
			if (this._after !== void 0) {
				let t = this._after.indexOf(e);
				t !== -1 && this._after.splice(t, 1);
			}
		};
	}
};
function Vu() {
	return new Bu();
}
var Hu = class {
	_hooks;
	constructor() {
		this._hooks = {};
	}
	hook(e, t) {
		return !e || typeof t != "function" ? () => {} : (this._hooks[e] = this._hooks[e] || [], this._hooks[e].push(t), () => {
			t &&= (this.removeHook(e, t), void 0);
		});
	}
	removeHook(e, t) {
		let n = this._hooks[e];
		if (n) {
			let r = n.indexOf(t);
			r !== -1 && n.splice(r, 1), n.length === 0 && (this._hooks[e] = void 0);
		}
	}
	callHook(e, ...t) {
		let n = this._hooks[e];
		if (n && n.length !== 0) return Iu(n, t, 0);
	}
};
//#endregion
//#region ../../node_modules/unhead/dist/shared/unhead.Bm4Y6XQI.mjs
function Uu(e) {
	let t = new Hu();
	for (let n in e || {}) t.hook(n, e[n]);
	return t;
}
function Wu(e, t, n) {
	if (e.hooks?._hooks?.[t]?.length) return e.hooks?.callHook(t, n);
}
//#endregion
//#region ../../node_modules/unhead/dist/shared/unhead.C5Bksi2B.mjs
function Gu(e, t, n) {
	let r = e.push, i = e;
	i.ssr = !1, i.hooks = t, i.dirty = !!i.dirty, i.use = (e) => xu(i, e), i.render = () => n(i);
	function a() {
		t.callHook("entries:updated", i), i._b || i.render();
	}
	return i.invalidate = () => {
		for (let e of i.entries.values()) delete e._tags;
		i.dirty = !0, a();
	}, i.push = (n, o) => {
		let s = o?.onRendered ? t.hook("dom:rendered", o.onRendered) : void 0, c = r(n, o), l = e.entries.get(c._i);
		return l && (l._o = n), i.dirty = !0, a(), {
			_i: c._i,
			patch(e) {
				c.patch(e), i.dirty = !0, a();
			},
			dispose() {
				s?.(), e.entries.has(c._i) && (c.dispose(), i.invalidate());
			}
		};
	}, i;
}
//#endregion
//#region ../../node_modules/unhead/dist/shared/unhead.-hZVKou0.mjs
var Ku = /^(?:viewport|description|keywords|robots)$/, qu = [
	"name",
	"property",
	"http-equiv"
];
function Ju(e) {
	let t = e.indexOf(":");
	if (t === -1) return !1;
	let n = e.slice(t + 1);
	return Au.has(n) || n.startsWith("og:image:") || n.startsWith("og:video:") || n.startsWith("og:audio:") || n.startsWith("twitter:image:");
}
function Yu(e) {
	let { props: t, tag: n, key: r } = e;
	if (Du.has(n)) return n;
	if (n === "link") {
		if (t.rel === "canonical") return "canonical";
		if (t.rel === "alternate" && t.hreflang) return `alternate:${t.hreflang}`;
	}
	if (t.charset) return "charset";
	if (n === "meta") for (let e of qu) {
		let n = t[e];
		if (n !== void 0) return `meta:${n}${(typeof n != "string" || !n.includes(":")) && !Ku.test(n) && r ? `:key:${r}` : ""}`;
	}
	return r ? `${n}:key:${r}` : t.id ? `${n}:id:${t.id}` : n === "link" && t.rel && t.href ? `link:${t.rel}:${t.href}` : wu.has(n) && (e.textContent || e.innerHTML) ? `${n}:content:${e.textContent || e.innerHTML}` : void 0;
}
function Xu(e) {
	let t = e._h || e._d || e.textContent || e.innerHTML;
	if (t) return t;
	let n = Object.keys(e.props).sort(), r = `${e.tag}:`, i = "";
	for (let t of n) r += `${i}${t}:${String(e.props[t])}`, i = ",";
	return r;
}
function Zu(e, t, n) {
	if (n === "_resolver") return e;
	typeof e == "function" && (!n || n !== "titleTemplate" && !n.startsWith("on")) && (e = e());
	let r = t ? t(n, e) : e;
	if (Array.isArray(r)) {
		let e;
		for (let n = 0; n < r.length; n++) {
			let i = Zu(r[n], t);
			e ? e[n] = i : i !== r[n] && (e = r.slice(0, n), e[n] = i);
		}
		return e || r;
	}
	if (r?.constructor === Object) {
		let e;
		for (let n in r) {
			let i = /* @__PURE__ */ Nu(n), a = i ? void 0 : Zu(r[n], t, n);
			if (!e && (i || a !== r[n])) {
				e = {};
				for (let t in r) {
					if (t === n) break;
					e[t] = r[t];
				}
			}
			e && !i && (e[n] = a);
		}
		return e || r;
	}
	return r;
}
var Qu = /[\s"'<>/=\x00-\x1F\x7F]/;
function $u(e, t) {
	let n = e === "style", r = n ? /* @__PURE__ */ new Map() : /* @__PURE__ */ new Set(), i = (e) => {
		if (e) {
			if (n) {
				let t = e.indexOf(":");
				t > 0 && r.set(e.slice(0, t).trim(), e.slice(t + 1).trim());
			} else e.split(" ").forEach((e) => e && r.add(e));
		}
	};
	if (typeof t == "string") (n ? t.split(";") : [t]).forEach(i);
	else if (Array.isArray(t)) t.forEach(i);
	else if (t && typeof t == "object") for (let e in t) {
		let a = t[e];
		a && a !== "false" && (n ? r.set(e.trim(), String(a)) : i(e));
	}
	return r;
}
function ed(e, t) {
	if (e.props = e.props || {}, !t) return e;
	if (e.tag === "templateParams") return e.props = t, e;
	let n = Tu.has(e.tag) || e.tag === "htmlAttrs" || e.tag === "bodyAttrs";
	for (let r in t) {
		if (/* @__PURE__ */ Nu(r)) continue;
		let i = r.startsWith("data-"), a = n && !Ou.has(r), o = a && !i ? r.toLowerCase() : r;
		if (a && (!o || Qu.test(o))) continue;
		let s = t[r];
		if (s === null) e.props[o] = null;
		else if (r === "class" || r === "style") e.props[r] = $u(r, s);
		else if (Ou.has(r)) {
			if ((r === "textContent" || r === "innerHTML") && typeof s == "object") {
				let n = t.type || "application/json";
				(n.endsWith("json") || n === "speculationrules" || n === "importmap") && (e.props.type = n, e[r] = JSON.stringify(s));
			} else e[r] = s;
		} else if (s !== void 0) {
			let t = String(s), n = e.tag === "meta" && o === "content";
			e.props[o] = t === "true" || t === "" ? i || n ? t : !0 : !s && i && t === "false" ? "false" : s;
		}
	}
	return e;
}
function td(e, t) {
	let n;
	return t.length && (n = (e, n) => {
		for (let r = 0; r < t.length; r++) n = t[r](e, n);
		return n;
	}, e = n(void 0, e)), Zu(e, n);
}
function nd(e, t) {
	let n = ed({
		tag: e,
		props: {}
	}, typeof t == "object" && typeof t != "function" ? t : { [e === "script" || e === "noscript" || e === "style" ? "innerHTML" : "textContent"]: t });
	if (n.key && Cu.has(n.tag) && (n.props["data-hid"] = n._h = n.key), n.tag === "script" && typeof n.innerHTML == "object" && (n.innerHTML = JSON.stringify(n.innerHTML), n.props.type = n.props.type || "application/json"), Array.isArray(n.props.content)) {
		let e = [];
		for (let t of n.props.content) e.push({
			...n,
			props: {
				...n.props,
				content: t
			}
		});
		return e;
	}
	return n;
}
function rd(e, t) {
	if (Array.isArray(t)) for (let n of t) e.push(n);
	else e.push(t);
}
function id(e, t) {
	if (!e) return [];
	typeof e == "function" && (e = e()), e = td(e, t);
	let n = [];
	for (let t in e) {
		let r = e[t];
		if (r !== void 0) {
			if (Array.isArray(r)) for (let e of r) rd(n, nd(t, e));
			else rd(n, nd(t, r));
		}
	}
	return n;
}
var ad = /</g, od = /<\/script/g, sd = (e, t) => e._w === t._w ? e._p - t._p : e._w - t._w, cd = () => 100;
function ld(e) {
	for (let t in e) return !1;
	return !0;
}
var ud = /^tags:|:render/;
function dd(e, t) {
	let n = (t["entries:resolve"]?.length || 0) + (t["entries:normalize"]?.length || 0);
	if (e._h !== n) {
		e._h = n;
		for (let t of e.entries.values()) delete t._tags;
	}
}
function fd(e) {
	for (let t = 0; t < e.length; t++) {
		let n = e[t], r = { ...n.props };
		r.class instanceof Set && (r.class = new Set(r.class)), r.style instanceof Map && (r.style = new Map(r.style)), e[t] = {
			...n,
			props: r
		};
	}
}
function pd(e, t) {
	let n = e.tags, r = 0;
	for (let t of e.tagMap.values()) if (Array.isArray(t)) for (let e of t) n[r++] = e;
	else n[r++] = t;
	n.length = r, t && n.sort(sd);
}
function md(e) {
	let t = !1;
	for (let n of e.tags.sort(sd)) {
		let r = n._d || Xu(n);
		if (!r) continue;
		let i = e.tagMap.get(r);
		if (!i) {
			e.tagMap.set(r, n);
			continue;
		}
		if ((n.tagDuplicateStrategy || (ku.has(n.tag) ? "merge" : null) || (n.key && n.key === i.key ? "merge" : null)) === "merge") {
			let t = { ...i.props };
			for (let e in n.props) t[e] = e === "style" ? new Map([...i.props.style || /* @__PURE__ */ new Map(), ...n.props[e]]) : e === "class" ? /* @__PURE__ */ new Set([...i.props.class || [], ...n.props[e]]) : n.props[e];
			e.tagMap.set(r, {
				...n,
				props: t
			});
		} else n._p >> 10 == i._p >> 10 && n.tag === "meta" && Ju(r) ? (e.tagMap.set(r, Object.assign([...Array.isArray(i) ? i : [i], n], n)), t = !0) : (n._w === i._w ? n._p > i._p : n._w < i._w) && e.tagMap.set(r, n);
	}
	return t;
}
function hd(e, t) {
	let n = e.tagMap.get("title"), r = e.tagMap.get("titleTemplate");
	if (t._title = n?.textContent, !r) return;
	let i = r.textContent;
	if (t._titleTemplate = i, !i) return;
	let a = typeof i == "function" ? i(n?.textContent) : i;
	typeof a == "string" && !t.plugins.has("template-params") && (a = a.replace("%s", n?.textContent || "")), n ? a === null ? e.tagMap.delete("title") : e.tagMap.set("title", {
		...n,
		textContent: a
	}) : e.tagMap.set("titleTemplate", {
		...r,
		tag: "title",
		textContent: a
	});
}
function gd(e) {
	let t = 0;
	for (let n of e) {
		let { innerHTML: r, tag: i, props: a } = n;
		if (Eu.has(i) && (!ld(a) || Mu(r) || Mu(n.textContent)) && (i !== "meta" || Mu(a.content) || a["http-equiv"] || a.charset)) {
			if (i === "script" && (r || n.textContent)) {
				let e = String(a.type), t = e.endsWith("json") || e === "importmap" || e === "speculationrules", i = (e) => t ? (typeof e == "string" ? e : JSON.stringify(e)).replace(ad, "\\u003C") : typeof e == "string" ? e.replace(od, "<\\/script") : e;
				n = { ...n }, r && (n.innerHTML = i(r)), n.textContent && (n.textContent = i(n.textContent)), n._d = Yu(n);
			}
			e[t++] = n;
		}
	}
	return e.length = t, e;
}
function _d(e, t) {
	let n = t?.tagWeight ?? e.resolvedOptions._tagWeight ?? cd, r = {
		tagMap: /* @__PURE__ */ new Map(),
		tags: []
	}, i = e.hooks?._hooks || {};
	dd(e, i);
	for (let t of e.entries.values()) t._pending !== void 0 && (t.input = t._pending, delete t._pending, delete t._tags, delete t._precomputedTags);
	let a;
	(i["entries:resolve"]?.length || i["entries:normalize"]?.length) && (a = [...e.entries.values()], i["entries:resolve"]?.length && Wu(e, "entries:resolve", {
		entries: a,
		...r
	})), dd(e, i);
	for (let t of a || e.entries.values()) {
		let a = t._tags;
		if (!a) {
			if (t._precomputedTags && n === e.resolvedOptions._tagWeight && !i["entries:normalize"]?.length && !i["entries:resolve"]?.length && (!t.options || ld(t.options))) a = t._precomputedTags;
			else {
				if (a = id(t.input, e.resolvedOptions.propResolvers || []), t.options && !ld(t.options)) for (let e of a) Object.assign(e, t.options);
				if (i["entries:normalize"]?.length) {
					let n = {
						tags: a,
						entry: t
					};
					Wu(e, "entries:normalize", n), a = n.tags;
				}
				for (let e = 0; e < a.length; e++) {
					let r = a[e];
					r._w = n(r), r._p = (t._i << 10) + e, r._d = Yu(r), r._d || (r._h = Xu(r));
				}
				t._tags = a;
			}
		}
		r.tags.push(...a);
	}
	for (let e in i) if (i[e]?.length && ud.test(e)) {
		fd(r.tags);
		break;
	}
	let o = md(r);
	return hd(r, e), pd(r, o), Wu(e, "tags:beforeResolve", r), Wu(e, "tags:resolve", r), Wu(e, "tags:afterResolve", r), gd(r.tags);
}
//#endregion
//#region ../../node_modules/unhead/dist/shared/unhead.Bjbp1C8D.mjs
var vd = /\s+/;
// @__NO_SIDE_EFFECTS__
function yd(e = {}) {
	return (t) => Sd(t, e);
}
function bd(e) {
	for (let t of e.entries.values()) if (t._pending !== void 0) return !0;
	return !1;
}
function xd(e, t) {
	let n = {
		_d: t,
		_t: t.title,
		_e: /* @__PURE__ */ new Map([["htmlAttrs", t.documentElement], ["bodyAttrs", t.body]]),
		_p: {},
		_s: {},
		_l: /* @__PURE__ */ new Map()
	};
	for (let t of e.entries.values()) if (t._o !== void 0) {
		let e = t._o;
		for (let t of ["bodyAttrs", "htmlAttrs"]) {
			let r = e[t]?.class;
			if (typeof r == "string") {
				let e = n._e.get(t);
				for (let i of r.split(vd)) i && (n._p[`${t}:attr:class:${i}`] = () => e.classList.remove(i));
			}
		}
	}
	return n;
}
function Sd(e, t = {}) {
	let n = t.document || e.resolvedOptions.document, r = e._dom;
	if (!n || e._du || r && r._d === n && !e.dirty && !bd(e)) return !1;
	let i = n.defaultView;
	e._du = !0;
	let a = !1;
	try {
		let o = function(e, t, n) {
			d._s[e] = !n && f[e] || t, delete f[e];
		}, s = function(e, t, n, r, i, a) {
			let s = `${e}:event:${t}`, c = d._l.get(s);
			if (c && c[0] === a && c[1] === n && c[2] === r) {
				o(s, c[4]);
				return;
			}
			c?.[4]();
			let l = `data-${t}`, u = ((e) => r.call(i, e)), f = () => {
				a.removeEventListener(n, u), i.getAttribute(l) === "" && i.removeAttribute(l), d._l.get(s)?.[3] === u && d._l.delete(s);
			};
			a.addEventListener(n, u), d._l.set(s, [
				a,
				n,
				r,
				u,
				f
			]), i.setAttribute(l, ""), o(s, f, !0);
		}, c = function({ id: e, $el: t, tag: n }) {
			if (d._e.set(e, t), !n.tag.endsWith("Attrs")) {
				let r = n.textContent;
				r != null && r !== "" && (r !== t.textContent && (t.textContent = r), o(`${e}:text`, () => {
					t.textContent === r && (t.textContent = "");
				}, !0));
				let i = n.innerHTML;
				i != null && i !== "" && (i !== t.innerHTML && (t.innerHTML = i), o(`${e}:html`, () => {
					t.innerHTML === i && (t.innerHTML = "");
				}, !0));
				let a = `${e}:el`;
				o(a, f[a] || (() => {
					t?.remove(), d._e.delete(e);
				}));
			}
			for (let r in n.props) {
				let a = n.props[r];
				if (r[0] === "o" && r[1] === "n" && typeof a == "function") {
					let o = r.slice(2);
					t?.dataset?.[`${r}fired`] && a.call(t, new ((i?.Event) || Event)(o)), s(e, r, o, a, t, n.tag === "bodyAttrs" && i ? i : t);
					continue;
				}
				let c = `${e}:attr:${r}`;
				if (r === "class" && a) for (let e of a) {
					let n = `${c}:${e}`;
					o(n, f[n] || (() => t.classList.remove(e))), t.classList.contains(e) || t.classList.add(e);
				}
				else if (r === "style" && a) for (let [e, n] of a) {
					let r = `${c}:${e}`;
					o(r, f[r] || (() => t.style.removeProperty(e))), t.style.setProperty(e, n);
				}
				else a !== !1 && a !== null && (t.getAttribute(r) !== a && t.setAttribute(r, a === !0 ? "" : String(a)), o(c, f[c] || (() => t.removeAttribute(r))));
			}
		}, l = {
			shouldRender: !0,
			tags: []
		};
		if (Wu(e, "dom:beforeRender", l), !l.shouldRender) return !1;
		let u = r;
		if (u?._d !== n) {
			if (u) {
				for (let e in u._s) u._s[e]();
				for (let e in u._p) u._p[e]();
				u._s = u._p = {}, u._e.clear(), u._l.clear();
			}
			u = void 0;
		}
		u ? u._p = u._s : u = xd(e, n), u._s = {};
		let d = u, f = d._p, p = [], m = {};
		e.dirty = !1;
		let h = _d(e, t.tagWeight ? { tagWeight: t.tagWeight } : void 0), g = [], _ = {};
		for (let e of h) {
			let t = _[e._d] || 0, r = (t ? `${e._d}:${t}` : e._d) || e._h, i = {
				tag: e,
				id: r,
				shouldRender: !0
			};
			if (e.tag === "meta" && e._d && Ju(e._d) && (_[e._d] = t + 1), g.push(i), e.tag === "title") {
				n.title = e.textContent, o("title:", () => n.title = d._t);
				continue;
			}
			i.$el = d._e.get(r), i.$el ? c(i) : Tu.has(e.tag) && p.push(i);
		}
		if (p.length) {
			let e = new Set(d._e.values());
			for (let t of [...n.body.children, ...n.head.children]) {
				let n = t.tagName.toLowerCase();
				if (!Tu.has(n) || e.has(t)) continue;
				let r = { innerHTML: t.innerHTML };
				for (let e of t.getAttributeNames()) r[e] = t.getAttribute(e);
				let i = ed({
					tag: n,
					props: {}
				}, r);
				i.key = t.getAttribute("data-hid") || void 0;
				let a = Yu(i) || Xu(i), o = a, s = 1;
				for (; d._e.has(o);) o = `${a}:${s++}`;
				d._e.set(o, t);
			}
		}
		for (let e of p) {
			let t = d._e.get(e.id);
			e.$el = t || n.createElement(e.tag.tag), c(e), t || (m[e.tag.tagPosition || "head"] ??= n.createDocumentFragment()).appendChild(e.$el);
		}
		m.head && n.head.appendChild(m.head), m.bodyOpen && n.body.insertBefore(m.bodyOpen, n.body.firstChild), m.bodyClose && n.body.appendChild(m.bodyClose);
		for (let e in f) f[e]();
		e._dom = d, a = !0, Wu(e, "dom:rendered", { renders: g });
	} catch (t) {
		throw e.dirty = !0, t;
	} finally {
		e._du = !1;
	}
	return a && (e.dirty || bd(e)) && Sd(e, t), a;
}
//#endregion
//#region ../../node_modules/unhead/dist/shared/unhead.oZ7pkTV1.mjs
var Cd = (e) => typeof e.tagPriority == "number" ? e.tagPriority : 100 + (ju[e.tagPriority] || 0);
function wd(e = {}) {
	e.document = e.document || (typeof window < "u" ? document : void 0);
	let t = e.render || /* @__PURE__ */ yd({ document: e.document }), n = Gu(/* @__PURE__ */ Su(t, {
		document: e.document,
		propResolvers: e.propResolvers,
		_tagWeight: Cd,
		init: []
	}), Uu(e.hooks), t);
	return e.plugins?.forEach((e) => n.use(e)), e.init?.forEach((e) => e && n.push(e)), n;
}
//#endregion
//#region ../../node_modules/@unhead/vue/dist/shared/vue.DKb5ZKVl.mjs
var Td = "usehead";
// @__NO_SIDE_EFFECTS__
function Ed() {
	if (Lr()) {
		let e = Ir(Td);
		if (e) return e;
	}
	throw Error("useHead() was called without provide context, ensure you call it through the setup() function.");
}
// @__NO_SIDE_EFFECTS__
function Dd(e) {
	return { install(t) {
		t.config.globalProperties.$unhead = e, t.config.globalProperties.$head = e, t.provide(Td, e);
	} }.install;
}
//#endregion
//#region ../../node_modules/@unhead/vue/dist/shared/vue.D2XR8FqS.mjs
var Od = /* @__PURE__ */ Object.assign((e, t) => /* @__PURE__ */ z(t) ? on(t) : t, { _static: !0 });
//#endregion
//#region ../../node_modules/@unhead/vue/dist/shared/vue.BHyNcdic.mjs
function kd(e, t = {}) {
	let n = t.head || /* @__PURE__ */ Ed();
	return n.ssr ? n.push(e || {}, t) : Ad(n, e, t);
}
function Ad(e, t, n = {}) {
	let r = ke();
	if (r && !r.active) return {
		patch() {},
		dispose() {},
		_i: -1
	};
	let i = /* @__PURE__ */ B(!1);
	if (n.onRendered && r) {
		let e = n.onRendered;
		n = {
			...n,
			onRendered: (t) => r.run(() => e(t))
		};
	}
	let a;
	return Br(() => {
		let r = i.value ? {} : Zu(t, Od);
		a ? a.patch(r) : a = e.push(r, n);
	}), rs() && (yi(() => {
		a.dispose();
	}), ui(() => {
		i.value = !0;
	}), li(() => {
		i.value = !1;
	})), a;
}
//#endregion
//#region ../../node_modules/@unhead/vue/dist/client.mjs
// @__NO_SIDE_EFFECTS__
function jd(e = {}) {
	let t = /* @__PURE__ */ yd(), n, r = 0;
	return n = wd({
		render: () => {
			let e = ++r;
			setTimeout(() => {
				e === r && t(n);
			}, 0);
		},
		...e
	}), n.install = /* @__PURE__ */ Dd(n), n;
}
//#endregion
//#region ../../node_modules/@nuxt/ui/dist/runtime/vue/plugins/head.js
var Md = { install(e) {
	if (e._context.provides.usehead) return;
	let t = /* @__PURE__ */ jd();
	e.use(t);
} }, Nd = { install(e, t) {
	t?.router && typeof t.router == "function" && e.provide("nuxtui:router", t.router);
} }, Pd = {
	inherit: "inherit",
	current: "currentcolor",
	transparent: "transparent",
	black: "#000",
	white: "#fff",
	slate: {
		50: "oklch(98.4% 0.003 247.858)",
		100: "oklch(96.8% 0.007 247.896)",
		200: "oklch(92.9% 0.013 255.508)",
		300: "oklch(86.9% 0.022 252.894)",
		400: "oklch(70.4% 0.04 256.788)",
		500: "oklch(55.4% 0.046 257.417)",
		600: "oklch(44.6% 0.043 257.281)",
		700: "oklch(37.2% 0.044 257.287)",
		800: "oklch(27.9% 0.041 260.031)",
		900: "oklch(20.8% 0.042 265.755)",
		950: "oklch(12.9% 0.042 264.695)"
	},
	gray: {
		50: "oklch(98.5% 0.002 247.839)",
		100: "oklch(96.7% 0.003 264.542)",
		200: "oklch(92.8% 0.006 264.531)",
		300: "oklch(87.2% 0.01 258.338)",
		400: "oklch(70.7% 0.022 261.325)",
		500: "oklch(55.1% 0.027 264.364)",
		600: "oklch(44.6% 0.03 256.802)",
		700: "oklch(37.3% 0.034 259.733)",
		800: "oklch(27.8% 0.033 256.848)",
		900: "oklch(21% 0.034 264.665)",
		950: "oklch(13% 0.028 261.692)"
	},
	zinc: {
		50: "oklch(98.5% 0 none)",
		100: "oklch(96.7% 0.001 286.375)",
		200: "oklch(92% 0.004 286.32)",
		300: "oklch(87.1% 0.006 286.286)",
		400: "oklch(70.5% 0.015 286.067)",
		500: "oklch(55.2% 0.016 285.938)",
		600: "oklch(44.2% 0.017 285.786)",
		700: "oklch(37% 0.013 285.805)",
		800: "oklch(27.4% 0.006 286.033)",
		900: "oklch(21% 0.006 285.885)",
		950: "oklch(14.1% 0.005 285.823)"
	},
	neutral: {
		50: "oklch(98.5% 0 none)",
		100: "oklch(97% 0 none)",
		200: "oklch(92.2% 0 none)",
		300: "oklch(87% 0 none)",
		400: "oklch(70.8% 0 none)",
		500: "oklch(55.6% 0 none)",
		600: "oklch(43.9% 0 none)",
		700: "oklch(37.1% 0 none)",
		800: "oklch(26.9% 0 none)",
		900: "oklch(20.5% 0 none)",
		950: "oklch(14.5% 0 none)"
	},
	stone: {
		50: "oklch(98.5% 0.001 106.423)",
		100: "oklch(97% 0.001 106.424)",
		200: "oklch(92.3% 0.003 48.717)",
		300: "oklch(86.9% 0.005 56.366)",
		400: "oklch(70.9% 0.01 56.259)",
		500: "oklch(55.3% 0.013 58.071)",
		600: "oklch(44.4% 0.011 73.639)",
		700: "oklch(37.4% 0.01 67.558)",
		800: "oklch(26.8% 0.007 34.298)",
		900: "oklch(21.6% 0.006 56.043)",
		950: "oklch(14.7% 0.004 49.25)"
	},
	mauve: {
		50: "oklch(98.5% 0 none)",
		100: "oklch(96% 0.003 325.6)",
		200: "oklch(92.2% 0.005 325.62)",
		300: "oklch(86.5% 0.012 325.68)",
		400: "oklch(71.1% 0.019 323.02)",
		500: "oklch(54.2% 0.034 322.5)",
		600: "oklch(43.5% 0.029 321.78)",
		700: "oklch(36.4% 0.029 323.89)",
		800: "oklch(26.3% 0.024 320.12)",
		900: "oklch(21.2% 0.019 322.12)",
		950: "oklch(14.5% 0.008 326)"
	},
	olive: {
		50: "oklch(98.8% 0.003 106.5)",
		100: "oklch(96.6% 0.005 106.5)",
		200: "oklch(93% 0.007 106.5)",
		300: "oklch(88% 0.011 106.6)",
		400: "oklch(73.7% 0.021 106.9)",
		500: "oklch(58% 0.031 107.3)",
		600: "oklch(46.6% 0.025 107.3)",
		700: "oklch(39.4% 0.023 107.4)",
		800: "oklch(28.6% 0.016 107.4)",
		900: "oklch(22.8% 0.013 107.4)",
		950: "oklch(15.3% 0.006 107.1)"
	},
	mist: {
		50: "oklch(98.7% 0.002 197.1)",
		100: "oklch(96.3% 0.002 197.1)",
		200: "oklch(92.5% 0.005 214.3)",
		300: "oklch(87.2% 0.007 219.6)",
		400: "oklch(72.3% 0.014 214.4)",
		500: "oklch(56% 0.021 213.5)",
		600: "oklch(45% 0.017 213.2)",
		700: "oklch(37.8% 0.015 216)",
		800: "oklch(27.5% 0.011 216.9)",
		900: "oklch(21.8% 0.008 223.9)",
		950: "oklch(14.8% 0.004 228.8)"
	},
	taupe: {
		50: "oklch(98.6% 0.002 67.8)",
		100: "oklch(96% 0.002 17.2)",
		200: "oklch(92.2% 0.005 34.3)",
		300: "oklch(86.8% 0.007 39.5)",
		400: "oklch(71.4% 0.014 41.2)",
		500: "oklch(54.7% 0.021 43.1)",
		600: "oklch(43.8% 0.017 39.3)",
		700: "oklch(36.7% 0.016 35.7)",
		800: "oklch(26.8% 0.011 36.5)",
		900: "oklch(21.4% 0.009 43.1)",
		950: "oklch(14.7% 0.004 49.3)"
	},
	red: {
		50: "oklch(97.1% 0.013 17.38)",
		100: "oklch(93.6% 0.032 17.717)",
		200: "oklch(88.5% 0.062 18.334)",
		300: "oklch(80.8% 0.114 19.571)",
		400: "oklch(70.4% 0.191 22.216)",
		500: "oklch(63.7% 0.237 25.331)",
		600: "oklch(57.7% 0.245 27.325)",
		700: "oklch(50.5% 0.213 27.518)",
		800: "oklch(44.4% 0.177 26.899)",
		900: "oklch(39.6% 0.141 25.723)",
		950: "oklch(25.8% 0.092 26.042)"
	},
	orange: {
		50: "oklch(98% 0.016 73.684)",
		100: "oklch(95.4% 0.038 75.164)",
		200: "oklch(90.1% 0.076 70.697)",
		300: "oklch(83.7% 0.128 66.29)",
		400: "oklch(75% 0.183 55.934)",
		500: "oklch(70.5% 0.213 47.604)",
		600: "oklch(64.6% 0.222 41.116)",
		700: "oklch(55.3% 0.195 38.402)",
		800: "oklch(47% 0.157 37.304)",
		900: "oklch(40.8% 0.123 38.172)",
		950: "oklch(26.6% 0.079 36.259)"
	},
	amber: {
		50: "oklch(98.7% 0.022 95.277)",
		100: "oklch(96.2% 0.059 95.617)",
		200: "oklch(92.4% 0.12 95.746)",
		300: "oklch(87.9% 0.169 91.605)",
		400: "oklch(82.8% 0.189 84.429)",
		500: "oklch(76.9% 0.188 70.08)",
		600: "oklch(66.6% 0.179 58.318)",
		700: "oklch(55.5% 0.163 48.998)",
		800: "oklch(47.3% 0.137 46.201)",
		900: "oklch(41.4% 0.112 45.904)",
		950: "oklch(27.9% 0.077 45.635)"
	},
	yellow: {
		50: "oklch(98.7% 0.026 102.212)",
		100: "oklch(97.3% 0.071 103.193)",
		200: "oklch(94.5% 0.129 101.54)",
		300: "oklch(90.5% 0.182 98.111)",
		400: "oklch(85.2% 0.199 91.936)",
		500: "oklch(79.5% 0.184 86.047)",
		600: "oklch(68.1% 0.162 75.834)",
		700: "oklch(55.4% 0.135 66.442)",
		800: "oklch(47.6% 0.114 61.907)",
		900: "oklch(42.1% 0.095 57.708)",
		950: "oklch(28.6% 0.066 53.813)"
	},
	lime: {
		50: "oklch(98.6% 0.031 120.757)",
		100: "oklch(96.7% 0.067 122.328)",
		200: "oklch(93.8% 0.127 124.321)",
		300: "oklch(89.7% 0.196 126.665)",
		400: "oklch(84.1% 0.238 128.85)",
		500: "oklch(76.8% 0.233 130.85)",
		600: "oklch(64.8% 0.2 131.684)",
		700: "oklch(53.2% 0.157 131.589)",
		800: "oklch(45.3% 0.124 130.933)",
		900: "oklch(40.5% 0.101 131.063)",
		950: "oklch(27.4% 0.072 132.109)"
	},
	green: {
		50: "oklch(98.2% 0.018 155.826)",
		100: "oklch(96.2% 0.044 156.743)",
		200: "oklch(92.5% 0.084 155.995)",
		300: "oklch(87.1% 0.15 154.449)",
		400: "oklch(79.2% 0.209 151.711)",
		500: "oklch(72.3% 0.219 149.579)",
		600: "oklch(62.7% 0.194 149.214)",
		700: "oklch(52.7% 0.154 150.069)",
		800: "oklch(44.8% 0.119 151.328)",
		900: "oklch(39.3% 0.095 152.535)",
		950: "oklch(26.6% 0.065 152.934)"
	},
	emerald: {
		50: "oklch(97.9% 0.021 166.113)",
		100: "oklch(95% 0.052 163.051)",
		200: "oklch(90.5% 0.093 164.15)",
		300: "oklch(84.5% 0.143 164.978)",
		400: "oklch(76.5% 0.177 163.223)",
		500: "oklch(69.6% 0.17 162.48)",
		600: "oklch(59.6% 0.145 163.225)",
		700: "oklch(50.8% 0.118 165.612)",
		800: "oklch(43.2% 0.095 166.913)",
		900: "oklch(37.8% 0.077 168.94)",
		950: "oklch(26.2% 0.051 172.552)"
	},
	teal: {
		50: "oklch(98.4% 0.014 180.72)",
		100: "oklch(95.3% 0.051 180.801)",
		200: "oklch(91% 0.096 180.426)",
		300: "oklch(85.5% 0.138 181.071)",
		400: "oklch(77.7% 0.152 181.912)",
		500: "oklch(70.4% 0.14 182.503)",
		600: "oklch(60% 0.118 184.704)",
		700: "oklch(51.1% 0.096 186.391)",
		800: "oklch(43.7% 0.078 188.216)",
		900: "oklch(38.6% 0.063 188.416)",
		950: "oklch(27.7% 0.046 192.524)"
	},
	cyan: {
		50: "oklch(98.4% 0.019 200.873)",
		100: "oklch(95.6% 0.045 203.388)",
		200: "oklch(91.7% 0.08 205.041)",
		300: "oklch(86.5% 0.127 207.078)",
		400: "oklch(78.9% 0.154 211.53)",
		500: "oklch(71.5% 0.143 215.221)",
		600: "oklch(60.9% 0.126 221.723)",
		700: "oklch(52% 0.105 223.128)",
		800: "oklch(45% 0.085 224.283)",
		900: "oklch(39.8% 0.07 227.392)",
		950: "oklch(30.2% 0.056 229.695)"
	},
	sky: {
		50: "oklch(97.7% 0.013 236.62)",
		100: "oklch(95.1% 0.026 236.824)",
		200: "oklch(90.1% 0.058 230.902)",
		300: "oklch(82.8% 0.111 230.318)",
		400: "oklch(74.6% 0.16 232.661)",
		500: "oklch(68.5% 0.169 237.323)",
		600: "oklch(58.8% 0.158 241.966)",
		700: "oklch(50% 0.134 242.749)",
		800: "oklch(44.3% 0.11 240.79)",
		900: "oklch(39.1% 0.09 240.876)",
		950: "oklch(29.3% 0.066 243.157)"
	},
	blue: {
		50: "oklch(97% 0.014 254.604)",
		100: "oklch(93.2% 0.032 255.585)",
		200: "oklch(88.2% 0.059 254.128)",
		300: "oklch(80.9% 0.105 251.813)",
		400: "oklch(70.7% 0.165 254.624)",
		500: "oklch(62.3% 0.214 259.815)",
		600: "oklch(54.6% 0.245 262.881)",
		700: "oklch(48.8% 0.243 264.376)",
		800: "oklch(42.4% 0.199 265.638)",
		900: "oklch(37.9% 0.146 265.522)",
		950: "oklch(28.2% 0.091 267.935)"
	},
	indigo: {
		50: "oklch(96.2% 0.018 272.314)",
		100: "oklch(93% 0.034 272.788)",
		200: "oklch(87% 0.065 274.039)",
		300: "oklch(78.5% 0.115 274.713)",
		400: "oklch(67.3% 0.182 276.935)",
		500: "oklch(58.5% 0.233 277.117)",
		600: "oklch(51.1% 0.262 276.966)",
		700: "oklch(45.7% 0.24 277.023)",
		800: "oklch(39.8% 0.195 277.366)",
		900: "oklch(35.9% 0.144 278.697)",
		950: "oklch(25.7% 0.09 281.288)"
	},
	violet: {
		50: "oklch(96.9% 0.016 293.756)",
		100: "oklch(94.3% 0.029 294.588)",
		200: "oklch(89.4% 0.057 293.283)",
		300: "oklch(81.1% 0.111 293.571)",
		400: "oklch(70.2% 0.183 293.541)",
		500: "oklch(60.6% 0.25 292.717)",
		600: "oklch(54.1% 0.281 293.009)",
		700: "oklch(49.1% 0.27 292.581)",
		800: "oklch(43.2% 0.232 292.759)",
		900: "oklch(38% 0.189 293.745)",
		950: "oklch(28.3% 0.141 291.089)"
	},
	purple: {
		50: "oklch(97.7% 0.014 308.299)",
		100: "oklch(94.6% 0.033 307.174)",
		200: "oklch(90.2% 0.063 306.703)",
		300: "oklch(82.7% 0.119 306.383)",
		400: "oklch(71.4% 0.203 305.504)",
		500: "oklch(62.7% 0.265 303.9)",
		600: "oklch(55.8% 0.288 302.321)",
		700: "oklch(49.6% 0.265 301.924)",
		800: "oklch(43.8% 0.218 303.724)",
		900: "oklch(38.1% 0.176 304.987)",
		950: "oklch(29.1% 0.149 302.717)"
	},
	fuchsia: {
		50: "oklch(97.7% 0.017 320.058)",
		100: "oklch(95.2% 0.037 318.852)",
		200: "oklch(90.3% 0.076 319.62)",
		300: "oklch(83.3% 0.145 321.434)",
		400: "oklch(74% 0.238 322.16)",
		500: "oklch(66.7% 0.295 322.15)",
		600: "oklch(59.1% 0.293 322.896)",
		700: "oklch(51.8% 0.253 323.949)",
		800: "oklch(45.2% 0.211 324.591)",
		900: "oklch(40.1% 0.17 325.612)",
		950: "oklch(29.3% 0.136 325.661)"
	},
	pink: {
		50: "oklch(97.1% 0.014 343.198)",
		100: "oklch(94.8% 0.028 342.258)",
		200: "oklch(89.9% 0.061 343.231)",
		300: "oklch(82.3% 0.12 346.018)",
		400: "oklch(71.8% 0.202 349.761)",
		500: "oklch(65.6% 0.241 354.308)",
		600: "oklch(59.2% 0.249 0.584)",
		700: "oklch(52.5% 0.223 3.958)",
		800: "oklch(45.9% 0.187 3.815)",
		900: "oklch(40.8% 0.153 2.432)",
		950: "oklch(28.4% 0.109 3.907)"
	},
	rose: {
		50: "oklch(96.9% 0.015 12.422)",
		100: "oklch(94.1% 0.03 12.58)",
		200: "oklch(89.2% 0.058 10.001)",
		300: "oklch(81% 0.117 11.638)",
		400: "oklch(71.2% 0.194 13.428)",
		500: "oklch(64.5% 0.246 16.439)",
		600: "oklch(58.6% 0.253 17.585)",
		700: "oklch(51.4% 0.222 16.935)",
		800: "oklch(45.5% 0.188 13.697)",
		900: "oklch(41% 0.159 10.272)",
		950: "oklch(27.1% 0.105 12.094)"
	}
};
//#endregion
//#region ../../node_modules/@vueuse/shared/dist/index.js
function Fd(e, t) {
	return ke() ? (Ae(e, t), !0) : !1;
}
var Id = /* @__PURE__ */ new WeakMap(), Ld = (...e) => {
	let t = e[0], n = rs()?.proxy ?? ke();
	if (n == null && !Lr()) throw Error("injectLocal must be called in setup");
	return n && Id.has(n) && t in Id.get(n) ? Id.get(n)[t] : Ir(...e);
}, Rd = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
var zd = (e) => e !== void 0, Bd = Object.prototype.toString, Vd = (e) => Bd.call(e) === "[object Object]", Hd = () => {};
function Ud(...e) {
	if (e.length !== 1) return /* @__PURE__ */ mn(...e);
	let t = e[0];
	return typeof t == "function" ? /* @__PURE__ */ Gt(un(() => ({
		get: t,
		set: Hd
	}))) : /* @__PURE__ */ B(t);
}
function Wd(e, t) {
	function n(...n) {
		return new Promise((r, i) => {
			Promise.resolve(e(() => t.apply(this, n), {
				fn: t,
				thisArg: this,
				args: n
			})).then(r).catch(i);
		});
	}
	return "cancel" in e && Object.assign(n, {
		cancel: e.cancel,
		flush: e.flush,
		isPending: e.isPending
	}), n;
}
var Gd = (e) => e();
function Kd(e, t = {}) {
	let n, r, i = Hd, a = Hd, o = /* @__PURE__ */ tn(!1), s = (e) => {
		clearTimeout(e), i(), i = Hd;
	}, c;
	return Object.assign((l) => {
		let u = on(e), d = on(t.maxWait);
		return n && s(n), u <= 0 || d !== void 0 && d <= 0 ? (r &&= (s(r), void 0), o.value = !1, Promise.resolve(l())) : (o.value = !0, new Promise((e, f) => {
			i = t.rejectOnCancel ? f : e, a = e, c = l, d && !r && (r = setTimeout(() => {
				n && s(n), r = void 0, o.value = !1, e(c());
			}, d)), n = setTimeout(() => {
				r && s(r), r = void 0, o.value = !1, e(l());
			}, u);
		}));
	}, {
		cancel: () => {
			n &&= (s(n), void 0), r &&= (s(r), void 0), o.value = !1, a = Hd;
		},
		flush: () => {
			if (o.value) {
				n &&= (clearTimeout(n), void 0), r &&= (clearTimeout(r), void 0), o.value = !1;
				let e = a;
				i = Hd, a = Hd, e(c());
			}
		},
		isPending: /* @__PURE__ */ Kt(o)
	});
}
function qd(e = Gd, t = {}) {
	let { initialState: n = "active" } = t, r = Ud(n === "active");
	function i() {
		r.value = !1;
	}
	function a() {
		r.value = !0;
	}
	return {
		isActive: /* @__PURE__ */ Kt(r),
		pause: i,
		resume: a,
		eventFilter: (...t) => {
			r.value && e(...t);
		}
	};
}
function Jd(e) {
	return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function Yd(e) {
	return Array.isArray(e) ? e : [e];
}
function Xd(e) {
	return e || rs();
}
function Zd(e) {
	return /* @__PURE__ */ Ut(/* @__PURE__ */ z(e) ? new Proxy({}, {
		get(t, n, r) {
			return V(Reflect.get(e.value, n, r));
		},
		set(t, n, r) {
			return /* @__PURE__ */ z(e.value[n]) && !/* @__PURE__ */ z(r) ? e.value[n].value = r : e.value[n] = r, !0;
		},
		deleteProperty(t, n) {
			return Reflect.deleteProperty(e.value, n);
		},
		has(t, n) {
			return Reflect.has(e.value, n);
		},
		ownKeys() {
			return Object.keys(e.value);
		},
		getOwnPropertyDescriptor() {
			return {
				enumerable: !0,
				configurable: !0
			};
		}
	}) : e);
}
function Qd(e) {
	return Zd(X(e));
}
function $d(e, ...t) {
	let n = t.flat(), r = n[0];
	return Qd(() => Object.fromEntries(typeof r == "function" ? Object.entries(/* @__PURE__ */ dn(e)).filter(([e, t]) => r(on(t), e)) : n.map((t) => [t, Ud(e, t)])));
}
function ef(e, t = 200, n = {}) {
	return Wd(Kd(t, n), e);
}
function tf(e, t, n = {}) {
	let { eventFilter: r = Gd, ...i } = n;
	return Hr(e, Wd(r, t), i);
}
function nf(e, t, n = {}) {
	let { eventFilter: r, initialState: i = "active", ...a } = n, { eventFilter: o, pause: s, resume: c, isActive: l } = qd(r, { initialState: i });
	return {
		stop: tf(e, t, {
			...a,
			eventFilter: o
		}),
		pause: s,
		resume: c,
		isActive: l
	};
}
function rf(e, t = !0, n) {
	Xd(n) ? gi(e, n) : t ? e() : Kn(e);
}
function af(e, t, n) {
	return Hr(e, t, {
		...n,
		immediate: !0
	});
}
//#endregion
//#region ../../node_modules/@vueuse/core/dist/index.js
var of = Rd ? window : void 0;
Rd && window.document, Rd && window.navigator, Rd && window.location;
function sf(e) {
	let t = on(e);
	return t?.$el ?? t;
}
function cf(...e) {
	let t = (e, t, n, r) => (e.addEventListener(t, n, r), () => e.removeEventListener(t, n, r)), n = X(() => {
		let t = Yd(on(e[0])).filter((e) => e != null);
		return t.every((e) => typeof e != "string") ? t : void 0;
	});
	return af(() => [
		n.value?.map((e) => sf(e)) ?? [of].filter((e) => e != null),
		Yd(on(n.value ? e[1] : e[0])),
		Yd(V(n.value ? e[2] : e[1])),
		on(n.value ? e[3] : e[2])
	], ([e, n, r, i], a, o) => {
		if (!e?.length || !n?.length || !r?.length) return;
		let s = Vd(i) ? { ...i } : i, c = e.flatMap((e) => n.flatMap((n) => r.map((r) => t(e, n, r, s))));
		o(() => {
			c.forEach((e) => e());
		});
	}, { flush: "post" });
}
function lf() {
	let e = /* @__PURE__ */ tn(!1), t = rs();
	return t && gi(() => {
		e.value = !0;
	}, t), e;
}
/* @__NO_SIDE_EFFECTS__ */
function uf(e) {
	let t = lf();
	return X(() => (t.value, !!e()));
}
var df = Symbol("vueuse-ssr-width");
/* @__NO_SIDE_EFFECTS__ */
function ff() {
	let e = Lr() ? Ld(df, null) : null;
	return typeof e == "number" ? e : void 0;
}
function pf(e, t = {}) {
	let { window: n = of, ssrWidth: r = /* @__PURE__ */ ff() } = t, i = /* @__PURE__ */ uf(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), a = /* @__PURE__ */ tn(typeof r == "number"), o = /* @__PURE__ */ tn(), s = /* @__PURE__ */ tn(!1);
	return Br(() => {
		if (a.value) {
			a.value = !i.value;
			let t = on(e).split(",");
			s.value = t.some((e) => {
				let t = e.includes("not all"), n = e.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), i = e.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), a = !!(n || i);
				return n && a && (a = r >= Jd(n[1])), i && a && (a = r <= Jd(i[1])), t ? !a : a;
			});
			return;
		}
		i.value && (o.value = n.matchMedia(on(e)), s.value = o.value.matches);
	}), cf(o, "change", (e) => {
		s.value = e.matches;
	}, { passive: !0 }), X(() => s.value);
}
function mf(e) {
	return JSON.parse(JSON.stringify(e));
}
var hf = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, gf = "__vueuse_ssr_handlers__", _f = /* #__PURE__ */ vf();
function vf() {
	return gf in hf || (hf[gf] = hf[gf] || {}), hf[gf];
}
function yf(e, t) {
	return _f[e] || t;
}
function bf(e) {
	return pf("(prefers-color-scheme: dark)", e);
}
function xf(e) {
	return e == null ? "any" : e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof Date ? "date" : typeof e == "boolean" ? "boolean" : typeof e == "string" ? "string" : typeof e == "object" ? "object" : Number.isNaN(e) ? "any" : "number";
}
var Sf = {
	boolean: {
		read: (e) => e === "true",
		write: (e) => String(e)
	},
	object: {
		read: (e) => JSON.parse(e),
		write: (e) => JSON.stringify(e)
	},
	number: {
		read: (e) => Number.parseFloat(e),
		write: (e) => String(e)
	},
	any: {
		read: (e) => e,
		write: (e) => String(e)
	},
	string: {
		read: (e) => e,
		write: (e) => String(e)
	},
	map: {
		read: (e) => new Map(JSON.parse(e)),
		write: (e) => JSON.stringify(Array.from(e.entries()))
	},
	set: {
		read: (e) => new Set(JSON.parse(e)),
		write: (e) => JSON.stringify(Array.from(e))
	},
	date: {
		read: (e) => new Date(e),
		write: (e) => e.toISOString()
	}
}, Cf = "vueuse-storage";
function wf(e, t, n, r = {}) {
	let { flush: i = "pre", deep: a = !0, listenToStorageChanges: o = !0, writeDefaults: s = !0, mergeDefaults: c = !1, shallow: l, window: u = of, eventFilter: d, onError: f = (e) => {
		console.error(e);
	}, initOnMounted: p } = r, m = (l ? tn : B)(typeof t == "function" ? t() : t), h = X(() => on(e));
	if (!n) try {
		n = yf("getDefaultStorage", () => of?.localStorage)();
	} catch (e) {
		f(e);
	}
	if (!n) return m;
	let g = on(t), _ = xf(g), v = r.serializer ?? Sf[_], { pause: y, resume: b } = nf(m, (e) => C(e), {
		flush: i,
		deep: a,
		eventFilter: d
	});
	Hr(h, () => T(), { flush: i });
	let x = !1;
	u && o && (n instanceof Storage ? cf(u, "storage", (e) => {
		(!p || x) && T(e);
	}, { passive: !0 }) : cf(u, Cf, (e) => {
		(!p || x) && ee(e);
	})), p ? rf(() => {
		x = !0, T();
	}) : T();
	function S(e, t) {
		if (u) {
			let r = {
				key: h.value,
				oldValue: e,
				newValue: t,
				storageArea: n
			};
			u.dispatchEvent(n instanceof Storage ? new StorageEvent("storage", r) : new CustomEvent(Cf, { detail: r }));
		}
	}
	function C(e) {
		try {
			let t = n.getItem(h.value);
			if (e == null) S(t, null), n.removeItem(h.value);
			else {
				let r = v.write(e);
				t !== r && (n.setItem(h.value, r), S(t, r));
			}
		} catch (e) {
			f(e);
		}
	}
	function w(e) {
		let t = e ? e.newValue : n.getItem(h.value);
		if (t == null) return s && g != null && n.setItem(h.value, v.write(g)), g;
		if (!e && c) {
			let e = v.read(t);
			return typeof c == "function" ? c(e, g) : _ === "object" && !Array.isArray(e) ? {
				...g,
				...e
			} : e;
		}
		return typeof t == "string" ? v.read(t) : t;
	}
	function T(e) {
		if (!(e && e.storageArea !== n)) {
			if (e && e.key == null) {
				m.value = g;
				return;
			}
			if (!(e && e.key !== h.value)) {
				y();
				try {
					let t = v.write(m.value);
					(e === void 0 || e?.newValue !== t) && (m.value = w(e));
				} catch (e) {
					f(e);
				} finally {
					e ? Kn(b) : b();
				}
			}
		}
	}
	function ee(e) {
		T(e.detail);
	}
	return m;
}
var Tf = "*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function Ef(e = {}) {
	let { selector: t = "html", attribute: n = "class", initialValue: r = "auto", window: i = of, storage: a, storageKey: o = "vueuse-color-scheme", listenToStorageChanges: s = !0, storageRef: c, emitAuto: l, disableTransition: u = !0 } = e, d = {
		auto: "",
		light: "light",
		dark: "dark",
		...e.modes || {}
	}, f = bf({ window: i }), p = X(() => f.value ? "dark" : "light"), m = c || (o == null ? Ud(r) : wf(o, r, a, {
		window: i,
		listenToStorageChanges: s
	})), h = X(() => m.value === "auto" ? p.value : m.value), g = yf("updateHTMLAttrs", (e, t, n) => {
		let r = typeof e == "string" ? i?.document.querySelector(e) : sf(e);
		if (!r) return;
		let a = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set(), s = null;
		if (t === "class") {
			let e = n.split(/\s/g);
			Object.values(d).flatMap((e) => (e || "").split(/\s/g)).filter(Boolean).forEach((t) => {
				e.includes(t) ? a.add(t) : o.add(t);
			});
		} else s = {
			key: t,
			value: n
		};
		if (a.size === 0 && o.size === 0 && s === null) return;
		let c;
		u && (c = i.document.createElement("style"), c.appendChild(document.createTextNode(Tf)), i.document.head.appendChild(c));
		for (let e of a) r.classList.add(e);
		for (let e of o) r.classList.remove(e);
		s && r.setAttribute(s.key, s.value), u && (i.getComputedStyle(c).opacity, document.head.removeChild(c));
	});
	function _(e) {
		g(t, n, d[e] ?? e);
	}
	function v(t) {
		e.onChanged ? e.onChanged(t, _) : _(t);
	}
	Hr(h, v, {
		flush: "post",
		immediate: !0
	}), rf(() => v(h.value));
	let y = X({
		get() {
			return l ? m.value : h.value;
		},
		set(e) {
			m.value = e;
		}
	});
	return Object.assign(y, {
		store: m,
		system: p,
		state: h
	});
}
function Df(e = {}) {
	let { valueDark: t = "dark", valueLight: n = "" } = e, r = Ef({
		...e,
		onChanged: (t, n) => {
			var r;
			e.onChanged ? (r = e.onChanged) == null || r.call(e, t === "dark", n, t) : n(t);
		},
		modes: {
			dark: t,
			light: n
		}
	}), i = X(() => r.system.value);
	return X({
		get() {
			return r.value === "dark";
		},
		set(e) {
			let t = e ? "dark" : "light";
			i.value === t ? r.value = "auto" : r.value = t;
		}
	});
}
var Of = /* @__PURE__ */ new Map();
/* @__NO_SIDE_EFFECTS__ */
function kf(e) {
	function t(t) {
		let n = Of.get(e) || /* @__PURE__ */ new Set();
		n.add(t), Of.set(e, n);
		let i = () => r(t);
		return Fd(i), i;
	}
	function n(e) {
		function n(...t) {
			r(n), e(...t);
		}
		return t(n);
	}
	function r(t) {
		let n = Of.get(e);
		n && (n.delete(t), n.size || i());
	}
	function i() {
		Of.delete(e);
	}
	function a(t, n) {
		var r;
		(r = Of.get(e)) == null || r.forEach((e) => e(t, n));
	}
	return {
		on: t,
		once: n,
		off: r,
		emit: a,
		reset: i
	};
}
function Af(e, t, n, r = {}) {
	var i, a;
	let { clone: o = !1, passive: s = !1, eventName: c, deep: l = !1, defaultValue: u, shouldEmit: d } = r, f = rs(), p = n || f?.emit || (f == null || (i = f.$emit) == null ? void 0 : i.bind(f)) || (f == null || (a = f.proxy) == null || (a = a.$emit) == null ? void 0 : a.bind(f?.proxy)), m = c;
	t ||= "modelValue", m ||= `update:${t.toString()}`;
	let h = (e) => o ? typeof o == "function" ? o(e) : mf(e) : e, g = () => zd(e[t]) ? h(e[t]) : u, _ = (e) => {
		d ? d(e) && p(m, e) : p(m, e);
	};
	if (s) {
		let n = /* @__PURE__ */ B(g()), r = !1;
		return Hr(() => e[t], (e) => {
			r || (r = !0, n.value = h(e), Kn(() => r = !1));
		}), Hr(n, (n) => {
			!r && (n !== e[t] || l) && _(n);
		}, { deep: l }), n;
	}
	return X({
		get() {
			return g();
		},
		set(e) {
			_(e);
		}
	});
}
//#endregion
//#region virtual:nuxt-ui-app-config
var jf = {
	ui: {
		colors: {
			primary: "yellow",
			secondary: "blue",
			success: "green",
			info: "blue",
			warning: "yellow",
			error: "red",
			neutral: "slate"
		},
		icons: {
			arrowDown: "i-lucide-arrow-down",
			arrowLeft: "i-lucide-arrow-left",
			arrowRight: "i-lucide-arrow-right",
			arrowUp: "i-lucide-arrow-up",
			caution: "i-lucide-circle-alert",
			check: "i-lucide-check",
			chevronDoubleLeft: "i-lucide-chevrons-left",
			chevronDoubleRight: "i-lucide-chevrons-right",
			chevronDown: "i-lucide-chevron-down",
			chevronLeft: "i-lucide-chevron-left",
			chevronRight: "i-lucide-chevron-right",
			chevronUp: "i-lucide-chevron-up",
			close: "i-lucide-x",
			copy: "i-lucide-copy",
			copyCheck: "i-lucide-copy-check",
			dark: "i-lucide-moon",
			drag: "i-lucide-grip-vertical",
			ellipsis: "i-lucide-ellipsis",
			error: "i-lucide-circle-x",
			external: "i-lucide-arrow-up-right",
			eye: "i-lucide-eye",
			eyeOff: "i-lucide-eye-off",
			file: "i-lucide-file",
			folder: "i-lucide-folder",
			folderOpen: "i-lucide-folder-open",
			hash: "i-lucide-hash",
			info: "i-lucide-info",
			light: "i-lucide-sun",
			loading: "i-lucide-loader-circle",
			menu: "i-lucide-menu",
			minus: "i-lucide-minus",
			panelClose: "i-lucide-panel-left-close",
			panelOpen: "i-lucide-panel-left-open",
			plus: "i-lucide-plus",
			reload: "i-lucide-rotate-ccw",
			search: "i-lucide-search",
			stop: "i-lucide-square",
			star: "i-lucide-star",
			success: "i-lucide-circle-check",
			system: "i-lucide-monitor",
			tip: "i-lucide-lightbulb",
			upload: "i-lucide-upload",
			warning: "i-lucide-triangle-alert"
		},
		tv: { twMergeConfig: {} },
		switch: {
			slots: { base: "data-[state=unchecked]:bg-[#D4C8BD]" },
			variants: { color: { primary: { base: "data-[state=checked]:bg-[#2D78A5]" } } }
		},
		button: {
			slots: { base: "uppercase tracking-wider" },
			compoundVariants: [{
				color: "primary",
				variant: "solid",
				class: "text-default bg-[#F5D373]"
			}]
		}
	},
	colorMode: !0,
	icon: {}
}, Mf = /* @__PURE__ */ Ut(jf), Nf = () => Mf;
//#endregion
//#region ../../node_modules/defu/dist/defu.mjs
function Pf(e) {
	if (typeof e != "object" || !e) return !1;
	let t = Object.getPrototypeOf(e);
	return t !== null && t !== Object.prototype && Object.getPrototypeOf(t) !== null || Symbol.iterator in e ? !1 : Symbol.toStringTag in e ? Object.prototype.toString.call(e) === "[object Module]" : !0;
}
function Ff(e, t, n = ".", r) {
	if (!Pf(t)) return Ff(e, {}, n, r);
	let i = { ...t };
	for (let t of Object.keys(e)) {
		if (t === "__proto__" || t === "constructor") continue;
		let a = e[t];
		a != null && (r && r(i, t, a, n) || (i[t] = Array.isArray(a) && Array.isArray(i[t]) ? [...a, ...i[t]] : Pf(a) && Pf(i[t]) ? Ff(a, i[t], (n ? `${n}.` : "") + t.toString(), r) : a));
	}
	return i;
}
function If(e) {
	return (...t) => t.reduce((t, n) => Ff(t, n, "", e), {});
}
var Lf = If();
String.fromCharCode;
var Rf = /^[\s\w\0+.-]{2,}:([/\\]{1,2})/, zf = /^[\s\w\0+.-]{2,}:([/\\]{2})?/, Bf = /^([/\\]\s*){2,}[^/\\]/;
function Vf(e, t = {}) {
	return typeof t == "boolean" && (t = { acceptRelative: t }), t.strict ? Rf.test(e) : zf.test(e) || (t.acceptRelative ? Bf.test(e) : !1);
}
//#endregion
//#region ../../node_modules/@nuxt/ui/dist/runtime/utils/index.js
function Hf(e, t) {
	let n = { ...e };
	for (let e of t) delete n[e];
	return n;
}
function Uf(e, t, n) {
	typeof t == "string" && (t = t.split(".").map((e) => {
		let t = Number(e);
		return Number.isNaN(t) ? e : t;
	}));
	let r = e;
	for (let e of t) {
		if (r == null) return n;
		r = r[e];
	}
	return r === void 0 ? n : r;
}
function Wf(e) {
	let t = Number.parseFloat(e);
	return Number.isNaN(t) ? e : t;
}
function Gf(e, t) {
	return !e && !t ? "" : [...Array.isArray(e) ? e : [e], t].filter(Boolean);
}
//#endregion
//#region ../../node_modules/@nuxt/ui/dist/runtime/vue/stubs/base.js
var Kf = Vu();
function qf() {
	return {
		isHydrating: !0,
		payload: { serverRendered: !1 },
		hooks: Kf,
		hook: Kf.hook
	};
}
function Jf(e) {
	return { install(t) {
		t.runWithContext(() => e({ vueApp: t }));
	} };
}
//#endregion
//#region ../../node_modules/@nuxt/ui/dist/runtime/plugins/colors.js
var Yf = [
	50,
	100,
	200,
	300,
	400,
	500,
	600,
	700,
	800,
	900,
	950
];
function Xf(e, t) {
	return e in Pd && typeof Pd[e] == "object" && t in Pd[e] ? Pd[e][t] : "";
}
function Zf(e, t, n) {
	let r = n ? `${n}-` : "";
	return `${Yf.map((n) => `--ui-color-${e}-${n}: var(--${r}color-${t === "neutral" ? "old-neutral" : t}-${n}, ${Xf(t, n)});`).join("\n  ")}`;
}
function Qf(e, t) {
	return `--ui-${e}: var(--ui-color-${e}-${t});`;
}
function $f() {
	document.querySelector("[data-nuxt-ui-colors]")?.remove();
}
var ep = Jf(() => {
	let e = Nf(), t = qf(), n = X(() => {
		let { neutral: t, ...n } = e.ui.colors, r = e.ui.prefix;
		return `@layer theme {
  :root, :host {
  ${Object.entries(e.ui.colors).map(([e, t]) => Zf(e, t, r)).join("\n  ")}
  }
  :root, :host, .light {
  ${Object.keys(n).map((e) => Qf(e, 500)).join("\n  ")}
  }
  .dark {
  ${Object.keys(n).map((e) => Qf(e, 400)).join("\n  ")}
  }
}`;
	}), r = { style: [{
		innerHTML: n,
		tagPriority: "critical",
		id: "nuxt-ui-colors"
	}] };
	if (t.isHydrating && !t.payload.serverRendered) {
		let e = document.createElement("style");
		e.innerHTML = n.value, e.setAttribute("data-nuxt-ui-colors", ""), document.head.appendChild(e);
		let t = (/* @__PURE__ */ Ed()).hooks?.hook("dom:rendered", () => {
			$f(), t?.();
		});
	}
	kd(r);
}), tp = { install() {
	Df();
} }, np = { install(e, t = {}) {
	e.use(bu, t), e.use(Md, t), e.use(Nd, t), e.use(ep, t), e.use(tp, t);
} }, rp = Symbol("nuxt-ui.form-options"), ip = Symbol("nuxt-ui.form-events"), ap = Symbol("nuxt-ui.form-state"), op = Symbol("nuxt-ui.form-field"), sp = Symbol("nuxt-ui.input-id"), cp = Symbol("nuxt-ui.form-inputs"), lp = Symbol("nuxt-ui.form-loading"), up = Symbol("nuxt-ui.form-errors");
function dp(e, t) {
	let n = Ir(rp, void 0), r = Ir(ip, void 0), i = Ir(op, void 0), a = Ir(sp, void 0);
	Fr(op, void 0), i && a && (t?.bind === !1 ? a.value = void 0 : e?.id && (a.value = e?.id));
	function o(e, t, n) {
		r && i && t && r.emit({
			type: e,
			name: t,
			eager: n
		});
	}
	function s() {
		o("blur", i?.value.name);
	}
	function c() {
		o("focus", i?.value.name);
	}
	function l() {
		o("change", i?.value.name);
	}
	let u = !1;
	ke() && Ae(() => {
		u = !0;
	});
	let d = ef(() => {
		u || o("input", i?.value.name, !t?.deferInputValidation || i?.value.eagerValidation);
	}, i?.value.validateOnInputDelay ?? n?.value.validateOnInputDelay ?? 0);
	return {
		id: X(() => e?.id ?? a?.value),
		name: X(() => e?.name ?? i?.value.name),
		size: X(() => e?.size ?? i?.value.size),
		color: X(() => i?.value.error ? "error" : e?.color),
		highlight: X(() => i?.value.error ? !0 : e?.highlight || void 0),
		disabled: X(() => n?.value.disabled || e?.disabled || void 0),
		emitFormBlur: s,
		emitFormInput: d,
		emitFormChange: l,
		emitFormFocus: c,
		ariaAttrs: X(() => {
			if (!i?.value) return;
			let e = [
				"error",
				"hint",
				"description",
				"help"
			].filter((e) => i?.value?.[e]).map((e) => `${i?.value.ariaId}-${e}`) || [], t = { "aria-invalid": !!i?.value.error };
			return e.length > 0 && (t["aria-describedby"] = e.join(" ")), t;
		})
	};
}
//#endregion
//#region ../../node_modules/tailwind-variants/dist/chunk-OYFAXDFZ.js
var fp = Array.isArray, pp = (e) => {
	if (!e && e !== 0 && e !== 0n) return "";
	if (typeof e == "string") return e;
	if (typeof e == "number") return e === e ? "" + e : "";
	if (typeof e == "bigint") return "" + e;
	let t = "";
	if (fp(e)) {
		let n = e.length;
		for (let r = 0; r < n; r++) {
			let n = e[r];
			if (!n && n !== 0 && n !== 0n) continue;
			let i = typeof n == "string" ? n : pp(n);
			i && (t && (t += " "), t += i);
		}
		return t;
	}
	if (typeof e == "object") for (let n in e) e[n] && (t && (t += " "), t += n);
	return t;
}, mp = /\s+/g, hp = Array.isArray, gp = (e) => typeof e != "string" || !e ? e : e.replace(mp, " ").trim(), _p = (e) => {
	let t = e.length;
	if (t === 0) return !1;
	let n = e.charCodeAt(0), r = e.charCodeAt(t - 1);
	if (n === 32 || r === 32 || n >= 9 && n <= 13 || n === 160 || r >= 9 && r <= 13 || r === 160) return !0;
	for (let n = 0; n < t; n++) {
		let r = e.charCodeAt(n);
		if (r >= 9 && r <= 13 || r === 160 || r === 32 && n + 1 < t && e.charCodeAt(n + 1) === 32) return !0;
	}
	return !1;
}, vp = (...e) => {
	let t = pp(e);
	if (t) return _p(t) ? gp(t) : t;
}, yp = (e) => e === !1 ? "false" : e === !0 ? "true" : e === 0 ? "0" : e, bp = (e) => {
	if (!e || typeof e != "object") return !0;
	for (let t in e) return !1;
	return !0;
}, xp = (e, t) => {
	if (e === t) return !0;
	if (!e || !t) return !1;
	let n = e, r = t, i = Object.keys(n), a = Object.keys(r);
	if (i.length !== a.length) return !1;
	for (let e = 0; e < i.length; e++) {
		let t = i[e];
		if (!a.includes(t) || n[t] !== r[t]) return !1;
	}
	return !0;
}, Sp = (e, t) => {
	let n = e;
	for (let e in t) if (Object.hasOwn(t, e)) {
		let r = t[e];
		n[e] = e in n ? vp(n[e], r) : r;
	}
	return e;
}, Cp = (e, t) => {
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		hp(r) ? Cp(r, t) : r && t.push(r);
	}
}, wp = (...e) => {
	let t = [];
	Cp(e, t);
	let n = [];
	for (let e = 0; e < t.length; e++) t[e] && n.push(t[e]);
	return n;
}, Tp = (e, t) => {
	let n = e, r = t, i = {};
	for (let e in n) {
		let t = n[e];
		if (e in r) {
			let n = r[e];
			i[e] = hp(t) || hp(n) ? wp(n, t) : typeof t == "object" && typeof n == "object" && t && n ? Tp(t, n) : n + " " + t;
		} else i[e] = t;
	}
	for (let e in r) e in n || (i[e] = r[e]);
	return i;
}, Ep = {
	twMerge: !0,
	twMergeConfig: {}
}, Dp = 256, Op = 128, kp = /* @__PURE__ */ Symbol("tv-cache-miss"), Ap = (e) => e?.class != null && e.class !== "" || e?.className != null && e.className !== "", jp = (e) => {
	if (e === void 0) return "";
	if (e === null) return "null";
	if (typeof e == "string") return e;
	if (typeof e == "boolean") return e ? "true" : "false";
	if (typeof e == "number") return e === 0 ? "0" : String(e);
	if (typeof e == "bigint") return String(e);
	let t = yp(e), n = typeof t;
	if (n === "string" || n === "number" || n === "boolean" || n === "bigint") return String(t);
	if (n === "object") try {
		return JSON.stringify(t);
	} catch {
		return null;
	}
	return null;
}, Mp = (e, t) => {
	if (t === void 0) return e;
	if (t === null) return e + "null";
	let n = typeof t;
	if (n === "string" || n === "number" || n === "boolean" || n === "bigint") return e + String(t);
	if (Array.isArray(t)) return e + t.join("\0");
	try {
		return e + JSON.stringify(t);
	} catch {
		return e + "?";
	}
}, Np = (e, t, n, r) => {
	let i = "", a = /* @__PURE__ */ Object.create(null);
	for (let r = 0; r < e.length; r++) {
		let o = e[r];
		a[o] = 1;
		let s = t[o];
		n && n[o] !== void 0 && (s = n[o]);
		let c = jp(s);
		if (c === null) return null;
		i += o + ":" + c + ";";
	}
	let o = [];
	for (let e in t) e === "class" || e === "className" || a[e] || (a[e] = 1, o.push(e));
	if (n) for (let e in n) e === "class" || e === "className" || a[e] || n[e] === void 0 || (a[e] = 1, o.push(e));
	o.length > 1 && o.sort();
	for (let e = 0; e < o.length; e++) {
		let r = o[e], a = t[r];
		n && n[r] !== void 0 && (a = n[r]);
		let s = jp(a);
		if (s === null) return null;
		i += r + ":" + s + ";";
	}
	return i;
}, Pp = (e, t) => {
	let n = "";
	for (let t = 0; t < e.length; t++) {
		let { conditionKeys: r, source: i } = e[t];
		for (let e = 0; e < r.length; e++) {
			let t = r[e];
			n += t + "=", n = Mp(n, i[t]), n += ",";
		}
		n += "c=", n = Mp(n, i.class), n += "|cn=", n = Mp(n, i.className), n += ";";
	}
	for (let e = 0; e < t.length; e++) {
		let { conditionKeys: r, source: i } = t[e];
		for (let e = 0; e < r.length; e++) {
			let t = r[e];
			n += t + "=", n = Mp(n, i[t]), n += ",";
		}
		Array.isArray(i.slots) && (n += "slots=" + i.slots.join(",") + ","), n += "c=", n = Mp(n, i.class), n += "|cn=", n = Mp(n, i.className), n += ";";
	}
	return n;
}, Fp = (e = Dp) => {
	let t = /* @__PURE__ */ new Map(), n = null;
	return {
		get(e) {
			if (t.has(e)) return t.get(e);
			if (n?.has(e)) {
				let r = n.get(e);
				return t.set(e, r), r;
			}
			return kp;
		},
		set(r, i) {
			t.size >= e && (n = t, t = /* @__PURE__ */ new Map()), t.set(r, i);
		}
	};
}, Ip = (e = Dp) => {
	let t = Fp(e);
	return {
		get(e) {
			return t.get(e);
		},
		set(e, n) {
			t.set(e, n);
		}
	};
}, Lp = (e = Op) => {
	let t = /* @__PURE__ */ new Map(), n = null, r = 0;
	return {
		get(e, i) {
			let a = t.get(e);
			if (a) {
				let e = a.get(i);
				if (e !== void 0 || a.has(i)) return e;
			}
			if (n) {
				let a = n.get(e);
				if (a) {
					let n = a.get(i);
					if (n !== void 0 || a.has(i)) {
						let a = t.get(e);
						return a || (a = /* @__PURE__ */ new Map(), t.set(e, a)), a.has(i) || r++, a.set(i, n), n;
					}
				}
			}
			return kp;
		},
		set(i, a, o) {
			r >= e && (n = t, t = /* @__PURE__ */ new Map(), r = 0);
			let s = t.get(i);
			s || (s = /* @__PURE__ */ new Map(), t.set(i, s)), s.has(a) || r++, s.set(a, o);
		}
	};
}, Rp = (e, t) => {
	let n = null;
	return (r, i) => {
		if (!Ap(i)) return r;
		let a = i.class, o = i.className;
		if (a != null && a !== "" && typeof a != "string" || o != null && o !== "" && typeof o != "string") return e(t, r, a, o);
		n ??= Lp();
		let s = r ?? "", c = (typeof a == "string" ? a : "") + "\0" + (typeof o == "string" ? o : ""), l = n.get(s, c);
		if (l !== kp) return l;
		let u = e(t, r, a, o);
		return n.set(s, c, u), u;
	};
};
function zp() {
	let e = null, t = {}, n = !1;
	return {
		get cachedTwMerge() {
			return e;
		},
		set cachedTwMerge(t) {
			e = t;
		},
		get cachedTwMergeConfig() {
			return t;
		},
		set cachedTwMergeConfig(e) {
			t = e;
		},
		get didTwMergeConfigChange() {
			return n;
		},
		set didTwMergeConfigChange(e) {
			n = e;
		},
		reset() {
			e = null, t = {}, n = !1;
		}
	};
}
var Bp = zp(), Vp = (e) => {
	!bp(e.twMergeConfig) && !xp(e.twMergeConfig, Bp.cachedTwMergeConfig) && (Bp.didTwMergeConfigChange = !0, Bp.cachedTwMergeConfig = e.twMergeConfig);
}, Hp = (e, t) => {
	let n = [];
	for (let r = 0; r < t.length; r++) {
		let i = t[r], a = e[i];
		n.push({
			key: i,
			values: a,
			isEmpty: bp(a)
		});
	}
	return n;
}, Up = (e) => {
	if (!Array.isArray(e) || e.length === 0) return [];
	let t = [];
	for (let n = 0; n < e.length; n++) {
		let r = e[n], i = [];
		for (let e in r) e !== "class" && e !== "className" && i.push(e);
		t.push({
			conditionKeys: i,
			source: r
		});
	}
	return t;
}, Wp = (e) => {
	if (!Array.isArray(e) || e.length === 0) return [];
	let t = [];
	for (let n = 0; n < e.length; n++) {
		let r = e[n], i = [];
		for (let e in r) e !== "slots" && e !== "class" && e !== "className" && i.push(e);
		t.push({
			conditionKeys: i,
			source: r
		});
	}
	return t;
}, Gp = (e) => {
	let t = {};
	for (let n = 0; n < e.length; n++) {
		let r = e[n], i = r.source.slots;
		if (Array.isArray(i)) for (let e = 0; e < i.length; e++) {
			let n = i[e];
			t[n] || (t[n] = []), t[n].push(r);
		}
	}
	return t;
}, Kp = (e, t) => {
	let { extend: n = null, slots: r = {}, variants: i = {}, compoundVariants: a = [], compoundSlots: o = [], defaultVariants: s = {} } = e, c = {
		...Ep,
		...t
	}, l = e.slots !== void 0, u = n?.base ? vp(n.base, e?.base) : e?.base, d = n?.variants && !bp(n.variants) ? Tp(i, n.variants) : i, f = n?.defaultVariants && !bp(n.defaultVariants) ? {
		...n.defaultVariants,
		...s
	} : s;
	Vp(c);
	let p = !n?.slots || bp(n.slots), m = l ? p && n?.base ? vp(e?.base, n.base) : typeof e?.base == "string" || e?.base == null ? e.base : vp(e.base) : void 0, h = l ? {
		base: m,
		...r
	} : {}, g = p ? h : Sp({ ...n?.slots }, bp(h) ? { base: e?.base } : h), _ = !n?.compoundVariants || bp(n.compoundVariants) ? a : wp(n?.compoundVariants, a), v = !n?.compoundSlots || bp(n.compoundSlots) ? o : wp(n?.compoundSlots, o), y = Object.keys(d);
	return {
		config: c,
		extend: n,
		base: u,
		variants: d,
		defaultVariants: f,
		slots: g,
		compoundVariants: _,
		compoundSlots: v,
		compiledVariants: null,
		compiledCompoundVariants: null,
		compiledCompoundSlots: null,
		compiledCompoundSlotsBySlot: null,
		deferredError: _ && !Array.isArray(_) ? /* @__PURE__ */ TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof _}`) : v && !Array.isArray(v) ? /* @__PURE__ */ TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof v}`) : null,
		mode: l || !p ? "slots" : y.length === 0 ? "plain" : "variants",
		slotKeys: null,
		variantKeys: y
	};
}, qp = (e) => e.compiledVariants === null ? (e.compiledVariants = Hp(e.variants, e.variantKeys), e.compiledCompoundVariants = Up(e.compoundVariants), e.compiledCompoundSlots = Wp(e.compoundSlots), e.compiledCompoundSlotsBySlot = Gp(e.compiledCompoundSlots), e.slotKeys = e.slots && typeof e.slots == "object" ? Object.keys(e.slots) : [], e) : e, Jp = [], Yp = [], Xp = [], Zp = [], Qp = [], $p = (e, t, n) => {
	let r = {};
	for (let t in e) r[t] = e[t];
	if (t) for (let e in t) t[e] !== void 0 && (r[e] = t[e]);
	if (n) for (let e in n) n[e] !== void 0 && (r[e] = n[e]);
	return r;
}, em = (e) => e == null || e === !1, tm = (e, t) => {
	if (!Array.isArray(e)) return e === t || em(e) && em(t);
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		if (r === t || em(r) && em(t)) return !0;
	}
	return !1;
}, nm = (e, t, n, r) => {
	if (e.isEmpty) return null;
	let i = r?.[e.key] ?? n?.[e.key];
	if (i === null) return null;
	let a = yp(i);
	if (typeof a == "object") return null;
	let o = t?.[e.key], s = a ?? yp(o);
	return e.values[s || "false"];
}, rm = (e, t) => {
	let { conditionKeys: n, source: r } = e;
	for (let e = 0; e < n.length; e++) {
		let i = n[e];
		if (!tm(r[i], t[i])) return !1;
	}
	return !0;
}, im = (e, t, n) => {
	typeof n == "string" ? t === "base" && e.push(n) : n && typeof n == "object" && n[t] && e.push(n[t]);
}, am = (e, t, n) => {
	let r = Yp;
	r.length = 0;
	for (let i = 0; i < e.length; i++) {
		let a = nm(e[i], t, n);
		a && r.push(a);
	}
	return r;
}, om = (e, t, n, r, i) => {
	let a = Yp;
	a.length = 0;
	for (let o = 0; o < t.length; o++) {
		let s = nm(t[o], n, r, i), c = e === "base" && typeof s == "string" ? s : s && s[e];
		c && a.push(c);
	}
	return a;
}, sm = (e, t) => {
	let n = Xp;
	n.length = 0;
	for (let r = 0; r < e.length; r++) {
		let i = e[r];
		rm(i, t) && (i.source.class && n.push(i.source.class), i.source.className && n.push(i.source.className));
	}
	return n;
}, cm = (e, t, n) => {
	let r = Zp;
	r.length = 0;
	for (let i = 0; i < t.length; i++) {
		let a = t[i];
		rm(a, n) && (im(r, e, a.source.class), im(r, e, a.source.className));
	}
	return r;
}, lm = (e, t) => {
	let n = Qp;
	n.length = 0;
	for (let r = 0; r < e.length; r++) {
		let i = e[r];
		rm(i, t) && (i.source.class && n.push(i.source.class), i.source.className && n.push(i.source.className));
	}
	return n;
}, um = (e, t) => {
	let { base: n, config: r } = e, i = kp, a = Rp(t, r);
	return ((e) => (i === kp && (i = t(r, n)), a(i, e)));
}, dm = (e, t) => {
	let { base: n, config: r, defaultVariants: i, deferredError: a, variantKeys: o } = e, s = e.compiledCompoundVariants, c = e.compiledVariants, l = Jp, u = null, d = Rp(t, r), f = 1, p = (e) => {
		let a = s.length > 0 ? sm(s, $p(i, e)) : void 0;
		return t(r, n, am(c, i, e), a);
	};
	return ((t) => {
		if (a) throw a;
		(c === null || s === null) && (qp(e), c = e.compiledVariants, s = e.compiledCompoundVariants, l = e.compiledCompoundSlots ?? Jp);
		let n;
		if (f > 0) f--, n = p(t);
		else {
			u ??= Ip();
			let e = Np(o, i, t);
			if (e !== null) {
				let r = s.length > 0 || l.length > 0 ? Pp(s, l) : "", i = e + "#" + r, a = u.get(i);
				a === kp ? (n = p(t), u.set(i, n)) : n = a;
			} else n = p(t);
		}
		return d(n, t);
	});
}, fm = (e, t) => {
	let { config: n, defaultVariants: r, deferredError: i, slots: a, variantKeys: o } = e, s = null, c = null, l = null, u = null, d = !1, f = null, p = null, m = 1, h = () => {
		if (l !== null) return;
		(e.compiledVariants === null || e.compiledCompoundVariants === null || e.compiledCompoundSlots === null || e.compiledCompoundSlotsBySlot === null || e.slotKeys === null) && qp(e);
		let i = e.compiledVariants;
		s = e.compiledCompoundVariants, c = e.compiledCompoundSlots;
		let o = e.compiledCompoundSlotsBySlot;
		l = e.slotKeys, d = s.length > 0 || c.length > 0, f = Rp(t, n);
		let p = Array(l.length);
		for (let e = 0; e < l.length; e++) {
			let c = l[e], u = o[c] ?? Jp;
			p[e] = (e, o) => {
				let l = d ? $p(r, e, o) : void 0, f = l ? cm(c, s, l) : void 0, p = l ? lm(u, l) : void 0;
				return t(n, a[c], om(c, i, r, e, o), f, p);
			};
		}
		u = p;
	}, g = (e) => {
		let t = l, n = u, r = f, i = {};
		for (let a = 0; a < t.length; a++) {
			let o = n[a], s = o(e);
			i[t[a]] = (t) => {
				if (t == null) return s;
				let n = !1;
				for (let e in t) if (e !== "class" && e !== "className" && t[e] !== void 0) {
					n = !0;
					break;
				}
				return r(n ? o(e, t) : s, t);
			};
		}
		return i;
	};
	return ((e) => {
		if (i) throw i;
		if (h(), m > 0) return m--, g(e);
		let t = Np(o, r, e);
		if (t === null) return g(e);
		let n = d ? Pp(s, c) : "", a = t + "#" + n;
		p ??= Fp();
		let l = p.get(a);
		if (l !== kp) return l;
		let u = g(e);
		return p.set(a, u), u;
	});
}, pm = (e, t) => {
	if (e.mode === "plain") return um(e, t);
	let n;
	return ((r) => (n ??= e.mode === "slots" ? fm(e, t) : dm(e, t), n(r)));
}, mm = (e, t) => {
	e.variantKeys = t.variantKeys, e.extend = t.extend, e.base = t.base, e.slots = t.slots, e.variants = t.variants, e.defaultVariants = t.defaultVariants, e.compoundSlots = t.compoundSlots, e.compoundVariants = t.compoundVariants;
}, hm = (e) => {
	let t = (t, n) => {
		let r = Kp(t, n), i = pm(r, e);
		return mm(i, r), i;
	};
	return {
		tv: t,
		createTV: (e) => (n, r) => t(n, r ? Tp(e, r) : e)
	};
}, gm = (e, t) => {
	let n = e.length, r = t.length, i = Array(n + r);
	for (let t = 0; t < n; t++) i[t] = e[t];
	for (let e = 0; e < r; e++) i[n + e] = t[e];
	return i;
}, _m = (e, t) => ({
	classGroupId: e,
	validator: t
}), vm = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
	nextPart: e,
	validators: t,
	classGroupId: n
}), ym = "-", bm = [], xm = "arbitrary..", Sm = (e) => {
	let t = Tm(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			if (e[0] === "[" && e[e.length - 1] === "]") return wm(e);
			let n = e.split(ym);
			return Cm(n, +(n[0] === "" && n.length > 1), t);
		},
		getConflictingClassGroupIds: (e, t) => {
			if (t) {
				let t = r[e], i = n[e];
				return t ? i ? gm(i, t) : t : i || bm;
			}
			return n[e] || bm;
		}
	};
}, Cm = (e, t, n) => {
	if (e.length - t === 0) return n.classGroupId;
	let r = e[t], i = n.nextPart.get(r);
	if (i) {
		let n = Cm(e, t + 1, i);
		if (n) return n;
	}
	let a = n.validators;
	if (a === null) return;
	let o = t === 0 ? e.join(ym) : e.slice(t).join(ym), s = a.length;
	for (let e = 0; e < s; e++) {
		let t = a[e];
		if (t.validator(o)) return t.classGroupId;
	}
}, wm = (e) => {
	let t = e.slice(1, -1), n = t.indexOf(":");
	if (n === -1) return;
	let r = t.slice(0, n);
	return r ? xm + r : void 0;
}, Tm = (e) => {
	let { theme: t, classGroups: n } = e;
	return Em(n, t);
}, Em = (e, t) => {
	let n = vm();
	for (let r in e) {
		let i = e[r];
		Dm(i, n, r, t);
	}
	return n;
}, Dm = (e, t, n, r) => {
	let i = e.length;
	for (let a = 0; a < i; a++) {
		let i = e[a];
		Om(i, t, n, r);
	}
}, Om = (e, t, n, r) => {
	if (typeof e == "string") {
		km(e, t, n);
		return;
	}
	if (typeof e == "function") {
		Am(e, t, n, r);
		return;
	}
	jm(e, t, n, r);
}, km = (e, t, n) => {
	let r = e === "" ? t : Mm(t, e);
	r.classGroupId = n;
}, Am = (e, t, n, r) => {
	if (Nm(e)) {
		Dm(e(r), t, n, r);
		return;
	}
	t.validators === null && (t.validators = []), t.validators.push(_m(n, e));
}, jm = (e, t, n, r) => {
	let i = Object.entries(e), a = i.length;
	for (let e = 0; e < a; e++) {
		let [a, o] = i[e];
		Dm(o, Mm(t, a), n, r);
	}
}, Mm = (e, t) => {
	let n = e, r = t.split(ym), i = r.length;
	for (let e = 0; e < i; e++) {
		let t = r[e], i = n.nextPart.get(t);
		i || (i = vm(), n.nextPart.set(t, i)), n = i;
	}
	return n;
}, Nm = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, Pm = "!", Fm = 58, Im = 47, Lm = 91, Rm = 93, zm = 40, Bm = 41, Vm = 33, Hm = (e, t, n, r) => ({
	modifiers: e,
	hasImportantModifier: t,
	baseClassName: n,
	maybePostfixModifierPosition: r,
	isExternal: void 0
}), Um = (e) => {
	let t = [], n = 0, r = 0, i = 0, a, o = e.length;
	for (let s = 0; s < o; s++) {
		let o = e.charCodeAt(s);
		if (n === 0 && r === 0) {
			if (o === Fm) {
				t.push(e.slice(i, s)), i = s + 1;
				continue;
			}
			if (o === Im) {
				a = s;
				continue;
			}
		}
		o === Lm ? n++ : o === Rm ? n-- : o === zm ? r++ : o === Bm && r--;
	}
	let s = t.length === 0 ? e : e.slice(i), c = s, l = !1, u = s.length - 1;
	s.charCodeAt(u) === Vm ? (c = s.slice(0, -1), l = !0) : s.charCodeAt(0) === Vm && (c = s.slice(1), l = !0);
	let d = a && a > i ? a - i : void 0;
	return Hm(t, l, c, d);
}, Wm = (e) => {
	let t = new Set(e.orderSensitiveModifiers);
	return (e) => {
		let n = [], r = [];
		for (let i = 0; i < e.length; i++) {
			let a = e[i], o = a[0] === "[", s = t.has(a);
			if (o || s) {
				if (r.length > 0) {
					r.sort();
					for (let e = 0; e < r.length; e++) n.push(r[e]);
					r = [];
				}
				n.push(a);
			} else r.push(a);
		}
		if (r.length > 0) {
			r.sort();
			for (let e = 0; e < r.length; e++) n.push(r[e]);
		}
		return n;
	};
}, Gm = {
	isExternal: !0,
	classId: -1,
	conflictIds: []
}, Km = 4096, qm = 16384, Jm = (e) => {
	let t = Wm(e), n = Ym(e), { getClassGroupId: r, getConflictingClassGroupIds: i } = Sm(e), a = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ Object.create(null), s = 0, c = /* @__PURE__ */ new Int32Array(256), l = 0, u = /* @__PURE__ */ new Uint8Array(64), d = !1, f = (e) => {
		let t = [], n = e.length, r = -1;
		d = !1;
		for (let i = 0; i < n; i++) {
			let n = e.charCodeAt(i);
			n === 32 ? r !== -1 && (t.push(e.slice(r, i)), r = -1) : n >= 9 && n <= 13 ? (d = !0, r !== -1 && (t.push(e.slice(r, i)), r = -1)) : r === -1 && (r = i);
		}
		return r !== -1 && t.push(e.slice(r)), t;
	}, p = /* @__PURE__ */ new Map(), m = 0, h = (e) => {
		let t = p.get(e);
		if (t === void 0 && (t = m++, p.set(e, t), t >= c.length)) {
			let e = new Int32Array(c.length * 2);
			e.set(c), c = e;
		}
		return t;
	}, g = (e) => {
		let { isExternal: a, modifiers: o, hasImportantModifier: s, baseClassName: c, maybePostfixModifierPosition: l } = Um(e);
		if (a) return Gm;
		let u = !!l, d;
		if (u) {
			let e = c.substring(0, l);
			d = r(e);
			let t = d && n[d] ? r(c) : void 0;
			t && t !== d && (d = t, u = !1);
		} else d = r(c);
		if (!d) {
			if (!u || (d = r(c), !d)) return Gm;
			u = !1;
		}
		let f = o.length === 0 ? "" : o.length === 1 ? o[0] : t(o).join(":"), p = s ? f + Pm : f, m = i(d, u), g = [];
		for (let e = 0; e < m.length; e++) g.push(h(p + m[e]));
		return {
			isExternal: !1,
			classId: h(p + d),
			conflictIds: g
		};
	}, _ = (e) => {
		let t = a[e];
		return t === void 0 ? (t = o[e], t === void 0 && (t = g(e)), a[e] = t, ++s > Km && (s = 0, o = a, a = /* @__PURE__ */ Object.create(null)), t) : t;
	};
	return {
		parseClassName: Um,
		sortModifiers: t,
		postfixLookupClassGroupIds: n,
		getClassGroupId: r,
		getConflictingClassGroupIds: i,
		getClassDescriptor: _,
		mergeClassList: (e) => {
			let t = f(e), n = t.length;
			if (n === 1) return t[0];
			m > qm && (p.clear(), m = 0, a = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ Object.create(null), s = 0), l = l + 1 | 0, l === 0 && (l = 1);
			let r = l;
			if (n > u.length) {
				let e = u.length;
				for (; e < n;) e *= 2;
				u = new Uint8Array(e);
			}
			let i = !1, h = 0;
			for (let e = n - 1; e >= 0; --e) {
				let n = t[e];
				h += n.length;
				let a = _(n);
				if (a.isExternal) {
					u[e] = 1;
					continue;
				}
				let o = a.classId;
				if (c[o] === r) {
					u[e] = 0, i = !0;
					continue;
				}
				c[o] = r;
				let s = a.conflictIds;
				for (let e = 0; e < s.length; e++) c[s[e]] = r;
				u[e] = 1;
			}
			if (!i && !d && e.length === h + n - 1) return e;
			let g = "";
			for (let e = 0; e < n; e++) u[e] === 1 && (g && (g += " "), g += t[e]);
			return g;
		}
	};
}, Ym = (e) => {
	let t = /* @__PURE__ */ Object.create(null), n = e.postfixLookupClassGroups;
	if (n) for (let e = 0; e < n.length; e++) t[n[e]] = !0;
	return t;
}, Xm = 500, Zm = (e) => {
	let t, n, r = /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null), a = 0, o = (r) => (t = Jm(e()), n = t.mergeClassList, c.mergeString = s, s(r)), s = (e) => {
		let t = r[e];
		return t === void 0 ? (t = i[e], t === void 0 && (t = n(e)), r[e] = t, ++a > Xm && (a = 0, i = r, r = /* @__PURE__ */ Object.create(null)), t) : t;
	}, c = (...e) => c.mergeString(pp(e));
	return c.mergeString = o, c;
}, Qm = [], $m = (e) => {
	let t = (t) => t[e] || Qm;
	return t.isThemeGetter = !0, t;
}, eh = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, th = /^\((?:(\w[\w-]*):)?(.+)\)$/i, nh = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, rh = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, ih = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, ah = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, oh = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, sh = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, ch = Number, lh = Number.isNaN, uh = Number.isInteger, dh = (e) => nh.test(e), Z = (e) => !!e && !lh(ch(e)), fh = (e) => !!e && uh(ch(e)), ph = (e) => e.endsWith("%") && Z(e.slice(0, -1)), mh = (e) => rh.test(e), hh = () => !0, gh = (e) => ih.test(e) && !ah.test(e), _h = () => !1, vh = (e) => oh.test(e), yh = (e) => sh.test(e), bh = (e) => !Q(e) && !$(e), xh = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), Sh = (e) => Lh(e, Vh, _h), Q = (e) => eh.test(e), Ch = (e) => Lh(e, Hh, gh), wh = (e) => Lh(e, Uh, Z), Th = (e) => Lh(e, Gh, hh), Eh = (e) => Lh(e, Wh, _h), Dh = (e) => Lh(e, zh, _h), Oh = (e) => Lh(e, Bh, yh), kh = (e) => Lh(e, Kh, vh), $ = (e) => th.test(e), Ah = (e) => Rh(e, Hh), jh = (e) => Rh(e, Wh), Mh = (e) => Rh(e, zh), Nh = (e) => Rh(e, Vh), Ph = (e) => Rh(e, Bh), Fh = (e) => Rh(e, Kh, !0), Ih = (e) => Rh(e, Gh, !0), Lh = (e, t, n) => {
	let r = eh.exec(e);
	return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Rh = (e, t, n = !1) => {
	let r = th.exec(e);
	return r ? r[1] ? t(r[1]) : n : !1;
}, zh = (e) => e === "position" || e === "percentage", Bh = (e) => e === "image" || e === "url", Vh = (e) => e === "length" || e === "size" || e === "bg-size", Hh = (e) => e === "length", Uh = (e) => e === "number", Wh = (e) => e === "family-name", Gh = (e) => e === "number" || e === "weight", Kh = (e) => e === "shadow", qh = () => {
	let e = $m("color"), t = $m("font"), n = $m("text"), r = $m("font-weight"), i = $m("tracking"), a = $m("leading"), o = $m("breakpoint"), s = $m("container"), c = $m("spacing"), l = $m("radius"), u = $m("shadow"), d = $m("inset-shadow"), f = $m("text-shadow"), p = $m("drop-shadow"), m = $m("blur"), h = $m("perspective"), g = $m("aspect"), _ = $m("ease"), v = $m("animate"), y = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], b = () => [
		"center",
		"top",
		"bottom",
		"left",
		"right",
		"top-left",
		"left-top",
		"top-right",
		"right-top",
		"bottom-right",
		"right-bottom",
		"bottom-left",
		"left-bottom"
	], x = () => [
		...b(),
		$,
		Q
	], S = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], C = () => [
		"auto",
		"contain",
		"none"
	], w = () => [
		$,
		Q,
		c
	], T = () => [
		dh,
		"full",
		"auto",
		...w()
	], ee = () => [
		fh,
		"none",
		"subgrid",
		$,
		Q
	], te = () => [
		"auto",
		{ span: [
			"full",
			fh,
			$,
			Q
		] },
		fh,
		$,
		Q
	], ne = () => [
		fh,
		"auto",
		$,
		Q
	], E = () => [
		"auto",
		"min",
		"max",
		"fr",
		$,
		Q
	], D = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch",
		"baseline",
		"center-safe",
		"end-safe"
	], O = () => [
		"start",
		"end",
		"center",
		"stretch",
		"center-safe",
		"end-safe"
	], k = () => ["auto", ...w()], A = () => [
		dh,
		"auto",
		"full",
		"dvw",
		"dvh",
		"lvw",
		"lvh",
		"svw",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], j = () => [
		dh,
		"screen",
		"full",
		"dvw",
		"lvw",
		"svw",
		"min",
		"max",
		"fit",
		...w()
	], re = () => [
		dh,
		"screen",
		"full",
		"lh",
		"dvh",
		"lvh",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], M = () => [
		e,
		$,
		Q
	], N = () => [
		...b(),
		Mh,
		Dh,
		{ position: [$, Q] }
	], ie = () => ["no-repeat", { repeat: [
		"",
		"x",
		"y",
		"space",
		"round"
	] }], ae = () => [
		"auto",
		"cover",
		"contain",
		Nh,
		Sh,
		{ size: [$, Q] }
	], oe = () => [
		ph,
		Ah,
		Ch
	], P = () => [
		"",
		"none",
		"full",
		l,
		$,
		Q
	], F = () => [
		"",
		Z,
		Ah,
		Ch
	], se = () => [
		"solid",
		"dashed",
		"dotted",
		"double"
	], ce = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], I = () => [
		Z,
		ph,
		Mh,
		Dh
	], le = () => [
		"",
		"none",
		m,
		$,
		Q
	], ue = () => [
		"none",
		Z,
		$,
		Q
	], de = () => [
		"none",
		Z,
		$,
		Q
	], fe = () => [
		Z,
		$,
		Q
	], pe = () => [
		dh,
		"full",
		...w()
	];
	return {
		theme: {
			animate: [
				"spin",
				"ping",
				"pulse",
				"bounce"
			],
			aspect: ["video"],
			blur: [mh],
			breakpoint: [mh],
			color: [hh],
			container: [mh],
			"drop-shadow": [mh],
			ease: [
				"in",
				"out",
				"in-out"
			],
			font: [bh],
			"font-weight": [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black"
			],
			"inset-shadow": [mh],
			leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose"
			],
			perspective: [
				"dramatic",
				"near",
				"normal",
				"midrange",
				"distant",
				"none"
			],
			radius: [mh],
			shadow: [mh],
			spacing: ["px", Z],
			text: [mh],
			"text-shadow": [mh],
			tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest"
			]
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				dh,
				Q,
				$,
				g
			] }],
			container: ["container"],
			"container-type": [{ "@container": [
				"",
				"normal",
				"size",
				$,
				Q
			] }],
			"container-named": [xh],
			columns: [{ columns: [
				Z,
				Q,
				$,
				s
			] }],
			"break-after": [{ "break-after": y() }],
			"break-before": [{ "break-before": y() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			sr: ["sr-only", "not-sr-only"],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: x() }],
			overflow: [{ overflow: S() }],
			"overflow-x": [{ "overflow-x": S() }],
			"overflow-y": [{ "overflow-y": S() }],
			overscroll: [{ overscroll: C() }],
			"overscroll-x": [{ "overscroll-x": C() }],
			"overscroll-y": [{ "overscroll-y": C() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: T() }],
			"inset-x": [{ "inset-x": T() }],
			"inset-y": [{ "inset-y": T() }],
			start: [{
				"inset-s": T(),
				start: T()
			}],
			end: [{
				"inset-e": T(),
				end: T()
			}],
			"inset-bs": [{ "inset-bs": T() }],
			"inset-be": [{ "inset-be": T() }],
			top: [{ top: T() }],
			right: [{ right: T() }],
			bottom: [{ bottom: T() }],
			left: [{ left: T() }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				fh,
				"auto",
				$,
				Q
			] }],
			basis: [{ basis: [
				dh,
				"full",
				"auto",
				s,
				...w()
			] }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"nowrap",
				"wrap",
				"wrap-reverse"
			] }],
			flex: [{ flex: [
				Z,
				dh,
				"auto",
				"initial",
				"none",
				Q
			] }],
			grow: [{ grow: [
				"",
				Z,
				$,
				Q
			] }],
			shrink: [{ shrink: [
				"",
				Z,
				$,
				Q
			] }],
			order: [{ order: [
				fh,
				"first",
				"last",
				"none",
				$,
				Q
			] }],
			"grid-cols": [{ "grid-cols": ee() }],
			"col-start-end": [{ col: te() }],
			"col-start": [{ "col-start": ne() }],
			"col-end": [{ "col-end": ne() }],
			"grid-rows": [{ "grid-rows": ee() }],
			"row-start-end": [{ row: te() }],
			"row-start": [{ "row-start": ne() }],
			"row-end": [{ "row-end": ne() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": E() }],
			"auto-rows": [{ "auto-rows": E() }],
			gap: [{ gap: w() }],
			"gap-x": [{ "gap-x": w() }],
			"gap-y": [{ "gap-y": w() }],
			"justify-content": [{ justify: [...D(), "normal"] }],
			"justify-items": [{ "justify-items": [...O(), "normal"] }],
			"justify-self": [{ "justify-self": ["auto", ...O()] }],
			"align-content": [{ content: ["normal", ...D()] }],
			"align-items": [{ items: [...O(), { baseline: ["", "last"] }] }],
			"align-self": [{ self: [
				"auto",
				...O(),
				{ baseline: ["", "last"] }
			] }],
			"place-content": [{ "place-content": D() }],
			"place-items": [{ "place-items": [...O(), "baseline"] }],
			"place-self": [{ "place-self": ["auto", ...O()] }],
			p: [{ p: w() }],
			px: [{ px: w() }],
			py: [{ py: w() }],
			ps: [{ ps: w() }],
			pe: [{ pe: w() }],
			pbs: [{ pbs: w() }],
			pbe: [{ pbe: w() }],
			pt: [{ pt: w() }],
			pr: [{ pr: w() }],
			pb: [{ pb: w() }],
			pl: [{ pl: w() }],
			m: [{ m: k() }],
			mx: [{ mx: k() }],
			my: [{ my: k() }],
			ms: [{ ms: k() }],
			me: [{ me: k() }],
			mbs: [{ mbs: k() }],
			mbe: [{ mbe: k() }],
			mt: [{ mt: k() }],
			mr: [{ mr: k() }],
			mb: [{ mb: k() }],
			ml: [{ ml: k() }],
			"space-x": [{ "space-x": w() }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": w() }],
			"space-y-reverse": ["space-y-reverse"],
			size: [{ size: A() }],
			"inline-size": [{ inline: ["auto", ...j()] }],
			"min-inline-size": [{ "min-inline": ["auto", ...j()] }],
			"max-inline-size": [{ "max-inline": ["none", ...j()] }],
			"block-size": [{ block: ["auto", ...re()] }],
			"min-block-size": [{ "min-block": ["auto", ...re()] }],
			"max-block-size": [{ "max-block": ["none", ...re()] }],
			w: [{ w: [
				s,
				"screen",
				...A()
			] }],
			"min-w": [{ "min-w": [
				s,
				"screen",
				"none",
				...A()
			] }],
			"max-w": [{ "max-w": [
				s,
				"screen",
				"none",
				"prose",
				{ screen: [o] },
				...A()
			] }],
			h: [{ h: [
				"screen",
				"lh",
				...A()
			] }],
			"min-h": [{ "min-h": [
				"screen",
				"lh",
				"none",
				...A()
			] }],
			"max-h": [{ "max-h": [
				"screen",
				"lh",
				...A()
			] }],
			"font-size": [{ text: [
				"base",
				n,
				Ah,
				Ch
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				r,
				Ih,
				Th
			] }],
			"font-stretch": [{ "font-stretch": [
				"ultra-condensed",
				"extra-condensed",
				"condensed",
				"semi-condensed",
				"normal",
				"semi-expanded",
				"expanded",
				"extra-expanded",
				"ultra-expanded",
				ph,
				Q
			] }],
			"font-family": [{ font: [
				jh,
				Eh,
				t
			] }],
			"font-features": [{ "font-features": [Q] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				i,
				$,
				Q
			] }],
			"line-clamp": [{ "line-clamp": [
				Z,
				"none",
				$,
				wh
			] }],
			leading: [{ leading: [a, ...w()] }],
			"list-image": [{ "list-image": [
				"none",
				$,
				Q
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"list-style-type": [{ list: [
				"disc",
				"decimal",
				"none",
				$,
				Q
			] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"placeholder-color": [{ placeholder: M() }],
			"text-color": [{ text: M() }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...se(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				Z,
				"from-font",
				"auto",
				$,
				Ch
			] }],
			"text-decoration-color": [{ decoration: M() }],
			"underline-offset": [{ "underline-offset": [
				Z,
				"auto",
				$,
				Q
			] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: w() }],
			"tab-size": [{ tab: [
				fh,
				$,
				Q
			] }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				$,
				Q
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			wrap: [{ wrap: [
				"break-word",
				"anywhere",
				"normal"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: [
				"none",
				$,
				Q
			] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: N() }],
			"bg-repeat": [{ bg: ie() }],
			"bg-size": [{ bg: ae() }],
			"bg-image": [{ bg: [
				"none",
				{
					linear: [
						{ to: [
							"t",
							"tr",
							"r",
							"br",
							"b",
							"bl",
							"l",
							"tl"
						] },
						fh,
						$,
						Q
					],
					radial: [
						"",
						$,
						Q
					],
					conic: [
						fh,
						$,
						Q
					]
				},
				Ph,
				Oh
			] }],
			"bg-color": [{ bg: M() }],
			"gradient-from-pos": [{ from: oe() }],
			"gradient-via-pos": [{ via: oe() }],
			"gradient-to-pos": [{ to: oe() }],
			"gradient-from": [{ from: M() }],
			"gradient-via": [{ via: M() }],
			"gradient-to": [{ to: M() }],
			rounded: [{ rounded: P() }],
			"rounded-s": [{ "rounded-s": P() }],
			"rounded-e": [{ "rounded-e": P() }],
			"rounded-t": [{ "rounded-t": P() }],
			"rounded-r": [{ "rounded-r": P() }],
			"rounded-b": [{ "rounded-b": P() }],
			"rounded-l": [{ "rounded-l": P() }],
			"rounded-ss": [{ "rounded-ss": P() }],
			"rounded-se": [{ "rounded-se": P() }],
			"rounded-ee": [{ "rounded-ee": P() }],
			"rounded-es": [{ "rounded-es": P() }],
			"rounded-tl": [{ "rounded-tl": P() }],
			"rounded-tr": [{ "rounded-tr": P() }],
			"rounded-br": [{ "rounded-br": P() }],
			"rounded-bl": [{ "rounded-bl": P() }],
			"border-w": [{ border: F() }],
			"border-w-x": [{ "border-x": F() }],
			"border-w-y": [{ "border-y": F() }],
			"border-w-s": [{ "border-s": F() }],
			"border-w-e": [{ "border-e": F() }],
			"border-w-bs": [{ "border-bs": F() }],
			"border-w-be": [{ "border-be": F() }],
			"border-w-t": [{ "border-t": F() }],
			"border-w-r": [{ "border-r": F() }],
			"border-w-b": [{ "border-b": F() }],
			"border-w-l": [{ "border-l": F() }],
			"divide-x": [{ "divide-x": F() }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": F() }],
			"divide-y-reverse": ["divide-y-reverse"],
			"border-style": [{ border: [
				...se(),
				"hidden",
				"none"
			] }],
			"divide-style": [{ divide: [
				...se(),
				"hidden",
				"none"
			] }],
			"border-color": [{ border: M() }],
			"border-color-x": [{ "border-x": M() }],
			"border-color-y": [{ "border-y": M() }],
			"border-color-s": [{ "border-s": M() }],
			"border-color-e": [{ "border-e": M() }],
			"border-color-bs": [{ "border-bs": M() }],
			"border-color-be": [{ "border-be": M() }],
			"border-color-t": [{ "border-t": M() }],
			"border-color-r": [{ "border-r": M() }],
			"border-color-b": [{ "border-b": M() }],
			"border-color-l": [{ "border-l": M() }],
			"divide-color": [{ divide: M() }],
			"outline-style": [{ outline: [
				...se(),
				"none",
				"hidden"
			] }],
			"outline-offset": [{ "outline-offset": [
				Z,
				$,
				Q
			] }],
			"outline-w": [{ outline: [
				"",
				Z,
				Ah,
				Ch
			] }],
			"outline-color": [{ outline: M() }],
			shadow: [{ shadow: [
				"",
				"none",
				u,
				Fh,
				kh
			] }],
			"shadow-color": [{ shadow: M() }],
			"inset-shadow": [{ "inset-shadow": [
				"none",
				d,
				Fh,
				kh
			] }],
			"inset-shadow-color": [{ "inset-shadow": M() }],
			"ring-w": [{ ring: F() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: M() }],
			"ring-offset-w": [{ "ring-offset": [Z, Ch] }],
			"ring-offset-color": [{ "ring-offset": M() }],
			"inset-ring-w": [{ "inset-ring": F() }],
			"inset-ring-color": [{ "inset-ring": M() }],
			"text-shadow": [{ "text-shadow": [
				"none",
				f,
				Fh,
				kh
			] }],
			"text-shadow-color": [{ "text-shadow": M() }],
			opacity: [{ opacity: [
				Z,
				$,
				Q
			] }],
			"mix-blend": [{ "mix-blend": [
				...ce(),
				"plus-darker",
				"plus-lighter"
			] }],
			"bg-blend": [{ "bg-blend": ce() }],
			"mask-clip": [{ "mask-clip": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }, "mask-no-clip"],
			"mask-composite": [{ mask: [
				"add",
				"subtract",
				"intersect",
				"exclude"
			] }],
			"mask-image-linear-pos": [{ "mask-linear": [Z] }],
			"mask-image-linear-from-pos": [{ "mask-linear-from": I() }],
			"mask-image-linear-to-pos": [{ "mask-linear-to": I() }],
			"mask-image-linear-from-color": [{ "mask-linear-from": M() }],
			"mask-image-linear-to-color": [{ "mask-linear-to": M() }],
			"mask-image-t-from-pos": [{ "mask-t-from": I() }],
			"mask-image-t-to-pos": [{ "mask-t-to": I() }],
			"mask-image-t-from-color": [{ "mask-t-from": M() }],
			"mask-image-t-to-color": [{ "mask-t-to": M() }],
			"mask-image-r-from-pos": [{ "mask-r-from": I() }],
			"mask-image-r-to-pos": [{ "mask-r-to": I() }],
			"mask-image-r-from-color": [{ "mask-r-from": M() }],
			"mask-image-r-to-color": [{ "mask-r-to": M() }],
			"mask-image-b-from-pos": [{ "mask-b-from": I() }],
			"mask-image-b-to-pos": [{ "mask-b-to": I() }],
			"mask-image-b-from-color": [{ "mask-b-from": M() }],
			"mask-image-b-to-color": [{ "mask-b-to": M() }],
			"mask-image-l-from-pos": [{ "mask-l-from": I() }],
			"mask-image-l-to-pos": [{ "mask-l-to": I() }],
			"mask-image-l-from-color": [{ "mask-l-from": M() }],
			"mask-image-l-to-color": [{ "mask-l-to": M() }],
			"mask-image-x-from-pos": [{ "mask-x-from": I() }],
			"mask-image-x-to-pos": [{ "mask-x-to": I() }],
			"mask-image-x-from-color": [{ "mask-x-from": M() }],
			"mask-image-x-to-color": [{ "mask-x-to": M() }],
			"mask-image-y-from-pos": [{ "mask-y-from": I() }],
			"mask-image-y-to-pos": [{ "mask-y-to": I() }],
			"mask-image-y-from-color": [{ "mask-y-from": M() }],
			"mask-image-y-to-color": [{ "mask-y-to": M() }],
			"mask-image-radial": [{ "mask-radial": [$, Q] }],
			"mask-image-radial-from-pos": [{ "mask-radial-from": I() }],
			"mask-image-radial-to-pos": [{ "mask-radial-to": I() }],
			"mask-image-radial-from-color": [{ "mask-radial-from": M() }],
			"mask-image-radial-to-color": [{ "mask-radial-to": M() }],
			"mask-image-radial-shape": [{ "mask-radial": ["circle", "ellipse"] }],
			"mask-image-radial-size": [{ "mask-radial": [{
				closest: ["side", "corner"],
				farthest: ["side", "corner"]
			}] }],
			"mask-image-radial-pos": [{ "mask-radial-at": b() }],
			"mask-image-conic-pos": [{ "mask-conic": [Z] }],
			"mask-image-conic-from-pos": [{ "mask-conic-from": I() }],
			"mask-image-conic-to-pos": [{ "mask-conic-to": I() }],
			"mask-image-conic-from-color": [{ "mask-conic-from": M() }],
			"mask-image-conic-to-color": [{ "mask-conic-to": M() }],
			"mask-mode": [{ mask: [
				"alpha",
				"luminance",
				"match"
			] }],
			"mask-origin": [{ "mask-origin": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }],
			"mask-position": [{ mask: N() }],
			"mask-repeat": [{ mask: ie() }],
			"mask-size": [{ mask: ae() }],
			"mask-type": [{ "mask-type": ["alpha", "luminance"] }],
			"mask-image": [{ mask: [
				"none",
				$,
				Q
			] }],
			filter: [{ filter: [
				"",
				"none",
				$,
				Q
			] }],
			blur: [{ blur: le() }],
			brightness: [{ brightness: [
				Z,
				$,
				Q
			] }],
			contrast: [{ contrast: [
				Z,
				$,
				Q
			] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				p,
				Fh,
				kh
			] }],
			"drop-shadow-color": [{ "drop-shadow": M() }],
			grayscale: [{ grayscale: [
				"",
				Z,
				$,
				Q
			] }],
			"hue-rotate": [{ "hue-rotate": [
				Z,
				$,
				Q
			] }],
			invert: [{ invert: [
				"",
				Z,
				$,
				Q
			] }],
			saturate: [{ saturate: [
				Z,
				$,
				Q
			] }],
			sepia: [{ sepia: [
				"",
				Z,
				$,
				Q
			] }],
			"backdrop-filter": [{ "backdrop-filter": [
				"",
				"none",
				$,
				Q
			] }],
			"backdrop-blur": [{ "backdrop-blur": le() }],
			"backdrop-brightness": [{ "backdrop-brightness": [
				Z,
				$,
				Q
			] }],
			"backdrop-contrast": [{ "backdrop-contrast": [
				Z,
				$,
				Q
			] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [
				"",
				Z,
				$,
				Q
			] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [
				Z,
				$,
				Q
			] }],
			"backdrop-invert": [{ "backdrop-invert": [
				"",
				Z,
				$,
				Q
			] }],
			"backdrop-opacity": [{ "backdrop-opacity": [
				Z,
				$,
				Q
			] }],
			"backdrop-saturate": [{ "backdrop-saturate": [
				Z,
				$,
				Q
			] }],
			"backdrop-sepia": [{ "backdrop-sepia": [
				"",
				Z,
				$,
				Q
			] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": w() }],
			"border-spacing-x": [{ "border-spacing-x": w() }],
			"border-spacing-y": [{ "border-spacing-y": w() }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"",
				"all",
				"colors",
				"opacity",
				"shadow",
				"transform",
				"none",
				$,
				Q
			] }],
			"transition-behavior": [{ transition: ["normal", "discrete"] }],
			duration: [{ duration: [
				Z,
				"initial",
				$,
				Q
			] }],
			ease: [{ ease: [
				"linear",
				"initial",
				_,
				$,
				Q
			] }],
			delay: [{ delay: [
				Z,
				$,
				Q
			] }],
			animate: [{ animate: [
				"none",
				v,
				$,
				Q
			] }],
			backface: [{ backface: ["hidden", "visible"] }],
			perspective: [{ perspective: [
				h,
				$,
				Q
			] }],
			"perspective-origin": [{ "perspective-origin": x() }],
			rotate: [{ rotate: ue() }],
			"rotate-x": [{ "rotate-x": ue() }],
			"rotate-y": [{ "rotate-y": ue() }],
			"rotate-z": [{ "rotate-z": ue() }],
			scale: [{ scale: de() }],
			"scale-x": [{ "scale-x": de() }],
			"scale-y": [{ "scale-y": de() }],
			"scale-z": [{ "scale-z": de() }],
			"scale-3d": ["scale-3d"],
			skew: [{ skew: fe() }],
			"skew-x": [{ "skew-x": fe() }],
			"skew-y": [{ "skew-y": fe() }],
			transform: [{ transform: [
				$,
				Q,
				"",
				"none",
				"gpu",
				"cpu"
			] }],
			"transform-origin": [{ origin: x() }],
			"transform-style": [{ transform: ["3d", "flat"] }],
			translate: [{ translate: pe() }],
			"translate-x": [{ "translate-x": pe() }],
			"translate-y": [{ "translate-y": pe() }],
			"translate-z": [{ "translate-z": pe() }],
			"translate-none": ["translate-none"],
			zoom: [{ zoom: [
				fh,
				$,
				Q
			] }],
			accent: [{ accent: M() }],
			appearance: [{ appearance: ["none", "auto"] }],
			"caret-color": [{ caret: M() }],
			"color-scheme": [{ scheme: [
				"normal",
				"dark",
				"light",
				"light-dark",
				"only-dark",
				"only-light"
			] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				$,
				Q
			] }],
			"field-sizing": [{ "field-sizing": ["fixed", "content"] }],
			"pointer-events": [{ "pointer-events": ["auto", "none"] }],
			resize: [{ resize: [
				"none",
				"",
				"y",
				"x"
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scrollbar-thumb-color": [{ "scrollbar-thumb": M() }],
			"scrollbar-track-color": [{ "scrollbar-track": M() }],
			"scrollbar-gutter": [{ "scrollbar-gutter": [
				"auto",
				"stable",
				"both"
			] }],
			"scrollbar-w": [{ scrollbar: [
				"auto",
				"thin",
				"none"
			] }],
			"scroll-m": [{ "scroll-m": w() }],
			"scroll-mx": [{ "scroll-mx": w() }],
			"scroll-my": [{ "scroll-my": w() }],
			"scroll-ms": [{ "scroll-ms": w() }],
			"scroll-me": [{ "scroll-me": w() }],
			"scroll-mbs": [{ "scroll-mbs": w() }],
			"scroll-mbe": [{ "scroll-mbe": w() }],
			"scroll-mt": [{ "scroll-mt": w() }],
			"scroll-mr": [{ "scroll-mr": w() }],
			"scroll-mb": [{ "scroll-mb": w() }],
			"scroll-ml": [{ "scroll-ml": w() }],
			"scroll-p": [{ "scroll-p": w() }],
			"scroll-px": [{ "scroll-px": w() }],
			"scroll-py": [{ "scroll-py": w() }],
			"scroll-ps": [{ "scroll-ps": w() }],
			"scroll-pe": [{ "scroll-pe": w() }],
			"scroll-pbs": [{ "scroll-pbs": w() }],
			"scroll-pbe": [{ "scroll-pbe": w() }],
			"scroll-pt": [{ "scroll-pt": w() }],
			"scroll-pr": [{ "scroll-pr": w() }],
			"scroll-pb": [{ "scroll-pb": w() }],
			"scroll-pl": [{ "scroll-pl": w() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				$,
				Q
			] }],
			fill: [{ fill: ["none", ...M()] }],
			"stroke-w": [{ stroke: [
				Z,
				Ah,
				Ch,
				wh
			] }],
			stroke: [{ stroke: ["none", ...M()] }],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			"container-named": ["container-type"],
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"inset-bs",
				"inset-be",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pbs",
				"pbe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mbs",
				"mbe",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-x",
				"border-w-y",
				"border-w-s",
				"border-w-e",
				"border-w-bs",
				"border-w-be",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-x",
				"border-color-y",
				"border-color-s",
				"border-color-e",
				"border-color-bs",
				"border-color-be",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			translate: [
				"translate-x",
				"translate-y",
				"translate-none"
			],
			"translate-none": [
				"translate",
				"translate-x",
				"translate-y",
				"translate-z"
			],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mbs",
				"scroll-mbe",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pbs",
				"scroll-pbe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] },
		postfixLookupClassGroups: ["container-type"],
		orderSensitiveModifiers: [
			"*",
			"**",
			"after",
			"backdrop",
			"before",
			"details-content",
			"file",
			"first-letter",
			"first-line",
			"marker",
			"placeholder",
			"selection"
		]
	};
}, Jh = (e, { extend: t = {}, override: n = {} }) => (Xh(e.theme, n.theme), Xh(e.classGroups, n.classGroups), Xh(e.conflictingClassGroups, n.conflictingClassGroups), Xh(e.conflictingClassGroupModifiers, n.conflictingClassGroupModifiers), Yh(e, "postfixLookupClassGroups", n.postfixLookupClassGroups), Yh(e, "orderSensitiveModifiers", n.orderSensitiveModifiers), Zh(e.theme, t.theme), Zh(e.classGroups, t.classGroups), Zh(e.conflictingClassGroups, t.conflictingClassGroups), Zh(e.conflictingClassGroupModifiers, t.conflictingClassGroupModifiers), Qh(e, t, "postfixLookupClassGroups"), Qh(e, t, "orderSensitiveModifiers"), e), Yh = (e, t, n) => {
	n !== void 0 && (e[t] = n);
}, Xh = (e, t) => {
	if (t) for (let n in t) Yh(e, n, t[n]);
}, Zh = (e, t) => {
	if (t) for (let n in t) Qh(e, t, n);
}, Qh = (e, t, n) => {
	let r = t[n];
	r !== void 0 && (e[n] = e[n] ? e[n].concat(r) : r);
}, $h = (e) => Zm(e ? typeof e == "function" ? () => e(qh()) : () => Jh(qh(), e) : qh), eg = (e) => {
	if (bp(e)) return;
	let t = e, n = { ...t.extend ?? {} };
	for (let e of [
		"theme",
		"classGroups",
		"conflictingClassGroups",
		"conflictingClassGroupModifiers",
		"postfixLookupClassGroups",
		"orderSensitiveModifiers",
		"cacheSize",
		"prefix",
		"separator",
		"experimentalParseClassName"
	]) t[e] !== void 0 && n[e] === void 0 && (n[e] = t[e]);
	let r = {};
	if (Object.keys(n).length > 0 && (r.extend = n), t.override != null && !bp(t.override) && (r.override = t.override), r.extend || r.override) return r;
}, tg = (e) => {
	let t = $h(eg(e));
	return (e) => t.mergeString(e);
}, ng, rg = () => (ng ||= $h(), ng), ig = () => ((!Bp.cachedTwMerge || Bp.didTwMergeConfigChange) && (Bp.didTwMergeConfigChange = !1, Bp.cachedTwMerge = tg(Bp.cachedTwMergeConfig)), Bp.cachedTwMerge), ag = (e) => {
	let t = e?.twMergeConfig;
	t && !bp(t) && (xp(t, Bp.cachedTwMergeConfig) || (Bp.cachedTwMergeConfig = t, Bp.didTwMergeConfigChange = !0));
}, og = (e) => pp(e), sg = (() => {
	let e = /* @__PURE__ */ Error();
	return !("line" in e) && !("lineNumber" in e);
})(), cg = 64, lg = 500, ug = /* @__PURE__ */ new Map(), dg = /* @__PURE__ */ new Map(), fg = 0, pg = () => {
	ug = /* @__PURE__ */ new Map(), dg = /* @__PURE__ */ new Map(), fg = 0;
}, mg = (e) => {
	if (e) return e.indexOf(" ") === -1 ? e : rg().mergeString(e) || void 0;
}, hg = (e, t, n) => {
	let r = ug.get(e);
	r === void 0 && (r = [], ug.set(e, r)), r.length >= cg && r.shift(), r.push({
		rest: t,
		result: n
	}), ++fg > lg && (fg = 0, dg = ug, ug = /* @__PURE__ */ new Map());
}, gg = (e, t, n, r, i) => {
	let a = ug.get(e);
	if (a === void 0 && (a = dg.get(e)), a !== void 0) for (let e = 0; e < a.length; e++) {
		let o = a[e], s = o.rest;
		if (s.length !== n - 1) continue;
		let c = 0, l = !0;
		for (let e = t + 1; e < r; e++) {
			let t = i(e);
			if (t && t !== s[c++]) {
				l = !1;
				break;
			}
		}
		if (l) return o.result;
	}
}, _g = (e) => {
	let t = e.length, n = "", r = -1, i = 0, a = !0;
	for (let o = 0; o < t; o++) {
		let t = e[o];
		if (t) {
			if (typeof t != "string") {
				a = !1;
				break;
			}
			r === -1 && (n = t, r = o), i++;
		}
	}
	if (!a) return mg(og(e));
	if (i === 0) return;
	if (i === 1) return mg(n);
	let o = gg(n, r, i, t, (t) => e[t]);
	if (o !== void 0) return o || void 0;
	let s = n, c = [];
	for (let n = r + 1; n < t; n++) {
		let t = e[n];
		t && (s += " " + t, c.push(t));
	}
	let l = mg(s) ?? "";
	return hg(n, c, l), l || void 0;
}, vg = Bp.reset.bind(Bp);
Bp.reset = () => {
	ng = void 0, pg(), vg();
};
var yg = (e, t) => {
	let n = og(e);
	return !n || !(t?.twMerge ?? !0) ? n || void 0 : n.indexOf(" ") === -1 ? n : (ag(t), (t?.twMergeConfig && !bp(t.twMergeConfig) ? ig() : rg().mergeString)(n) || void 0);
}, bg = (e) => e == null || !(e.twMerge === !1 || e.twMergeConfig && !bp(e.twMergeConfig)), xg = (e, ...t) => yg(t, e), Sg = (...e) => (t) => bg(t) ? sg ? _g(e) : mg(og(e)) : yg(e, t), Cg = hm(xg);
Cg.tv;
var wg = Cg.createTV, Tg = jf.ui?.tv, Eg = /* @__PURE__ */ wg(Tg);
function Dg(e) {
	if (typeof e == "function") return e;
	if (Array.isArray(e)) for (let t = e.length - 1; t >= 0; t--) {
		let n = Dg(e[t]);
		if (n) return n;
	}
}
function Og(e) {
	return Array.isArray(e) ? e.flatMap((e) => Og(e)) : typeof e == "function" ? [] : [e];
}
function kg(e, t, n) {
	return Sg(e(n()), ...Og(t.class), ...Og(t.className))(Tg) ?? "";
}
function Ag(e, t = 0) {
	if (e == null) return !0;
	let n = typeof e;
	if (n === "string" || n === "boolean") return !0;
	if (n === "number") return Number.isFinite(e);
	if (Array.isArray(e)) {
		if (t >= 4) return !1;
		for (let n of e) if (!Ag(n, t + 1)) return !1;
		return !0;
	}
	return !1;
}
function jg(e) {
	let t = Object.getPrototypeOf(e);
	if (t === Object.prototype || t === null) {
		for (let t of Object.keys(e)) if (!Ag(e[t])) return;
		return JSON.stringify(e);
	}
}
function Mg(e) {
	let t = /* @__PURE__ */ new Map();
	return new Proxy(e, { get(e, n) {
		let r = e[n];
		return typeof r == "function" ? (e = {}) => {
			let i = Dg(e.class) ?? Dg(e.className);
			if (!i) {
				let i = jg(e);
				if (i === void 0) return r(e);
				let a = t.get(n);
				a || (a = /* @__PURE__ */ new Map(), t.set(n, a));
				let o = a.get(i);
				return o === void 0 && !a.has(i) && (a.size >= 500 && a.clear(), o = r(e), a.set(i, o)), o;
			}
			return kg(i, e, () => r({
				...e,
				class: void 0,
				className: void 0
			}));
		} : r;
	} });
}
function Ng(e) {
	return Sg(e)(Tg) ?? "";
}
function Pg(e) {
	if (!e || typeof e != "object") return e;
	let t = e.slots, n = t && typeof t == "object" ? Object.entries(t).filter((e) => typeof e[1] == "function") : [], r = typeof e.base == "function" ? e.base : void 0;
	if (!n.length && !r) return e;
	let i = e.extend, a = { ...e }, o, s = !1;
	if (r && (a.base = r(Ng(i?.slots?.base ?? i?.base)), i?.slots?.base && (o ??= { ...i.slots }, o.base = ""), i?.base && (s = !0)), n.length) {
		let e = { ...t };
		for (let [t, r] of n) e[t] = r(Ng(i?.slots?.[t])), i?.slots?.[t] && (o ??= { ...i.slots }, o[t] = "");
		a.slots = e;
	}
	if (o || s) {
		let e = { ...i };
		o && (e.slots = o), s && (e.base = ""), a.extend = e;
	}
	return a;
}
var Fg = ((e) => {
	let t = Eg(Pg(e));
	return new Proxy(t, { apply(e, t, n) {
		let r = Reflect.apply(e, t, n);
		if (r && typeof r == "object") return Mg(r);
		if (typeof r == "string") {
			let r = n[0] ?? {}, i = Dg(r.class) ?? Dg(r.className);
			if (i) return kg(i, r, () => Reflect.apply(e, t, [{
				...r,
				class: void 0,
				className: void 0
			}]));
		}
		return r;
	} });
});
//#endregion
//#region ../../node_modules/reka-ui/dist/shared/createContext.js
function Ig(e, t) {
	let n = typeof e == "string" && !t ? `${e}Context` : t, r = Symbol(n);
	return [(t) => {
		let n = Ir(r, t);
		if (n || n === null) return n;
		throw Error(`Injection \`${r.toString()}\` not found. Component must be used within ${Array.isArray(e) ? `one of the following components: ${e.join(", ")}` : `\`${e}\``}`);
	}, (e) => (Fr(r, e), e)];
}
//#endregion
//#region ../../node_modules/reka-ui/dist/shared/renderSlotFragments.js
function Lg(e) {
	return e ? e.flatMap((e) => e.type === To ? Lg(e.children) : [e]) : [];
}
//#endregion
//#region ../../node_modules/reka-ui/dist/shared/useEmitAsProps.js
function Rg(e) {
	let t = rs(), n = t?.type.emits, r = {};
	return n?.length || console.warn(`No emitted event found. Please check component: ${t?.type.__name}`), n?.forEach((t) => {
		r[A(E(t))] = (...n) => e(t, ...n);
	}), r;
}
//#endregion
//#region ../../node_modules/reka-ui/dist/shared/useFormControl.js
function zg(e) {
	return X(() => !on(e) || !!sf(e)?.closest("form"));
}
//#endregion
//#region ../../node_modules/reka-ui/dist/shared/useForwardExpose.js
function Bg() {
	let e = rs(), t = /* @__PURE__ */ B(), n = X(() => r());
	vi(() => {
		n.value !== r() && an(t);
	});
	function r() {
		return t.value && "$el" in t.value && ["#text", "#comment"].includes(t.value.$el.nodeName) ? t.value.$el.nextElementSibling : sf(t);
	}
	let i = Object.assign({}, e.exposed), a = {};
	for (let t in e.props) Object.defineProperty(a, t, {
		enumerable: !0,
		configurable: !0,
		get: () => e.props[t]
	});
	if (Object.keys(i).length > 0) for (let e in i) Object.defineProperty(a, e, {
		enumerable: !0,
		configurable: !0,
		get: () => i[e]
	});
	Object.defineProperty(a, "$el", {
		enumerable: !0,
		configurable: !0,
		get: () => e.vnode.el
	}), e.exposed = a;
	function o(n) {
		if (t.value = n, n && (Object.defineProperty(a, "$el", {
			enumerable: !0,
			configurable: !0,
			get: () => n instanceof Element ? n : n.$el
		}), !(n instanceof Element) && !Object.hasOwn(n, "$el"))) {
			let t = n.$.exposed, r = Object.assign({}, a);
			for (let e in t) Object.defineProperty(r, e, {
				enumerable: !0,
				configurable: !0,
				get: () => t[e]
			});
			e.exposed = r;
		}
	}
	return {
		forwardRef: o,
		currentRef: t,
		currentElement: n
	};
}
//#endregion
//#region ../../node_modules/reka-ui/dist/shared/useForwardScopeId.js
function Vg() {
	let e = rs()?.vnode?.scopeId;
	return e ? { [e]: "" } : {};
}
//#endregion
//#region ../../node_modules/reka-ui/dist/Primitive/Slot.js
var Hg = /*#__PURE__*/ Qr({
	name: "PrimitiveSlot",
	inheritAttrs: !1,
	setup(e, { attrs: t, slots: n }) {
		return () => {
			if (!n.default) return null;
			let e = Lg(n.default()), r = e.findIndex((e) => e.type !== Do);
			if (r === -1) return e;
			let i = e[r];
			delete i.props?.ref;
			let a = i.props ? Qo(t, i.props) : t, o = Go({
				...i,
				props: {}
			}, a);
			return e.length === 1 ? o : (e[r] = o, e);
		};
	}
}), Ug = [
	"area",
	"img",
	"input"
], Wg = /*#__PURE__*/ Qr({
	name: "Primitive",
	inheritAttrs: !1,
	props: {
		asChild: {
			type: Boolean,
			default: !1
		},
		as: {
			type: [String, Object],
			default: "div"
		}
	},
	setup(e, { attrs: t, slots: n }) {
		let r = e.asChild ? "template" : e.as;
		return typeof r == "string" && Ug.includes(r) ? () => Es(r, t) : r === "template" ? () => Es(Hg, t, { default: n.default }) : () => Es(e.as, t, { default: n.default });
	}
});
//#endregion
//#region ../../node_modules/reka-ui/dist/Primitive/usePrimitiveElement.js
function Gg() {
	let e = /* @__PURE__ */ B();
	return {
		primitiveElement: e,
		currentElement: X(() => ["#text", "#comment"].includes(e.value?.$el.nodeName) ? e.value?.$el.nextElementSibling : sf(e))
	};
}
//#endregion
//#region ../../node_modules/reka-ui/dist/VisuallyHidden/VisuallyHidden.js
var Kg = /* @__PURE__ */ Qr({
	__name: "VisuallyHidden",
	props: {
		feature: {
			type: String,
			required: !1,
			default: "focusable"
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "span"
		}
	},
	setup(e) {
		return (e, t) => (G(), K(V(Wg), {
			as: e.as,
			"as-child": e.asChild,
			"aria-hidden": e.feature === "focusable" || e.feature === "fully-hidden" ? "true" : void 0,
			"data-hidden": e.feature === "fully-hidden" ? "" : void 0,
			tabindex: e.feature === "fully-hidden" ? "-1" : void 0,
			style: {
				position: "absolute",
				border: 0,
				width: "1px",
				height: "1px",
				padding: 0,
				margin: "-1px",
				overflow: "hidden",
				clip: "rect(0, 0, 0, 0)",
				clipPath: "inset(50%)",
				whiteSpace: "nowrap",
				wordWrap: "normal",
				top: "-1px",
				left: "-1px"
			}
		}, {
			default: U(() => [W(e.$slots, "default")]),
			_: 3
		}, 8, [
			"as",
			"as-child",
			"aria-hidden",
			"data-hidden",
			"tabindex"
		]));
	}
}), qg = /* @__PURE__ */ Qr({
	inheritAttrs: !1,
	__name: "VisuallyHiddenInputBubble",
	props: {
		name: {
			type: String,
			required: !0
		},
		value: {
			type: null,
			required: !0
		},
		checked: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		required: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		feature: {
			type: String,
			required: !1,
			default: "fully-hidden"
		}
	},
	setup(e) {
		let t = e, { primitiveElement: n, currentElement: r } = Gg();
		return Hr(X(() => t.checked ?? t.value), (e, t) => {
			if (!r.value) return;
			let n = r.value, i = window.HTMLInputElement.prototype, a = Object.getOwnPropertyDescriptor(i, "value").set;
			if (a && e !== t) {
				let t = new Event("input", { bubbles: !0 }), r = new Event("change", { bubbles: !0 });
				a.call(n, e), n.dispatchEvent(t), n.dispatchEvent(r);
			}
		}), (e, r) => (G(), K(Kg, Qo({
			ref_key: "primitiveElement",
			ref: n
		}, {
			...t,
			...e.$attrs
		}, { as: "input" }), null, 16));
	}
}), Jg = /* @__PURE__ */ Qr({
	inheritAttrs: !1,
	__name: "VisuallyHiddenInput",
	props: {
		name: {
			type: String,
			required: !0
		},
		value: {
			type: null,
			required: !0
		},
		checked: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		required: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		feature: {
			type: String,
			required: !1,
			default: "fully-hidden"
		}
	},
	setup(e) {
		let t = e, n = X(() => typeof t.value == "object" && Array.isArray(t.value) && t.value.length === 0 && t.required), r = X(() => typeof t.value == "string" || typeof t.value == "number" || typeof t.value == "boolean" || t.value === null || t.value === void 0 ? [{
			name: t.name,
			value: t.value
		}] : typeof t.value == "object" && Array.isArray(t.value) ? t.value.flatMap((e, n) => typeof e == "object" ? Object.entries(e).map(([e, r]) => ({
			name: `${t.name}[${n}][${e}]`,
			value: r
		})) : {
			name: `${t.name}[${n}]`,
			value: e
		}) : t.value !== null && typeof t.value == "object" && !Array.isArray(t.value) ? Object.entries(t.value).map(([e, n]) => ({
			name: `${t.name}[${e}]`,
			value: n
		})) : []);
		return (e, i) => (G(), Fo(To, null, [J(" We render single input if it's required "), n.value ? (G(), K(qg, Qo({ key: e.name }, {
			...t,
			...e.$attrs
		}, {
			name: e.name,
			value: e.value
		}), null, 16, ["name", "value"])) : (G(!0), Fo(To, { key: 1 }, Ai(r.value, (n) => (G(), K(qg, Qo({ key: n.name }, { ref_for: !0 }, {
			...t,
			...e.$attrs
		}, {
			name: n.name,
			value: n.value
		}), null, 16, ["name", "value"]))), 128))], 2112));
	}
}), Yg = /* @__PURE__ */ Qr({
	__name: "Label",
	props: {
		for: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "label"
		}
	},
	setup(e) {
		let t = e;
		return Bg(), (e, n) => (G(), K(V(Wg), Qo(t, { onMousedown: n[0] ||= (e) => {
			!e.defaultPrevented && e.detail > 1 && e.preventDefault();
		} }), {
			default: U(() => [W(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), [Xg, Zg] = /*#__PURE__*/ Ig("SwitchRoot"), Qg = /* @__PURE__ */ Qr({
	inheritAttrs: !1,
	__name: "SwitchRoot",
	props: {
		defaultValue: {
			type: null,
			required: !1
		},
		modelValue: {
			type: null,
			required: !1,
			default: void 0
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		id: {
			type: String,
			required: !1
		},
		value: {
			type: String,
			required: !1,
			default: "on"
		},
		trueValue: {
			type: null,
			required: !1,
			default: () => !0
		},
		falseValue: {
			type: null,
			required: !1,
			default: () => !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = t, { disabled: i } = /* @__PURE__ */ dn(n), a = Af(n, "modelValue", r, {
			defaultValue: n.defaultValue ?? n.falseValue,
			passive: n.modelValue === void 0
		}), o = X(() => a.value === n.trueValue);
		function s() {
			i.value || (a.value = o.value ? n.falseValue : n.trueValue);
		}
		let { forwardRef: c, currentElement: l } = Bg(), u = zg(l), d = Vg(), f = X(() => n.id && l.value ? document.querySelector(`[for="${n.id}"]`)?.innerText : void 0);
		return Zg({
			checked: o,
			toggleCheck: s,
			disabled: i
		}), (e, t) => (G(), Fo(To, null, [q(V(Wg), Qo({
			id: e.id,
			ref: V(c),
			role: "switch",
			type: e.as === "button" ? "button" : void 0,
			value: e.value,
			"aria-label": e.$attrs["aria-label"] || f.value,
			"aria-checked": o.value,
			"aria-required": e.required,
			"data-state": o.value ? "checked" : "unchecked",
			"data-disabled": V(i) ? "" : void 0,
			"as-child": e.asChild,
			as: e.as,
			disabled: V(i)
		}, {
			...V(d),
			...e.$attrs
		}, {
			onClick: s,
			onKeydown: xc(yc(s, ["prevent"]), ["enter"])
		}), {
			default: U(() => [W(e.$slots, "default", {
				modelValue: V(a),
				checked: o.value
			})]),
			_: 3
		}, 16, [
			"id",
			"type",
			"value",
			"aria-label",
			"aria-checked",
			"aria-required",
			"data-state",
			"data-disabled",
			"as-child",
			"as",
			"disabled",
			"onKeydown"
		]), V(u) && e.name ? (G(), K(V(Jg), Qo({
			key: 0,
			type: "checkbox",
			name: e.name,
			disabled: V(i),
			required: e.required,
			value: e.value,
			checked: o.value
		}, V(d)), null, 16, [
			"name",
			"disabled",
			"required",
			"value",
			"checked"
		])) : J("v-if", !0)], 64));
	}
}), $g = /* @__PURE__ */ Qr({
	__name: "SwitchThumb",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "span"
		}
	},
	setup(e) {
		let t = Xg();
		return Bg(), (e, n) => (G(), K(V(Wg), {
			"data-state": V(t).checked.value ? "checked" : "unchecked",
			"data-disabled": V(t).disabled.value ? "" : void 0,
			"as-child": e.asChild,
			as: e.as
		}, {
			default: U(() => [W(e.$slots, "default")]),
			_: 3
		}, 8, [
			"data-state",
			"data-disabled",
			"as-child",
			"as"
		]));
	}
}), [e_, t_] = Ig("UTheme", "RootContext"), n_ = { defaults: X(() => ({})) };
function r_(e = n_) {
	return e_(e);
}
function i_(e) {
	return e.replace(/-(\w)/g, (e, t) => t.toUpperCase());
}
function a_(e) {
	return e.replace(/[A-Z]/g, (e) => `-${e.toLowerCase()}`);
}
function o_(e, t) {
	return !e || !e.props ? !1 : e.props[i_(t)] !== void 0 || e.props[a_(t)] !== void 0;
}
function s_(e, t) {
	let n = rs(), { defaults: r } = r_(), i = Nf();
	return new Proxy(t, {
		get(t, a, o) {
			if (a === "__v_isReactive") return !0;
			if (a === "__v_raw") return t;
			let s = Reflect.get(t, a, o);
			if (typeof a != "string") return s;
			let c = e.includes(".") ? Uf(r.value, e) : r.value[e];
			if (a === "ui") {
				let e = c?.ui;
				return !s && !e ? s : Lf(s ?? {}, e ?? {});
			}
			if (a === "class") {
				let e = c?.class;
				return e === void 0 ? s : s === void 0 ? e : [e, s];
			}
			if (n && o_(n.vnode, a)) return s;
			let l = c?.[a];
			if (l !== void 0) return l;
			let u = (e.includes(".") ? Uf(i.ui ?? {}, e) : i.ui?.[e])?.defaultVariants?.[a];
			if (u !== void 0) return u;
			let d = n?.type?.props?.[a];
			if (d && Object.prototype.hasOwnProperty.call(d, "default")) return s;
		},
		has: (e, t) => Reflect.has(e, t),
		ownKeys: (e) => Reflect.ownKeys(e),
		getOwnPropertyDescriptor: (e, t) => Reflect.getOwnPropertyDescriptor(e, t)
	});
}
//#endregion
//#region ../../node_modules/@nuxt/ui/dist/runtime/utils/form.js
function c_(e) {
	return "schema" in e && typeof e.coercer == "function" && typeof e.validator == "function" && typeof e.refiner == "function";
}
function l_(e) {
	return "~standard" in e;
}
async function u_(e, t) {
	let n = await t["~standard"].validate(e);
	return n.issues ? {
		errors: n.issues?.map((e) => ({
			name: e.path?.map((e) => typeof e == "object" ? e.key : e).join(".") || "",
			message: e.message
		})) || [],
		result: null
	} : {
		errors: null,
		result: n.value
	};
}
async function d_(e, t) {
	let [n, r] = t.validate(e);
	return n ? {
		errors: n.failures().map((e) => ({
			message: e.message,
			name: e.path.join(".")
		})),
		result: null
	} : {
		errors: null,
		result: r
	};
}
function f_(e, t) {
	let n = /* @__PURE__ */ R(t);
	if (l_(n)) return u_(e, n);
	if (c_(n)) return d_(e, n);
	throw Error("Form validation failed: Unsupported form schema");
}
function p_(e, t) {
	return t ? t.split(".").reduce((e, t) => e?.[t], e) : e;
}
function m_(e, t, n) {
	if (!t) return Object.assign(e, n);
	if (!e) return e;
	let r = t.split("."), i = e;
	for (let e = 0; e < r.length - 1; e++) {
		let t = r[e];
		(i[t] === void 0 || i[t] === null) && (e + 1 < r.length && !Number.isNaN(Number(r[e + 1])) ? i[t] = [] : i[t] = {}), i = i[t];
	}
	let a = r[r.length - 1];
	return i[a] = n, e;
}
//#endregion
//#region ../../node_modules/@nuxt/ui/dist/runtime/types/form.js
var h_ = class e extends Error {
	formId;
	errors;
	constructor(t, n) {
		super("Form validation exception"), this.formId = t, this.errors = n, Object.setPrototypeOf(this, e.prototype);
	}
}, g_ = { base: "" }, __ = {
	__name: "Form",
	props: {
		id: {
			type: [String, Number],
			required: !1
		},
		schema: {
			type: null,
			required: !1
		},
		state: {
			type: null,
			required: !1
		},
		validate: {
			type: Function,
			required: !1
		},
		validateOn: {
			type: Array,
			required: !1,
			default() {
				return [
					"input",
					"blur",
					"change"
				];
			}
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		validateOnInputDelay: {
			type: Number,
			required: !1,
			default: 300
		},
		transform: {
			type: null,
			required: !1,
			default: () => !0
		},
		nested: {
			type: Boolean,
			required: !1
		},
		loadingAuto: {
			type: Boolean,
			required: !1,
			default: !0
		},
		class: {
			type: null,
			required: !1
		},
		ui: {
			type: Object,
			required: !1
		},
		onSubmit: {
			type: Function,
			required: !1
		}
	},
	emits: ["submit", "error"],
	setup(e, { expose: t, emit: n }) {
		let r = e, i = n, a = s_("form", r), o = Nf(), s = X(() => Fg({
			extend: g_,
			...o.ui?.form || {}
		})), c = a.id ?? $r(), l = ni("formRef"), u = /* @__PURE__ */ kf(`form-${c}`), d = a.nested === !0 && Ir(ip, void 0), f = a.nested === !0 ? Ir(ap, void 0) : void 0, p = X(() => f?.value ? a.name ? p_(f.value, a.name) : f.value : a.state);
		Fr(ip, u), Fr(ap, p);
		let m = /* @__PURE__ */ B(/* @__PURE__ */ new Map());
		gi(async () => {
			d && (await Kn(), d.emit({
				type: "attach",
				validate: C,
				formId: c,
				name: a.name,
				api: N
			}));
		}), bi(() => {
			u.reset(), d && d.emit({
				type: "detach",
				formId: c
			});
		}), gi(async () => {
			u.on(async (e) => {
				e.type === "attach" ? m.value.set(e.formId, {
					validate: e.validate,
					name: e.name,
					api: e.api
				}) : e.type === "detach" ? m.value.delete(e.formId) : a.validateOn?.includes(e.type) && !w.value && (e.type === "input" ? (e.eager || y.has(e.name)) && await C({
					name: e.name,
					silent: !0,
					nested: !1
				}) : await C({
					name: e.name,
					silent: !0,
					nested: !1
				})), e.type === "blur" && y.add(e.name), (e.type === "change" || e.type === "input" || e.type === "blur" || e.type === "focus") && v.add(e.name), (e.type === "change" || e.type === "input") && _.add(e.name);
			});
		});
		let h = /* @__PURE__ */ B([]);
		Fr(up, h);
		let g = /* @__PURE__ */ B({});
		Fr(cp, g);
		let _ = /* @__PURE__ */ Ut(/* @__PURE__ */ new Set()), v = /* @__PURE__ */ Ut(/* @__PURE__ */ new Set()), y = /* @__PURE__ */ Ut(/* @__PURE__ */ new Set());
		function b(e) {
			return e.map((e) => ({
				...e,
				id: e?.name ? g.value[e.name]?.id : void 0
			}));
		}
		let x = /* @__PURE__ */ B(null);
		async function S() {
			let e = a.validate ? await a.validate(p.value) ?? [] : [];
			if (a.schema) {
				let { errors: t, result: n } = await f_(p.value, a.schema);
				t ? e = e.concat(t) : x.value = n;
			}
			return b(e);
		}
		async function C(e = {
			silent: !1,
			nested: !1,
			transform: !1
		}) {
			let t = e.name && !Array.isArray(e.name) ? [e.name] : e.name, n = [], r = [];
			if (!t && e.nested) {
				let t = Array.from(m.value.values()).map((t) => te(t, e)), i = await Promise.all(t);
				r = i.filter((e) => e.error).flatMap((e) => e.error.errors.map((t) => ne(t, e.name))), n = i.filter((e) => e.output !== void 0);
			}
			let i = [...await S(), ...r];
			if (t ? h.value = j(i, t) : h.value = i, h.value?.length) {
				if (e.silent) return !1;
				throw new h_(c, h.value);
			}
			return e.transform ? (n.forEach((e) => {
				e.name ? m_(x.value, e.name, e.output) : Object.assign(x.value, e.output);
			}), x.value ?? p.value) : p.value;
		}
		let w = /* @__PURE__ */ B(!1);
		Fr(lp, /* @__PURE__ */ Gt(w));
		async function T(e) {
			w.value = !!a.loadingAuto;
			let t = e;
			try {
				t.data = await C({
					nested: !0,
					transform: a.transform
				}), await a.onSubmit?.(t), _.clear();
			} catch (e) {
				if (!(e instanceof h_)) throw e;
				let n = {
					...t,
					errors: e.errors
				};
				i("error", n);
			} finally {
				w.value = !1;
			}
		}
		let ee = X(() => a.disabled || w.value);
		Fr(rp, X(() => ({
			disabled: ee.value,
			validateOnInputDelay: a.validateOnInputDelay
		})));
		async function te(e, t) {
			try {
				let n = await e.validate({
					...t,
					silent: !1
				});
				return {
					name: e.name,
					output: n
				};
			} catch (t) {
				if (!(t instanceof h_)) throw t;
				return {
					name: e.name,
					error: t
				};
			}
		}
		function ne(e, t) {
			return !t || !e.name ? e : {
				...e,
				name: t + "." + e.name
			};
		}
		function E(e, t) {
			let n = t + ".", r = e?.name?.startsWith(n) ? e.name.substring(n.length) : e.name;
			return {
				...e,
				name: r
			};
		}
		function D(e, t) {
			return t ? e.filter((e) => e?.name?.startsWith(t + ".")).map((e) => E(e, t)) : e;
		}
		function O(e) {
			return e.api.getErrors().map((t) => e.name ? {
				...t,
				name: e.name + "." + t.name
			} : t);
		}
		function k(e, t) {
			return !e || !t ? !0 : e instanceof RegExp ? e.test(t) : t === e || typeof e == "string" && e.startsWith(t + ".");
		}
		function A(e, t) {
			if (!e || e instanceof RegExp) return e;
			if (t !== e) return typeof e == "string" && e.startsWith(t + ".") ? e.substring(t.length + 1) : e;
		}
		function j(e, t) {
			let n = new Set(t), r = t.map((e) => g.value?.[e]?.pattern).filter(Boolean), i = (e) => e.name ? n.has(e.name) ? !0 : r.some((t) => t.test(e.name)) : !1, a = h.value.filter((e) => !i(e)), o = e.filter(i);
			return [...a, ...o];
		}
		function re(e, t) {
			return e.filter((e) => t instanceof RegExp ? !(e.name && t.test(e.name)) : !e.name || e.name !== t);
		}
		function M(e) {
			return !e.name || !!g.value[e.name];
		}
		let N = {
			validate: C,
			errors: h,
			setErrors(e, t) {
				let n = b(e.filter(M)), r = [];
				for (let n of m.value.values()) if (k(t, n.name)) {
					let i = D(e, n.name);
					n.api.setErrors(i, A(t, n.name || "")), r.push(...O(n));
				}
				if (t) {
					let e = re(h.value, t);
					h.value = [
						...e,
						...n,
						...r
					];
				} else h.value = [...n, ...r];
			},
			async submit() {
				l.value instanceof HTMLFormElement && l.value.reportValidity() === !1 || await T(new Event("submit"));
			},
			getErrors(e) {
				return e ? h.value.filter((t) => e instanceof RegExp ? t.name && e.test(t.name) : t.name === e) : h.value;
			},
			clear(e) {
				let t = e ? h.value.filter((t) => M(t) && (e instanceof RegExp ? !(t.name && e.test(t.name)) : t.name !== e)) : [], n = [];
				for (let t of m.value.values()) k(e, t.name) && t.api.clear(), n.push(...O(t));
				h.value = [...t, ...n];
			},
			disabled: ee,
			loading: w,
			dirty: X(() => !!_.size),
			dirtyFields: /* @__PURE__ */ Gt(_),
			blurredFields: /* @__PURE__ */ Gt(y),
			touchedFields: /* @__PURE__ */ Gt(v)
		};
		return t(N), (e, t) => (G(), K(Di(V(d) ? "div" : "form"), {
			id: V(c),
			ref_key: "formRef",
			ref: l,
			name: V(d) ? void 0 : V(a).name,
			method: V(d) ? void 0 : "post",
			class: I(s.value({ class: [V(a).ui?.base, V(a).class] })),
			onSubmit: yc(T, ["prevent"])
		}, {
			default: U(() => [W(e.$slots, "default", {
				errors: h.value,
				loading: w.value
			})]),
			_: 3
		}, 40, [
			"id",
			"name",
			"method",
			"class"
		]));
	}
};
//#endregion
//#region ../../node_modules/@nuxt/ui/dist/runtime/composables/useForwardProps.js
function v_(e, t) {
	let n = t ? Rg(t) : {};
	return X(() => {
		let t = /* @__PURE__ */ z(e) ? e.value : e, r = { ...n };
		for (let e in t) {
			let n = t[e];
			n !== void 0 && (r[e] = n);
		}
		return r;
	});
}
//#endregion
//#region ../../node_modules/@nuxt/ui/dist/runtime/vue/components/Icon.vue
var y_ = {
	__name: "Icon",
	props: {
		name: {
			type: null,
			required: !0
		},
		mode: {
			type: String,
			required: !1
		},
		size: {
			type: [String, Number],
			required: !1
		},
		customize: {
			type: [
				Function,
				Boolean,
				null
			],
			required: !1
		}
	},
	setup(e) {
		let t = e, n = Nf();
		function r(e, t) {
			if (e !== !1) return e === !0 || e === null ? t : e;
		}
		let i = X(() => {
			let e = t.mode || n.icon?.mode;
			return e === "css" ? "style" : e;
		}), a = X(() => t.size || n.icon?.size), o = X(() => r(t.customize, n.icon?.customize)), s = X(() => typeof t.name == "string" ? t.name.replace(/^i-/, "") : ""), c = X(() => nl(s.value));
		return (t, n) => typeof e.name == "string" ? (G(), K(V(_u), {
			key: 0,
			icon: s.value,
			mode: i.value,
			width: a.value,
			height: a.value,
			customise: o.value,
			ssr: c.value
		}, null, 8, [
			"icon",
			"mode",
			"width",
			"height",
			"customise",
			"ssr"
		])) : (G(), K(Di(e.name), { key: 1 }));
	}
}, b_ = {
	slots: {
		root: "relative flex items-start",
		base: ["inline-flex items-center shrink-0 rounded-full border-2 border-transparent focus-visible:outline-3 data-[state=unchecked]:bg-accented", "transition-[background] duration-200 ease-out"],
		container: "flex items-center",
		thumb: "group pointer-events-none rounded-full bg-default shadow-lg ring-0 transition-transform duration-200 ease-out motion-reduce:transition-none data-[state=unchecked]:translate-x-0 data-[state=unchecked]:rtl:-translate-x-0 flex items-center justify-center",
		icon: ["absolute shrink-0 group-data-[state=unchecked]:text-dimmed opacity-0 size-10/12", "transition-[color,opacity] duration-200 ease-out"],
		wrapper: "ms-2",
		label: "block font-medium text-default",
		description: "text-muted"
	},
	variants: {
		color: {
			primary: {
				base: "data-[state=checked]:bg-primary outline-primary/25",
				icon: "group-data-[state=checked]:text-primary"
			},
			secondary: {
				base: "data-[state=checked]:bg-secondary outline-secondary/25",
				icon: "group-data-[state=checked]:text-secondary"
			},
			success: {
				base: "data-[state=checked]:bg-success outline-success/25",
				icon: "group-data-[state=checked]:text-success"
			},
			info: {
				base: "data-[state=checked]:bg-info outline-info/25",
				icon: "group-data-[state=checked]:text-info"
			},
			warning: {
				base: "data-[state=checked]:bg-warning outline-warning/25",
				icon: "group-data-[state=checked]:text-warning"
			},
			error: {
				base: "data-[state=checked]:bg-error outline-error/25",
				icon: "group-data-[state=checked]:text-error"
			},
			neutral: {
				base: "data-[state=checked]:bg-inverted outline-inverted/25",
				icon: "group-data-[state=checked]:text-highlighted"
			}
		},
		size: {
			xs: {
				base: "w-7",
				container: "h-4",
				thumb: "size-3 data-[state=checked]:translate-x-3 data-[state=checked]:rtl:-translate-x-3",
				wrapper: "text-xs"
			},
			sm: {
				base: "w-8",
				container: "h-4",
				thumb: "size-3.5 data-[state=checked]:translate-x-3.5 data-[state=checked]:rtl:-translate-x-3.5",
				wrapper: "text-xs"
			},
			md: {
				base: "w-9",
				container: "h-5",
				thumb: "size-4 data-[state=checked]:translate-x-4 data-[state=checked]:rtl:-translate-x-4",
				wrapper: "text-sm"
			},
			lg: {
				base: "w-10",
				container: "h-5",
				thumb: "size-4.5 data-[state=checked]:translate-x-4.5 data-[state=checked]:rtl:-translate-x-4.5",
				wrapper: "text-sm"
			},
			xl: {
				base: "w-11",
				container: "h-6",
				thumb: "size-5 data-[state=checked]:translate-x-5 data-[state=checked]:rtl:-translate-x-5",
				wrapper: "text-base"
			}
		},
		checked: { true: { icon: "group-data-[state=checked]:opacity-100" } },
		unchecked: { true: { icon: "group-data-[state=unchecked]:opacity-100" } },
		loading: { true: { icon: "animate-spin" } },
		highlight: { true: "" },
		required: { true: { label: "after:content-['*'] after:ms-0.5 after:text-error" } },
		disabled: { true: {
			root: "opacity-75",
			base: "cursor-not-allowed",
			label: "cursor-not-allowed",
			description: "cursor-not-allowed"
		} }
	},
	compoundVariants: [
		{
			color: "primary",
			highlight: !0,
			class: { base: "ring ring-primary" }
		},
		{
			color: "secondary",
			highlight: !0,
			class: { base: "ring ring-secondary" }
		},
		{
			color: "success",
			highlight: !0,
			class: { base: "ring ring-success" }
		},
		{
			color: "info",
			highlight: !0,
			class: { base: "ring ring-info" }
		},
		{
			color: "warning",
			highlight: !0,
			class: { base: "ring ring-warning" }
		},
		{
			color: "error",
			highlight: !0,
			class: { base: "ring ring-error" }
		},
		{
			color: "neutral",
			highlight: !0,
			class: { base: "ring ring-inverted" }
		}
	],
	defaultVariants: {
		color: "primary",
		size: "md"
	}
}, x_ = /*@__PURE__*/ Object.assign({ inheritAttrs: !1 }, {
	__name: "Switch",
	props: {
		as: {
			type: null,
			required: !1
		},
		color: {
			type: null,
			required: !1
		},
		size: {
			type: null,
			required: !1
		},
		highlight: {
			type: Boolean,
			required: !1
		},
		loading: {
			type: Boolean,
			required: !1
		},
		loadingIcon: {
			type: null,
			required: !1
		},
		checkedIcon: {
			type: null,
			required: !1
		},
		uncheckedIcon: {
			type: null,
			required: !1
		},
		label: {
			type: String,
			required: !1
		},
		description: {
			type: String,
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		ui: {
			type: Object,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		id: {
			type: String,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		value: {
			type: String,
			required: !1
		},
		defaultValue: {
			type: null,
			required: !1
		},
		modelValue: {
			type: null,
			required: !1
		},
		trueValue: {
			type: null,
			required: !1
		},
		falseValue: {
			type: null,
			required: !1
		}
	},
	emits: ["change", "update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = Hi(), i = t, a = s_("switch", n), o = Nf(), s = v_($d(a, "required", "value", "defaultValue", "modelValue", "trueValue", "falseValue"), i), { id: c, emitFormChange: l, emitFormInput: u, size: d, color: f, highlight: p, name: m, disabled: h, ariaAttrs: g } = dp(n), _ = c.value ?? $r(), v = X(() => f.value ?? a.color), y = X(() => p.value ?? a.highlight), b = X(() => d.value ?? a.size), x = X(() => h.value ?? a.disabled), S = Ui(), C = X(() => {
			let { "data-state": e, ...t } = S;
			return t;
		}), w = X(() => Fg({
			extend: b_,
			...o.ui?.switch || {}
		})({
			size: b.value,
			color: v.value,
			highlight: y.value,
			required: a.required,
			loading: a.loading,
			disabled: x.value || a.loading
		}));
		function T(e) {
			let t = new Event("change", { target: { value: e } });
			i("change", t), l(), u();
		}
		return (e, t) => (G(), K(V(Wg), {
			as: V(a).as,
			"data-slot": e.$attrs["data-slot"] ?? "root",
			class: I(w.value.root({ class: [V(a).ui?.root, V(a).class] }))
		}, {
			default: U(() => [Vo("div", {
				"data-slot": "container",
				class: I(w.value.container({ class: V(a).ui?.container }))
			}, [q(V(Qg), Qo({ id: V(_) }, {
				...V(s),
				...C.value,
				...V(g)
			}, {
				name: V(m),
				disabled: x.value || V(a).loading,
				"data-slot": "base",
				class: w.value.base({ class: V(a).ui?.base }),
				"onUpdate:modelValue": T
			}), {
				default: U(() => [q(V($g), {
					"data-slot": "thumb",
					class: I(w.value.thumb({ class: V(a).ui?.thumb }))
				}, {
					default: U(() => [V(a).loading ? (G(), K(y_, {
						key: 0,
						name: V(a).loadingIcon || V(o).ui.icons.loading,
						"data-slot": "icon",
						class: I(w.value.icon({
							class: V(a).ui?.icon,
							checked: !0,
							unchecked: !0
						}))
					}, null, 8, ["name", "class"])) : (G(), Fo(To, { key: 1 }, [V(a).checkedIcon ? (G(), K(y_, {
						key: 0,
						name: V(a).checkedIcon,
						"data-slot": "icon",
						class: I(w.value.icon({
							class: V(a).ui?.icon,
							checked: !0
						}))
					}, null, 8, ["name", "class"])) : J("", !0), V(a).uncheckedIcon ? (G(), K(y_, {
						key: 1,
						name: V(a).uncheckedIcon,
						"data-slot": "icon",
						class: I(w.value.icon({
							class: V(a).ui?.icon,
							unchecked: !0
						}))
					}, null, 8, ["name", "class"])) : J("", !0)], 64))]),
					_: 1
				}, 8, ["class"])]),
				_: 1
			}, 16, [
				"id",
				"name",
				"disabled",
				"class"
			])], 2), V(a).label || r.label || V(a).description || r.description ? (G(), Fo("div", {
				key: 0,
				"data-slot": "wrapper",
				class: I(w.value.wrapper({ class: V(a).ui?.wrapper }))
			}, [V(a).label || r.label ? (G(), K(V(Yg), {
				key: 0,
				for: V(_),
				"data-slot": "label",
				class: I(w.value.label({ class: V(a).ui?.label }))
			}, {
				default: U(() => [W(e.$slots, "label", { label: V(a).label }, () => [qo(Ce(V(a).label), 1)])]),
				_: 3
			}, 8, ["for", "class"])) : J("", !0), V(a).description || r.description ? (G(), Fo("p", {
				key: 1,
				"data-slot": "description",
				class: I(w.value.description({ class: V(a).ui?.description }))
			}, [W(e.$slots, "description", { description: V(a).description }, () => [qo(Ce(V(a).description), 1)])], 2)) : J("", !0)], 2)) : J("", !0)]),
			_: 3
		}, 8, [
			"as",
			"data-slot",
			"class"
		]));
	}
});
//#endregion
//#region ../../node_modules/@nuxt/ui/dist/runtime/composables/useComponentIcons.js
function S_(e) {
	let t = Nf(), n = X(() => on(e)), r = X(() => n.value.icon && n.value.leading || n.value.icon && !n.value.trailing || n.value.loading && !n.value.trailing || !!n.value.leadingIcon);
	return {
		isLeading: r,
		isTrailing: X(() => n.value.icon && n.value.trailing || n.value.loading && n.value.trailing || !!n.value.trailingIcon && n.value.trailing !== !1),
		leadingIconName: X(() => n.value.loading ? n.value.loadingIcon || t.ui.icons.loading : n.value.leadingIcon || n.value.icon),
		trailingIconName: X(() => n.value.loading && !r.value ? n.value.loadingIcon || t.ui.icons.loading : n.value.trailingIcon || n.value.icon)
	};
}
//#endregion
//#region ../../node_modules/@nuxt/ui/dist/runtime/composables/useFieldGroup.js
var C_ = Symbol("nuxt-ui.field-group");
function w_(e) {
	let t = Ir(C_, void 0);
	return {
		orientation: X(() => t?.value.orientation),
		size: X(() => e?.size ?? t?.value.size)
	};
}
//#endregion
//#region ../../node_modules/@nuxt/ui/dist/runtime/utils/link-keys.js
var T_ = /* @__PURE__ */ "active.activeClass.ariaCurrentValue.as.disabled.download.exact.exactActiveClass.exactHash.exactQuery.external.form.formaction.formenctype.formmethod.formnovalidate.formtarget.href.hreflang.inactiveClass.locale.media.noPrefetch.noRel.onClick.ping.prefetch.prefetchOn.prefetchedClass.referrerpolicy.rel.replace.target.title.to.trailingSlash.type.viewTransition".split(".");
//#endregion
//#region ../../node_modules/@nuxt/ui/dist/runtime/utils/link.js
function E_(e) {
	let t = Object.keys(e), n = t.filter((e) => e.startsWith("aria-")), r = t.filter((e) => e.startsWith("data-"));
	return $d(e, ...T_, ...n, ...r);
}
//#endregion
//#region ../../node_modules/@nuxt/ui/dist/runtime/composables/useAvatarGroup.js
var D_ = Symbol("nuxt-ui.avatar-group");
function O_(e) {
	let t = Ir(D_, void 0), n = X(() => e.size ?? t?.value.size), r = X(() => e.color ?? t?.value.color);
	return Fr(D_, X(() => ({
		size: n.value,
		color: r.value
	}))), {
		size: n,
		color: r
	};
}
//#endregion
//#region virtual:nuxt-ui-templates/ui/chip.ts
var k_ = {
	slots: {
		root: "relative inline-flex items-center justify-center shrink-0",
		base: "rounded-full ring ring-bg flex items-center justify-center text-inverted font-medium whitespace-nowrap"
	},
	variants: {
		color: {
			primary: "bg-primary",
			secondary: "bg-secondary",
			success: "bg-success",
			info: "bg-info",
			warning: "bg-warning",
			error: "bg-error",
			neutral: "bg-inverted"
		},
		size: {
			"3xs": "h-[4px] min-w-[4px] text-[4px]",
			"2xs": "h-[5px] min-w-[5px] text-[5px]",
			xs: "h-[6px] min-w-[6px] text-[6px]",
			sm: "h-[7px] min-w-[7px] text-[7px]",
			md: "h-[8px] min-w-[8px] text-[8px]",
			lg: "h-[9px] min-w-[9px] text-[9px]",
			xl: "h-[10px] min-w-[10px] text-[10px]",
			"2xl": "h-[11px] min-w-[11px] text-[11px]",
			"3xl": "h-[12px] min-w-[12px] text-[12px]"
		},
		position: {
			"top-right": "top-0 right-0",
			"bottom-right": "bottom-0 right-0",
			"top-left": "top-0 left-0",
			"bottom-left": "bottom-0 left-0"
		},
		inset: { false: "" },
		standalone: { false: "absolute" }
	},
	compoundVariants: [
		{
			position: "top-right",
			inset: !1,
			class: "-translate-y-1/2 translate-x-1/2 transform"
		},
		{
			position: "bottom-right",
			inset: !1,
			class: "translate-y-1/2 translate-x-1/2 transform"
		},
		{
			position: "top-left",
			inset: !1,
			class: "-translate-y-1/2 -translate-x-1/2 transform"
		},
		{
			position: "bottom-left",
			inset: !1,
			class: "translate-y-1/2 -translate-x-1/2 transform"
		}
	],
	defaultVariants: {
		size: "md",
		color: "primary",
		position: "top-right"
	}
}, A_ = /*@__PURE__*/ Object.assign({ inheritAttrs: !1 }, {
	__name: "Chip",
	props: /*@__PURE__*/ Ki({
		as: {
			type: null,
			required: !1
		},
		text: {
			type: [String, Number],
			required: !1
		},
		color: {
			type: null,
			required: !1
		},
		size: {
			type: null,
			required: !1
		},
		position: {
			type: null,
			required: !1
		},
		inset: {
			type: Boolean,
			required: !1,
			default: !1
		},
		standalone: {
			type: Boolean,
			required: !1,
			default: !1
		},
		class: {
			type: null,
			required: !1
		},
		ui: {
			type: Object,
			required: !1
		}
	}, {
		show: {
			type: Boolean,
			default: !0
		},
		showModifiers: {}
	}),
	emits: ["update:show"],
	setup(e) {
		let t = e, n = s_("chip", t), r = pa(e, "show", {
			type: Boolean,
			default: !0
		}), { size: i } = O_(t), a = Nf(), o = X(() => Fg({
			extend: k_,
			...a.ui?.chip || {}
		})({
			color: n.color,
			size: i.value ?? n.size,
			position: n.position,
			inset: n.inset,
			standalone: n.standalone
		}));
		return (e, t) => (G(), K(V(Wg), {
			as: V(n).as,
			"data-slot": e.$attrs["data-slot"] ?? "root",
			class: I(o.value.root({ class: [V(n).ui?.root, V(n).class] }))
		}, {
			default: U(() => [q(V(Hg), le(Wo({
				...e.$attrs,
				"data-slot": void 0
			})), {
				default: U(() => [W(e.$slots, "default")]),
				_: 3
			}, 16), r.value ? (G(), Fo("span", {
				key: 0,
				"data-slot": "base",
				class: I(o.value.base({ class: V(n).ui?.base }))
			}, [W(e.$slots, "content", {}, () => [qo(Ce(V(n).text), 1)])], 2)) : J("", !0)]),
			_: 3
		}, 8, [
			"as",
			"data-slot",
			"class"
		]));
	}
}), j_ = {
	slots: {
		root: "inline-flex items-center justify-center shrink-0 select-none rounded-full align-middle",
		image: "h-full w-full rounded-[inherit] object-cover",
		fallback: "font-medium truncate",
		icon: "shrink-0"
	},
	variants: {
		color: {
			primary: {
				root: "bg-primary/10",
				fallback: "text-primary",
				icon: "text-primary"
			},
			secondary: {
				root: "bg-secondary/10",
				fallback: "text-secondary",
				icon: "text-secondary"
			},
			success: {
				root: "bg-success/10",
				fallback: "text-success",
				icon: "text-success"
			},
			info: {
				root: "bg-info/10",
				fallback: "text-info",
				icon: "text-info"
			},
			warning: {
				root: "bg-warning/10",
				fallback: "text-warning",
				icon: "text-warning"
			},
			error: {
				root: "bg-error/10",
				fallback: "text-error",
				icon: "text-error"
			},
			neutral: {
				root: "bg-elevated",
				fallback: "text-muted",
				icon: "text-muted"
			}
		},
		size: {
			"3xs": { root: "size-4 text-[8px]" },
			"2xs": { root: "size-5 text-[10px]" },
			xs: { root: "size-6 text-xs" },
			sm: { root: "size-7 text-sm" },
			md: { root: "size-8 text-base" },
			lg: { root: "size-9 text-lg" },
			xl: { root: "size-10 text-xl" },
			"2xl": { root: "size-11 text-[22px]" },
			"3xl": { root: "size-12 text-2xl" }
		}
	},
	defaultVariants: {
		size: "md",
		color: "neutral"
	}
}, M_ = /*@__PURE__*/ Object.assign({ inheritAttrs: !1 }, {
	__name: "Avatar",
	props: {
		as: {
			type: null,
			required: !1
		},
		src: {
			type: String,
			required: !1
		},
		alt: {
			type: String,
			required: !1
		},
		icon: {
			type: null,
			required: !1
		},
		text: {
			type: String,
			required: !1
		},
		size: {
			type: null,
			required: !1
		},
		color: {
			type: null,
			required: !1
		},
		chip: {
			type: [Boolean, Object],
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		style: {
			type: null,
			required: !1
		},
		ui: {
			type: Object,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = s_("avatar", t), r = X(() => typeof n.as == "string" || typeof n.as?.render == "function" ? { root: n.as } : Lf(n.as, { root: "span" })), i = X(() => n.text || (n.alt || "").split(" ").map((e) => e.charAt(0)).join("").substring(0, 2)), a = Nf(), { size: o, color: s } = O_(t), c = X(() => Fg({
			extend: j_,
			...a.ui?.avatar || {}
		})({
			size: o.value ?? n.size,
			color: s.value ?? n.color
		})), l = X(() => c.value.root({ class: [n.ui?.root, n.class] })), u = X(() => {
			let e = (l.value || "").split(" ").find((e) => /^size-\d+$/.test(e));
			if (e) {
				let t = Number.parseFloat(e.split("-")[1] ?? "");
				if (!Number.isNaN(t)) return t * 4;
			}
			return null;
		}), d = /* @__PURE__ */ B(!1);
		Hr(() => n.src, () => {
			d.value &&= !1;
		});
		function f() {
			d.value = !0;
		}
		return (e, t) => (G(), K(Di(V(n).chip ? A_ : V(Wg)), Qo({ as: r.value.root }, V(n).chip ? typeof V(n).chip == "object" ? {
			inset: !0,
			...V(n).chip
		} : { inset: !0 } : {}, {
			"data-slot": e.$attrs["data-slot"] ?? "root",
			class: l.value,
			style: V(n).style
		}), {
			default: U(() => [V(n).src && !d.value ? (G(), K(Di(r.value.img || V("img")), Qo({
				key: 0,
				src: V(n).src,
				alt: V(n).alt,
				width: u.value,
				height: u.value
			}, e.$attrs, {
				"data-slot": "image",
				class: c.value.image({ class: V(n).ui?.image }),
				onError: f
			}), null, 16, [
				"src",
				"alt",
				"width",
				"height",
				"class"
			])) : (G(), K(V(Hg), le(Qo({ key: 1 }, {
				...e.$attrs,
				"data-slot": void 0
			})), {
				default: U(() => [W(e.$slots, "default", {}, () => [V(n).icon ? (G(), K(y_, {
					key: 0,
					name: V(n).icon,
					"data-slot": "icon",
					class: I(c.value.icon({ class: V(n).ui?.icon }))
				}, null, 8, ["name", "class"])) : (G(), Fo("span", {
					key: 1,
					"data-slot": "fallback",
					class: I(c.value.fallback({ class: V(n).ui?.fallback }))
				}, Ce(i.value || "\xA0"), 3))])]),
				_: 3
			}, 16))]),
			_: 3
		}, 16, [
			"as",
			"data-slot",
			"class",
			"style"
		]));
	}
}), N_ = {
	__name: "LinkBase",
	props: {
		as: {
			type: String,
			required: !1,
			default: "button"
		},
		type: {
			type: String,
			required: !1,
			default: "button"
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		onClick: {
			type: [Function, Array],
			required: !1
		},
		href: {
			type: [String, null],
			required: !1
		},
		navigate: {
			type: Function,
			required: !1
		},
		target: {
			type: [
				String,
				Object,
				null
			],
			required: !1
		},
		rel: {
			type: [
				String,
				Object,
				null
			],
			required: !1
		},
		active: {
			type: Boolean,
			required: !1
		},
		isExternal: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = e;
		function n(e) {
			if (t.disabled) {
				e.stopPropagation(), e.preventDefault();
				return;
			}
			if (t.onClick) for (let n of Array.isArray(t.onClick) ? t.onClick : [t.onClick]) n(e);
			t.href && t.navigate && !t.isExternal && t.navigate(e);
		}
		return (t, r) => (G(), K(V(Wg), Qo(e.href ? {
			as: "a",
			href: e.disabled ? void 0 : e.href,
			"aria-disabled": e.disabled ? "true" : void 0,
			role: e.disabled ? "link" : void 0,
			tabindex: e.disabled ? -1 : void 0
		} : e.as === "button" ? {
			as: e.as,
			type: e.type,
			disabled: e.disabled
		} : { as: e.as }, {
			rel: e.rel,
			target: e.target,
			onClick: n
		}), {
			default: U(() => [W(t.$slots, "default")]),
			_: 3
		}, 16, ["rel", "target"]));
	}
}, P_ = {
	base: "outline-primary/25 focus-visible:outline-3 rounded-md",
	variants: {
		active: {
			true: "text-primary",
			false: "text-muted"
		},
		disabled: { true: "cursor-not-allowed opacity-75" }
	},
	compoundVariants: [{
		active: !1,
		disabled: !1,
		class: ["hover:text-default", "transition-colors"]
	}]
}, F_ = /*@__PURE__*/ Object.assign({ inheritAttrs: !1 }, {
	__name: "Link",
	props: {
		as: {
			type: null,
			required: !1,
			default: "button"
		},
		type: {
			type: null,
			required: !1,
			default: "button"
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		active: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		exact: {
			type: Boolean,
			required: !1
		},
		exactQuery: {
			type: [Boolean, String],
			required: !1
		},
		exactHash: {
			type: Boolean,
			required: !1
		},
		inactiveClass: {
			type: String,
			required: !1
		},
		activeClass: {
			type: String,
			required: !1
		},
		ariaCurrentValue: {
			type: String,
			required: !1,
			default: "page"
		},
		custom: {
			type: Boolean,
			required: !1
		},
		raw: {
			type: Boolean,
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		to: {
			type: String,
			required: !1
		},
		href: {
			type: String,
			required: !1
		},
		external: {
			type: Boolean,
			required: !1
		},
		target: {
			type: [
				String,
				Object,
				null
			],
			required: !1
		},
		rel: {
			type: [
				String,
				Object,
				null
			],
			required: !1
		},
		noRel: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = Nf(), r = X(() => Fg({
			extend: P_,
			...Lf({ variants: { active: {
				true: Gf(n.ui?.link?.variants?.active?.true, t.activeClass),
				false: Gf(n.ui?.link?.variants?.active?.false, t.inactiveClass)
			} } }, n.ui?.link || {})
		})), i = X(() => t.to ?? t.href), a = X(() => t.target === "_blank" || t.external ? !0 : i.value ? Vf(i.value, { acceptRelative: !0 }) : !1), o = X(() => !!t.target && t.target !== "_self"), s = X(() => t.active !== void 0 && t.active), c = X(() => {
			let e = s.value;
			return t.raw ? [t.class, e ? t.activeClass : t.inactiveClass] : r.value({
				class: t.class,
				active: e,
				disabled: t.disabled
			});
		}), l = X(() => t.noRel ? null : t.rel === void 0 ? a.value || o.value ? "noopener noreferrer" : null : t.rel || null), u = Ir("nuxtui:router", void 0), d = u ? (e) => {
			u(e, {
				href: i.value || "",
				external: a.value,
				target: t.target || (a.value ? "_blank" : void 0)
			});
		} : void 0;
		return (t, n) => e.custom ? (G(), K(V(Hg), { key: 0 }, {
			default: U(() => [W(t.$slots, "default", le(Wo({
				...t.$attrs,
				as: e.as,
				type: e.type,
				disabled: e.disabled,
				href: i.value,
				navigate: V(d),
				rel: l.value,
				target: e.target || (a.value ? "_blank" : void 0),
				isExternal: a.value,
				active: s.value
			})))]),
			_: 3
		})) : (G(), K(N_, Qo({ key: 1 }, {
			...t.$attrs,
			as: e.as,
			type: e.type,
			disabled: e.disabled,
			href: i.value,
			navigate: V(d),
			rel: l.value,
			target: e.target || (a.value ? "_blank" : void 0),
			isExternal: a.value
		}, { class: c.value }), {
			default: U(() => [W(t.$slots, "default", { active: s.value })]),
			_: 3
		}, 16, ["class"]));
	}
}), I_ = {
	slots: {
		base: ["rounded-md font-medium inline-flex items-center disabled:cursor-not-allowed aria-disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:opacity-75", "transition-colors"],
		label: "truncate",
		leadingIcon: "shrink-0",
		leadingAvatar: "shrink-0",
		leadingAvatarSize: "",
		trailingIcon: "shrink-0"
	},
	variants: {
		fieldGroup: {
			horizontal: "not-only:first:rounded-e-none not-only:last:rounded-s-none not-last:not-first:rounded-none focus-visible:z-[1]",
			vertical: "not-only:first:rounded-b-none not-only:last:rounded-t-none not-last:not-first:rounded-none focus-visible:z-[1]"
		},
		color: {
			primary: "",
			secondary: "",
			success: "",
			info: "",
			warning: "",
			error: "",
			neutral: ""
		},
		variant: {
			solid: "",
			outline: "",
			soft: "",
			subtle: "",
			ghost: "",
			link: ""
		},
		size: {
			xs: {
				base: "px-2 py-1 text-xs gap-1",
				leadingIcon: "size-4",
				leadingAvatarSize: "3xs",
				trailingIcon: "size-4"
			},
			sm: {
				base: "px-2.5 py-1.5 text-xs gap-1.5",
				leadingIcon: "size-4",
				leadingAvatarSize: "3xs",
				trailingIcon: "size-4"
			},
			md: {
				base: "px-2.5 py-1.5 text-sm gap-1.5",
				leadingIcon: "size-5",
				leadingAvatarSize: "2xs",
				trailingIcon: "size-5"
			},
			lg: {
				base: "px-3 py-2 text-sm gap-2",
				leadingIcon: "size-5",
				leadingAvatarSize: "2xs",
				trailingIcon: "size-5"
			},
			xl: {
				base: "px-3 py-2 text-base gap-2",
				leadingIcon: "size-6",
				leadingAvatarSize: "xs",
				trailingIcon: "size-6"
			}
		},
		block: { true: {
			base: "w-full justify-center",
			trailingIcon: "ms-auto"
		} },
		square: { true: "" },
		leading: { true: "" },
		trailing: { true: "" },
		loading: { true: "" },
		active: {
			true: { base: "" },
			false: { base: "" }
		}
	},
	compoundVariants: [
		{
			color: "primary",
			variant: "solid",
			class: "text-inverted bg-primary hover:bg-primary/75 active:bg-primary/75 disabled:bg-primary aria-disabled:bg-primary outline-primary/25 focus-visible:outline-3"
		},
		{
			color: "secondary",
			variant: "solid",
			class: "text-inverted bg-secondary hover:bg-secondary/75 active:bg-secondary/75 disabled:bg-secondary aria-disabled:bg-secondary outline-secondary/25 focus-visible:outline-3"
		},
		{
			color: "success",
			variant: "solid",
			class: "text-inverted bg-success hover:bg-success/75 active:bg-success/75 disabled:bg-success aria-disabled:bg-success outline-success/25 focus-visible:outline-3"
		},
		{
			color: "info",
			variant: "solid",
			class: "text-inverted bg-info hover:bg-info/75 active:bg-info/75 disabled:bg-info aria-disabled:bg-info outline-info/25 focus-visible:outline-3"
		},
		{
			color: "warning",
			variant: "solid",
			class: "text-inverted bg-warning hover:bg-warning/75 active:bg-warning/75 disabled:bg-warning aria-disabled:bg-warning outline-warning/25 focus-visible:outline-3"
		},
		{
			color: "error",
			variant: "solid",
			class: "text-inverted bg-error hover:bg-error/75 active:bg-error/75 disabled:bg-error aria-disabled:bg-error outline-error/25 focus-visible:outline-3"
		},
		{
			color: "primary",
			variant: "outline",
			class: "ring ring-inset ring-primary/50 text-primary hover:bg-primary/10 active:bg-primary/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-primary/25 focus-visible:outline-3 focus-visible:ring-primary"
		},
		{
			color: "secondary",
			variant: "outline",
			class: "ring ring-inset ring-secondary/50 text-secondary hover:bg-secondary/10 active:bg-secondary/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-secondary/25 focus-visible:outline-3 focus-visible:ring-secondary"
		},
		{
			color: "success",
			variant: "outline",
			class: "ring ring-inset ring-success/50 text-success hover:bg-success/10 active:bg-success/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-success/25 focus-visible:outline-3 focus-visible:ring-success"
		},
		{
			color: "info",
			variant: "outline",
			class: "ring ring-inset ring-info/50 text-info hover:bg-info/10 active:bg-info/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-info/25 focus-visible:outline-3 focus-visible:ring-info"
		},
		{
			color: "warning",
			variant: "outline",
			class: "ring ring-inset ring-warning/50 text-warning hover:bg-warning/10 active:bg-warning/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-warning/25 focus-visible:outline-3 focus-visible:ring-warning"
		},
		{
			color: "error",
			variant: "outline",
			class: "ring ring-inset ring-error/50 text-error hover:bg-error/10 active:bg-error/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-error/25 focus-visible:outline-3 focus-visible:ring-error"
		},
		{
			color: "primary",
			variant: "soft",
			class: "text-primary bg-primary/10 hover:bg-primary/15 active:bg-primary/15 outline-primary/25 focus-visible:outline-3 disabled:bg-primary/10 aria-disabled:bg-primary/10"
		},
		{
			color: "secondary",
			variant: "soft",
			class: "text-secondary bg-secondary/10 hover:bg-secondary/15 active:bg-secondary/15 outline-secondary/25 focus-visible:outline-3 disabled:bg-secondary/10 aria-disabled:bg-secondary/10"
		},
		{
			color: "success",
			variant: "soft",
			class: "text-success bg-success/10 hover:bg-success/15 active:bg-success/15 outline-success/25 focus-visible:outline-3 disabled:bg-success/10 aria-disabled:bg-success/10"
		},
		{
			color: "info",
			variant: "soft",
			class: "text-info bg-info/10 hover:bg-info/15 active:bg-info/15 outline-info/25 focus-visible:outline-3 disabled:bg-info/10 aria-disabled:bg-info/10"
		},
		{
			color: "warning",
			variant: "soft",
			class: "text-warning bg-warning/10 hover:bg-warning/15 active:bg-warning/15 outline-warning/25 focus-visible:outline-3 disabled:bg-warning/10 aria-disabled:bg-warning/10"
		},
		{
			color: "error",
			variant: "soft",
			class: "text-error bg-error/10 hover:bg-error/15 active:bg-error/15 outline-error/25 focus-visible:outline-3 disabled:bg-error/10 aria-disabled:bg-error/10"
		},
		{
			color: "primary",
			variant: "subtle",
			class: "text-primary ring ring-inset ring-primary/25 bg-primary/10 hover:bg-primary/15 active:bg-primary/15 disabled:bg-primary/10 aria-disabled:bg-primary/10 outline-primary/25 focus-visible:outline-3 focus-visible:ring-primary"
		},
		{
			color: "secondary",
			variant: "subtle",
			class: "text-secondary ring ring-inset ring-secondary/25 bg-secondary/10 hover:bg-secondary/15 active:bg-secondary/15 disabled:bg-secondary/10 aria-disabled:bg-secondary/10 outline-secondary/25 focus-visible:outline-3 focus-visible:ring-secondary"
		},
		{
			color: "success",
			variant: "subtle",
			class: "text-success ring ring-inset ring-success/25 bg-success/10 hover:bg-success/15 active:bg-success/15 disabled:bg-success/10 aria-disabled:bg-success/10 outline-success/25 focus-visible:outline-3 focus-visible:ring-success"
		},
		{
			color: "info",
			variant: "subtle",
			class: "text-info ring ring-inset ring-info/25 bg-info/10 hover:bg-info/15 active:bg-info/15 disabled:bg-info/10 aria-disabled:bg-info/10 outline-info/25 focus-visible:outline-3 focus-visible:ring-info"
		},
		{
			color: "warning",
			variant: "subtle",
			class: "text-warning ring ring-inset ring-warning/25 bg-warning/10 hover:bg-warning/15 active:bg-warning/15 disabled:bg-warning/10 aria-disabled:bg-warning/10 outline-warning/25 focus-visible:outline-3 focus-visible:ring-warning"
		},
		{
			color: "error",
			variant: "subtle",
			class: "text-error ring ring-inset ring-error/25 bg-error/10 hover:bg-error/15 active:bg-error/15 disabled:bg-error/10 aria-disabled:bg-error/10 outline-error/25 focus-visible:outline-3 focus-visible:ring-error"
		},
		{
			color: "primary",
			variant: "ghost",
			class: "text-primary hover:bg-primary/10 active:bg-primary/10 outline-primary/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
		},
		{
			color: "secondary",
			variant: "ghost",
			class: "text-secondary hover:bg-secondary/10 active:bg-secondary/10 outline-secondary/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
		},
		{
			color: "success",
			variant: "ghost",
			class: "text-success hover:bg-success/10 active:bg-success/10 outline-success/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
		},
		{
			color: "info",
			variant: "ghost",
			class: "text-info hover:bg-info/10 active:bg-info/10 outline-info/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
		},
		{
			color: "warning",
			variant: "ghost",
			class: "text-warning hover:bg-warning/10 active:bg-warning/10 outline-warning/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
		},
		{
			color: "error",
			variant: "ghost",
			class: "text-error hover:bg-error/10 active:bg-error/10 outline-error/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
		},
		{
			color: "primary",
			variant: "link",
			class: "text-primary hover:text-primary/75 active:text-primary/75 disabled:text-primary aria-disabled:text-primary outline-primary/25 focus-visible:outline-3"
		},
		{
			color: "secondary",
			variant: "link",
			class: "text-secondary hover:text-secondary/75 active:text-secondary/75 disabled:text-secondary aria-disabled:text-secondary outline-secondary/25 focus-visible:outline-3"
		},
		{
			color: "success",
			variant: "link",
			class: "text-success hover:text-success/75 active:text-success/75 disabled:text-success aria-disabled:text-success outline-success/25 focus-visible:outline-3"
		},
		{
			color: "info",
			variant: "link",
			class: "text-info hover:text-info/75 active:text-info/75 disabled:text-info aria-disabled:text-info outline-info/25 focus-visible:outline-3"
		},
		{
			color: "warning",
			variant: "link",
			class: "text-warning hover:text-warning/75 active:text-warning/75 disabled:text-warning aria-disabled:text-warning outline-warning/25 focus-visible:outline-3"
		},
		{
			color: "error",
			variant: "link",
			class: "text-error hover:text-error/75 active:text-error/75 disabled:text-error aria-disabled:text-error outline-error/25 focus-visible:outline-3"
		},
		{
			color: "neutral",
			variant: "solid",
			class: "text-inverted bg-inverted hover:bg-inverted/90 active:bg-inverted/90 disabled:bg-inverted aria-disabled:bg-inverted outline-inverted/25 focus-visible:outline-3"
		},
		{
			color: "neutral",
			variant: "outline",
			class: "ring ring-inset ring-accented text-default bg-default hover:bg-elevated active:bg-elevated disabled:bg-default aria-disabled:bg-default outline-inverted/25 focus-visible:outline-3 focus-visible:ring-inverted"
		},
		{
			color: "neutral",
			variant: "soft",
			class: "text-default bg-elevated hover:bg-accented/75 active:bg-accented/75 outline-inverted/25 focus-visible:outline-3 disabled:bg-elevated aria-disabled:bg-elevated"
		},
		{
			color: "neutral",
			variant: "subtle",
			class: "ring ring-inset ring-accented text-default bg-elevated hover:bg-accented/75 active:bg-accented/75 disabled:bg-elevated aria-disabled:bg-elevated outline-inverted/25 focus-visible:outline-3 focus-visible:ring-inverted"
		},
		{
			color: "neutral",
			variant: "ghost",
			class: "text-default hover:bg-elevated active:bg-elevated outline-inverted/25 focus-visible:outline-3 hover:disabled:bg-transparent dark:hover:disabled:bg-transparent hover:aria-disabled:bg-transparent dark:hover:aria-disabled:bg-transparent"
		},
		{
			color: "neutral",
			variant: "link",
			class: "text-muted hover:text-default active:text-default disabled:text-muted aria-disabled:text-muted outline-inverted/25 focus-visible:outline-3"
		},
		{
			size: "xs",
			square: !0,
			class: "p-1"
		},
		{
			size: "sm",
			square: !0,
			class: "p-1.5"
		},
		{
			size: "md",
			square: !0,
			class: "p-1.5"
		},
		{
			size: "lg",
			square: !0,
			class: "p-2"
		},
		{
			size: "xl",
			square: !0,
			class: "p-2"
		},
		{
			loading: !0,
			leading: !0,
			class: { leadingIcon: "animate-spin" }
		},
		{
			loading: !0,
			leading: !1,
			trailing: !0,
			class: { trailingIcon: "animate-spin" }
		}
	],
	defaultVariants: {
		color: "primary",
		variant: "solid",
		size: "md"
	}
}, L_ = {
	__name: "Button",
	props: {
		label: {
			type: String,
			required: !1
		},
		color: {
			type: null,
			required: !1
		},
		activeColor: {
			type: null,
			required: !1
		},
		variant: {
			type: null,
			required: !1
		},
		activeVariant: {
			type: null,
			required: !1
		},
		size: {
			type: null,
			required: !1
		},
		square: {
			type: Boolean,
			required: !1
		},
		block: {
			type: Boolean,
			required: !1
		},
		loadingAuto: {
			type: Boolean,
			required: !1
		},
		onClick: {
			type: [Function, Array],
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		ui: {
			type: Object,
			required: !1
		},
		icon: {
			type: null,
			required: !1
		},
		avatar: {
			type: Object,
			required: !1
		},
		leading: {
			type: Boolean,
			required: !1
		},
		leadingIcon: {
			type: null,
			required: !1
		},
		trailing: {
			type: Boolean,
			required: !1
		},
		trailingIcon: {
			type: null,
			required: !1
		},
		loading: {
			type: Boolean,
			required: !1
		},
		loadingIcon: {
			type: null,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		type: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		active: {
			type: Boolean,
			required: !1
		},
		exact: {
			type: Boolean,
			required: !1
		},
		exactQuery: {
			type: [Boolean, String],
			required: !1
		},
		exactHash: {
			type: Boolean,
			required: !1
		},
		inactiveClass: {
			type: String,
			required: !1
		},
		locale: {
			type: [Boolean, String],
			required: !1
		},
		to: {
			type: null,
			required: !1
		},
		href: {
			type: null,
			required: !1
		},
		external: {
			type: Boolean,
			required: !1
		},
		target: {
			type: [
				String,
				Object,
				null
			],
			required: !1
		},
		rel: {
			type: [
				String,
				Object,
				null
			],
			required: !1
		},
		noRel: {
			type: Boolean,
			required: !1
		},
		prefetchedClass: {
			type: String,
			required: !1
		},
		prefetch: {
			type: Boolean,
			required: !1
		},
		prefetchOn: {
			type: [String, Object],
			required: !1
		},
		noPrefetch: {
			type: Boolean,
			required: !1
		},
		trailingSlash: {
			type: String,
			required: !1
		},
		activeClass: {
			type: String,
			required: !1
		},
		exactActiveClass: {
			type: String,
			required: !1
		},
		ariaCurrentValue: {
			type: String,
			required: !1
		},
		viewTransition: {
			type: Boolean,
			required: !1
		},
		replace: {
			type: Boolean,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = Hi(), r = s_("button", t), i = Nf(), { orientation: a, size: o } = w_(t), s = v_(E_(r)), c = X(() => Hf(s.value, [
			"type",
			"disabled",
			"onClick"
		])), l = /* @__PURE__ */ B(!1), u = Ir(lp, void 0);
		async function d(e) {
			l.value = !0;
			let t = Array.isArray(r.onClick) ? r.onClick : [r.onClick];
			try {
				await Promise.all(t.map((t) => t?.(e)));
			} finally {
				l.value = !1;
			}
		}
		let f = X(() => r.loading || r.loadingAuto && (l.value || u?.value && r.type === "submit")), { isLeading: p, isTrailing: m, leadingIconName: h, trailingIconName: g } = S_(X(() => ({
			icon: r.icon,
			leading: r.leading,
			leadingIcon: r.leadingIcon,
			trailing: r.trailing,
			trailingIcon: r.trailingIcon,
			loading: f.value,
			loadingIcon: r.loadingIcon
		}))), _ = X(() => Fg({
			extend: I_,
			...Lf({ variants: { active: {
				true: { base: Gf(i.ui?.button?.variants?.active?.true?.base, r.activeClass) },
				false: { base: Gf(i.ui?.button?.variants?.active?.false?.base, r.inactiveClass) }
			} } }, i.ui?.button || {})
		})({
			color: r.color,
			variant: r.variant,
			size: o.value ?? r.size,
			loading: f.value,
			block: r.block,
			square: r.square || !n.default && !r.label,
			leading: p.value,
			trailing: m.value,
			fieldGroup: a.value
		}));
		return (e, t) => (G(), K(F_, Qo({
			type: V(r).type,
			disabled: V(r).disabled || f.value
		}, c.value, { custom: "" }), {
			default: U(({ active: t, ...n }) => [q(N_, Qo({ "data-slot": "base" }, n, {
				class: _.value.base({
					class: [V(r).ui?.base, V(r).class],
					active: t,
					...t && V(r).activeVariant ? { variant: V(r).activeVariant } : {},
					...t && V(r).activeColor ? { color: V(r).activeColor } : {}
				}),
				onClick: d
			}), {
				default: U(() => [
					W(e.$slots, "leading", { ui: _.value }, () => [V(p) && V(h) ? (G(), K(y_, {
						key: 0,
						name: V(h),
						"data-slot": "leadingIcon",
						class: I(_.value.leadingIcon({
							class: V(r).ui?.leadingIcon,
							active: t
						}))
					}, null, 8, ["name", "class"])) : V(r).avatar ? (G(), K(M_, Qo({
						key: 1,
						size: V(r).ui?.leadingAvatarSize || _.value.leadingAvatarSize()
					}, V(r).avatar, {
						"data-slot": "leadingAvatar",
						class: _.value.leadingAvatar({
							class: V(r).ui?.leadingAvatar,
							active: t
						})
					}), null, 16, ["size", "class"])) : J("", !0)]),
					W(e.$slots, "default", { ui: _.value }, () => [V(r).label !== void 0 && V(r).label !== null ? (G(), Fo("span", {
						key: 0,
						"data-slot": "label",
						class: I(_.value.label({
							class: V(r).ui?.label,
							active: t
						}))
					}, Ce(V(r).label), 3)) : J("", !0)]),
					W(e.$slots, "trailing", { ui: _.value }, () => [V(m) && V(g) ? (G(), K(y_, {
						key: 0,
						name: V(g),
						"data-slot": "trailingIcon",
						class: I(_.value.trailingIcon({
							class: V(r).ui?.trailingIcon,
							active: t
						}))
					}, null, 8, ["name", "class"])) : J("", !0)])
				]),
				_: 2
			}, 1040, ["class"])]),
			_: 3
		}, 16, ["type", "disabled"]));
	}
}, R_ = {
	slots: {
		root: "",
		wrapper: "",
		labelWrapper: "flex content-center items-center justify-between gap-1",
		label: "block font-medium text-default",
		container: "relative",
		description: "text-muted",
		error: "mt-2 text-error",
		hint: "text-muted",
		help: "mt-2 text-muted"
	},
	variants: {
		size: {
			xs: { root: "text-xs" },
			sm: { root: "text-xs" },
			md: { root: "text-sm" },
			lg: { root: "text-sm" },
			xl: { root: "text-base" }
		},
		required: { true: { label: "after:content-['*'] after:ms-0.5 after:text-error" } },
		orientation: {
			vertical: { container: "mt-1" },
			horizontal: { root: "flex justify-between place-items-baseline gap-2" }
		}
	},
	defaultVariants: { size: "md" }
}, z_ = ["id"], B_ = ["id"], V_ = ["id"], H_ = ["id"], U_ = {
	__name: "FormField",
	props: {
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		errorPattern: {
			type: null,
			required: !1
		},
		label: {
			type: String,
			required: !1
		},
		description: {
			type: String,
			required: !1
		},
		help: {
			type: String,
			required: !1
		},
		error: {
			type: [Boolean, String],
			required: !1,
			default: void 0
		},
		hint: {
			type: String,
			required: !1
		},
		size: {
			type: null,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		eagerValidation: {
			type: Boolean,
			required: !1
		},
		validateOnInputDelay: {
			type: Number,
			required: !1
		},
		orientation: {
			type: null,
			required: !1,
			default: "vertical"
		},
		class: {
			type: null,
			required: !1
		},
		ui: {
			type: Object,
			required: !1
		}
	},
	setup(e) {
		let t = e, n = Hi(), r = s_("formField", t), i = Nf(), a = X(() => Fg({
			extend: R_,
			...i.ui?.formField || {}
		})({
			size: r.size,
			required: r.required,
			orientation: r.orientation
		})), o = Ir(up, null), s = X(() => r.error || o?.value?.find((e) => e.name === r.name || r.errorPattern && e.name?.match(r.errorPattern))?.message), c = /* @__PURE__ */ B($r()), l = c.value, u = Ir(cp, void 0);
		return Hr(c, () => {
			u && r.name && (u.value[r.name] = {
				id: c.value,
				pattern: r.errorPattern
			});
		}, { immediate: !0 }), Fr(sp, c), Fr(op, X(() => ({
			error: s.value,
			name: r.name,
			size: r.size,
			eagerValidation: r.eagerValidation,
			validateOnInputDelay: r.validateOnInputDelay,
			errorPattern: r.errorPattern,
			hint: r.hint,
			description: r.description,
			help: r.help,
			ariaId: l
		}))), (e, t) => (G(), K(V(Wg), {
			as: V(r).as,
			"data-orientation": V(r).orientation,
			"data-slot": "root",
			class: I(a.value.root({ class: [V(r).ui?.root, V(r).class] }))
		}, {
			default: U(() => [Vo("div", {
				"data-slot": "wrapper",
				class: I(a.value.wrapper({ class: V(r).ui?.wrapper }))
			}, [V(r).label || n.label ? (G(), Fo("div", {
				key: 0,
				"data-slot": "labelWrapper",
				class: I(a.value.labelWrapper({ class: V(r).ui?.labelWrapper }))
			}, [q(V(Yg), {
				for: c.value,
				"data-slot": "label",
				class: I(a.value.label({ class: V(r).ui?.label }))
			}, {
				default: U(() => [W(e.$slots, "label", { label: V(r).label }, () => [qo(Ce(V(r).label), 1)])]),
				_: 3
			}, 8, ["for", "class"]), V(r).hint || n.hint ? (G(), Fo("span", {
				key: 0,
				id: `${V(l)}-hint`,
				"data-slot": "hint",
				class: I(a.value.hint({ class: V(r).ui?.hint }))
			}, [W(e.$slots, "hint", { hint: V(r).hint }, () => [qo(Ce(V(r).hint), 1)])], 10, z_)) : J("", !0)], 2)) : J("", !0), V(r).description || n.description ? (G(), Fo("p", {
				key: 1,
				id: `${V(l)}-description`,
				"data-slot": "description",
				class: I(a.value.description({ class: V(r).ui?.description }))
			}, [W(e.$slots, "description", { description: V(r).description }, () => [qo(Ce(V(r).description), 1)])], 10, B_)) : J("", !0)], 2), Vo("div", { class: I([(V(r).label || !!n.label || V(r).description || !!n.description) && a.value.container({ class: V(r).ui?.container })]) }, [W(e.$slots, "default", { error: s.value }), V(r).error !== !1 && (typeof s.value == "string" && s.value || n.error) ? (G(), Fo("div", {
				key: 0,
				id: `${V(l)}-error`,
				"data-slot": "error",
				class: I(a.value.error({ class: V(r).ui?.error }))
			}, [W(e.$slots, "error", { error: s.value }, () => [qo(Ce(s.value), 1)])], 10, V_)) : V(r).help || n.help ? (G(), Fo("div", {
				key: 1,
				id: `${V(l)}-help`,
				"data-slot": "help",
				class: I(a.value.help({ class: V(r).ui?.help }))
			}, [W(e.$slots, "help", { help: V(r).help }, () => [qo(Ce(V(r).help), 1)])], 10, H_)) : J("", !0)], 2)]),
			_: 3
		}, 8, [
			"as",
			"data-orientation",
			"class"
		]));
	}
}, W_ = {
	slots: {
		root: "relative inline-flex items-center",
		base: ["w-full rounded-md border-0 appearance-none placeholder:text-dimmed disabled:cursor-not-allowed disabled:opacity-75", "transition-colors"],
		leading: "absolute inset-y-0 start-0 flex items-center",
		leadingIcon: "shrink-0 text-dimmed",
		leadingAvatar: "shrink-0",
		leadingAvatarSize: "",
		trailing: "absolute inset-y-0 end-0 flex items-center",
		trailingIcon: "shrink-0 text-dimmed"
	},
	variants: {
		fieldGroup: {
			horizontal: {
				root: "group has-focus-visible:z-[1]",
				base: "group-not-only:group-first:rounded-e-none group-not-only:group-last:rounded-s-none group-not-last:group-not-first:rounded-none"
			},
			vertical: {
				root: "group has-focus-visible:z-[1]",
				base: "group-not-only:group-first:rounded-b-none group-not-only:group-last:rounded-t-none group-not-last:group-not-first:rounded-none"
			}
		},
		size: {
			xs: {
				base: "px-2 py-1 text-sm/4 gap-1",
				leading: "ps-2",
				trailing: "pe-2",
				leadingIcon: "size-4",
				leadingAvatarSize: "3xs",
				trailingIcon: "size-4"
			},
			sm: {
				base: "px-2.5 py-1.5 text-sm/4 gap-1.5",
				leading: "ps-2.5",
				trailing: "pe-2.5",
				leadingIcon: "size-4",
				leadingAvatarSize: "3xs",
				trailingIcon: "size-4"
			},
			md: {
				base: "px-2.5 py-1.5 text-base/5 gap-1.5",
				leading: "ps-2.5",
				trailing: "pe-2.5",
				leadingIcon: "size-5",
				leadingAvatarSize: "2xs",
				trailingIcon: "size-5"
			},
			lg: {
				base: "px-3 py-2 text-base/5 gap-2",
				leading: "ps-3",
				trailing: "pe-3",
				leadingIcon: "size-5",
				leadingAvatarSize: "2xs",
				trailingIcon: "size-5"
			},
			xl: {
				base: "px-3 py-2 text-base gap-2",
				leading: "ps-3",
				trailing: "pe-3",
				leadingIcon: "size-6",
				leadingAvatarSize: "xs",
				trailingIcon: "size-6"
			}
		},
		variant: {
			outline: "text-highlighted bg-default ring ring-inset ring-accented",
			soft: "text-highlighted bg-elevated/50 hover:bg-elevated focus:bg-elevated disabled:bg-elevated/50",
			subtle: "text-highlighted bg-elevated ring ring-inset ring-accented",
			ghost: "text-highlighted bg-transparent hover:bg-elevated focus:bg-elevated disabled:bg-transparent dark:disabled:bg-transparent",
			none: "text-highlighted bg-transparent focus:outline-none"
		},
		color: {
			primary: "",
			secondary: "",
			success: "",
			info: "",
			warning: "",
			error: "",
			neutral: ""
		},
		leading: { true: "" },
		trailing: { true: "" },
		loading: { true: "" },
		highlight: { true: "" },
		fixed: { false: "" },
		type: { file: "file:me-1.5 file:font-medium file:text-muted file:outline-none" }
	},
	compoundVariants: [
		{
			color: "primary",
			variant: ["outline", "subtle"],
			class: "outline-primary/25 focus-visible:outline-3 focus-visible:ring-primary"
		},
		{
			color: "secondary",
			variant: ["outline", "subtle"],
			class: "outline-secondary/25 focus-visible:outline-3 focus-visible:ring-secondary"
		},
		{
			color: "success",
			variant: ["outline", "subtle"],
			class: "outline-success/25 focus-visible:outline-3 focus-visible:ring-success"
		},
		{
			color: "info",
			variant: ["outline", "subtle"],
			class: "outline-info/25 focus-visible:outline-3 focus-visible:ring-info"
		},
		{
			color: "warning",
			variant: ["outline", "subtle"],
			class: "outline-warning/25 focus-visible:outline-3 focus-visible:ring-warning"
		},
		{
			color: "error",
			variant: ["outline", "subtle"],
			class: "outline-error/25 focus-visible:outline-3 focus-visible:ring-error"
		},
		{
			color: "primary",
			variant: ["soft", "ghost"],
			class: "outline-primary/25 focus-visible:outline-3"
		},
		{
			color: "secondary",
			variant: ["soft", "ghost"],
			class: "outline-secondary/25 focus-visible:outline-3"
		},
		{
			color: "success",
			variant: ["soft", "ghost"],
			class: "outline-success/25 focus-visible:outline-3"
		},
		{
			color: "info",
			variant: ["soft", "ghost"],
			class: "outline-info/25 focus-visible:outline-3"
		},
		{
			color: "warning",
			variant: ["soft", "ghost"],
			class: "outline-warning/25 focus-visible:outline-3"
		},
		{
			color: "error",
			variant: ["soft", "ghost"],
			class: "outline-error/25 focus-visible:outline-3"
		},
		{
			color: "primary",
			highlight: !0,
			class: "ring ring-inset ring-primary"
		},
		{
			color: "secondary",
			highlight: !0,
			class: "ring ring-inset ring-secondary"
		},
		{
			color: "success",
			highlight: !0,
			class: "ring ring-inset ring-success"
		},
		{
			color: "info",
			highlight: !0,
			class: "ring ring-inset ring-info"
		},
		{
			color: "warning",
			highlight: !0,
			class: "ring ring-inset ring-warning"
		},
		{
			color: "error",
			highlight: !0,
			class: "ring ring-inset ring-error"
		},
		{
			color: "neutral",
			variant: ["outline", "subtle"],
			class: "outline-inverted/25 focus-visible:outline-3 focus-visible:ring-inverted"
		},
		{
			color: "neutral",
			variant: ["soft", "ghost"],
			class: "outline-inverted/25 focus-visible:outline-3"
		},
		{
			color: "neutral",
			highlight: !0,
			class: "ring ring-inset ring-inverted"
		},
		{
			leading: !0,
			size: "xs",
			class: "ps-7"
		},
		{
			leading: !0,
			size: "sm",
			class: "ps-8"
		},
		{
			leading: !0,
			size: "md",
			class: "ps-9"
		},
		{
			leading: !0,
			size: "lg",
			class: "ps-10"
		},
		{
			leading: !0,
			size: "xl",
			class: "ps-11"
		},
		{
			trailing: !0,
			size: "xs",
			class: "pe-7"
		},
		{
			trailing: !0,
			size: "sm",
			class: "pe-8"
		},
		{
			trailing: !0,
			size: "md",
			class: "pe-9"
		},
		{
			trailing: !0,
			size: "lg",
			class: "pe-10"
		},
		{
			trailing: !0,
			size: "xl",
			class: "pe-11"
		},
		{
			loading: !0,
			leading: !0,
			class: { leadingIcon: "animate-spin" }
		},
		{
			loading: !0,
			leading: !1,
			trailing: !0,
			class: { trailingIcon: "animate-spin" }
		},
		{
			fixed: !1,
			size: "xs",
			class: "md:text-xs"
		},
		{
			fixed: !1,
			size: "sm",
			class: "md:text-xs"
		},
		{
			fixed: !1,
			size: "md",
			class: "md:text-sm"
		},
		{
			fixed: !1,
			size: "lg",
			class: "md:text-sm"
		}
	],
	defaultVariants: {
		size: "md",
		color: "primary",
		variant: "outline"
	}
}, G_ = [
	"id",
	"type",
	"value",
	"name",
	"placeholder",
	"disabled",
	"required",
	"autocomplete"
], K_ = /*@__PURE__*/ Object.assign({ inheritAttrs: !1 }, {
	__name: "Input",
	props: {
		as: {
			type: null,
			required: !1
		},
		id: {
			type: String,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		type: {
			type: null,
			required: !1,
			default: "text"
		},
		placeholder: {
			type: String,
			required: !1
		},
		color: {
			type: null,
			required: !1
		},
		variant: {
			type: null,
			required: !1
		},
		size: {
			type: null,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		autocomplete: {
			type: [String, Object],
			required: !1,
			default: "off"
		},
		autofocus: {
			type: Boolean,
			required: !1
		},
		autofocusDelay: {
			type: Number,
			required: !1,
			default: 0
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		highlight: {
			type: Boolean,
			required: !1
		},
		fixed: {
			type: Boolean,
			required: !1
		},
		modelValue: {
			type: null,
			required: !1
		},
		defaultValue: {
			type: null,
			required: !1
		},
		modelModifiers: {
			type: null,
			required: !1
		},
		class: {
			type: null,
			required: !1
		},
		ui: {
			type: Object,
			required: !1
		},
		icon: {
			type: null,
			required: !1
		},
		avatar: {
			type: Object,
			required: !1
		},
		leading: {
			type: Boolean,
			required: !1
		},
		leadingIcon: {
			type: null,
			required: !1
		},
		trailing: {
			type: Boolean,
			required: !1
		},
		trailingIcon: {
			type: null,
			required: !1
		},
		loading: {
			type: Boolean,
			required: !1
		},
		loadingIcon: {
			type: null,
			required: !1
		}
	},
	emits: [
		"update:modelValue",
		"blur",
		"change"
	],
	setup(e, { expose: t, emit: n }) {
		let r = e, i = n, a = Hi(), o = s_("input", r), s = Af(o, "modelValue", i, { defaultValue: o.defaultValue }), c = Nf(), { emitFormBlur: l, emitFormInput: u, emitFormChange: d, size: f, color: p, id: m, name: h, highlight: g, disabled: _, emitFormFocus: v, ariaAttrs: y } = dp(r, { deferInputValidation: !0 }), { orientation: b, size: x } = w_(r), { isLeading: S, isTrailing: C, leadingIconName: w, trailingIconName: T } = S_(o), ee = X(() => p.value ?? o.color), te = X(() => g.value ?? o.highlight), ne = X(() => x.value ?? f.value ?? o.size), E = X(() => _.value ?? o.disabled), D = X(() => Fg({
			extend: W_,
			...c.ui?.input || {}
		})({
			type: o.type,
			color: ee.value,
			variant: o.variant,
			size: ne.value,
			loading: o.loading,
			highlight: te.value,
			fixed: o.fixed,
			leading: S.value || !!o.avatar || !!a.leading,
			trailing: C.value || !!a.trailing,
			fieldGroup: b.value
		})), O = ni("inputRef");
		function k(e) {
			o.modelModifiers?.trim && (typeof e == "string" || e == null) && (e = e?.trim() ?? null), (o.modelModifiers?.number || o.type === "number") && (e = Wf(e)), o.modelModifiers?.nullable && (e ||= null), o.modelModifiers?.optional && !o.modelModifiers?.nullable && e !== null && (e ||= void 0), s.value = e, u();
		}
		function A(e) {
			o.modelModifiers?.lazy || k(e.target.value);
		}
		function j(e) {
			let t = e.target.value;
			o.modelModifiers?.lazy && k(t), o.modelModifiers?.trim && (e.target.value = t.trim()), d(), i("change", e);
		}
		function re(e) {
			l(), i("blur", e);
		}
		function M() {
			o.autofocus && O.value?.focus();
		}
		let N;
		return gi(() => {
			N = setTimeout(() => {
				M();
			}, o.autofocusDelay);
		}), Ae(() => clearTimeout(N)), t({ inputRef: O }), (e, t) => (G(), K(V(Wg), {
			as: V(o).as,
			"data-slot": e.$attrs["data-slot"] ?? "root",
			class: I(D.value.root({ class: [V(o).ui?.root, V(o).class] }))
		}, {
			default: U(() => [
				Vo("input", Qo({
					id: V(m),
					ref_key: "inputRef",
					ref: O,
					type: V(o).type,
					value: V(s),
					name: V(h),
					placeholder: V(o).placeholder,
					class: D.value.base({ class: V(o).ui?.base }),
					disabled: E.value,
					required: V(o).required,
					autocomplete: V(o).autocomplete
				}, {
					...e.$attrs,
					...V(y)
				}, {
					"data-slot": "base",
					onInput: A,
					onBlur: re,
					onChange: j,
					onFocus: t[0] ||= (...e) => V(v) && V(v)(...e)
				}), null, 16, G_),
				W(e.$slots, "default", { ui: D.value }),
				V(S) || V(o).avatar || a.leading ? (G(), Fo("span", {
					key: 0,
					"data-slot": "leading",
					class: I(D.value.leading({ class: V(o).ui?.leading }))
				}, [W(e.$slots, "leading", { ui: D.value }, () => [V(S) && V(w) ? (G(), K(y_, {
					key: 0,
					name: V(w),
					"data-slot": "leadingIcon",
					class: I(D.value.leadingIcon({ class: V(o).ui?.leadingIcon }))
				}, null, 8, ["name", "class"])) : V(o).avatar ? (G(), K(M_, Qo({
					key: 1,
					size: V(o).ui?.leadingAvatarSize || D.value.leadingAvatarSize()
				}, V(o).avatar, {
					"data-slot": "leadingAvatar",
					class: D.value.leadingAvatar({ class: V(o).ui?.leadingAvatar })
				}), null, 16, ["size", "class"])) : J("", !0)])], 2)) : J("", !0),
				V(C) || a.trailing ? (G(), Fo("span", {
					key: 1,
					"data-slot": "trailing",
					class: I(D.value.trailing({ class: V(o).ui?.trailing }))
				}, [W(e.$slots, "trailing", { ui: D.value }, () => [V(T) ? (G(), K(y_, {
					key: 0,
					name: V(T),
					"data-slot": "trailingIcon",
					class: I(D.value.trailingIcon({ class: V(o).ui?.trailingIcon }))
				}, null, 8, ["name", "class"])) : J("", !0)])], 2)) : J("", !0)
			]),
			_: 3
		}, 8, [
			"as",
			"data-slot",
			"class"
		]));
	}
}), q_ = {
	lang: void 0,
	message: void 0,
	abortEarly: void 0,
	abortPipeEarly: void 0
};
/* @__NO_SIDE_EFFECTS__ */
function J_(e) {
	return e ? {
		lang: e?.lang ?? void 0,
		message: e?.message,
		abortEarly: e?.abortEarly ?? void 0,
		abortPipeEarly: e?.abortPipeEarly ?? void 0
	} : q_;
}
/* @__NO_SIDE_EFFECTS__ */
function Y_(e) {
	let t = typeof e;
	return t === "string" ? `"${e}"` : t === "number" || t === "bigint" || t === "boolean" ? `${e}` : t === "object" || t === "function" ? (e && Object.getPrototypeOf(e)?.constructor?.name) ?? "null" : t;
}
function X_(e, t, n, r, i) {
	let a = i && "input" in i ? i.input : n.value, o = i?.expected ?? e.expects ?? null, s = i?.received ?? /* @__PURE__ */ Y_(a), c = {
		kind: e.kind,
		type: e.type,
		input: a,
		expected: o,
		received: s,
		message: `Invalid ${t}: ${o ? `Expected ${o} but r` : "R"}eceived ${s}`,
		requirement: e.requirement,
		path: i?.path,
		issues: i?.issues,
		lang: r.lang,
		abortEarly: r.abortEarly,
		abortPipeEarly: r.abortPipeEarly
	}, l = e.kind === "schema", u = i?.message ?? e.message ?? (e.reference, c.lang, void 0) ?? (l ? (c.lang, void 0) : null) ?? r.message ?? (c.lang, void 0);
	u !== void 0 && (c.message = typeof u == "function" ? u(c) : u), l && (n.typed = !1), n.issues ? n.issues.push(c) : n.issues = [c];
}
function Z_(e) {
	return e["~standard"] = {
		version: 1,
		vendor: "valibot",
		validate: (t) => e["~run"]({ value: t }, /* @__PURE__ */ J_())
	}, e;
}
var Q_ = /^[\w+-]+(?:\.[\w+-]+)*@[\da-zA-Z]+(?:[.-][\da-zA-Z]+)*\.[a-zA-Z]{2,}$/u;
/* @__NO_SIDE_EFFECTS__ */
function $_(e) {
	return {
		kind: "validation",
		type: "email",
		reference: $_,
		expects: null,
		async: !1,
		requirement: Q_,
		message: e,
		"~run"(e, t) {
			return e.typed && !this.requirement.test(e.value) && X_(this, "email", e, t), e;
		}
	};
}
/* @__NO_SIDE_EFFECTS__ */
function ev(e, t) {
	return {
		kind: "validation",
		type: "max_length",
		reference: ev,
		async: !1,
		expects: `<=${e}`,
		requirement: e,
		message: t,
		"~run"(e, t) {
			return e.typed && e.value.length > this.requirement && X_(this, "length", e, t, { received: `${e.value.length}` }), e;
		}
	};
}
/* @__NO_SIDE_EFFECTS__ */
function tv(e) {
	return {
		kind: "validation",
		type: "non_empty",
		reference: tv,
		async: !1,
		expects: "!0",
		message: e,
		"~run"(e, t) {
			return e.typed && e.value.length === 0 && X_(this, "length", e, t, { received: "0" }), e;
		}
	};
}
/* @__NO_SIDE_EFFECTS__ */
function nv(e, t, n) {
	return typeof e.fallback == "function" ? e.fallback(t, n) : e.fallback;
}
/* @__NO_SIDE_EFFECTS__ */
function rv(e, t, n) {
	return typeof e.default == "function" ? e.default(t, n) : e.default;
}
/* @__NO_SIDE_EFFECTS__ */
function iv(e) {
	return Z_({
		kind: "schema",
		type: "boolean",
		reference: iv,
		expects: "boolean",
		async: !1,
		message: e,
		"~run"(e, t) {
			return typeof e.value == "boolean" ? e.typed = !0 : X_(this, "type", e, t), e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function av(e, t) {
	return Z_({
		kind: "schema",
		type: "object",
		reference: av,
		expects: "Object",
		async: !1,
		entries: e,
		message: t,
		"~run"(e, t) {
			let n = e.value;
			if (n && typeof n == "object") {
				e.typed = !0, e.value = {};
				for (let r in this.entries) {
					let i = this.entries[r];
					if (r in n || (i.type === "exact_optional" || i.type === "optional" || i.type === "nullish") && i.default !== void 0) {
						let a = r in n ? n[r] : /* @__PURE__ */ rv(i), o = i["~run"]({ value: a }, t);
						if (o.issues) {
							let i = {
								type: "object",
								origin: "value",
								input: n,
								key: r,
								value: a
							};
							for (let t of o.issues) t.path ? t.path.unshift(i) : t.path = [i], e.issues?.push(t);
							if (e.issues ||= o.issues, t.abortEarly) {
								e.typed = !1;
								break;
							}
						}
						o.typed || (e.typed = !1), e.value[r] = o.value;
					} else if (i.fallback !== void 0) e.value[r] = /* @__PURE__ */ nv(i);
					else if (i.type !== "exact_optional" && i.type !== "optional" && i.type !== "nullish" && (X_(this, "key", e, t, {
						input: void 0,
						expected: `"${r}"`,
						path: [{
							type: "object",
							origin: "key",
							input: n,
							key: r,
							value: n[r]
						}]
					}), t.abortEarly)) break;
				}
			} else X_(this, "type", e, t);
			return e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function ov(e, t) {
	return Z_({
		kind: "schema",
		type: "optional",
		reference: ov,
		expects: `(${e.expects} | undefined)`,
		async: !1,
		wrapped: e,
		default: t,
		"~run"(e, t) {
			return e.value === void 0 && (this.default !== void 0 && (e.value = /* @__PURE__ */ rv(this, e, t)), e.value === void 0) ? (e.typed = !0, e) : this.wrapped["~run"](e, t);
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function sv(e) {
	return Z_({
		kind: "schema",
		type: "string",
		reference: sv,
		expects: "string",
		async: !1,
		message: e,
		"~run"(e, t) {
			return typeof e.value == "string" ? e.typed = !0 : X_(this, "type", e, t), e;
		}
	});
}
/* @__NO_SIDE_EFFECTS__ */
function cv(...e) {
	return Z_({
		...e[0],
		pipe: e,
		"~run"(t, n) {
			for (let r of e) if (r.kind !== "metadata") {
				if (t.issues && (r.kind === "schema" || r.kind === "transformation")) {
					t.typed = !1;
					break;
				}
				(!t.issues || !n.abortEarly && !n.abortPipeEarly) && (t = r["~run"](t, n));
			}
			return t;
		}
	});
}
//#endregion
//#region app/composables/useLogin.ts
var lv = "This page has expired. Reload it and try again.";
function uv(e, t) {
	let n = document.createElement("form");
	n.method = "POST", n.action = "/login", n.style.display = "none";
	let r = [
		["_token", t],
		["email", e.email],
		["password", e.password]
	];
	e.remember && r.push(["remember", "1"]);
	for (let [e, t] of r) {
		let r = document.createElement("input");
		r.type = "hidden", r.name = e, r.value = t, n.append(r);
	}
	document.body.append(n), HTMLFormElement.prototype.submit.call(n);
}
function dv(e = {}) {
	let t = /* @__PURE__ */ Ut({
		email: e.email ?? "",
		password: "",
		remember: !1
	}), n = /* @__PURE__ */ B(!1), r = /* @__PURE__ */ B(!1), i = /* @__PURE__ */ B(e.error ?? "");
	async function a(e) {
		i.value = "";
		let t = document.querySelector("meta[name=\"csrf-token\"]")?.content;
		if (!t) {
			i.value = lv;
			return;
		}
		r.value = !0, window.setTimeout(() => {
			uv(e, t);
		}, 0);
	}
	return {
		credentials: t,
		showPassword: n,
		submitting: r,
		errorMessage: i,
		login: a
	};
}
//#endregion
//#region app/components/LoginPage.vue?vue&type=script&setup=true&lang.ts
var fv = { class: "min-h-screen bg-[#F5F0E6] lg:grid grid-cols-2" }, pv = { class: "flex flex-col min-h-screen items-center justify-center px-6 py-12" }, mv = {
	key: 0,
	role: "alert",
	class: "rounded-md bg-error/10 px-3 py-2 text-sm text-error mb-8"
}, hv = /* @__PURE__ */ Qr({
	__name: "LoginPage",
	props: {
		initialEmail: {},
		initialError: {}
	},
	setup(e) {
		let t = /* @__PURE__ */ av({
			email: /* @__PURE__ */ cv(/* @__PURE__ */ sv(), /* @__PURE__ */ tv("Email is required"), /* @__PURE__ */ $_("Invalid email"), /* @__PURE__ */ ev(255)),
			password: /* @__PURE__ */ cv(/* @__PURE__ */ sv(), /* @__PURE__ */ tv("Password is required"), /* @__PURE__ */ ev(1024)),
			remember: /* @__PURE__ */ ov(/* @__PURE__ */ iv())
		}), n = e, { credentials: r, showPassword: i, submitting: a, errorMessage: o, login: s } = dv({
			email: n.initialEmail,
			error: n.initialError
		});
		async function c(e) {
			await s(e.data);
		}
		return (e, n) => {
			let s = K_, l = U_, u = L_, d = x_, f = __;
			return G(), Fo("main", fv, [Vo("div", pv, [
				n[5] ||= Vo("svg", {
					class: "absolute top-15",
					width: "210",
					height: "24",
					viewBox: "0 0 210 24",
					fill: "none",
					xmlns: "http://www.w3.org/2000/svg"
				}, [Vo("path", {
					"fill-rule": "evenodd",
					"clip-rule": "evenodd",
					d: "M12.1603 11.8947C13.6084 12.8504 14.9706 14.3194 15.1664 16.645C15.5143 20.7825 11.7387 24.1252 7.59188 23.983C4.70228 23.8837 2.06701 22.6431 0.123579 20.457C-0.0801215 20.2277 -0.0166551 19.9099 0.201978 19.6955C0.662345 19.2444 1.39221 18.5373 1.62158 18.3029C1.90578 18.0122 2.26395 18.0122 2.56611 18.3505C3.85621 19.7955 5.65965 20.8241 7.79885 20.8241C9.96302 20.8241 11.8607 19.4244 11.8607 17.3254C11.8607 13.7607 6.93318 13.3604 3.83708 11.3282C2.17225 10.2286 0.873512 8.62955 0.873512 6.19709C0.873512 2.79883 3.87021 0 7.93208 0C10.44 0 12.2611 0.992645 13.5641 1.84308C13.9549 2.09807 13.9999 2.5254 13.813 2.8007C13.6884 2.98424 13.0799 3.72726 12.6627 4.2571C12.3706 4.62814 11.9548 4.53824 11.657 4.32785C10.5459 3.54303 9.31412 3.16474 8.06508 3.16474C6.13425 3.16474 4.20318 4.2648 4.20318 6.29726C4.20318 9.26259 9.16408 9.89563 12.1603 11.8947ZM74.5285 10.9389C76.3872 12.1548 77.7021 14.3297 77.7021 16.6928C77.7021 18.8582 76.7034 20.8241 75.1382 22.0904C73.9398 23.0898 72.4082 23.6563 70.0445 23.6563H61.6742C61.3323 23.6563 61.0551 23.3789 61.0551 23.0366V0.952948C61.0551 0.610624 61.3323 0.333216 61.6742 0.333216H68.9791C71.2429 0.333216 72.6747 0.966025 73.7737 1.96544C74.9721 3.06527 75.7045 4.66457 75.7045 6.3972C75.7045 7.73077 75.1951 9.01834 74.3887 10.0079C74.1479 10.3033 74.2098 10.7304 74.5285 10.9389ZM64.3846 4.11816V8.87636C64.3846 9.21845 64.6618 9.49586 65.0038 9.49586H68.3799C70.2443 9.49586 71.0432 9.12949 71.5759 8.5296C72.0755 7.99627 72.3751 7.29691 72.3751 6.49738C72.3751 5.69761 72.0755 4.99779 71.5759 4.46492C71.0432 3.86503 70.2443 3.49866 68.3799 3.49866H65.0038C64.6618 3.49866 64.3846 3.77607 64.3846 4.11816ZM73.2739 19.2915C73.9398 18.5915 74.3726 17.6255 74.3726 16.5595C74.3726 15.4933 73.9398 14.5602 73.2739 13.8606C72.5417 13.1274 71.5425 12.6613 69.4451 12.6613H65.0038C64.6618 12.6613 64.3846 12.9387 64.3846 13.2808V19.8714C64.3846 20.2134 64.6618 20.4908 65.0038 20.4908H69.4451C71.5425 20.4908 72.5417 20.0243 73.2739 19.2915ZM100.767 0.592878C100.832 0.435727 100.985 0.333216 101.155 0.333216H102.924C103.094 0.333216 103.247 0.435727 103.312 0.592878L112.619 23.0749C112.734 23.3516 112.531 23.6563 112.231 23.6563H109.679C109.509 23.6563 109.355 23.5533 109.29 23.3957L107.041 17.9192C106.976 17.7616 106.823 17.6586 106.652 17.6586H97.3952C97.2239 17.6586 97.0699 17.7625 97.0057 17.9211L94.7881 23.3938C94.7237 23.5524 94.5697 23.6563 94.3987 23.6563H91.8479C91.5485 23.6563 91.3451 23.3516 91.4599 23.0749L100.767 0.592878ZM98.6855 13.9117C98.5705 14.1887 98.7737 14.4936 99.0733 14.4936H105.006C105.306 14.4936 105.509 14.1887 105.394 13.912L102.428 6.76568C102.284 6.42009 101.795 6.42009 101.652 6.76568L98.6855 13.9117ZM141.003 11.295C140.453 11.7448 139.848 12.1011 139.087 12.3353C138.707 12.4525 138.571 12.9249 138.81 13.2437L145.939 22.7372C146.223 23.1155 145.954 23.6563 145.481 23.6563H142.886C142.706 23.6563 142.537 23.5718 142.429 23.4279L134.483 12.8894C134.374 12.7458 134.205 12.6613 134.025 12.6613H132.22C131.904 12.6613 131.647 12.9182 131.647 13.2353V23.0821C131.647 23.3992 131.39 23.6563 131.073 23.6563H128.891C128.574 23.6563 128.317 23.3992 128.317 23.0821V0.907414C128.317 0.590309 128.574 0.333216 128.891 0.333216H136.475C138.605 0.333216 139.937 0.832925 141.003 1.69924C142.401 2.83199 143.3 4.56463 143.3 6.49714C143.3 8.42966 142.401 10.1621 141.003 11.295ZM131.647 8.9219C131.647 9.23877 131.904 9.49586 132.22 9.49586H136.308C137.806 9.49586 138.572 9.16241 139.105 8.62955C139.637 8.09645 139.97 7.33007 139.97 6.49714C139.97 5.66399 139.637 4.89808 139.105 4.36474C138.572 3.83188 137.806 3.49866 136.308 3.49866H132.22C131.904 3.49866 131.647 3.75575 131.647 4.07286V8.9219ZM159.382 3.49866C159.052 3.49866 158.785 3.23129 158.785 2.90134V0.930532C158.785 0.600818 159.052 0.333216 159.382 0.333216H174.169C174.498 0.333216 174.766 0.600818 174.766 0.930532V2.90134C174.766 3.23129 174.498 3.49866 174.169 3.49866H169.037C168.707 3.49866 168.44 3.76603 168.44 4.09597V23.059C168.44 23.3887 168.173 23.6563 167.843 23.6563H165.707C165.378 23.6563 165.11 23.3887 165.11 23.059V4.09597C165.11 3.76603 164.843 3.49866 164.514 3.49866H159.382ZM206.671 0.82662C206.671 0.554115 206.892 0.333216 207.164 0.333216H209.507C209.779 0.333216 210 0.554115 210 0.82662V23.1627C210 23.4352 209.779 23.6561 209.507 23.6561H207.164C206.892 23.6561 206.671 23.4352 206.671 23.1627V13.1545C206.671 12.882 206.45 12.6611 206.178 12.6611H194.179C193.907 12.6611 193.686 12.882 193.686 13.1545V23.1627C193.686 23.4352 193.465 23.6561 193.193 23.6561H190.85C190.578 23.6561 190.357 23.4352 190.357 23.1627V0.82662C190.357 0.554115 190.578 0.333216 190.85 0.333216H193.193C193.465 0.333216 193.686 0.554115 193.686 0.82662V9.00222C193.686 9.27473 193.907 9.49563 194.179 9.49563H206.178C206.45 9.49563 206.671 9.27473 206.671 9.00222V0.82662ZM30.0005 20.4906H44.9462C45.2321 20.4906 45.464 20.7225 45.464 21.0088V23.1379C45.464 23.424 45.2321 23.6561 44.9462 23.6561H30.0005C29.7147 23.6561 29.4828 23.424 29.4828 23.1379V21.0088C29.4828 20.7225 29.7147 20.4906 30.0005 20.4906ZM36.2639 18.1217C36.0124 18.1217 35.8084 17.9176 35.8084 17.6659V3.954C35.8084 3.70228 35.6045 3.49819 35.353 3.49819H29.9382C29.6867 3.49819 29.4828 3.29411 29.4828 3.04238V0.788792C29.4828 0.537069 29.6867 0.332983 29.9382 0.332983H45.0081C45.2596 0.332983 45.4635 0.537069 45.4635 0.788792V3.04238C45.4635 3.29411 45.2596 3.49819 45.0081 3.49819H39.5931C39.3416 3.49819 39.1376 3.70228 39.1376 3.954V17.6659C39.1376 17.9176 38.9339 18.1217 38.6824 18.1217H36.2639Z",
					fill: "#131317"
				})], -1),
				n[6] ||= Vo("div", { class: "mb-20 text-center" }, [Vo("h1", { class: "text-3xl lg:text-6xl font-serif tracking-tight text-highlighted" }, "Welcome Back")], -1),
				q(f, {
					schema: V(t),
					state: V(r),
					"validate-on": [],
					novalidate: "",
					class: "w-full max-w-96.25 space-y-2.5",
					disabled: V(a),
					onSubmit: c
				}, {
					default: U(() => [
						V(o) ? (G(), Fo("p", mv, Ce(V(o)), 1)) : J("", !0),
						q(l, {
							label: "Email",
							name: "email"
						}, {
							default: U(() => [q(s, {
								modelValue: V(r).email,
								"onUpdate:modelValue": n[0] ||= (e) => V(r).email = e,
								type: "email",
								autocomplete: "email",
								placeholder: "you@sibarth.com",
								size: "lg",
								class: "w-full"
							}, null, 8, ["modelValue"])]),
							_: 1
						}),
						q(l, {
							label: "Password",
							name: "password"
						}, {
							help: U(() => [...n[4] ||= [Vo("a", {
								href: "/password/reset",
								class: "text-sm text-muted"
							}, " Forgot your password? ", -1)]]),
							default: U(() => [q(s, {
								modelValue: V(r).password,
								"onUpdate:modelValue": n[2] ||= (e) => V(r).password = e,
								type: V(i) ? "text" : "password",
								autocomplete: "current-password",
								size: "lg",
								class: "w-full"
							}, {
								trailing: U(() => [q(u, {
									type: "button",
									color: "neutral",
									variant: "link",
									size: "sm",
									icon: V(i) ? "i-lucide-eye-off" : "i-lucide-eye",
									"aria-label": V(i) ? "Hide password" : "Show password",
									onClick: n[1] ||= (e) => i.value = !V(i)
								}, null, 8, ["icon", "aria-label"])]),
								_: 1
							}, 8, ["modelValue", "type"])]),
							_: 1
						}),
						q(d, {
							modelValue: V(r).remember,
							"onUpdate:modelValue": n[3] ||= (e) => V(r).remember = e,
							label: "Remember sign in details",
							size: "lg",
							class: "my-10"
						}, null, 8, ["modelValue"]),
						q(u, {
							type: "submit",
							label: "Log in",
							size: "xl",
							block: "",
							loading: V(a)
						}, null, 8, ["loading"])
					]),
					_: 1
				}, 8, [
					"schema",
					"state",
					"disabled"
				])
			]), n[7] ||= Jo("<div class=\"bg-[#FBFAF6] hidden lg:block\"><picture class=\"w-full h-full relative\"><source data-srcset=\"https://cms.sibarth.com/api/media/file/_MG_3818%20(1)-800x533.avif\" type=\"image/avif\" media=\"(max-width: 768px)\" srcset=\"https://cms.sibarth.com/api/media/file/_MG_3818%20(1)-800x533.avif\"><source data-srcset=\"https://cms.sibarth.com/api/media/file/_MG_3818%20(1)-800x533.webp\" type=\"image/webp\" media=\"(max-width: 768px)\" srcset=\"https://cms.sibarth.com/api/media/file/_MG_3818%20(1)-800x533.webp\"><source data-srcset=\"https://cms.sibarth.com/api/media/file/_MG_3818%20(1)-2200x1467.avif\" type=\"image/avif\" srcset=\"https://cms.sibarth.com/api/media/file/_MG_3818%20(1)-2200x1467.avif\"><source data-srcset=\"https://cms.sibarth.com/api/media/file/_MG_3818%20(1)-2200x1467.webp\" type=\"image/webp\" srcset=\"https://cms.sibarth.com/api/media/file/_MG_3818%20(1)-2200x1467.webp\"><img loading=\"lazy\" decoding=\"async\" class=\"h-full w-full object-cover\" src=\"https://cms.sibarth.com/api/media/file/_MG_3818%20(1)-2200x1467.avif\" height=\"1468\" width=\"3000\" alt=\"\"></picture></div>", 1)]);
		};
	}
});
//#endregion
//#region src/mount.ts
function gv({ elementId: e }) {
	let t = document.getElementById(e);
	if (!t) throw Error(`Cannot mount frontend: element #${e} was not found.`);
	let n = Tc(hv, {
		initialEmail: t.dataset.email ?? "",
		initialError: t.dataset.error ?? ""
	});
	return n.use(np), n.mount(t), n;
}
//#endregion
export { gv as mountFrontend };
